
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1a46"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1a46"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5h1Kk", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._test_private_schema = module.exports.IS_MARK = module.exports.SCHEMA_CHILDREN = module.exports.SCHEMA_CONTENT = module.exports.SCHEMAS = module.exports.NODE_ATTR_NAMES = module.exports.NODE_ATTRS = module.exports.TO_DOM = module.exports.NODE_NAMES = void 0;
module.exports.defaultToDom = $3d6fe51095357fb4$var$defaultToDom;
module.exports.getDomAttr = $3d6fe51095357fb4$var$getDomAttr;
module.exports.defaultNodeAttrs = $3d6fe51095357fb4$var$defaultNodeAttrs;
module.exports.defaultNodeName = $3d6fe51095357fb4$var$defaultNodeName;
module.exports.schema = $3d6fe51095357fb4$var$schema;

var $57yyk = parcelRequire("57yyk");

var $hWgwJ = parcelRequire("hWgwJ");

var $6B4AI = parcelRequire("6B4AI");
/**
 * Referenced schema: https://github.com/oasis-tcs/dita-lwdita/tree/spec/org.oasis.xdita/dtd
 */ /**
 * Set the root node `document` to string "doc"
 *
 * @remarks
 * Will be used in `defaultNodeName()`.
 */ module.exports.NODE_NAMES = {
    document: "doc"
};
/**
 * Provide a map of special (media) nodes to their corresponding DOM node
 */ module.exports.TO_DOM = {};
/**
 * Some nodes have special attributes.
 * This List allows to add special attributes to the node if it's not
 * in the schema and render them in the DOM
 */ module.exports.NODE_ATTRS = {
    video: (node)=>$3d6fe51095357fb4$var$defaultNodeAttrs([
            ...node,
            "poster",
            "title"
        ]),
    audio: (node)=>$3d6fe51095357fb4$var$defaultNodeAttrs([
            ...node,
            "title"
        ]),
    image: (node)=>$3d6fe51095357fb4$var$defaultNodeAttrs([
            ...node,
            "alt"
        ])
};
/**
 * A map of attributes for special nodes and their
 * corresponding attribute names in the Prosemirror DOM
 *
 * @privateRemarks
 * TODO: autoplay, controls, loop, muted are boolean attributes in XDITA, but they don't require a value in HTML5.
 * As soon as they are rendered in the DOM, browsers will render them as true, even if they have a value "false".
 * This needs to be fixed where handling the attribute values:
 * If attribute value === false, then prefix it with a `data-j-*` attribute.
 */ module.exports.NODE_ATTR_NAMES = {
    video: {
        _: "*",
        autoplay: "autoplay",
        controls: "controls",
        loop: "loop",
        muted: "muted",
        tabindex: "tabindex",
        height: "height",
        width: "width",
        poster: "poster",
        parent: "*",
        outputclass: "class"
    },
    audio: {
        _: "*",
        autoplay: "autoplay",
        controls: "controls",
        loop: "loop",
        muted: "muted",
        tabindex: "tabindex",
        keyref: "src",
        parent: "*",
        outputclass: "class"
    },
    "media-source": {
        href: "src",
        format: "type"
    },
    "media-track": {
        kind: "kind",
        href: "src",
        srclang: "srclang"
    },
    xref: {
        keyref: "href",
        href: "href"
    },
    image: {
        _: "*",
        href: "src",
        alt: "alt",
        width: "width",
        height: "height",
        scope: "*",
        parent: "*",
        outputclass: "class"
    }
};
/**
 * Provide a map of special nodes to their corresponding Schema
 */ module.exports.SCHEMAS = {
    "text": ()=>{
        const result = {
            attrs: {
                parent: {
                    default: ""
                }
            }
        };
        return result;
    }
};
/**
 * The LwDITA Schema. Describes parent-child relationships.
 * content: The allowed child elements of the element
 * groups: The content-groups, the element is allowed to be part of
 */ module.exports.SCHEMA_CONTENT = {
    /*
      lwdita-ast node groups:
      'ph': ['b', 'em', 'i', 'ph', 'strong', 'sub', 'sup', 'tt', 'u'],
      'inline.noimage': ['text', 'b', 'em', 'i', 'ph', 'strong', 'sub', 'sup', 'tt', 'u', 'xref'],
      'inline.noxref': ['text', 'b', 'em', 'i', 'ph', 'strong', 'sub', 'sup', 'tt', 'u', 'image'],
      'inline': ['text', 'b', 'em', 'i', 'ph', 'strong', 'sub', 'sup', 'tt', 'u', 'image', 'xref'],
      'simple_blocks': ['p', 'ul', 'ol', 'dl', 'pre', 'audio', 'video', 'example', 'note'],
      'fn-blocks': ['p', 'ul', 'ol', 'dl'],
      'all-blocks': ['p','ul','ol','dl','pre','audio','video','example','simpletable','fig','note'],
      'list-blocks': ['p','ul', 'ol', 'dl', 'pre', 'audio', 'video', 'example', 'simpletable', 'fig', 'note'],
      'fig-blocks': ['p', 'ul', 'ol', 'dl', 'pre', 'audio', 'video', 'example', 'simpletable'],
      'example-blocks': ['p','ul','ol','dl','pre','audio','video','simpletable','fig','note'],
      'fallback-blocks': ['image','alt','p','ul','ol','dl','pre','note'],
     */ alt: [
        "(text|ph)*",
        "fallback_blocks"
    ],
    audio: [
        "desc? fallback? media_source* media_track*",
        "simple_blocks all_blocks list_blocks fig_blocks example_blocks"
    ],
    body: [
        "list_blocks* section* div?",
        ""
    ],
    dd: [
        "list_blocks*",
        ""
    ],
    desc: [
        "inline_noxref*",
        ""
    ],
    div: [
        "fn+",
        ""
    ],
    dl: [
        "dlentry+",
        "simple_blocks fn_blocks all_blocks list_blocks fig_blocks example_blocks fallback_blocks"
    ],
    dlentry: [
        "dt dd",
        ""
    ],
    dt: [
        "inline*",
        ""
    ],
    document: [
        "topic",
        ""
    ],
    fallback: [
        "fallback_blocks",
        ""
    ],
    em: [
        "inline_noimage*",
        "ph "
    ],
    example: [
        "title? example_blocks*",
        "simple_blocks all_blocks list_blocks fig_blocks"
    ],
    fig: [
        "title? desc? (fig_blocks|image|xref)*",
        "all_blocks list_blocks example_blocks"
    ],
    fn: [
        "fn_blocks*",
        ""
    ],
    image: [
        "alt?",
        "inline_noxref inline fallback_blocks"
    ],
    keydef: [
        "topicmeta?",
        ""
    ],
    keytext: [
        "(text|ph)*",
        ""
    ],
    li: [
        "list_blocks*",
        ""
    ],
    map: [
        "(topicmeta? (topicref|keydef)*)",
        ""
    ],
    "media-source": [
        "",
        ""
    ],
    "media-track": [
        "",
        ""
    ],
    metadata: [
        "othermeta*",
        ""
    ],
    navtitle: [
        "(text|ph)*",
        ""
    ],
    note: [
        "simple_blocks*",
        "simple_blocks all_blocks list_blocks example_blocks fallback_blocks"
    ],
    ol: [
        "li+",
        "simple_blocks fn_blocks all_blocks list_blocks fig_blocks example_blocks fallback_blocks"
    ],
    othermeta: [
        "",
        ""
    ],
    p: [
        "inline*",
        "fn_blocks simple_blocks fig_blocks list_blocks all_blocks"
    ],
    ph: [
        "inline*",
        "ph inline_noimage inline_noxref inline"
    ],
    pre: [
        "(text|ph|xref)*",
        "simple_blocks all_blocks list_blocks fig_blocks example_blocks fallback_blocks"
    ],
    prolog: [
        "metadata*",
        ""
    ],
    section: [
        "title? all_blocks*",
        ""
    ],
    simpletable: [
        "title? sthead? strow+",
        " all_blocks list_blocks fig_blocks example_blocks"
    ],
    shortdesc: [
        "inline*",
        ""
    ],
    stentry: [
        "simple_blocks*",
        ""
    ],
    sthead: [
        "stentry+",
        ""
    ],
    strong: [
        "inline_noimage*",
        ""
    ],
    strow: [
        "(stentry*)",
        ""
    ],
    title: [
        "inline_noxref*",
        ""
    ],
    topic: [
        "title shortdesc? prolog? body?",
        ""
    ],
    topicmeta: [
        "navtitle? keytext? othermeta*",
        ""
    ],
    topicref: [
        "topicmeta? topicref*",
        ""
    ],
    tt: [
        "inline_noimage*",
        ""
    ],
    ul: [
        "li+",
        "simple_blocks fn_blocks  all_blocks list_blocks fig_blocks example_blocks fallback_blocks"
    ],
    video: [
        "desc? fallback? video_poster? media_source* media_track*",
        "simple_blocks all_blocks list_blocks fig_blocks example_blocks"
    ],
    "video-poster": [
        "",
        ""
    ],
    xref: [
        "inline_noxref",
        "inline_noimage inline"
    ]
};
/**
 * A map of special children for certain media nodes
 */ module.exports.SCHEMA_CHILDREN = {
    video: ()=>[
            "desc",
            "fallback",
            "video-poster",
            "media-source",
            "media-track"
        ],
    audio: ()=>[
            "desc",
            "fallback",
            "media-source",
            "media-track"
        ]
};
/**
 * The inline markup elements bold, italic, underline, subscript, superscript
 */ module.exports.IS_MARK = [
    "b",
    "i",
    "u",
    "sub",
    "sup"
];
/**
 * Get node children
 *
 * @param type - Type of the Child nodes
 * @returns - The children of the node
 */ function $3d6fe51095357fb4$var$getChildren(type) {
    if (Array.isArray(type)) return type.map((subType)=>$3d6fe51095357fb4$var$getChildren(subType)).reduce((result, children)=>result.concat(children.filter((child)=>result.indexOf(child) < 0)), []);
    return type.isGroup ? $57yyk.nodeGroups[type.name] : [
        type.name
    ];
}
/**
 * Travel the node and generate the node spec
 *
 * @param node - JDita node
 * @param next - Next travel function
 * @returns SchemaNode
 */ function $3d6fe51095357fb4$var$schemaTravel(node, next) {
    return (module.exports.SCHEMAS[node.nodeName] || $3d6fe51095357fb4$var$defaultTravel)(node, next);
}
/**
 * Returns a function that generates the dom spec for a node
 *
 * @see {@link https://prosemirror.net/docs/ref/#model.DOMOutputSpec} for more info
 *
 * @param node - JDita node
 * @param attrs - The attributes of the node
 * @returns A function that generates the DOM spec
 */ function $3d6fe51095357fb4$var$defaultToDom(node, attrs) {
    return function(pmNode) {
        var _a;
        return [
            (0, $hWgwJ.getDomNode)(node.nodeName, (_a = pmNode.attrs) === null || _a === void 0 ? void 0 : _a.parent),
            attrs ? Object.keys(attrs).reduce((newAttrs, attr)=>{
                if (pmNode.attrs[attr]) {
                    const domAttr = $3d6fe51095357fb4$var$getDomAttr(node.nodeName, attr);
                    newAttrs[domAttr] = pmNode.attrs[attr];
                }
                return newAttrs;
            }, {
                "data-j-type": node.nodeName
            }) : {},
            0
        ];
    };
}
/**
 * Returns the dom attribute name
 *
 * @param nodeName - The name of the node
 * @param attr - The name of the attribute
 * @returns The DOM attribute
 */ function $3d6fe51095357fb4$var$getDomAttr(nodeName, attr) {
    return module.exports.NODE_ATTR_NAMES[nodeName] ? module.exports.NODE_ATTR_NAMES[nodeName]._ ? module.exports.NODE_ATTR_NAMES[nodeName][attr] ? module.exports.NODE_ATTR_NAMES[nodeName][attr] === "*" ? "data-j-" + attr : module.exports.NODE_ATTR_NAMES[nodeName][attr] : attr : module.exports.NODE_ATTR_NAMES[nodeName][attr] ? module.exports.NODE_ATTR_NAMES[nodeName][attr] : "data-j-" + attr : "data-j-" + attr;
}
/**
 * Create default node attributes
 *
 * @param attrs - The attributes of the node
 * @returns A map of the attributes with default values
 */ function $3d6fe51095357fb4$var$defaultNodeAttrs(attrs) {
    return attrs.reduce((result, field)=>{
        result[field] = {
            default: ""
        };
        return result;
    }, {});
}
/**
 * Travel the node and generate the node spec
 *
 * @remarks
 * NodeSpec is a description of a node type, used when defining a schema.
 * @see {@link https://prosemirror.net/docs/ref/#model.NodeSpec} for more info
 *
 * @param nodeName - The name of the node
 * @param parent - The parent of the node
 * @param next - Next travel function
 * @returns NodeSpec
 */ function $3d6fe51095357fb4$var$defaultTravel(node, next) {
    const children = (module.exports.SCHEMA_CHILDREN[node.nodeName] || $3d6fe51095357fb4$var$getChildren)(node.childTypes);
    const isNode = module.exports.IS_MARK.indexOf(node.nodeName) < 0;
    const [content, group] = isNode ? module.exports.SCHEMA_CONTENT[node.nodeName] : [
        undefined,
        undefined
    ];
    const attrs = (module.exports.NODE_ATTRS[node.nodeName] || $3d6fe51095357fb4$var$defaultNodeAttrs)([
        "parent",
        ...node.fields
    ]);
    // create the node spec
    const result = {
        attrs: attrs,
        inline: !(typeof group === "string" && (group.indexOf("block") > -1 || group === "")),
        group: group,
        parseDom: [
            {
                tag: "[data-j-type=" + node.nodeName + "]",
                getAttrs (dom) {
                    return attrs ? Object.keys(attrs).reduce((newAttrs, attr)=>{
                        const domAttr = $3d6fe51095357fb4$var$getDomAttr(node.nodeName, attr);
                        if (dom.hasAttribute(domAttr)) newAttrs[attr] = dom.getAttribute(domAttr);
                        return newAttrs;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    }, {}) : {};
                }
            }
        ],
        toDOM: (module.exports.TO_DOM[node.nodeName] || $3d6fe51095357fb4$var$defaultToDom)(node, attrs)
    };
    if (typeof content === "string") result.content = content;
    result.inline = true;
    children.forEach((child)=>next(child, node));
    return result;
}
/**
 * Transforms the node `nodeName`
 * by replacing dashes with underscores
 *
 * @remarks
 * defaultNodeName will return all nodeNames retrieved by `schema()`
 * and document()
 *
 * @example
 * `media-track` will be transformed to `media_track`
 *
 * @param nodeName - The name of the node
 * @returns A string with the transformed node name
 */ function $3d6fe51095357fb4$var$defaultNodeName(nodeName) {
    return module.exports.NODE_NAMES[nodeName] || nodeName.replace(/-/g, "_");
}
/**
 * Creates a schema for the prosemirror editor
 * based on the jdita nodes
 *
 * @see {@link https://prosemirror.net/docs/ref/#model.SchemaSpec}.
 *
 * @returns The Schema Object, describing a schema, as passed to the Schema constructor
 */ function $3d6fe51095357fb4$var$schema() {
    const done = [];
    // the schema spec are the nodes and marks
    const spec = {
        // the node types in this schema
        nodes: {
            text: {
                group: "inline inline_noimage inline_noxref",
                inline: true
            },
            hard_break: {
                inline: true,
                group: "inline inline_noxref inline_noimage",
                selectable: false,
                parseDOM: [
                    {
                        tag: "br"
                    }
                ],
                toDOM () {
                    return [
                        "br"
                    ];
                }
            }
        },
        // the mark types that exist in this schema
        marks: {}
    };
    // populate the schema spec using the jdita nodes
    function browse(node) {
        // get the node name
        const nodeName = typeof node === "string" ? node : node.nodeName;
        // if we have already processed this node then there's no need to process it again
        if (done.indexOf(nodeName) > -1) return;
        // add the node to the list of done nodes
        done.push(nodeName);
        // do not process the alt or text nodes
        if ([
            "text",
            "cdata"
        ].indexOf(node) > -1) return;
        try {
            const nodeClass = typeof node === "string" ? (0, $57yyk.getNodeClassType)(node) : node;
            // travel the node class and generate the node spec
            const result = $3d6fe51095357fb4$var$defaultTravel(nodeClass, browse);
            if (result) {
                // set the node spec based on the node type
                if (module.exports.IS_MARK.indexOf(nodeName) > -1) spec.marks[$3d6fe51095357fb4$var$defaultNodeName(nodeName)] = result;
                else spec.nodes[$3d6fe51095357fb4$var$defaultNodeName(nodeName)] = result;
            }
        } catch (e) {
            if (e instanceof $57yyk.UnknownNodeError) console.error(e);
            else {
                console.error(node);
                console.error(e);
            }
        }
    }
    // start the process of populating the schema spec using the jdita nodes from the document node
    browse($57yyk.DocumentNode);
    browse($57yyk.MapNode);
    spec.nodes.topic.content = "title shortdesc? prolog? body?";
    spec.nodes.doc.content = "topic+";
    return new $6B4AI.Schema(spec);
}
//Escape hatch for Unit Testing due to a lack of “package-private” accessibility scope in TypeScript
module.exports._test_private_schema = {
    getChildren: $3d6fe51095357fb4$var$getChildren,
    schemaTravel: $3d6fe51095357fb4$var$schemaTravel
};

});
parcelRegister("57yyk", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $3ba8689e447bd111$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3ba8689e447bd111$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $3ba8689e447bd111$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$3ba8689e447bd111$var$__exportStar((parcelRequire("9UoIS")), module.exports);

$3ba8689e447bd111$var$__exportStar((parcelRequire("2IpG1")), module.exports);

$3ba8689e447bd111$var$__exportStar((parcelRequire("38z30")), module.exports);

$3ba8689e447bd111$var$__exportStar((parcelRequire("6vT1r")), module.exports);

$3ba8689e447bd111$var$__exportStar((parcelRequire("eSF03")), module.exports);

$3ba8689e447bd111$var$__exportStar((parcelRequire("lRuta")), module.exports);

});
parcelRegister("9UoIS", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNodeClass = $736c85704f401671$var$getNodeClass;
module.exports.getNodeClassType = $736c85704f401671$var$getNodeClassType;

var $38z30 = parcelRequire("38z30");

var $aZ93Y = parcelRequire("aZ93Y");

var $l2MDk = parcelRequire("l2MDk");

var $bxKqZ = parcelRequire("bxKqZ");

var $ijj0O = parcelRequire("ijj0O");

var $9AVDl = parcelRequire("9AVDl");

var $9KUto = parcelRequire("9KUto");

var $1wL3m = parcelRequire("1wL3m");

var $lvlE5 = parcelRequire("lvlE5");

var $4ehFq = parcelRequire("4ehFq");

var $a6Brx = parcelRequire("a6Brx");

var $4yNjh = parcelRequire("4yNjh");

var $7IWky = parcelRequire("7IWky");

var $3VZ65 = parcelRequire("3VZ65");

var $stdZo = parcelRequire("stdZo");

var $b6btC = parcelRequire("b6btC");

var $7KFhV = parcelRequire("7KFhV");

var $5WqeZ = parcelRequire("5WqeZ");

var $f5Obj = parcelRequire("f5Obj");

var $dOaWj = parcelRequire("dOaWj");

var $8Uhbn = parcelRequire("8Uhbn");

var $eY9fH = parcelRequire("eY9fH");

var $bV8lz = parcelRequire("bV8lz");

var $23hQz = parcelRequire("23hQz");

var $k268p = parcelRequire("k268p");

var $5f1xY = parcelRequire("5f1xY");

var $cYzuY = parcelRequire("cYzuY");

var $k4O5A = parcelRequire("k4O5A");

var $gaX2o = parcelRequire("gaX2o");

var $8jviQ = parcelRequire("8jviQ");

var $g41Dz = parcelRequire("g41Dz");

var $2zXyl = parcelRequire("2zXyl");

var $6VH7H = parcelRequire("6VH7H");

var $fjtDj = parcelRequire("fjtDj");

var $lMYdM = parcelRequire("lMYdM");

var $1NVZt = parcelRequire("1NVZt");

var $lXNXY = parcelRequire("lXNXY");

var $4lPc1 = parcelRequire("4lPc1");

var $7964w = parcelRequire("7964w");

var $l1bn3 = parcelRequire("l1bn3");

var $cXyv8 = parcelRequire("cXyv8");

var $a9PHc = parcelRequire("a9PHc");

var $b8iNJ = parcelRequire("b8iNJ");

var $k6LQ5 = parcelRequire("k6LQ5");

var $eDKcN = parcelRequire("eDKcN");

var $dnRz0 = parcelRequire("dnRz0");

var $9XAst = parcelRequire("9XAst");

var $5QxUx = parcelRequire("5QxUx");

var $HIFUh = parcelRequire("HIFUh");

var $fg70N = parcelRequire("fg70N");

var $1BGxu = parcelRequire("1BGxu");

var $jnCMm = parcelRequire("jnCMm");
/**
 * getNodeClass - Get the Node class constructor based on the node type
 *
 * @param name - A string containing the node name
 * @returns - The node class constructor
 * @throws - UnknownNodeError
 */ function $736c85704f401671$var$getNodeClass(name) {
    switch(name){
        case "alt":
            return $aZ93Y.AltNode;
        case "audio":
            return $l2MDk.AudioNode;
        case "b":
            return $ijj0O.BoldNode;
        case "body":
            return $bxKqZ.BodyNode;
        case "dd":
            return $9AVDl.DdNode;
        case "desc":
            return $9KUto.DescNode;
        case "div":
            return $1wL3m.DivNode;
        case "dl":
            return $4ehFq.DlNode;
        case "dlentry":
            return $lvlE5.DlEntryNode;
        case "dt":
            return $a6Brx.DtNode;
        case "em":
            return $4yNjh.EmNode;
        case "example":
            return $7IWky.ExampleNode;
        case "fallback":
            return $3VZ65.FallbackNode;
        case "fig":
            return $stdZo.FigNode;
        case "fn":
            return $b6btC.FnNode;
        case "i":
            return $5WqeZ.ItalicNode;
        case "image":
            return $7KFhV.ImageNode;
        case "keydef":
            return $f5Obj.KeydefNode;
        case "keytext":
            return $dOaWj.KeytextNode;
        case "li":
            return $8Uhbn.LiNode;
        case "map":
            return $eY9fH.MapNode;
        case "media-source":
            return $bV8lz.MediaSourceNode;
        case "media-track":
            return $23hQz.MediaTrackNode;
        case "metadata":
            return $k268p.MetadataNode;
        case "navtitle":
            return $5f1xY.NavtitleNode;
        case "note":
            return $cYzuY.NoteNode;
        case "ol":
            return $k4O5A.OlNode;
        case "othermeta":
            return $gaX2o.OthermetaNode;
        case "p":
            return $g41Dz.PNode;
        case "ph":
            return $8jviQ.PhNode;
        case "pre":
            return $2zXyl.PreNode;
        case "prolog":
            return $6VH7H.PrologNode;
        case "section":
            return $fjtDj.SectionNode;
        case "simpletable":
            return $1NVZt.SimpleTableNode;
        case "shortdesc":
            return $lMYdM.ShortDescNode;
        case "stentry":
            return $lXNXY.StEntryNode;
        case "sthead":
            return $4lPc1.StHeadNode;
        case "strong":
            return $7964w.StrongNode;
        case "strow":
            return $l1bn3.StRowNode;
        case "sub":
            return $cXyv8.SubscriptNode;
        case "sup":
            return $a9PHc.SuperscriptNode;
        case "title":
            return $b8iNJ.TitleNode;
        case "topic":
            return $k6LQ5.TopicNode;
        case "topicmeta":
            return $eDKcN.TopicmetaNode;
        case "topicref":
            return $dnRz0.TopicrefNode;
        case "tt":
            return $9XAst.TtNode;
        case "u":
            return $HIFUh.UnderlinedNode;
        case "ul":
            return $5QxUx.UlNode;
        case "video":
            return $fg70N.VideoNode;
        case "video-poster":
            return $1BGxu.VideoPosterNode;
        case "xref":
            return $jnCMm.XRefNode;
        default:
            throw new $38z30.UnknownNodeError('unkonwn node "' + name + '"');
    }
}
/**
 * getNodeClassType
 *
 * @privateRemarks
 * This function is never used, remove this function if not needed
 *
 * @param name - String
 * @returns A node of type BaseNode
 */ function $736c85704f401671$var$getNodeClassType(name) {
    return $736c85704f401671$var$getNodeClass(name);
}

});
parcelRegister("38z30", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NonAcceptedChildError = module.exports.WrongAttributeTypeError = module.exports.UnknownAttributeError = module.exports.UnknownNodeError = module.exports.isKindType = module.exports.isNoteType = module.exports.isBooleanString = module.exports.isDisplayExpanse = module.exports.isDisplayFrame = module.exports.isDisplayScale = module.exports.isDITAARCH = module.exports.isINCLUDED_DOMAINS = module.exports.isNMTOKENS = module.exports.isNMTOKEN = module.exports.isPCDATA = module.exports.isCDATA = module.exports.isID = module.exports.isXmlSpace = module.exports.isTableScope = module.exports.isProcessingRole = module.exports.isReferenceContentScope = void 0;
/**
 * isReferenceContentScope - Checks if a value is a ReferenceContentScope
 *
 * @param value - String
 * @returns - If the value is a ReferenceContentScope
 */ const $248d4e260487db66$var$isReferenceContentScope = (value)=>[
        "local",
        "peer",
        "external"
    ].includes(value);
module.exports.isReferenceContentScope = $248d4e260487db66$var$isReferenceContentScope;
/**
 * ProcessingRole validation function
 *
 * @param value - String
 * @returns - If the value is a ProcessingRole
 */ const $248d4e260487db66$var$isProcessingRole = (value)=>[
        "normal",
        "resource-only"
    ].includes(value);
module.exports.isProcessingRole = $248d4e260487db66$var$isProcessingRole;
/**
 * isScope validation function
 *
 * @param value - String
 * @returns - If the value is a TableScope
 */ const $248d4e260487db66$var$isTableScope = (value)=>[
        "row",
        "col",
        "rowgroup",
        "colgroup"
    ].includes(value);
module.exports.isTableScope = $248d4e260487db66$var$isTableScope;
/**
 * XmlSpace validation function
 *
 * @param value - String
 * @returns - If the value is a xmlSpace type
 */ const $248d4e260487db66$var$isXmlSpace = (value)=>[
        "preserve"
    ].includes(value);
module.exports.isXmlSpace = $248d4e260487db66$var$isXmlSpace;
/**
 * Id validation function
 */ const $248d4e260487db66$var$isID = (value)=>typeof value === "string";
module.exports.isID = $248d4e260487db66$var$isID;
/**
 * CDATA validation function
 */ const $248d4e260487db66$var$isCDATA = (value)=>typeof value === "string";
module.exports.isCDATA = $248d4e260487db66$var$isCDATA;
/**
 * PCData validation function
 */ const $248d4e260487db66$var$isPCDATA = (value)=>typeof value === "string";
module.exports.isPCDATA = $248d4e260487db66$var$isPCDATA;
/**
 * NMTOKEN validation function
 */ const $248d4e260487db66$var$isNMTOKEN = (value)=>typeof value === "string";
module.exports.isNMTOKEN = $248d4e260487db66$var$isNMTOKEN;
/**
 * NMTOKENS validation function
 */ const $248d4e260487db66$var$isNMTOKENS = (value)=>typeof value === "string";
module.exports.isNMTOKENS = $248d4e260487db66$var$isNMTOKENS;
/**
 * INCLUDED_DOMAINS validation function
 */ const $248d4e260487db66$var$isINCLUDED_DOMAINS = (value)=>typeof value === "string";
module.exports.isINCLUDED_DOMAINS = $248d4e260487db66$var$isINCLUDED_DOMAINS;
/**
 * INCLUDED_DOMAINS validation function
 */ const $248d4e260487db66$var$isDITAARCH = (value)=>typeof value === "string";
module.exports.isDITAARCH = $248d4e260487db66$var$isDITAARCH;
/**
 * DisplayScale validation function
 */ const $248d4e260487db66$var$isDisplayScale = (value)=>[
        50,
        60,
        70,
        80,
        90,
        100,
        110,
        120,
        140,
        160,
        180,
        200
    ].indexOf(value) > -1;
module.exports.isDisplayScale = $248d4e260487db66$var$isDisplayScale;
/**
 * DisplayAlign validation function
 */ const $248d4e260487db66$var$isDisplayFrame = (value)=>[
        "all",
        "bottom",
        "none",
        "sides",
        "top",
        "topbot"
    ].indexOf(value) > -1;
module.exports.isDisplayFrame = $248d4e260487db66$var$isDisplayFrame;
/**
 * DisplayAlign validation function
 */ const $248d4e260487db66$var$isDisplayExpanse = (value)=>[
        "column",
        "page",
        "spread",
        "textline"
    ].indexOf(value) > -1;
module.exports.isDisplayExpanse = $248d4e260487db66$var$isDisplayExpanse;
/**
 * BooleanString validation function
 */ const $248d4e260487db66$var$isBooleanString = (value)=>[
        "true",
        "false"
    ].indexOf(value) > -1;
module.exports.isBooleanString = $248d4e260487db66$var$isBooleanString;
/**
 * NoteType validation function
 */ const $248d4e260487db66$var$isNoteType = (value)=>[
        "caution",
        "warning",
        "danger",
        "trouble",
        "notice",
        "note"
    ].indexOf(value) > -1;
module.exports.isNoteType = $248d4e260487db66$var$isNoteType;
/**
 * KindType validation function
 */ const $248d4e260487db66$var$isKindType = (value)=>[
        "subtitles",
        "captions",
        "descriptions",
        "chapters",
        "metadata"
    ].indexOf(value) > -1;
module.exports.isKindType = $248d4e260487db66$var$isKindType;
/**
 * Typedef for UnknownNodeError
 */ class $248d4e260487db66$var$UnknownNodeError extends Error {
    constructor(){
        super(...arguments);
        this.name = "unknown-node";
    }
}
module.exports.UnknownNodeError = $248d4e260487db66$var$UnknownNodeError;
/**
 * Typedef for UnknownAttributeError
 */ class $248d4e260487db66$var$UnknownAttributeError extends Error {
    constructor(){
        super(...arguments);
        this.name = "unknown-attribute";
    }
}
module.exports.UnknownAttributeError = $248d4e260487db66$var$UnknownAttributeError;
/**
 * Typedef for UnknownChildError
 */ class $248d4e260487db66$var$WrongAttributeTypeError extends Error {
    constructor(){
        super(...arguments);
        this.name = "wrong-attribute-type";
    }
}
module.exports.WrongAttributeTypeError = $248d4e260487db66$var$WrongAttributeTypeError;
/**
 * Typedef for UnknownChildError
 */ class $248d4e260487db66$var$NonAcceptedChildError extends Error {
    constructor(){
        super(...arguments);
        this.name = "non-accepted-child";
    }
}
module.exports.NonAcceptedChildError = $248d4e260487db66$var$NonAcceptedChildError;

});

parcelRegister("aZ93Y", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $7ff6a1a40f06db3b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AltNode = module.exports.isAltNode = module.exports.isValidAltField = module.exports.AltFields = void 0;
module.exports.makeAlt = $7ff6a1a40f06db3b$var$makeAlt;

var $kCEGt = parcelRequire("kCEGt");

var $c7Ayi = parcelRequire("c7Ayi");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `alt` (Alternative content) fields:
 * `keyref`, `outputclass`, `class`, `dir`, `xml:lang`, `translate`, `props`
 */ module.exports.AltFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given fields of the `alt` node are valid and matches this list:
 * `keyref`, `outputclass`, `class`, `dir`, `xml:lang`, `translate`, `props`
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $7ff6a1a40f06db3b$var$isValidAltField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidAltField = $7ff6a1a40f06db3b$var$isValidAltField;
/**
 * Check if the `alt` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `alt` node to test
 * @returns Boolean
 */ const $7ff6a1a40f06db3b$var$isAltNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.AltFields, value, module.exports.isValidAltField);
module.exports.isAltNode = $7ff6a1a40f06db3b$var$isAltNode;
/**
 * Construct an `alt` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `alt` node
 */ function $7ff6a1a40f06db3b$var$makeAlt(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create an `alt` node
 *
 * @decorator `@makeComponent`
 * @param makeAlt - The `Alt` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidAltField - A boolean value, if the field is valid or not
 * @param fields - A List of valid fields
 * @param childNodes - An Array of allowed child node `text*` or `%ph*`
 */ let $7ff6a1a40f06db3b$var$AltNode = class AltNode extends $7Uewc.AbstractBaseNode {
};
module.exports.AltNode = $7ff6a1a40f06db3b$var$AltNode;
module.exports.AltNode = $7ff6a1a40f06db3b$var$AltNode = $7ff6a1a40f06db3b$var$__decorate([
    (0, $7Uewc.makeComponent)($7ff6a1a40f06db3b$var$makeAlt, "alt", module.exports.isValidAltField, module.exports.AltFields, [
        [
            "text*",
            "%ph*"
        ]
    ])
], $7ff6a1a40f06db3b$var$AltNode);

});
parcelRegister("kCEGt", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isLocalizationNode = module.exports.LocalizationFields = void 0;
module.exports.isValidLocalizationField = $f036ea41469e56be$var$isValidLocalizationField;
module.exports.makeLocalization = $f036ea41469e56be$var$makeLocalization;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * `LocalizationFields`: `dir`, `xml:lang`, `translate`
 */ module.exports.LocalizationFields = [
    "dir",
    "xml:lang",
    "translate"
];
/**
 * Check if the given attributes of the `localization` node are valid and match this list:
 * @see {@link LocalizationFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $f036ea41469e56be$var$isValidLocalizationField(field, value) {
    switch(field){
        case "dir":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "xml:lang":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "translate":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `localization` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `localization` node to test
 * @returns Boolean
 */ const $f036ea41469e56be$var$isLocalizationNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.LocalizationFields, value, $f036ea41469e56be$var$isValidLocalizationField);
module.exports.isLocalizationNode = $f036ea41469e56be$var$isLocalizationNode;
/**
 * Create a `localization` node with an `dir`, `xml:lang`, `translate` attribute
 *
 * @param constructor - The constructor
 * @returns The `localization` node with an `dir`, `xml:lang`, `translate` attribute and their values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f036ea41469e56be$var$makeLocalization(constructor) {
    return class extends constructor {
        get "dir"() {
            return this.readProp("dir");
        }
        set "dir"(value) {
            this.writeProp("dir", value);
        }
        get "xml:lang"() {
            return this.readProp("xml:lang");
        }
        set "xml:lang"(value) {
            this.writeProp("xml:lang", value);
        }
        get "translate"() {
            return this.readProp("translate");
        }
        set "translate"(value) {
            this.writeProp("translate", value);
        }
    };
}

});
parcelRegister("lRuta", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.acceptsNodeName = $041b745e3d1c43b3$var$acceptsNodeName;
module.exports.areFieldsValid = $041b745e3d1c43b3$var$areFieldsValid;
module.exports.has = $041b745e3d1c43b3$var$has;
module.exports.isChildTypeRequired = $041b745e3d1c43b3$var$isChildTypeRequired;
module.exports.isChildTypeSingle = $041b745e3d1c43b3$var$isChildTypeSingle;
module.exports.isOrUndefined = $041b745e3d1c43b3$var$isOrUndefined;
module.exports.splitTypenames = $041b745e3d1c43b3$var$splitTypenames;
module.exports.stringToChildTypes = $041b745e3d1c43b3$var$stringToChildTypes;
/**
 * acceptsNodeName - Check whether a child type accepts a node name
 *
 * @param value - Node name
 * @param childType - String or an ChildType object or an array ChildType objects
 * @param nodeGroups - Node groups
 * @returns ChildType | undefined - returns the ChildType oject if it's accepted or undefined if it's not
 */ function $041b745e3d1c43b3$var$acceptsNodeName(value, childType, nodeGroups) {
    // if child type is an array
    if (Array.isArray(childType)) {
        let result;
        childType.some((type)=>{
            // if any of the children in the array accepts the node name then return true
            result = $041b745e3d1c43b3$var$acceptsNodeName(value, type, nodeGroups);
            if (result) return true;
        });
        return result;
    } else // if child type is not a group
    // then check if the child type name is equal to the value
    // if it's a group check if the value is in the group
    return !childType.isGroup ? childType.name === value ? childType : undefined : $041b745e3d1c43b3$var$has(nodeGroups[childType.name], value) ? childType : undefined;
}
/**
 * areFieldsValid - Attribute validator
 *
 * @param fields - Array of attribute names
 * @param value - Object of attribute values
 * @param validations - Validation functions
 * @returns Boolean - Whether the attributes are valid or not
 */ function $041b745e3d1c43b3$var$areFieldsValid(fields, value, ...validations) {
    for (const field of fields){
        let valid = false;
        for (const validation of validations)if (validation(field, value[field])) {
            valid = true;
            break;
        }
        if (!valid) return false;
    }
    return true;
}
/**
 * has - Check if an array has a value
 *
 * @param array - Array
 * @param value - Value
 * @returns Boolean
 */ function $041b745e3d1c43b3$var$has(array, value) {
    return array.indexOf(value) >= 0;
}
/**
 * isChildTypeRequired - Check if a child is required
 *
 * the required property is denoted by `+` or the lack of `?` in the end of the string
 * This means the child must be present in the node in the order specified by the parent node
 *
 * @param childType -  String or an ChildType object or an array ChildType objects
 * @returns Boolean - Whether the child is required or not
 */ function $041b745e3d1c43b3$var$isChildTypeRequired(childType) {
    // if it's an Array
    if (Array.isArray(childType)) // if one of the children in the array is required then return true
    return childType.some($041b745e3d1c43b3$var$isChildTypeRequired);
    else {
        if (typeof childType === "string") // if it's a string parse it and check if it's required
        return $041b745e3d1c43b3$var$isChildTypeRequired($041b745e3d1c43b3$var$stringToChildTypes(childType));
        // if the oject is already parsed then return the required property
        return !!childType.required;
    }
}
/**
 * isChildTypeSingle - check if the child belongs to a group of elements eg: `list-blocks` or `all-line`
 *
 * @param childType - String or an ChildType object or an array ChildType objects
 * @returns Boolean - Whether the child is a group or not
 */ function $041b745e3d1c43b3$var$isChildTypeSingle(childType) {
    // if it's an Array
    if (Array.isArray(childType)) {
        let result = true;
        // if any of the children in the array is not a single type then return false
        childType.some((type)=>{
            result = $041b745e3d1c43b3$var$isChildTypeSingle(type);
            return !result;
        });
        return result;
    } else {
        // it's a string
        if (typeof childType === "string") // parse the string using `stringToChildTypes` and check if it's a single type
        // single type can be denoted by the lack of `%` in the beginning of the string
        return $041b745e3d1c43b3$var$isChildTypeSingle($041b745e3d1c43b3$var$stringToChildTypes(childType));
        // if the oject is already parsed then return the single property
        return !!childType.single;
    }
}
/**
 * isOrUndefined - Check if a value is undefined or not
 *
 * @param check - Function to check the value
 * @param value - Value
 * @returns - Boolean
 */ function $041b745e3d1c43b3$var$isOrUndefined(check, value) {
    return typeof value === "undefined" || check(value);
}
/**
 * splitTypenames - Converts a string to an array of strings
 * it splits the string by `|`
 *
 * @privateRemarks
 * This is only used in tests
 *
 * @param value - string
 * @returns - String[]
 */ function $041b745e3d1c43b3$var$splitTypenames(value) {
    if (value[0] !== "(") return value.split("|");
    // if the string starts with `(` and ends with `)` then remove them
    const last = value.slice(-1);
    return $041b745e3d1c43b3$var$has([
        "+",
        "*",
        "?"
    ], last) ? value.slice(1, -2).split("|").map((type)=>type + last) : value.slice(1, -1).split("|");
}
/**
 * stringToChildTypes - Convert the array list of string to child objects
 *
 * @remarks
 * `?` - optional
 * `+` - required
 * `*` - optional and multiple
 * `%` - group
 *
 * @param value - String or Array of strings
 * @param topLevel - Entry of the document
 * @returns Array of ChildType objects , @see {@link ChildType}
 */ function $041b745e3d1c43b3$var$stringToChildTypes(value, topLevel = true) {
    if (typeof value === "string") {
        if (value === "") return [];
        if (value.indexOf("|") < 0) {
            const last = value.slice(-1);
            const result = $041b745e3d1c43b3$var$has([
                "+",
                "*",
                "?"
            ], last) ? {
                name: value.slice(0, -1),
                single: last === "?",
                required: last === "+",
                isGroup: false
            } : {
                name: value,
                single: true,
                required: true,
                isGroup: false
            };
            if (result.name[0] === "%") {
                result.name = result.name.substr(1);
                result.isGroup = true;
            }
            return topLevel && !Array.isArray(result) ? [
                result
            ] : result;
        } else return $041b745e3d1c43b3$var$stringToChildTypes($041b745e3d1c43b3$var$splitTypenames(value), false);
    } else return value.map((subType)=>$041b745e3d1c43b3$var$stringToChildTypes(subType, false)).filter((type)=>!Array.isArray(type) || type.length > 0);
} // NOTE(AR) these functions appear to be unused but could be helpful in the near future, so I have commented them out here!
 // /**
 //  * childTypeToString - Convert a child type to a string
 //  *
 //  * @param type - ChildType object
 //  * @param getNodeName - Get node name function
 //  * @param nodeGroups - Node groups
 //  * @returns - string
 //  */
 // export function childTypeToString(type: ChildType, nodeGroups: Record<string, string[]>, getNodeName?: (nodeName: string) => string): string {
 //     return (type.isGroup
 //         ? nodeGroups[type.name].length === 1
 //             ? (getNodeName
 //                 ? nodeGroups[type.name].map(getNodeName)
 //                 : nodeGroups[type.name]
 //             ).join('|')
 //             : '(' + (getNodeName
 //                 ? nodeGroups[type.name].map(getNodeName)
 //                 : nodeGroups[type.name]
 //             ).join('|') + ')'
 //         : getNodeName ? getNodeName(type.name) : type.name
 //     ) + (type.single
 //         ? type.required ? '' : '?'
 //         : type.required ? '+' : '*');
 // }
 //
 // /**
 //  * customChildTypesToString - Serialize a child type object to a string with a custom function to get the node name
 //  *
 //  * @param type - ChildType Array
 //  * @param nodeGroups - Node groups
 //  * @param getNodeName - function to get the node name
 //  * @param topLevel - start of the document
 //  * @returns string - Serialized ChildType Array
 //  */
 // export function customChildTypesToString(type: ChildTypes, nodeGroups: Record<string, string[]>, getNodeName?: (nodeName: string) => string, topLevel = true): string {
 //     if (Array.isArray(type)) {
 //         const types = type.map(subType => customChildTypesToString(subType, nodeGroups, getNodeName, false)).join('|');
 //         return topLevel || type.length === 1 ? types : '(' + types + ')';
 //     } else {
 //         return childTypeToString(type, nodeGroups, getNodeName)
 //     }
 // }
 //
 // /**
 //  * childTypesToString - Serialize a child type object to a string
 //  *
 //  * @param type - ChildType Array
 //  * @param nodeGroups - Node groups
 //  * @param topLevel - start of the document
 //  * @returns string - Serialized ChildType Array
 //  */
 // export function childTypesToString(type: ChildTypes, nodeGroups: Record<string, string[]>, topLevel = true): string {
 //     return customChildTypesToString(type, nodeGroups, undefined, topLevel);
 // }
 //
 // /**
 //  * childTypesArray - Check whether the child types is an array or not and return an array
 //  *
 //  * @param childTypes - ChildType array or ChildType object
 //  * @returns - ChildType array
 //  */
 // export function childTypesArray(childTypes: ChildTypes): ChildTypes[] {
 //     return Array.isArray(childTypes) ? childTypes : [childTypes];
 // }

});


parcelRegister("c7Ayi", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isVariableContentNode = module.exports.VariableContentFields = void 0;
module.exports.isValidVariableContentField = $8d327dfb599d1576$var$isValidVariableContentField;
module.exports.makeVariableContent = $8d327dfb599d1576$var$makeVariableContent;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `variable-content` attributes:
 * The only allowed field is `keyref`
 */ module.exports.VariableContentFields = [
    "keyref"
];
/**
 * Check if the attributes `keyref` of the `variable-content` node is valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ function $8d327dfb599d1576$var$isValidVariableContentField(field, value) {
    switch(field){
        case "keyref":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `variable-content` node is valid
 *
 * @remarks
 * Assert that the node is an object and has a valid attribute
 *
 * @param value - The `variable-content` node to test
 * @returns Boolean
 */ const $8d327dfb599d1576$var$isVariableContentNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.VariableContentFields, value, $8d327dfb599d1576$var$isValidVariableContentField);
module.exports.isVariableContentNode = $8d327dfb599d1576$var$isVariableContentNode;
/**
 * Create a `variable-content` node with a `keyref` attribute
 *
 * @param constructor - The constructor
 * @returns The `variable-content` node with a `keyref` attribute and its value
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8d327dfb599d1576$var$makeVariableContent(constructor) {
    return class extends constructor {
        get "keyref"() {
            return this.readProp("keyref");
        }
        set "keyref"(value) {
            this.writeProp("keyref", value);
        }
    };
}

});

parcelRegister("gT0BI", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClassNode = module.exports.ClassFields = void 0;
module.exports.isValidClassField = $c4b24103193e67d1$var$isValidClassField;
module.exports.makeClass = $c4b24103193e67d1$var$makeClass;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * ClassFields (universal attributes): `outputclass`, `class`
 */ module.exports.ClassFields = [
    "outputclass",
    "class"
];
/**
 * Check if the attributes `outputclass`, `class` are valid
 *
 * @see {@link ClassFields}
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ function $c4b24103193e67d1$var$isValidClassField(field, value) {
    switch(field){
        case "outputclass":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "class":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `class` attribute is valid
 *
 * @param value - The `class` node to test
 * @returns Boolean
 */ const $c4b24103193e67d1$var$isClassNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.ClassFields, value, $c4b24103193e67d1$var$isValidClassField);
module.exports.isClassNode = $c4b24103193e67d1$var$isClassNode;
/**
 * Create a `class` node (universal attribute)
 * This will be transformed to an LwDita attribute e.g. `class=""`
 *
 * @see {@link https://dita-lang.org/lwdita/commonspec/specification/langref/attributes/attribute-groups#attribute-groups__universal-attributes}
 *
 * @param constructor - The constructor
 * @returns The `class` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $c4b24103193e67d1$var$makeClass(constructor) {
    return class extends constructor {
        get "outputclass"() {
            return this.readProp("outputclass");
        }
        set "outputclass"(value) {
            this.writeProp("outputclass", value);
        }
        get "class"() {
            return this.readProp("class");
        }
        set "class"(value) {
            this.writeProp("class", value);
        }
    };
}

});

parcelRegister("7Uewc", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbstractBaseNode = void 0;
module.exports.makeAll = $5c1906624309bbdc$var$makeAll;
module.exports.makeComponent = $5c1906624309bbdc$var$makeComponent;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");

var $6vT1r = parcelRequire("6vT1r");
/**
 * The base class for all nodes.
 */ class $5c1906624309bbdc$var$AbstractBaseNode {
    constructor(attributes){
        if (attributes) // `_props` - these are the attributes provided by the parser
        this._props = this.static.attributesToProps(attributes);
    }
    /**
     * `attributesToProps` - Converts attributes to properties
     * Loops through all of the node attributes retrieved from the parser,
     * then gets their values from attributes,
     * and returns an object with all attributes an values.
     *
     * @param attributes - Attributes of the node
     * @returns An object with the record of properties
     */ static attributesToProps(attributes = {}) {
        const result = {};
        // loop through all node attributes and get their values
        this.fields.forEach((field)=>{
            const attr = attributes[field];
            // `attr` can be a string or an object with value
            result[field] = typeof attr === "string" ? attr : attr === null || attr === void 0 ? void 0 : attr.value;
        });
        return result;
    }
    /**
     * `isValidField` - This is a function template for validation of attributes
     *
     * @param field - A string containing the attribute name
     * @param value - A BasicValue-typed value containing the attribute value
     * @returns Boolean
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static isValidField(field, value) {
        return true;
    }
    get static() {
        return this.constructor;
    }
    get children() {
        return this._children || [];
    }
    get json() {
        var _a;
        return {
            nodeName: this.static.nodeName,
            attributes: this._props,
            children: (_a = this._children) === null || _a === void 0 ? void 0 : _a.map((child)=>child.json)
        };
    }
    canAddNode(child) {
        const childNodeName = child.static.nodeName;
        return this.canAdd(childNodeName);
    }
    canAdd(childNodeName) {
        var _a;
        let childType;
        let iChild = -1;
        // loop through all of the allowed child types and check if the child node name is accepted
        // `this.static.childTypes`, e.g. allowed children: `['%list-blocks*', 'section*', 'fn*']`
        this.static.childTypes.some((type, i)=>{
            childType = (0, $lRuta.acceptsNodeName)(childNodeName, type, $6vT1r.nodeGroups);
            if (childType) {
                iChild = i;
                return true;
            }
        });
        // If the child is not contained in the list `childTypes` it will be rejected
        if (!childType) return false;
        // get the last child of the parent nodename
        const last = ((_a = this.children) === null || _a === void 0 ? void 0 : _a.length) ? this.children[this.children.length - 1].static.nodeName : "";
        let iLast = -1;
        // if we do have a last child
        if (last) {
            // get the index of the last child in the list of allowed children
            iLast = this.static.childTypes.findIndex((type)=>(0, $lRuta.acceptsNodeName)(last, type, $6vT1r.nodeGroups));
            // if the child index is less than the last index, it can't be added
            // this ensures the correct and valid outline
            if (iLast > iChild) return false;
            // if the child index is equal to the last index, it can't be added if the child type is single
            // this ensure that there will be no duplication in an invalid manner
            if (iLast === iChild) {
                // if we have two of the same elements they can't be added
                // e.g. `<body>` and `<body>` within parent `<topic>`
                // you can tell if the element is single by checking the allowed children list `childNodes` and look for ? symbol
                if ((0, $lRuta.isChildTypeSingle)(this.static.childTypes[iChild])) return false;
                return true;
            }
        }
        // if the child index is greater than last index,
        // it can't be added if there are required child types between them
        const typesBetween = this.static.childTypes.slice(iLast + 1, iChild);
        // to check if a child type is required, check the allowed children list `childNodes`
        // and look for a child without `?` symbols at the end
        // e.g. `'title'` in this list: `['title', 'shortdesc?', 'prolog?', 'body?']`
        if (typesBetween.find($lRuta.isChildTypeRequired)) return false;
        return true;
    }
    add(child, breakOnError = true) {
        // If there are no children, initialize an empty array
        if (!this._children) this._children = [];
        // If there is a child that cannot be added, throw a new error
        if (!this.canAddNode(child)) {
            if (breakOnError) throw new $38z30.NonAcceptedChildError(`"${child.static.nodeName}" node can't be a child of "${this.static.nodeName}" node`);
            return;
        }
        // Else add the child to the document tree
        this._children.push(child);
    }
    readProp(field) {
        if (this.static.fields.indexOf(field) < 0) throw new $38z30.UnknownAttributeError('unknown attribute "' + field + '"');
        return this._props[field];
    }
    writeProp(field, value) {
        // If the attribute is identified as false then return error message
        if (this.static.fields.indexOf(field) < 0) throw new $38z30.UnknownAttributeError('unknown attribute "' + field + '"');
        // If the attribute is known but doesn't match the element, return error message
        if (!this.static.isValidField(field, value)) throw new $38z30.WrongAttributeTypeError('wrong attribute type "' + typeof value + '" for field"' + field + '"');
        // Else add attribute to element and document tree
        this._props[field] = value;
    }
    getProps() {
        return this._props;
    }
    allowsMixedContent() {
        return this.canAdd("text");
    }
}
module.exports.AbstractBaseNode = $5c1906624309bbdc$var$AbstractBaseNode;
// `nodeName` means node type (e.g. "image", "alt", "body", etc.)
$5c1906624309bbdc$var$AbstractBaseNode.nodeName = "node";
/**
 * `makeAll` - This is a template function for all nodes
 *
 * @param constructor - The constructor
 * @param decorators - The decorator
 * @returns Instance of BaseNode
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5c1906624309bbdc$var$makeAll(constructor, ...decorators) {
    return decorators.reduce((result, decorator)=>decorator(result), constructor);
}
/**
 * `makeComponent` -  A function that returns the constructor of a node
 *
 * @privateRemarks
 * The concept or processing of `decorator` is not yet fully understood
 *
 * @param decorator - The decorator
 * @param nodeName - A string containing the node name
 * @param fieldValidator -
 * @param fields - A List of attributes
 * @param childTypes - An Array of allowed child nodes
 * @returns The constructor function of an instance of BaseNode
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5c1906624309bbdc$var$makeComponent(decorator, nodeName, fieldValidator, fields, childTypes = []) {
    return (constructor)=>{
        var _a;
        return decorator((_a = class extends constructor {
        }, _a.nodeName = nodeName, _a.fields = fields, // These will get parsed when being set in the constructor
        _a.childTypes = (0, $lRuta.stringToChildTypes)(childTypes), _a.isValidField = fieldValidator, _a));
    };
}

});
parcelRegister("6vT1r", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nodeGroups = void 0;
/**
 * Phrase elements group
 *
 * @see {@link https://github.com/oasis-tcs/dita-lwdita/blob/b2985f254746b2614c1b9d6a5e6043f82335506f/org.oasis.xdita/dtd/lw-topic.dtd#L50}
 */ const $4be05195ab860301$var$phGroup = [
    "b",
    "em",
    "i",
    "ph",
    "strong",
    "sub",
    "sup",
    "tt",
    "u"
];
/**
 * Content groups
 *
 * @see {@link https://github.com/oasis-tcs/dita-lwdita/blob/f267f1e8eac5d41703eef950770e62a8972b5cd6/org.oasis.xdita/dtd/lw-common.ent#L20-L40}
 */ module.exports.nodeGroups = {
    "ph": $4be05195ab860301$var$phGroup,
    "inline.noimage": [
        "cdata",
        "text",
        ...$4be05195ab860301$var$phGroup,
        "xref"
    ],
    "inline.noxref": [
        "cdata",
        "text",
        ...$4be05195ab860301$var$phGroup,
        "image"
    ],
    "inline": [
        "cdata",
        "text",
        ...$4be05195ab860301$var$phGroup,
        "image",
        "xref"
    ],
    "simple-blocks": [
        "p",
        "ul",
        "ol",
        "dl",
        "pre",
        "audio",
        "video",
        "example",
        "note"
    ],
    "fn-blocks": [
        "p",
        "ul",
        "ol",
        "dl"
    ],
    "all-blocks": [
        "p",
        "ul",
        "ol",
        "dl",
        "pre",
        "audio",
        "video",
        "example",
        "simpletable",
        "fig",
        "note"
    ],
    "list-blocks": [
        "p",
        "ul",
        "ol",
        "dl",
        "pre",
        "audio",
        "video",
        "example",
        "simpletable",
        "fig",
        "note"
    ],
    "fig-blocks": [
        "p",
        "ul",
        "ol",
        "dl",
        "pre",
        "audio",
        "video",
        "example",
        "simpletable"
    ],
    "example-blocks": [
        "p",
        "ul",
        "ol",
        "dl",
        "pre",
        "audio",
        "video",
        "simpletable",
        "fig",
        "note"
    ],
    "fallback-blocks": [
        "image",
        "alt",
        "p",
        "ul",
        "ol",
        "dl",
        "pre",
        "note"
    ]
};

});



parcelRegister("l2MDk", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $f51f826ef9e1928c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AudioNode = module.exports.isAudioNode = module.exports.AudioFields = void 0;
module.exports.isValidAudioField = $f51f826ef9e1928c$var$isValidAudioField;
module.exports.makeAudio = $f51f826ef9e1928c$var$makeAudio;

var $22qJU = parcelRequire("22qJU");

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");

var $c7Ayi = parcelRequire("c7Ayi");

var $3rAp4 = parcelRequire("3rAp4");
/**
 * Define all allowed `audio` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `keyref`, `id`, `conref`, `outputclass`, `class`, `href`,
 * `format`, `scope`, `autoplay`, `controls`, `loop`, `muted`, `tabindex`
 */ module.exports.AudioFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$c7Ayi.VariableContentFields,
    ...$3rAp4.ReferenceContentFields,
    ...$gT0BI.ClassFields,
    "autoplay",
    "controls",
    "loop",
    "muted",
    "tabindex"
];
/**
 * Check if the given attributes of the `audio` node are valid and match this list:
 * `props`, `dir`, `xml:lang`, `translate`, `keyref`, `id`, `conref`, `outputclass`,
 * `class`, `href`, `format`, `scope`, `autoplay`, `controls`, `loop`, `muted`, `tabindex`
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $f51f826ef9e1928c$var$isValidAudioField(field, value) {
    if ((0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value)) return true;
    switch(field){
        case "autoplay":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "controls":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "loop":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "muted":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "tabindex":
            return (0, $lRuta.isOrUndefined)($38z30.isNMTOKEN, value);
        default:
            return false;
    }
}
/**
 * Check if the `audio` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `audio` node to test
 * @returns Boolean
 */ const $f51f826ef9e1928c$var$isAudioNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.AudioFields, value, $f51f826ef9e1928c$var$isValidAudioField);
module.exports.isAudioNode = $f51f826ef9e1928c$var$isAudioNode;
/**
 * Construct an `audio` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `audio` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f51f826ef9e1928c$var$makeAudio(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "autoplay"() {
            return this.readProp("autoplay");
        }
        set "autoplay"(value) {
            this.writeProp("autoplay", value);
        }
        get "controls"() {
            return this.readProp("controls");
        }
        set "controls"(value) {
            this.writeProp("controls", value);
        }
        get "loop"() {
            return this.readProp("loop");
        }
        set "loop"(value) {
            this.writeProp("loop", value);
        }
        get "muted"() {
            return this.readProp("muted");
        }
        set "muted"(value) {
            this.writeProp("muted", value);
        }
        get "tabindex"() {
            return this.readProp("tabindex");
        }
        set "tabindex"(value) {
            this.writeProp("tabindex", value);
        }
    }, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $3rAp4.makeReferenceContent, $gT0BI.makeClass);
}
/**
 * Create an `audio` node
 *
 * @decorator `@makeComponent`
 * @param makeAudio - The `audio` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidAudioField - A boolean value, if the attribute is valid or not
 * @param AudioFields - An array containing all valid attribute names
 * @param childNodes - An array containing all valid child node names: (`desc?`, `fallback?`, `media-source*`, `media-track*`)*
 */ let $f51f826ef9e1928c$var$AudioNode = class AudioNode extends $7Uewc.AbstractBaseNode {
};
module.exports.AudioNode = $f51f826ef9e1928c$var$AudioNode;
module.exports.AudioNode = $f51f826ef9e1928c$var$AudioNode = $f51f826ef9e1928c$var$__decorate([
    (0, $7Uewc.makeComponent)($f51f826ef9e1928c$var$makeAudio, "audio", $f51f826ef9e1928c$var$isValidAudioField, module.exports.AudioFields, [
        "desc?",
        "fallback?",
        "media-source*",
        "media-track*"
    ])
], $f51f826ef9e1928c$var$AudioNode);

});
parcelRegister("22qJU", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFiltersNode = module.exports.FiltersFields = void 0;
module.exports.isValidFiltersField = $17c0829274258ea3$var$isValidFiltersField;
module.exports.makeFilters = $17c0829274258ea3$var$makeFilters;

var $lRuta = parcelRequire("lRuta");

var $4b9pi = parcelRequire("4b9pi");

var $38z30 = parcelRequire("38z30");
/**
 * FiltersFields: `props`
 */ module.exports.FiltersFields = [
    ...$4b9pi.FiltersAddsFields,
    "props"
];
/**
 * Check if the given fields of the `filter` node are valid and matches this list:
 * @see {@link FiltersFields}
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ function $17c0829274258ea3$var$isValidFiltersField(field, value) {
    switch(field){
        case "props":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `filter` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `filter` node to test
 * @returns Boolean
 */ const $17c0829274258ea3$var$isFiltersNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.FiltersFields, value, $17c0829274258ea3$var$isValidFiltersField);
module.exports.isFiltersNode = $17c0829274258ea3$var$isFiltersNode;
/**
 * Create a `filter` node with an `props` attribute
 *
 * @param constructor - The constructor
 * @returns The `filter` node with an `props` attribute and their values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $17c0829274258ea3$var$makeFilters(constructor) {
    return class extends constructor {
        get "props"() {
            return this.readProp("props");
        }
        set "props"(value) {
            this.writeProp("props", value);
        }
    };
}

});
parcelRegister("4b9pi", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFiltersAddsNode = module.exports.FiltersAddsFields = void 0;
/**
 * FiltersAddsNode are empty
 */ module.exports.FiltersAddsFields = [];
const $30af7c8ce5cb2ab3$var$isFiltersAddsNode = (value)=>typeof value === "object" && !!value;
module.exports.isFiltersAddsNode = $30af7c8ce5cb2ab3$var$isFiltersAddsNode;

});


parcelRegister("dAWNe", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isReuseNode = module.exports.ReuseFields = void 0;
module.exports.isValidReuseField = $9e5c3e35ec9cc0df$var$isValidReuseField;
module.exports.makeReuse = $9e5c3e35ec9cc0df$var$makeReuse;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `reuse` attributes:
 * `id`, `conref`
 */ module.exports.ReuseFields = [
    "id",
    "conref"
];
/**
 * Check if the given attributes of the `reuse` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $9e5c3e35ec9cc0df$var$isValidReuseField(field, value) {
    switch(field){
        case "id":
            return (0, $lRuta.isOrUndefined)($38z30.isNMTOKEN, value);
        case "conref":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `reuse` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `reuse` node to test
 * @returns Boolean
 */ const $9e5c3e35ec9cc0df$var$isReuseNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.ReuseFields, value, $9e5c3e35ec9cc0df$var$isValidReuseField);
module.exports.isReuseNode = $9e5c3e35ec9cc0df$var$isReuseNode;
/**
 * Create a `reuse` node with an `id` and `conref` attribute
 *
 * @param constructor - The constructor
 * @returns The `reuse` node with an `id` and `conref` attribute and their values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9e5c3e35ec9cc0df$var$makeReuse(constructor) {
    return class extends constructor {
        get "id"() {
            return this.readProp("id");
        }
        set "id"(value) {
            this.writeProp("id", value);
        }
        get "conref"() {
            return this.readProp("conref");
        }
        set "conref"(value) {
            this.writeProp("conref", value);
        }
    };
}

});

parcelRegister("3rAp4", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isReferenceContentNode = module.exports.ReferenceContentFields = void 0;
module.exports.isValidReferenceContentField = $282021a3c4c67e5d$var$isValidReferenceContentField;
module.exports.makeReferenceContent = $282021a3c4c67e5d$var$makeReferenceContent;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
module.exports.ReferenceContentFields = [
    "href",
    "format",
    "scope"
];
function $282021a3c4c67e5d$var$isValidReferenceContentField(field, value) {
    switch(field){
        case "href":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "format":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "scope":
            return (0, $lRuta.isOrUndefined)($38z30.isReferenceContentScope, value);
        default:
            return false;
    }
}
const $282021a3c4c67e5d$var$isReferenceContentNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.ReferenceContentFields, value, $282021a3c4c67e5d$var$isValidReferenceContentField);
module.exports.isReferenceContentNode = $282021a3c4c67e5d$var$isReferenceContentNode;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $282021a3c4c67e5d$var$makeReferenceContent(constructor) {
    return class extends constructor {
        get "href"() {
            return this.readProp("href");
        }
        set "href"(value) {
            this.writeProp("href", value);
        }
        get "format"() {
            return this.readProp("format");
        }
        set "format"(value) {
            this.writeProp("format", value);
        }
        get "scope"() {
            return this.readProp("scope");
        }
        set "scope"(value) {
            this.writeProp("scope", value);
        }
    };
}

});


parcelRegister("bxKqZ", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $8676cba69c4be906$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BodyNode = module.exports.isBodyNode = module.exports.isValidBodyField = module.exports.BodyFields = void 0;
module.exports.makeBody = $8676cba69c4be906$var$makeBody;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `body` attributes:
 * `dir`, `xml:lang`, `translate`, `outputclass`, `class`
 */ module.exports.BodyFields = [
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `body` node are valid and match this list:
 * `dir`, `xml:lang`, `translate`, `outputclass`, `class`
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $8676cba69c4be906$var$isValidBodyField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidBodyField = $8676cba69c4be906$var$isValidBodyField;
/**
 * Check if the `body` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `body` node to test
 * @returns Boolean
 */ const $8676cba69c4be906$var$isBodyNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.BodyFields, value, module.exports.isValidBodyField);
module.exports.isBodyNode = $8676cba69c4be906$var$isBodyNode;
/**
 * Construct a `body` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `body` node
 * */ function $8676cba69c4be906$var$makeBody(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $gT0BI.makeClass);
}
/**
 * Create a `body` node (link) and map the `body` node with the LwDita tag name `div`
 *
 * @decorator `@makeComponent`
 * @param makeBody - The `Body` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidBodyField - A boolean value, if the attribute is valid or not
 * @param BodyFields - An array containing all valid attribute names
 * @param childNodes - An array containing all valid child node names: `%list-blocks*`, `section*`, `div?` (`p`,`ul`, `ol`, `dl`, `pre`, `audio`, `video`, `example`, `simpletable`, `fig`, `note`)
 */ let $8676cba69c4be906$var$BodyNode = class BodyNode extends $7Uewc.AbstractBaseNode {
};
module.exports.BodyNode = $8676cba69c4be906$var$BodyNode;
$8676cba69c4be906$var$BodyNode.domNodeName = "div";
module.exports.BodyNode = $8676cba69c4be906$var$BodyNode = $8676cba69c4be906$var$__decorate([
    (0, $7Uewc.makeComponent)($8676cba69c4be906$var$makeBody, "body", module.exports.isValidBodyField, module.exports.BodyFields, [
        "%list-blocks*",
        "section*",
        "div?"
    ])
], $8676cba69c4be906$var$BodyNode);

});

parcelRegister("ijj0O", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $d548bfc36bc1c022$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BoldNode = module.exports.isBoldNode = module.exports.isValidBoldField = module.exports.BoldFields = void 0;
module.exports.makeBold = $d548bfc36bc1c022$var$makeBold;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `bold` attributes:
 * `dir`, `xml:lang`, `translate`, `keyref`, `outputclass`, `class`
 */ module.exports.BoldFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `bold` node are valid and match this list:
 * @see {@link BoldFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $d548bfc36bc1c022$var$isValidBoldField = (field, value)=>(0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidBoldField = $d548bfc36bc1c022$var$isValidBoldField;
/**
 * Check if the `bold` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `bold` node to test
 * @returns Boolean
 */ const $d548bfc36bc1c022$var$isBoldNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.BoldFields, value, module.exports.isValidBoldField);
module.exports.isBoldNode = $d548bfc36bc1c022$var$isBoldNode;
/**
 * Construct a `bold` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `bold` node
 * */ function $d548bfc36bc1c022$var$makeBold(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `bold` node (link) and map the `bold` node with the LwDita tag name `b`
 *
 * @decorator `@makeComponent`
 * @param makeBold - The `Bold` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidBodyField - A boolean value, if the attribute is valid or not
 * @param BodyFields - An array containing all valid attribute names
 * @param childNodes - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
*/ let $d548bfc36bc1c022$var$BoldNode = class BoldNode extends $7Uewc.AbstractBaseNode {
};
module.exports.BoldNode = $d548bfc36bc1c022$var$BoldNode;
$d548bfc36bc1c022$var$BoldNode.domNodeName = "b";
module.exports.BoldNode = $d548bfc36bc1c022$var$BoldNode = $d548bfc36bc1c022$var$__decorate([
    (0, $7Uewc.makeComponent)($d548bfc36bc1c022$var$makeBold, "b", module.exports.isValidBoldField, module.exports.BoldFields, [
        "%inline.noimage*"
    ])
], $d548bfc36bc1c022$var$BoldNode);

});

parcelRegister("9AVDl", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $6fc42eb3de84520a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DdNode = module.exports.isDdNode = module.exports.isValidDdField = module.exports.DdFields = void 0;
module.exports.makeDd = $6fc42eb3de84520a$var$makeDd;

var $22qJU = parcelRequire("22qJU");

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $dAWNe = parcelRequire("dAWNe");
/**
 * Define all allowed `dd` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.DdFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `dd` node are valid and match this list:
 * @see {@link DdFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $6fc42eb3de84520a$var$isValidDdField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidDdField = $6fc42eb3de84520a$var$isValidDdField;
/**
 * Check if the `dd` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `dd` node to test
 * @returns Boolean
 */ const $6fc42eb3de84520a$var$isDdNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.DdFields, value, module.exports.isValidDdField);
module.exports.isDdNode = $6fc42eb3de84520a$var$isDdNode;
/**
 * Construct a `dd` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `dd` node
 */ function $6fc42eb3de84520a$var$makeDd(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `dd` (Description) node
 *
 * @decorator `@makeComponent`
 * @param makeDd - The `dd` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidDdField - A boolean value, if the attribute is valid or not
 * @param DdFields - An array containing all valid attribute names, @see {@link DdFields}
 * @param childNodes - An array containing all valid child node names: `%list-blocks*` (`p`,`ul`, `ol`, `dl`, `pre`, `audio`, `video`, `example`, `simpletable`, `fig`, `note`)
 * @returns A `dd` node
 */ let $6fc42eb3de84520a$var$DdNode = class DdNode extends $7Uewc.AbstractBaseNode {
};
module.exports.DdNode = $6fc42eb3de84520a$var$DdNode;
$6fc42eb3de84520a$var$DdNode.domNodeName = "dd";
module.exports.DdNode = $6fc42eb3de84520a$var$DdNode = $6fc42eb3de84520a$var$__decorate([
    (0, $7Uewc.makeComponent)($6fc42eb3de84520a$var$makeDd, "dd", module.exports.isValidDdField, module.exports.DdFields, [
        "%list-blocks*"
    ])
], $6fc42eb3de84520a$var$DdNode);

});

parcelRegister("9KUto", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $71a43752048348ec$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DescNode = module.exports.isDescNode = module.exports.isValidDescField = module.exports.DescFields = void 0;
module.exports.makeDesc = $71a43752048348ec$var$makeDesc;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `desc` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `outputclass`, `class`,
 */ module.exports.DescFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `desc` node are valid and match this list:
 * See {@link DescFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $71a43752048348ec$var$isValidDescField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidDescField = $71a43752048348ec$var$isValidDescField;
/**
 * Check if the `desc` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `desc` node to test
 * @returns Boolean
 */ const $71a43752048348ec$var$isDescNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.DescFields, value, module.exports.isValidDescField);
module.exports.isDescNode = $71a43752048348ec$var$isDescNode;
/**
 * Construct a `desc` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `desc` node
 */ function $71a43752048348ec$var$makeDesc(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $gT0BI.makeClass);
}
/**
 * Create a `desc` (Description) node
 *
 * @privateRemarks
 * TODO: Implement caption/figcaption
 *
 * @decorator `@makeComponent`
 * @param makeDesc - The `Desc` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidDescField - A boolean value, if the attribute is valid or not
 * @param DescFields - An array containing all valid attribute names @see {@link DescFields}
 * @param childNodes - An array containing all valid child node names: `%inline.noxref*` (`text`, `b`, `em`,  `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `image`)
 * @returns A `desc` node
 */ let $71a43752048348ec$var$DescNode = class DescNode extends $7Uewc.AbstractBaseNode {
};
module.exports.DescNode = $71a43752048348ec$var$DescNode;
$71a43752048348ec$var$DescNode.domNodeName = "caption";
module.exports.DescNode = $71a43752048348ec$var$DescNode = $71a43752048348ec$var$__decorate([
    (0, $7Uewc.makeComponent)($71a43752048348ec$var$makeDesc, "desc", module.exports.isValidDescField, module.exports.DescFields, [
        "%inline.noxref*"
    ])
], $71a43752048348ec$var$DescNode);

});

parcelRegister("1wL3m", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $11cd4761a4a2f28b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DivNode = module.exports.isDivNode = module.exports.isValidDivField = module.exports.DivFields = void 0;
module.exports.makeDiv = $11cd4761a4a2f28b$var$makeDiv;

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `div` (Division) fields:
 * `dir`, `xml:lang`, `translate`, `props`, `outputclass`, `class`
 */ module.exports.DivFields = [
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given fields of the `div` node are valid and matches this list:
 * `dir`, `xml:lang`, `translate`, `props`, `outputclass`, `class`
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $11cd4761a4a2f28b$var$isValidDivField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidDivField = $11cd4761a4a2f28b$var$isValidDivField;
/**
 * Check if the `div` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `div` node to test
 * @returns Boolean
 */ const $11cd4761a4a2f28b$var$isDivNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.DivFields, value, module.exports.isValidDivField);
module.exports.isDivNode = $11cd4761a4a2f28b$var$isDivNode;
/**
 * Construct a `div` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `div` node
 */ function $11cd4761a4a2f28b$var$makeDiv(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $gT0BI.makeClass);
}
/**
 * Create a `div` node
 *
 * @decorator `@makeComponent`
 * @param makeDiv - The `div` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidDivField - A boolean value, if the field is valid or not
 * @param fields - A List of valid fields
 * @param childNodes - An Array of allowed child node `fn+`
 */ let $11cd4761a4a2f28b$var$DivNode = class DivNode extends $7Uewc.AbstractBaseNode {
};
module.exports.DivNode = $11cd4761a4a2f28b$var$DivNode;
module.exports.DivNode = $11cd4761a4a2f28b$var$DivNode = $11cd4761a4a2f28b$var$__decorate([
    (0, $7Uewc.makeComponent)($11cd4761a4a2f28b$var$makeDiv, "div", module.exports.isValidDivField, module.exports.DivFields, [
        "fn+"
    ])
], $11cd4761a4a2f28b$var$DivNode);

});

parcelRegister("lvlE5", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $fa7d489ab5df7ccc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DlEntryNode = module.exports.isDlEntryNode = module.exports.isValidDlEntryField = module.exports.DlEntryFields = void 0;
module.exports.makeDlEntry = $fa7d489ab5df7ccc$var$makeDlEntry;

var $22qJU = parcelRequire("22qJU");

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $dAWNe = parcelRequire("dAWNe");
/**
 * Define all allowed `dlentry` fields:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.DlEntryFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `dlentry` node are valid and match this list:
 * @see {@link DlEntryFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $fa7d489ab5df7ccc$var$isValidDlEntryField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidDlEntryField = $fa7d489ab5df7ccc$var$isValidDlEntryField;
/**
 * Check if the `display` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `display` node to test
 * @returns Boolean
 */ const $fa7d489ab5df7ccc$var$isDlEntryNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.DlEntryFields, value, module.exports.isValidDlEntryField);
module.exports.isDlEntryNode = $fa7d489ab5df7ccc$var$isDlEntryNode;
/**
 * Construct a `dlentry` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `dlentry` node
 */ function $fa7d489ab5df7ccc$var$makeDlEntry(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `dlentry` (Description entry) node
 *
 * @decorator `@makeComponent`
 * @param makeDlEntry - The `dlEntry` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidDlEntryField - A boolean value, if the attribute is valid or not
 * @param DlEntryFields - An array containing all valid attribute names @see {@link DlEntryFields}
 * @param childNodes - An array containing all valid child node names: `dt`, `dd`
 * @returns A `dlentry` node
 */ let $fa7d489ab5df7ccc$var$DlEntryNode = class DlEntryNode extends $7Uewc.AbstractBaseNode {
};
module.exports.DlEntryNode = $fa7d489ab5df7ccc$var$DlEntryNode;
$fa7d489ab5df7ccc$var$DlEntryNode.domNodeName = "";
module.exports.DlEntryNode = $fa7d489ab5df7ccc$var$DlEntryNode = $fa7d489ab5df7ccc$var$__decorate([
    (0, $7Uewc.makeComponent)($fa7d489ab5df7ccc$var$makeDlEntry, "dlentry", module.exports.isValidDlEntryField, module.exports.DlEntryFields, [
        "dt",
        "dd"
    ])
], $fa7d489ab5df7ccc$var$DlEntryNode);

});

parcelRegister("4ehFq", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $31462c92bee2fe4c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DlNode = module.exports.isDlNode = module.exports.isValidDlField = module.exports.DlFields = void 0;
module.exports.makeDl = $31462c92bee2fe4c$var$makeDl;

var $22qJU = parcelRequire("22qJU");

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `dl` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.DlFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `dl` node are valid and match this list:
 * @see {@link DlFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $31462c92bee2fe4c$var$isValidDlField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidDlField = $31462c92bee2fe4c$var$isValidDlField;
/**
 * Check if the `dl` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `dl` node to test
 * @returns Boolean
 */ const $31462c92bee2fe4c$var$isDlNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.DlFields, value, module.exports.isValidDlField);
module.exports.isDlNode = $31462c92bee2fe4c$var$isDlNode;
/**
 * Construct a `dl` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `dl` node
 */ function $31462c92bee2fe4c$var$makeDl(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `dl` (Description list) node
 *
 * @decorator `@makeComponent`
 * @param makeDl - The `dl` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidDlField - A boolean value, if the attribute is valid or not
 * @param DlFields - An array containing all valid attribute names @see {@link DlFields}
 * @param childNodes - An array containing all valid child node names: `dlentry+`
 * @returns A `dl` node
 */ let $31462c92bee2fe4c$var$DlNode = class DlNode extends $7Uewc.AbstractBaseNode {
};
module.exports.DlNode = $31462c92bee2fe4c$var$DlNode;
$31462c92bee2fe4c$var$DlNode.domNodeName = "dl";
module.exports.DlNode = $31462c92bee2fe4c$var$DlNode = $31462c92bee2fe4c$var$__decorate([
    (0, $7Uewc.makeComponent)($31462c92bee2fe4c$var$makeDl, "dl", module.exports.isValidDlField, module.exports.DlFields, [
        "dlentry+"
    ])
], $31462c92bee2fe4c$var$DlNode);

});

parcelRegister("a6Brx", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $75b7825d1155bb44$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DtNode = module.exports.isDtNode = module.exports.isValidDtField = module.exports.DtFields = void 0;
module.exports.makeDt = $75b7825d1155bb44$var$makeDt;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $dAWNe = parcelRequire("dAWNe");
/**
 * Define all allowed `dt` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.DtFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `dt` node are valid and match this list:
 * @see {@link DtFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $75b7825d1155bb44$var$isValidDtField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidDtField = $75b7825d1155bb44$var$isValidDtField;
/**
 * Check if the `dt` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `dt` node to test
 * @returns Boolean
 */ const $75b7825d1155bb44$var$isDtNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.DtFields, value, module.exports.isValidDtField);
module.exports.isDtNode = $75b7825d1155bb44$var$isDtNode;
/**
 * Construct a `dt` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `dt` node
 */ function $75b7825d1155bb44$var$makeDt(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `dt` (Description term) node
 *
 * @decorator `@makeComponent`
 * @param makeDt - The `dt` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidDtField - A boolean value, if the attribute is valid or not
 * @param DtFields - An array containing all valid attribute names @see {@link DtFields}
 * @param childNodes - An array containing all valid child node names: `%inline*` (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `image`, `xref`)
 * @returns A `dt` node
 */ let $75b7825d1155bb44$var$DtNode = class DtNode extends $7Uewc.AbstractBaseNode {
};
module.exports.DtNode = $75b7825d1155bb44$var$DtNode;
$75b7825d1155bb44$var$DtNode.domNodeName = "dt";
module.exports.DtNode = $75b7825d1155bb44$var$DtNode = $75b7825d1155bb44$var$__decorate([
    (0, $7Uewc.makeComponent)($75b7825d1155bb44$var$makeDt, "dt", module.exports.isValidDtField, module.exports.DtFields, [
        "%inline*"
    ])
], $75b7825d1155bb44$var$DtNode);

});

parcelRegister("4yNjh", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $352096569f96a8e8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EmNode = module.exports.isEmNode = module.exports.isValidEmField = module.exports.EmFields = void 0;
module.exports.makeEm = $352096569f96a8e8$var$makeEm;

var $kCEGt = parcelRequire("kCEGt");

var $c7Ayi = parcelRequire("c7Ayi");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `em` (Emphasized text) fields:
 * `dir`, `xml:lang`, `translate`, `keyref`, `outputclass`, `class`
 */ module.exports.EmFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given fields of the `em` node are valid and matches this list:
 * `keyref`, `outputclass`, `class`, `dir`, `xml:lang`, `translate`, `props`
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $352096569f96a8e8$var$isValidEmField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidEmField = $352096569f96a8e8$var$isValidEmField;
/**
 * Check if the `em` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `em` node to test
 * @returns Boolean
 */ const $352096569f96a8e8$var$isEmNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.EmFields, value, module.exports.isValidEmField);
module.exports.isEmNode = $352096569f96a8e8$var$isEmNode;
/**
 * Construct an `em` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `em` node
 */ function $352096569f96a8e8$var$makeEm(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create an `em` node
 *
 * @decorator `@makeComponent`
 * @param makeEm - The `em` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidEmField - A boolean value, if the field is valid or not
 * @param fields - A List of valid fields
 * @param childNodes - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
 */ let $352096569f96a8e8$var$EmNode = class EmNode extends $7Uewc.AbstractBaseNode {
};
module.exports.EmNode = $352096569f96a8e8$var$EmNode;
module.exports.EmNode = $352096569f96a8e8$var$EmNode = $352096569f96a8e8$var$__decorate([
    (0, $7Uewc.makeComponent)($352096569f96a8e8$var$makeEm, "em", module.exports.isValidEmField, module.exports.EmFields, [
        "%inline.noimage*"
    ])
], $352096569f96a8e8$var$EmNode);

});

parcelRegister("7IWky", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $59f9e3ab6489930b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExampleNode = module.exports.isExampleNode = module.exports.isValidExampleField = module.exports.isExampleNodes = module.exports.ExampleFields = void 0;
module.exports.makeExample = $59f9e3ab6489930b$var$makeExample;

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $gT0BI = parcelRequire("gT0BI");

var $7Uewc = parcelRequire("7Uewc");

var $7tEnl = parcelRequire("7tEnl");

var $dAWNe = parcelRequire("dAWNe");

var $22qJU = parcelRequire("22qJU");
/**
 * Define all allowed `example` attributes:
 * `scale`, `frame`, `expanse`, `dir`, `xml:lang`, `translate`,  `props`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.ExampleFields = [
    ...$7tEnl.DisplayFields,
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the `example` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `example` node to test
 * @returns Boolean
 */ const $59f9e3ab6489930b$var$isExampleNodes = (value)=>typeof value === "object" && !!value && (0, $7tEnl.isDisplayNode)(value) && (0, $kCEGt.isLocalizationNode)(value) && (0, $22qJU.isFiltersNode)(value) && (0, $dAWNe.isReuseNode)(value) && (0, $gT0BI.isClassNode)(value);
module.exports.isExampleNodes = $59f9e3ab6489930b$var$isExampleNodes;
/**
 * Check if the given attributes of the `example` node are valid and match this list:
 * @see {@link ExampleFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the field attribute
 * @returns Boolean
 */ const $59f9e3ab6489930b$var$isValidExampleField = (field, value)=>(0, $7tEnl.isValidDisplayField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidExampleField = $59f9e3ab6489930b$var$isValidExampleField;
/**
 * Check if the `example` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `example` node to test
 * @returns Boolean
 */ const $59f9e3ab6489930b$var$isExampleNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.ExampleFields, value, module.exports.isValidExampleField);
module.exports.isExampleNode = $59f9e3ab6489930b$var$isExampleNode;
/**
 * Construct an `example` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `example` node
 */ function $59f9e3ab6489930b$var$makeExample(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $7tEnl.makeDisplay, $kCEGt.makeLocalization, $gT0BI.makeClass, $dAWNe.makeReuse);
}
/**
 * Create an `example` node
 *
 * @decorator `@makeComponent`
 * @param makeExample - The `example` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidExampleField - A boolean value, if the attribute is valid or not
 * @param ExampleFields - An array containing all valid attribute names, @see {@link ExampleFields}
 * @param childNodes - An array containing all valid child node names: 'title?, 'p','ul','ol','dl','pre','audio','video','simpletable','fig','note'
 * @returns An `example` node
 */ let $59f9e3ab6489930b$var$ExampleNode = class ExampleNode extends $7Uewc.AbstractBaseNode {
};
module.exports.ExampleNode = $59f9e3ab6489930b$var$ExampleNode;
module.exports.ExampleNode = $59f9e3ab6489930b$var$ExampleNode = $59f9e3ab6489930b$var$__decorate([
    (0, $7Uewc.makeComponent)($59f9e3ab6489930b$var$makeExample, "example", module.exports.isValidExampleField, module.exports.ExampleFields, [
        "title?",
        "%example-blocks"
    ])
], $59f9e3ab6489930b$var$ExampleNode);

});
parcelRegister("7tEnl", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDisplayNode = module.exports.DisplayFields = void 0;
module.exports.isValidDisplayField = $571a8f8e69f3e46c$var$isValidDisplayField;
module.exports.makeDisplay = $571a8f8e69f3e46c$var$makeDisplay;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * DisplayFields (display attributes): `scale`, `frame`, `expanse`
 *
 * @remarks
 * entity `%display-atts` in LwDITA DTD, @see {@link https://github.com/oasis-tcs/dita-lwdita/blob/b2985f254746b2614c1b9d6a5e6043f82335506f/org.oasis.xdita/dtd/lw-topic.mod#L120}
 */ module.exports.DisplayFields = [
    "scale",
    "frame",
    "expanse"
];
/**
 * Check if the attributes `scale`, `frame`, `expanse` are valid
 *
 * See {@link DisplayFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $571a8f8e69f3e46c$var$isValidDisplayField(field, value) {
    switch(field){
        case "scale":
            return (0, $lRuta.isOrUndefined)($38z30.isDisplayScale, value);
        case "frame":
            return (0, $lRuta.isOrUndefined)($38z30.isDisplayFrame, value);
        case "expanse":
            return (0, $lRuta.isOrUndefined)($38z30.isDisplayExpanse, value);
        default:
            return false;
    }
}
/**
 * Check if the `display` attribute is valid
 *
 * @param value - The `display` node to test
 * @returns Boolean
 */ const $571a8f8e69f3e46c$var$isDisplayNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.DisplayFields, value, $571a8f8e69f3e46c$var$isValidDisplayField);
module.exports.isDisplayNode = $571a8f8e69f3e46c$var$isDisplayNode;
/**
 * Create a `display` node (display attribute)
 *
 * @see {@link https://dita-lang.org/lwdita/commonspec/specification/langref/attributes/attribute-groups#attribute-groups__display-attributes}
 *
 * @param constructor - The constructor
 * @returns The `display` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $571a8f8e69f3e46c$var$makeDisplay(constructor) {
    return class extends constructor {
        get "scale"() {
            return this.readProp("scale");
        }
        set "scale"(value) {
            this.writeProp("scale", value);
        }
        get "frame"() {
            return this.readProp("frame");
        }
        set "frame"(value) {
            this.writeProp("frame", value);
        }
        get "expanse"() {
            return this.readProp("expanse");
        }
        set "expanse"(value) {
            this.writeProp("expanse", value);
        }
    };
}

});


parcelRegister("3VZ65", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $2dd61696d233911e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FallbackNode = module.exports.isFallbackNode = module.exports.isValidFallbackField = module.exports.FallbackFields = void 0;
module.exports.makeFallback = $2dd61696d233911e$var$makeFallback;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $22qJU = parcelRequire("22qJU");
/**
 * Define all allowed `fallback` attributes:
 * `dir`, `xml:lang`, `translate`, `props`, `class`, `outputclass`
 */ module.exports.FallbackFields = [
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `fallback` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ const $2dd61696d233911e$var$isValidFallbackField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidFallbackField = $2dd61696d233911e$var$isValidFallbackField;
/**
 * Check if the `fallback` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `fallback` node to test
 * @returns Boolean
 */ const $2dd61696d233911e$var$isFallbackNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.FallbackFields, value, module.exports.isValidFallbackField);
module.exports.isFallbackNode = $2dd61696d233911e$var$isFallbackNode;
/**
 * Construct a `fallback` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `fallback` node
 */ function $2dd61696d233911e$var$makeFallback(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $gT0BI.makeClass);
}
/**
 * Create a `fallback` node (Fallback)
 *
 * @decorator `@makeComponent`
 * @param makeFallback - The `fallback` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidFallbackField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link FallbackFields}
 * @param childNodes - An Array of allowed child nodes `image`,`alt`,`p`,`ul`,`ol`,`dl`,`pre`,`note`
 */ let $2dd61696d233911e$var$FallbackNode = class FallbackNode extends $7Uewc.AbstractBaseNode {
};
module.exports.FallbackNode = $2dd61696d233911e$var$FallbackNode;
module.exports.FallbackNode = $2dd61696d233911e$var$FallbackNode = $2dd61696d233911e$var$__decorate([
    (0, $7Uewc.makeComponent)($2dd61696d233911e$var$makeFallback, "fallback", module.exports.isValidFallbackField, module.exports.FallbackFields, [
        "%fallback-blocks*"
    ])
], $2dd61696d233911e$var$FallbackNode);

});

parcelRegister("stdZo", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $0559490b09aac423$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FigNode = module.exports.isFigNode = module.exports.isValidFigField = module.exports.FigFields = void 0;
module.exports.makeFig = $0559490b09aac423$var$makeFig;

var $7tEnl = parcelRequire("7tEnl");

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $22qJU = parcelRequire("22qJU");

var $dAWNe = parcelRequire("dAWNe");
/**
 * Define all allowed `fig` attributes:
 * `scale`, `frame`, `expanse`, `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.FigFields = [
    ...$7tEnl.DisplayFields,
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `fig` node are valid and match this list:
 * @see {@link FigFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $0559490b09aac423$var$isValidFigField = (field, value)=>(0, $7tEnl.isValidDisplayField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidFigField = $0559490b09aac423$var$isValidFigField;
/**
 * Check if the `fig` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `fig` node to test
 * @returns Boolean
 */ const $0559490b09aac423$var$isFigNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.FigFields, value, module.exports.isValidFigField);
module.exports.isFigNode = $0559490b09aac423$var$isFigNode;
/**
 * Construct a `fig` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `fig` node
 */ function $0559490b09aac423$var$makeFig(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $7tEnl.makeDisplay, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `fig` node
 *
 * @decorator `@makeComponent`
 * @param makeFig - The `fig` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidFigField - A boolean value, if the attribute is valid or not
 * @param FigFields - An array containing all valid attribute names, @see {@link FigFields}
 * @param childNodes - An array containing all valid child node names: `title?`, `desc?` and  [`p`, `ul`, `ol`, `dl`, `pre`, `audio`, `video`, `example`, `simpletable`, or `image*`, or `xref*`]
 * @returns A `fig` node
 */ let $0559490b09aac423$var$FigNode = class FigNode extends $7Uewc.AbstractBaseNode {
};
module.exports.FigNode = $0559490b09aac423$var$FigNode;
$0559490b09aac423$var$FigNode.domNodeName = "figure";
module.exports.FigNode = $0559490b09aac423$var$FigNode = $0559490b09aac423$var$__decorate([
    (0, $7Uewc.makeComponent)($0559490b09aac423$var$makeFig, "fig", module.exports.isValidFigField, module.exports.FigFields, [
        "title?",
        "desc?",
        [
            "%fig-blocks*",
            "image*",
            "xref*"
        ]
    ])
], $0559490b09aac423$var$FigNode);

});

parcelRegister("b6btC", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $81492849f029d355$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FnNode = module.exports.isFnNode = module.exports.isValidFnField = module.exports.FnFields = void 0;
module.exports.makeFn = $81492849f029d355$var$makeFn;

var $gT0BI = parcelRequire("gT0BI");

var $855Xi = parcelRequire("855Xi");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `fn` fields:
 * `id`, `callout`, `props`, `dir`, `xml:lang`, `translate`, `conref`, `outputclass`, `class`
 *
 * @privateRemarks
 * TODO: Handle 'xml:space' (preserve)
 */ module.exports.FnFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$855Xi.FnReuseFields,
    ...$gT0BI.ClassFields,
    "id",
    "callout"
];
/**
 * Check if the given attributes of the `fn` node are valid and match this list:
 * @see {@link FnFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $81492849f029d355$var$isValidFnField = (field, value)=>{
    if ((0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $855Xi.isValidFnReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value)) return true;
    switch(field){
        case "id":
            return (0, $lRuta.isOrUndefined)($38z30.isNMTOKEN, value);
        case "callout":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
};
module.exports.isValidFnField = $81492849f029d355$var$isValidFnField;
/**
 * Check if the `fn` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `fn` node to test
 * @returns Boolean
 */ const $81492849f029d355$var$isFnNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.FnFields, value, module.exports.isValidFnField);
module.exports.isFnNode = $81492849f029d355$var$isFnNode;
/**
 * Create a `fn` node with an `id` and `callout` attribute
 *
 * @param constructor - The constructor
 * @returns The `fn` node with an `id` and `callout` attribute and their values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81492849f029d355$var$makeFn(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "id"() {
            return this.readProp("id");
        }
        set "id"(value) {
            this.writeProp("id", value);
        }
        get "callout"() {
            return this.readProp("callout");
        }
        set "callout"(value) {
            this.writeProp("callout", value);
        }
    }, $kCEGt.makeLocalization, $22qJU.makeFilters, $855Xi.makeFnReuse, $gT0BI.makeClass);
}
/**
 * Create an `fn` (Footnote) node
 *
 * @decorator `@makeComponent`
 * @param makeFn - The `Fn` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidFnField - A boolean value, if the field is valid or not
 * @param FnFields - An array containing all valid attributes @see {@link FnFields}
 * @param FnContent - An array containing all valid child nodes: '%fn-blocks*' (`p`, `ul`, `ol`, `dl`)
 * @returns A `fn` node
 */ let $81492849f029d355$var$FnNode = class FnNode extends $7Uewc.AbstractBaseNode {
};
module.exports.FnNode = $81492849f029d355$var$FnNode;
$81492849f029d355$var$FnNode.domNodeName = "span";
module.exports.FnNode = $81492849f029d355$var$FnNode = $81492849f029d355$var$__decorate([
    (0, $7Uewc.makeComponent)($81492849f029d355$var$makeFn, "fn", module.exports.isValidFnField, module.exports.FnFields, [
        "%fn-blocks*"
    ])
], $81492849f029d355$var$FnNode);

});
parcelRegister("855Xi", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFnReuseNode = module.exports.FnReuseFields = void 0;
module.exports.isValidFnReuseField = $5e2368f814d1076e$var$isValidFnReuseField;
module.exports.makeFnReuse = $5e2368f814d1076e$var$makeFnReuse;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * FnReuseFields: `conref`
 */ module.exports.FnReuseFields = [
    "conref"
];
/**
 * Check if the given attributes of the `fn-reuse` node are valid and match this list:
 * @see {@link FnReuseFields}
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ function $5e2368f814d1076e$var$isValidFnReuseField(field, value) {
    switch(field){
        case "conref":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `fn-reuse` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `fn-reuse` node to test
 * @returns Boolean
 */ const $5e2368f814d1076e$var$isFnReuseNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.FnReuseFields, value, $5e2368f814d1076e$var$isValidFnReuseField);
module.exports.isFnReuseNode = $5e2368f814d1076e$var$isFnReuseNode;
/**
 * Create a `fn-reuse` node with a `conref` attribute
 *
 * @param constructor - The constructor
 * @returns The `fn-reuse` node with a `conref` attribute and its value
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $5e2368f814d1076e$var$makeFnReuse(constructor) {
    return class extends constructor {
        get "conref"() {
            return this.readProp("conref");
        }
        set "conref"(value) {
            this.writeProp("conref", value);
        }
    };
}

});


parcelRegister("7KFhV", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $5a4cdb42a261507f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ImageNode = module.exports.isImageNode = module.exports.isValidImageField = module.exports.isImageNodes = module.exports.ImageFields = void 0;
module.exports.makeImage = $5a4cdb42a261507f$var$makeImage;

var $kCEGt = parcelRequire("kCEGt");

var $c7Ayi = parcelRequire("c7Ayi");

var $3rAp4 = parcelRequire("3rAp4");

var $lRuta = parcelRequire("lRuta");

var $gT0BI = parcelRequire("gT0BI");

var $7Uewc = parcelRequire("7Uewc");

var $dWUFe = parcelRequire("dWUFe");
/**
 * Define all allowed `image` attributes:
 * `dir`, `xml:lang`, `translate`, `href`, `format`, `scope`, `width`, `height`, `keyref`, `outputclass`, `class`
 */ module.exports.ImageFields = [
    ...$kCEGt.LocalizationFields,
    ...$3rAp4.ReferenceContentFields,
    ...$dWUFe.SizeFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the `image` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @privateRemarks
 * Where is `isImageNodes` used?
 * And what is the difference to `isImageNode`?
 *
 * @param value - The `image` node to test
 * @returns Boolean
 */ const $5a4cdb42a261507f$var$isImageNodes = (value)=>typeof value === "object" && !!value && (0, $kCEGt.isLocalizationNode)(value) && (0, $3rAp4.isReferenceContentNode)(value) && (0, $dWUFe.isSizeNode)(value) && (0, $c7Ayi.isVariableContentNode)(value) && (0, $gT0BI.isClassNode)(value);
module.exports.isImageNodes = $5a4cdb42a261507f$var$isImageNodes;
/**
 * Check if the given attributes of the `image` node are valid and match this list:
 * @see {@link ImageFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the field attribute
 * @returns Boolean
 */ const $5a4cdb42a261507f$var$isValidImageField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $dWUFe.isValidSizeField)(field, value);
module.exports.isValidImageField = $5a4cdb42a261507f$var$isValidImageField;
/**
 * Check if the `image` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `image` node to test
 * @returns Boolean
 */ const $5a4cdb42a261507f$var$isImageNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.ImageFields, value, module.exports.isValidImageField);
module.exports.isImageNode = $5a4cdb42a261507f$var$isImageNode;
/**
 * Construct an `image` node with all available attributes
 *
 * @privateRemarks
 * TODO: add properties
 *
 * @param constructor - The constructor
 * @returns An `image` node
 */ function $5a4cdb42a261507f$var$makeImage(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass, $3rAp4.makeReferenceContent, $dWUFe.makeSize);
}
/**
 * Create an `image` node
 *
 * @decorator `@makeComponent`
 * @param makeImage - The `image` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidImageField - A boolean value, if the attribute is valid or not
 * @param ImageFields - An array containing all valid attribute names, @see {@link ImageFields}
 * @param childNodes - An array containing all valid child node names: `alt?`
 * @returns An `image` node
 */ let $5a4cdb42a261507f$var$ImageNode = class ImageNode extends $7Uewc.AbstractBaseNode {
};
module.exports.ImageNode = $5a4cdb42a261507f$var$ImageNode;
module.exports.ImageNode = $5a4cdb42a261507f$var$ImageNode = $5a4cdb42a261507f$var$__decorate([
    (0, $7Uewc.makeComponent)($5a4cdb42a261507f$var$makeImage, "image", module.exports.isValidImageField, module.exports.ImageFields, [
        "alt?"
    ])
], $5a4cdb42a261507f$var$ImageNode);

});
parcelRegister("dWUFe", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSizeNode = module.exports.SizeFields = void 0;
module.exports.isValidSizeField = $a27ca56cb6484fcd$var$isValidSizeField;
module.exports.makeSize = $a27ca56cb6484fcd$var$makeSize;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `size` attributes:
 * `width`, `height`
 */ module.exports.SizeFields = [
    "width",
    "height"
];
/**
 * Check if the given attributes of the `size` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $a27ca56cb6484fcd$var$isValidSizeField(field, value) {
    switch(field){
        case "width":
            return (0, $lRuta.isOrUndefined)($38z30.isNMTOKEN, value);
        case "height":
            return (0, $lRuta.isOrUndefined)($38z30.isNMTOKEN, value);
        default:
            return false;
    }
}
/**
 * Check if the `size` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `size` node to test
 * @returns Boolean
 */ const $a27ca56cb6484fcd$var$isSizeNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.SizeFields, value, $a27ca56cb6484fcd$var$isValidSizeField);
module.exports.isSizeNode = $a27ca56cb6484fcd$var$isSizeNode;
/**
 * Create a `size` node with a `width` and `height` attribute
 *
 * @param constructor - The constructor
 * @returns The `size` node with a `width` and `height` attribute and their values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a27ca56cb6484fcd$var$makeSize(constructor) {
    return class extends constructor {
        get "width"() {
            return this.readProp("width");
        }
        set "width"(value) {
            this.writeProp("width", value);
        }
        get "height"() {
            return this.readProp("height");
        }
        set "height"(value) {
            this.writeProp("height", value);
        }
    };
}

});


parcelRegister("5WqeZ", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $4536b96851f2380e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ItalicNode = module.exports.isItalicNode = module.exports.isValidItalicField = module.exports.ItalicFields = void 0;
module.exports.makeItalic = $4536b96851f2380e$var$makeItalic;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `i` attributes:
 * `dir`, `xml:lang`, `translate`, `keyref`, `outputclass`, `class`
 */ module.exports.ItalicFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `italic` node are valid and match this list:
 * @see {@link ItalicFields}
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $4536b96851f2380e$var$isValidItalicField = (field, value)=>(0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidItalicField = $4536b96851f2380e$var$isValidItalicField;
/**
 * Check if the `italic` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `italic` node to test
 * @returns Boolean
 */ const $4536b96851f2380e$var$isItalicNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.ItalicFields, value, module.exports.isValidItalicField);
module.exports.isItalicNode = $4536b96851f2380e$var$isItalicNode;
/**
 * Construct an `italic` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `italic` node
 */ function $4536b96851f2380e$var$makeItalic(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create an italic node
 *
 * @privateRemarks
 * TODO: Implement "+ topic/ph hi-d/i"
 *
 * @decorator `@makeComponent`
 * @param makeItalic - The `italic` node constructor
 * @param nodeName - A string containing the node name 'i'
 * @param isValidItalicField - A function to check if the field is valid see {@link isValidItalicField}
 * @param ItalicFields - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
 */ let $4536b96851f2380e$var$ItalicNode = class ItalicNode extends $7Uewc.AbstractBaseNode {
};
module.exports.ItalicNode = $4536b96851f2380e$var$ItalicNode;
$4536b96851f2380e$var$ItalicNode.domNodeName = "i";
module.exports.ItalicNode = $4536b96851f2380e$var$ItalicNode = $4536b96851f2380e$var$__decorate([
    (0, $7Uewc.makeComponent)($4536b96851f2380e$var$makeItalic, "i", module.exports.isValidItalicField, module.exports.ItalicFields, [
        "%inline.noimage*"
    ])
], $4536b96851f2380e$var$ItalicNode);

});

parcelRegister("f5Obj", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $afce3f9f6c04c95d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeydefNode = module.exports.isKeydefNode = module.exports.KeydefFields = void 0;
module.exports.isValidKeydefField = $afce3f9f6c04c95d$var$isValidKeydefField;
module.exports.makeKeydef = $afce3f9f6c04c95d$var$makeKeydef;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");

var $3rAp4 = parcelRequire("3rAp4");

var $22qJU = parcelRequire("22qJU");
/**
 * Define all allowed `keydef` attributes:
 * `dir`, `xml:lang`, `translate`, `props`, `class`, `outputclass`, `href`, `format`, `scope`, `keys`, `processing-role`
 */ module.exports.KeydefFields = [
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$gT0BI.ClassFields,
    ...$3rAp4.ReferenceContentFields,
    "keys",
    "processing-role"
];
/**
 * Check if the given attributes of the `keydef` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ function $afce3f9f6c04c95d$var$isValidKeydefField(field, value) {
    if ((0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value)) return true;
    switch(field){
        case "keys":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "processing-role":
            return (0, $lRuta.isOrUndefined)($38z30.isProcessingRole, value);
        default:
            return false;
    }
}
/**
 * Check if the `keydef` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `keydef` node to test
 * @returns Boolean
 */ const $afce3f9f6c04c95d$var$isKeydefNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.KeydefFields, value, $afce3f9f6c04c95d$var$isValidKeydefField);
module.exports.isKeydefNode = $afce3f9f6c04c95d$var$isKeydefNode;
/**
 * Construct a `keydef` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `keydef` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $afce3f9f6c04c95d$var$makeKeydef(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "keys"() {
            return this.readProp("keys");
        }
        set "keys"(value) {
            this.writeProp("keys", value);
        }
        get "processing-role"() {
            return this.readProp("processing-role");
        }
        set "processing-role"(value) {
            this.writeProp("processing-role", value);
        }
    }, $kCEGt.makeLocalization, $gT0BI.makeClass, $3rAp4.makeReferenceContent, $22qJU.makeFilters);
}
/**
 * Create a `keydef` node (Key Definition)
 *
 * @decorator `@makeComponent`
 * @param makeKeydef - The `keydef` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidKeydefField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link KeydefFields}
 * @param childNodes - An Array of allowed child nodes: `topicmeta?`
 */ let $afce3f9f6c04c95d$var$KeydefNode = class KeydefNode extends $7Uewc.AbstractBaseNode {
};
module.exports.KeydefNode = $afce3f9f6c04c95d$var$KeydefNode;
module.exports.KeydefNode = $afce3f9f6c04c95d$var$KeydefNode = $afce3f9f6c04c95d$var$__decorate([
    (0, $7Uewc.makeComponent)($afce3f9f6c04c95d$var$makeKeydef, "keydef", $afce3f9f6c04c95d$var$isValidKeydefField, module.exports.KeydefFields, [
        "topicmeta?"
    ])
], $afce3f9f6c04c95d$var$KeydefNode);

});

parcelRegister("dOaWj", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $a0d86e3fa0e6b299$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeytextNode = module.exports.isKeytextNode = module.exports.isValidKeytextField = module.exports.KeytextFields = void 0;
module.exports.makeKeytext = $a0d86e3fa0e6b299$var$makeKeytext;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `keytext` attributes:
 * `dir`, `xml:lang`, `translate`, `class`, `outputclass`
 */ module.exports.KeytextFields = [
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `keytext` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $a0d86e3fa0e6b299$var$isValidKeytextField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidKeytextField = $a0d86e3fa0e6b299$var$isValidKeytextField;
/**
 * Check if the `keytext` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `keytext` node to test
 * @returns Boolean
 */ const $a0d86e3fa0e6b299$var$isKeytextNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.KeytextFields, value, module.exports.isValidKeytextField);
module.exports.isKeytextNode = $a0d86e3fa0e6b299$var$isKeytextNode;
/**
 * Construct a `keytext` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `keytext` node
 */ function $a0d86e3fa0e6b299$var$makeKeytext(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $gT0BI.makeClass);
}
/**
 * Create a `keytext` node (Key text)
 *
 * @decorator `@makeComponent`
 * @param makeKeytext - The `keytext` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidKeytextField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link KeytextFields}
 * @param childNodes - An Array of allowed child node (`text` or `ph`)
 */ let $a0d86e3fa0e6b299$var$KeytextNode = class KeytextNode extends $7Uewc.AbstractBaseNode {
};
module.exports.KeytextNode = $a0d86e3fa0e6b299$var$KeytextNode;
module.exports.KeytextNode = $a0d86e3fa0e6b299$var$KeytextNode = $a0d86e3fa0e6b299$var$__decorate([
    (0, $7Uewc.makeComponent)($a0d86e3fa0e6b299$var$makeKeytext, "keytext", module.exports.isValidKeytextField, module.exports.KeytextFields, [
        [
            "text*",
            "%ph*"
        ]
    ])
], $a0d86e3fa0e6b299$var$KeytextNode);

});

parcelRegister("8Uhbn", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $67c0e1ca0f101d58$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LiNode = module.exports.isLiNode = module.exports.isValidLiField = module.exports.LiFields = void 0;
module.exports.makeLi = $67c0e1ca0f101d58$var$makeLi;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `li` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.LiFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `li` node are valid and match this list:
 * @see {@link LiFields}
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $67c0e1ca0f101d58$var$isValidLiField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidLiField = $67c0e1ca0f101d58$var$isValidLiField;
/**
 * Check if the `li` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `li` node to test
 * @returns Boolean
 */ const $67c0e1ca0f101d58$var$isLiNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.LiFields, value, module.exports.isValidLiField);
module.exports.isLiNode = $67c0e1ca0f101d58$var$isLiNode;
/**
 * Construct a `li` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `li` node
 */ function $67c0e1ca0f101d58$var$makeLi(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `li` (List item) node
 *
 * @decorator `@makeComponent`
 * @param makeLi - The `li` node constructor
 * @param nodeName - A string containing the node name 'li'
 * @param isValidLiField - A function to check if the attribute is valid see {@link isValidLiField}
 * @param LiFields - A list of valid attributes `%list-blocks*` (`p`,`ul`, `ol`, `dl`, `pre`, `audio`, `video`, `example`, `simpletable`, `fig`, `note`)
 * @returns A `li` node
 */ let $67c0e1ca0f101d58$var$LiNode = class LiNode extends $7Uewc.AbstractBaseNode {
};
module.exports.LiNode = $67c0e1ca0f101d58$var$LiNode;
$67c0e1ca0f101d58$var$LiNode.domNodeName = "li";
module.exports.LiNode = $67c0e1ca0f101d58$var$LiNode = $67c0e1ca0f101d58$var$__decorate([
    (0, $7Uewc.makeComponent)($67c0e1ca0f101d58$var$makeLi, "li", module.exports.isValidLiField, module.exports.LiFields, [
        "%list-blocks*"
    ])
], $67c0e1ca0f101d58$var$LiNode);

});

parcelRegister("eY9fH", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $ae5dd892810db895$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MapNode = module.exports.isMapNode = module.exports.MapFields = void 0;
module.exports.isValidMapField = $ae5dd892810db895$var$isValidMapField;
module.exports.makeMap = $ae5dd892810db895$var$makeMap;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");

var $8EJCT = parcelRequire("8EJCT");
/**
 * Define all allowed `map` attributes:
 * `dir`, `xml:lang`, `translate`, `class`, `outputclass`, `specializations`, `id`, `xmlns:ditaarch`, `ditaarch:DITAArchVersion`
 */ module.exports.MapFields = [
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields,
    ...$8EJCT.SpecializationsFields,
    "id",
    "xmlns:ditaarch",
    "ditaarch:DITAArchVersion"
];
/**
 * Check if the given attributes of the `map` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ function $ae5dd892810db895$var$isValidMapField(field, value) {
    if ((0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $8EJCT.isValidSpecializationsField)(field, value)) return true;
    switch(field){
        case "id":
            return (0, $lRuta.isOrUndefined)($38z30.isID, value);
        case "xmlns:ditaarch":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "ditaarch:DITAArchVersion":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `map` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `map` node to test
 * @returns Boolean
 */ const $ae5dd892810db895$var$isMapNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.MapFields, value, $ae5dd892810db895$var$isValidMapField);
module.exports.isMapNode = $ae5dd892810db895$var$isMapNode;
/**
 * Construct a `map` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `map` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ae5dd892810db895$var$makeMap(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "id"() {
            return this.readProp("id");
        }
        set "id"(value) {
            this.writeProp("id", value);
        }
        get "xmlns:ditaarch"() {
            return this.readProp("xmlns:ditaarch");
        }
        set "xmlns:ditaarch"(value) {
            this.writeProp("xmlns:ditaarch", value);
        }
        get "ditaarch:DITAArchVersion"() {
            return this.readProp("ditaarch:DITAArchVersion");
        }
        set "ditaarch:DITAArchVersion"(value) {
            this.writeProp("ditaarch:DITAArchVersion", value);
        }
    }, $kCEGt.makeLocalization, $gT0BI.makeClass, $8EJCT.makeSpecializations);
}
/**
 * Create a `map` node (Map)
 *
 * @decorator `@makeComponent`
 * @param makeMap - The `map` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidMapField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link MapFields}
 * @param childNodes - An Array of allowed child nodes: `topicmeta?`and (`topicref` or `keydef`)*
 */ let $ae5dd892810db895$var$MapNode = class MapNode extends $7Uewc.AbstractBaseNode {
};
module.exports.MapNode = $ae5dd892810db895$var$MapNode;
module.exports.MapNode = $ae5dd892810db895$var$MapNode = $ae5dd892810db895$var$__decorate([
    (0, $7Uewc.makeComponent)($ae5dd892810db895$var$makeMap, "map", $ae5dd892810db895$var$isValidMapField, module.exports.MapFields, [
        "topicmeta?",
        [
            "topicref*",
            "keydef*"
        ]
    ])
], $ae5dd892810db895$var$MapNode);

});
parcelRegister("8EJCT", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isSpecializationsNode = module.exports.SpecializationsFields = void 0;
module.exports.isValidSpecializationsField = $64d57395bf29fb95$var$isValidSpecializationsField;
module.exports.makeSpecializations = $64d57395bf29fb95$var$makeSpecializations;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `specializations` attributes:
 * The only allowed field is `specializations`
 */ module.exports.SpecializationsFields = [
    "specializations"
];
/**
 * Check if the attributes `specializations` of the `Specializations` node is valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ function $64d57395bf29fb95$var$isValidSpecializationsField(field, value) {
    switch(field){
        case "specializations":
            return (0, $lRuta.isOrUndefined)($38z30.isINCLUDED_DOMAINS, value);
        default:
            return false;
    }
}
/**
 * Check if the `specializations` node is valid
 *
 * @remarks
 * Assert that the node is an object and has a valid attribute
 *
 * @param value - The `specializations` node to test
 * @returns Boolean
 */ const $64d57395bf29fb95$var$isSpecializationsNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.SpecializationsFields, value, $64d57395bf29fb95$var$isValidSpecializationsField);
module.exports.isSpecializationsNode = $64d57395bf29fb95$var$isSpecializationsNode;
/**
 * Create a `Specializations` node with a `specializations` attribute
 *
 * @param constructor - The constructor
 * @returns The `variable-content` node with a `specializations` attribute and its value
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $64d57395bf29fb95$var$makeSpecializations(constructor) {
    return class extends constructor {
        get "specializations"() {
            return this.readProp("specializations");
        }
        set "specializations"(value) {
            this.writeProp("specializations", value);
        }
    };
}

});


parcelRegister("bV8lz", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $8adb7e14a727115c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediaSourceNode = module.exports.isMediaSourceNode = module.exports.isValidMediaSourceField = module.exports.MediaSourceFields = void 0;
module.exports.makeMediaSource = $8adb7e14a727115c$var$makeMediaSource;

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $gT0BI = parcelRequire("gT0BI");

var $c7Ayi = parcelRequire("c7Ayi");

var $3rAp4 = parcelRequire("3rAp4");
/**
 * Define all allowed `media-source` attributes:
 * `dir`, `xml:lang`, `translate`, `href`, `format`, `scope`, `keyref`, `class`, `outputclass`
 */ module.exports.MediaSourceFields = [
    ...$kCEGt.LocalizationFields,
    ...$3rAp4.ReferenceContentFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `media-source` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $8adb7e14a727115c$var$isValidMediaSourceField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidMediaSourceField = $8adb7e14a727115c$var$isValidMediaSourceField;
/**
 * Check if the `media-source` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `media-source` node to test
 * @returns Boolean
 */ const $8adb7e14a727115c$var$isMediaSourceNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.MediaSourceFields, value, module.exports.isValidMediaSourceField);
module.exports.isMediaSourceNode = $8adb7e14a727115c$var$isMediaSourceNode;
/**
 * Construct a `media-source` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `media-source` node
 */ function $8adb7e14a727115c$var$makeMediaSource(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $3rAp4.makeReferenceContent, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `media-source` node and map the `media-source` node with the LwDita tag name `source`
 *
 * @decorator `@makeComponent`
 * @param makeMediaSource - The `media-source` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidMediaSourceField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link MediaSourceFields}
 */ let $8adb7e14a727115c$var$MediaSourceNode = class MediaSourceNode extends $7Uewc.AbstractBaseNode {
};
module.exports.MediaSourceNode = $8adb7e14a727115c$var$MediaSourceNode;
$8adb7e14a727115c$var$MediaSourceNode.domNodeName = "source";
module.exports.MediaSourceNode = $8adb7e14a727115c$var$MediaSourceNode = $8adb7e14a727115c$var$__decorate([
    (0, $7Uewc.makeComponent)($8adb7e14a727115c$var$makeMediaSource, "media-source", module.exports.isValidMediaSourceField, module.exports.MediaSourceFields)
], $8adb7e14a727115c$var$MediaSourceNode);

});

parcelRegister("23hQz", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $17e9b4a14b3a5f8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MediaTrackNode = module.exports.isMediaTrackNode = module.exports.isValidMediaTrackField = module.exports.MediaTrackFields = void 0;
module.exports.makeMediaTrack = $17e9b4a14b3a5f8c$var$makeMediaTrack;

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $gT0BI = parcelRequire("gT0BI");

var $38z30 = parcelRequire("38z30");

var $3rAp4 = parcelRequire("3rAp4");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `media-track` attributes:
 * `dir`, `xml:lang`, `translate`, `href`, `format`, `scope`,
 * `keyref`, `kind`, `srclang`, `class`, `outputclass`
 */ module.exports.MediaTrackFields = [
    ...$kCEGt.LocalizationFields,
    ...$3rAp4.ReferenceContentFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields,
    "kind",
    "srclang"
];
/**
 * Check if the given fields of the `media-track` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $17e9b4a14b3a5f8c$var$isValidMediaTrackField = (field, value)=>{
    if ((0, $kCEGt.isValidLocalizationField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value)) return true;
    switch(field){
        case "kind":
            return (0, $lRuta.isOrUndefined)($38z30.isKindType, value);
        case "srclang":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
};
module.exports.isValidMediaTrackField = $17e9b4a14b3a5f8c$var$isValidMediaTrackField;
/**
 * Check if the `media-track` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `media-track` node to test
 * @returns Boolean
 */ const $17e9b4a14b3a5f8c$var$isMediaTrackNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.MediaTrackFields, value, module.exports.isValidMediaTrackField);
module.exports.isMediaTrackNode = $17e9b4a14b3a5f8c$var$isMediaTrackNode;
/**
 * Construct a `media-track` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `media-track` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $17e9b4a14b3a5f8c$var$makeMediaTrack(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "kind"() {
            return this.readProp("kind");
        }
        set "kind"(value) {
            this.writeProp("kind", value);
        }
        get "srclang"() {
            return this.readProp("srclang");
        }
        set "srclang"(value) {
            this.writeProp("srclang", value);
        }
    }, $kCEGt.makeLocalization, $3rAp4.makeReferenceContent, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `media-track` node
 *
 * @remarks
 * Track is a link to time-based text data relevant to audio or video content.
 *
 * @decorator `@makeComponent`
 * @param makeMediaTrack - The `media-track` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidMediaTrackField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link MediaTrackFields}
 * @param childNodes - An array containing all valid child node names: `text`
 */ let $17e9b4a14b3a5f8c$var$MediaTrackNode = class MediaTrackNode extends $7Uewc.AbstractBaseNode {
};
module.exports.MediaTrackNode = $17e9b4a14b3a5f8c$var$MediaTrackNode;
module.exports.MediaTrackNode = $17e9b4a14b3a5f8c$var$MediaTrackNode = $17e9b4a14b3a5f8c$var$__decorate([
    (0, $7Uewc.makeComponent)($17e9b4a14b3a5f8c$var$makeMediaTrack, "media-track", module.exports.isValidMediaTrackField, module.exports.MediaTrackFields, [
        "text"
    ])
], $17e9b4a14b3a5f8c$var$MediaTrackNode);

});

parcelRegister("k268p", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $e958c0c08ed4e7c1$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MetadataNode = module.exports.isMetadataNode = module.exports.isValidMetadataField = module.exports.MetadataFields = void 0;
module.exports.makeMetadata = $e958c0c08ed4e7c1$var$makeMetadata;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $22qJU = parcelRequire("22qJU");

var $dAWNe = parcelRequire("dAWNe");
/**
 * Define all allowed `metadata` attributes:
 * `dir`, `xml:lang`, `translate`, `props`, `id`, `conref`, `class`, `outputclass`
 */ module.exports.MetadataFields = [
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `metadata` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ const $e958c0c08ed4e7c1$var$isValidMetadataField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidMetadataField = $e958c0c08ed4e7c1$var$isValidMetadataField;
/**
 * Check if the `metadata` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `metadata` node to test
 * @returns Boolean
 */ const $e958c0c08ed4e7c1$var$isMetadataNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.MetadataFields, value, module.exports.isValidMetadataField);
module.exports.isMetadataNode = $e958c0c08ed4e7c1$var$isMetadataNode;
/**
 * Construct a `metadata` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `metadata` node
 */ function $e958c0c08ed4e7c1$var$makeMetadata(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $dAWNe.makeReuse, $22qJU.makeFilters, $gT0BI.makeClass);
}
/**
 * Create a `metadata` node (Metadata)
 *
 * @decorator `@makeComponent`
 * @param makeMetadata - The `metadata` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidMetadataField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link MetadataFields}
 * @param childNodes - An Array of allowed child nodes `othermeta*`
 */ let $e958c0c08ed4e7c1$var$MetadataNode = class MetadataNode extends $7Uewc.AbstractBaseNode {
};
module.exports.MetadataNode = $e958c0c08ed4e7c1$var$MetadataNode;
module.exports.MetadataNode = $e958c0c08ed4e7c1$var$MetadataNode = $e958c0c08ed4e7c1$var$__decorate([
    (0, $7Uewc.makeComponent)($e958c0c08ed4e7c1$var$makeMetadata, "metadata", module.exports.isValidMetadataField, module.exports.MetadataFields, [
        "othermeta*"
    ])
], $e958c0c08ed4e7c1$var$MetadataNode);

});

parcelRegister("5f1xY", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $3d0f8da7ded34aa3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NavtitleNode = module.exports.isNavtitleNode = module.exports.isValidNavtitleField = module.exports.NavtitleFields = void 0;
module.exports.makeNavtitle = $3d0f8da7ded34aa3$var$makeNavtitle;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `navtitle` (Navigation title) fields:
 * `dir`, `xml:lang`, `translate`, `outputclass`, `class`
 */ module.exports.NavtitleFields = [
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given fields of the `navtitle` node are valid and matches this list:
 * `dir`, `xml:lang`, `translate`, `outputclass`, `class`
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $3d0f8da7ded34aa3$var$isValidNavtitleField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidNavtitleField = $3d0f8da7ded34aa3$var$isValidNavtitleField;
/**
 * Check if the `navtitle` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `navtitle` node to test
 * @returns Boolean
 */ const $3d0f8da7ded34aa3$var$isNavtitleNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.NavtitleFields, value, module.exports.isValidNavtitleField);
module.exports.isNavtitleNode = $3d0f8da7ded34aa3$var$isNavtitleNode;
/**
 * Construct a `navtitle` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `navtitle` node
 */ function $3d0f8da7ded34aa3$var$makeNavtitle(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $gT0BI.makeClass);
}
/**
 * Create a `navtitle` node
 *
 * @decorator `@makeComponent`
 * @param makeNavtitle - The `Navtitle` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidNavtitleField - A boolean value, if the field is valid or not
 * @param fields - A List of valid fields
 * @param childNodes - An Array of allowed child node `text*` or `%ph*`
 */ let $3d0f8da7ded34aa3$var$NavtitleNode = class NavtitleNode extends $7Uewc.AbstractBaseNode {
};
module.exports.NavtitleNode = $3d0f8da7ded34aa3$var$NavtitleNode;
module.exports.NavtitleNode = $3d0f8da7ded34aa3$var$NavtitleNode = $3d0f8da7ded34aa3$var$__decorate([
    (0, $7Uewc.makeComponent)($3d0f8da7ded34aa3$var$makeNavtitle, "navtitle", module.exports.isValidNavtitleField, module.exports.NavtitleFields, [
        [
            "text*",
            "%ph*"
        ]
    ])
], $3d0f8da7ded34aa3$var$NavtitleNode);

});

parcelRegister("cYzuY", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $97269fed9801913a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NoteNode = module.exports.isNoteNode = module.exports.NoteTypes = module.exports.NoteFields = void 0;
module.exports.isValidNoteField = $97269fed9801913a$var$isValidNoteField;
module.exports.makeNote = $97269fed9801913a$var$makeNote;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `note` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`, `type`
 */ module.exports.NoteFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields,
    "type"
];
var $97269fed9801913a$var$NoteTypes;
(function(NoteTypes) {
    NoteTypes["Caution"] = "caution";
    NoteTypes["Warning"] = "warning";
    NoteTypes["Danger"] = "danger";
    NoteTypes["Trouble"] = "trouble";
    NoteTypes["Notice"] = "notice";
    NoteTypes["Note"] = "note";
})($97269fed9801913a$var$NoteTypes || (module.exports.NoteTypes = $97269fed9801913a$var$NoteTypes = {}));
/**
 * Check if the given attributes of the `note` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $97269fed9801913a$var$isValidNoteField(field, value) {
    if ((0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value)) return true;
    switch(field){
        case "type":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `note` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `note` node to test
 * @returns Boolean
 */ const $97269fed9801913a$var$isNoteNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.NoteFields, value, $97269fed9801913a$var$isValidNoteField);
module.exports.isNoteNode = $97269fed9801913a$var$isNoteNode;
/**
 * Construct a `note` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `note` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $97269fed9801913a$var$makeNote(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "type"() {
            return this.readProp("type");
        }
        set "type"(value) {
            this.writeProp("type", value);
        }
    }, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `note` node and map the `note` node with the LwDita tag name `div`
 *
 * @decorator `@makeComponent`
 * @param makeNote - The `note` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidNoteField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link NoteFields}
 * @param childNodes - An Array of allowed child nodes: `%simple-blocks*` (`p`, `ul`, `ol`, `dl`, `pre`, `audio`, `video`, `example`, `note`)
 */ let $97269fed9801913a$var$NoteNode = class NoteNode extends $7Uewc.AbstractBaseNode {
    constructor(){
        super(...arguments);
        // NoteNodeAttributes
        this.type = $97269fed9801913a$var$NoteTypes.Note;
    }
};
module.exports.NoteNode = $97269fed9801913a$var$NoteNode;
$97269fed9801913a$var$NoteNode.domNodeName = "div";
module.exports.NoteNode = $97269fed9801913a$var$NoteNode = $97269fed9801913a$var$__decorate([
    (0, $7Uewc.makeComponent)($97269fed9801913a$var$makeNote, "note", $97269fed9801913a$var$isValidNoteField, module.exports.NoteFields, [
        "%simple-blocks*"
    ])
], $97269fed9801913a$var$NoteNode);

});

parcelRegister("k4O5A", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $e9db090a4e33f3cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OlNode = module.exports.isOlNode = module.exports.isValidOlField = module.exports.OlFields = void 0;
module.exports.makeOl = $e9db090a4e33f3cc$var$makeOl;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `ol` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.OlFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `ol` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $e9db090a4e33f3cc$var$isValidOlField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidOlField = $e9db090a4e33f3cc$var$isValidOlField;
/**
 * Check if the `ol` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `ol` node to test
 * @returns Boolean
 */ const $e9db090a4e33f3cc$var$isOlNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.OlFields, value, module.exports.isValidOlField);
module.exports.isOlNode = $e9db090a4e33f3cc$var$isOlNode;
/**
 * Construct an `ol` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `ol` node
 */ function $e9db090a4e33f3cc$var$makeOl(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create an `ol` (ordered list) node and map the `ol` node with the LwDita tag name `ol`
 *
 * @decorator `@makeComponent`
 * @param makeOl - The `ol` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidOlField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link OlFields}
 * @param childNodes - An Array of allowed child nodes: `li+`
 */ let $e9db090a4e33f3cc$var$OlNode = class OlNode extends $7Uewc.AbstractBaseNode {
};
module.exports.OlNode = $e9db090a4e33f3cc$var$OlNode;
$e9db090a4e33f3cc$var$OlNode.domNodeName = "ol";
module.exports.OlNode = $e9db090a4e33f3cc$var$OlNode = $e9db090a4e33f3cc$var$__decorate([
    (0, $7Uewc.makeComponent)($e9db090a4e33f3cc$var$makeOl, "ol", module.exports.isValidOlField, module.exports.OlFields, [
        "li+"
    ])
], $e9db090a4e33f3cc$var$OlNode);

});

parcelRegister("gaX2o", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $bc6b60274fad2814$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OthermetaNode = module.exports.isOthermetaNode = module.exports.OthermetaFields = void 0;
module.exports.isValidOthermetaField = $bc6b60274fad2814$var$isValidOthermetaField;
module.exports.makeOthermeta = $bc6b60274fad2814$var$makeOthermeta;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `othermeta` attributes:
 * `dir`, `xml:lang`, `translate`, `class`, `name`, `content`
 */ module.exports.OthermetaFields = [
    ...$kCEGt.LocalizationFields,
    "name",
    "content",
    "class"
];
/**
 * Check if the given attributes of the `othermeta` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ function $bc6b60274fad2814$var$isValidOthermetaField(field, value) {
    if ((0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value)) return true;
    switch(field){
        case "name":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "content":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "class":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `Othermeta` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `Othermeta` node to test
 * @returns Boolean
 */ const $bc6b60274fad2814$var$isOthermetaNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.OthermetaFields, value, $bc6b60274fad2814$var$isValidOthermetaField);
module.exports.isOthermetaNode = $bc6b60274fad2814$var$isOthermetaNode;
/**
 * Construct a `othermeta` node with all available attributes
 *
 * @remarks
 * Element `othermeta` requires only a class attribute,
 * not an `outputclass` attribute, therefore it has been
 * added here instead of importing `ClassFields`
 *
 * @param constructor - The constructor
 * @returns A `othermeta` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bc6b60274fad2814$var$makeOthermeta(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "name"() {
            return this.readProp("name");
        }
        set "name"(value) {
            this.writeProp("name", value);
        }
        get "content"() {
            return this.readProp("content");
        }
        set "content"(value) {
            this.writeProp("content", value);
        }
        get "class"() {
            return this.readProp("class");
        }
        set "class"(value) {
            this.writeProp("class", value);
        }
    }, $kCEGt.makeLocalization, $gT0BI.makeClass);
}
/**
 * Create a `othermeta` node (Other Metadata)
 *
 * @decorator `@makeComponent`
 * @param makeOthermeta - The `Othermeta` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidOthermetaField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link OthermetaFields}
 */ let $bc6b60274fad2814$var$OthermetaNode = class OthermetaNode extends $7Uewc.AbstractBaseNode {
};
module.exports.OthermetaNode = $bc6b60274fad2814$var$OthermetaNode;
module.exports.OthermetaNode = $bc6b60274fad2814$var$OthermetaNode = $bc6b60274fad2814$var$__decorate([
    (0, $7Uewc.makeComponent)($bc6b60274fad2814$var$makeOthermeta, "othermeta", $bc6b60274fad2814$var$isValidOthermetaField, module.exports.OthermetaFields)
], $bc6b60274fad2814$var$OthermetaNode);

});

parcelRegister("8jviQ", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $60d8612cd092e2e4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PhNode = module.exports.isPhNode = module.exports.isValidPhField = module.exports.PhFields = void 0;
module.exports.makePh = $60d8612cd092e2e4$var$makePh;

var $gT0BI = parcelRequire("gT0BI");

var $c7Ayi = parcelRequire("c7Ayi");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `ph` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `keyref`, `class`, `outputclass`
 */ module.exports.PhFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `ph` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $60d8612cd092e2e4$var$isValidPhField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidPhField = $60d8612cd092e2e4$var$isValidPhField;
/**
 * Check if the `ph` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `ph` node to test
 * @returns Boolean
 */ const $60d8612cd092e2e4$var$isPhNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.PhFields, value, module.exports.isValidPhField);
module.exports.isPhNode = $60d8612cd092e2e4$var$isPhNode;
/**
 * Construct a `ph` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `ph` node
 */ function $60d8612cd092e2e4$var$makePh(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `ph` node (Phrase Content) and map the `ph` node with the LwDita tag name `span`
 *
 * @decorator `@makeComponent`
 * @param makePh - The `ph` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidPhField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link PhFields}
 * @param childNodes - An Array of allowed child node `%inline*` (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `image`, `xref`)
 */ let $60d8612cd092e2e4$var$PhNode = class PhNode extends $7Uewc.AbstractBaseNode {
};
module.exports.PhNode = $60d8612cd092e2e4$var$PhNode;
$60d8612cd092e2e4$var$PhNode.domNodeName = "span";
module.exports.PhNode = $60d8612cd092e2e4$var$PhNode = $60d8612cd092e2e4$var$__decorate([
    (0, $7Uewc.makeComponent)($60d8612cd092e2e4$var$makePh, "ph", module.exports.isValidPhField, module.exports.PhFields, [
        "%inline*"
    ])
], $60d8612cd092e2e4$var$PhNode);

});

parcelRegister("g41Dz", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $bb1e4a32e00a7b55$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PNode = module.exports.isPNode = module.exports.isValidPField = module.exports.PFields = void 0;
module.exports.makeP = $bb1e4a32e00a7b55$var$makeP;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `p` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`
 */ module.exports.PFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `p` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $bb1e4a32e00a7b55$var$isValidPField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidPField = $bb1e4a32e00a7b55$var$isValidPField;
/**
 * Check if the `p` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `p` node to test
 * @returns Boolean
 */ const $bb1e4a32e00a7b55$var$isPNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.PFields, value, module.exports.isValidPField);
module.exports.isPNode = $bb1e4a32e00a7b55$var$isPNode;
/**
 * Construct a `p` node with all available attributes
 *
 * @remarks
 * eslint-disable-next-line `@typescript-eslint/no-explicit-any`
 *
 * @param constructor - The constructor
 * @returns An `p` node
 */ function $bb1e4a32e00a7b55$var$makeP(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `p` node (paragraph) and map the `p` node with the LwDita tag name `p`
 *
 * @decorator `@makeComponent`
 * @param makeP - The `p` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidPField - A boolean value, if the field is valid or not
 * @param fields - A List of valid attributes @see {@link PFields}
 * @param childNodes - An Array of allowed child nodes `%inline*` (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `image`, `xref`)
 */ let $bb1e4a32e00a7b55$var$PNode = class PNode extends $7Uewc.AbstractBaseNode {
};
module.exports.PNode = $bb1e4a32e00a7b55$var$PNode;
$bb1e4a32e00a7b55$var$PNode.domNodeName = "p";
module.exports.PNode = $bb1e4a32e00a7b55$var$PNode = $bb1e4a32e00a7b55$var$__decorate([
    (0, $7Uewc.makeComponent)($bb1e4a32e00a7b55$var$makeP, "p", module.exports.isValidPField, module.exports.PFields, [
        "%inline*"
    ])
], $bb1e4a32e00a7b55$var$PNode);

});

parcelRegister("2zXyl", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $1e0d0ba4014c27e4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PreNode = module.exports.isPreNode = module.exports.isValidPreField = module.exports.PreFields = void 0;
module.exports.makePre = $1e0d0ba4014c27e4$var$makePre;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `pre` fields:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`, `xml:space`
 */ module.exports.PreFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields,
    "xml:space"
];
/**
 * Check if the given fields of the `pre` node are valid
 *
 * @privateRemarks
 * TODO: Implement field validation for `xml:space` (preserve)
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $1e0d0ba4014c27e4$var$isValidPreField = (field, value)=>{
    if ((0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value)) return true;
    switch(field){
        case "xml:space":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
};
module.exports.isValidPreField = $1e0d0ba4014c27e4$var$isValidPreField;
/**
 * Check if the `pre` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `pre` node to test
 * @returns Boolean
 */ const $1e0d0ba4014c27e4$var$isPreNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.PreFields, value, module.exports.isValidPreField);
module.exports.isPreNode = $1e0d0ba4014c27e4$var$isPreNode;
/**
 * Construct a `pre` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `pre` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1e0d0ba4014c27e4$var$makePre(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "xml:space"() {
            return this.readProp("xml:space");
        }
        set "xml:space"(value) {
            this.writeProp("xml:space", value);
        }
    }, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `pre` node (preformatted text) and map the `pre` node with the LwDita tag name `pre`
 *
 * @decorator `@makeComponent`
 * @param makePre - The `pre` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidPreField - A boolean value, if the field is valid or not
 * @param fields - A List of valid attributes @see {@link PreFields}
 * @param childNodes - An Array of allowed child nodes `text*`, `%ph*`, `xref*`, `%data*`
 */ let $1e0d0ba4014c27e4$var$PreNode = class PreNode extends $7Uewc.AbstractBaseNode {
};
module.exports.PreNode = $1e0d0ba4014c27e4$var$PreNode;
$1e0d0ba4014c27e4$var$PreNode.domNodeName = "pre";
module.exports.PreNode = $1e0d0ba4014c27e4$var$PreNode = $1e0d0ba4014c27e4$var$__decorate([
    (0, $7Uewc.makeComponent)($1e0d0ba4014c27e4$var$makePre, "pre", module.exports.isValidPreField, module.exports.PreFields, [
        [
            "text*",
            "%ph*",
            "xref*",
            "cdata*"
        ]
    ])
], $1e0d0ba4014c27e4$var$PreNode);

});

parcelRegister("6VH7H", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $50b9844d97c8d7c2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrologNode = module.exports.isPrologNode = module.exports.isValidPrologField = module.exports.PrologFields = void 0;
module.exports.makeProlog = $50b9844d97c8d7c2$var$makeProlog;

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $gT0BI = parcelRequire("gT0BI");
/**
 * Define all allowed `prolog` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `outputclass`, `class`
 */ module.exports.PrologFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `prolog` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ const $50b9844d97c8d7c2$var$isValidPrologField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidPrologField = $50b9844d97c8d7c2$var$isValidPrologField;
/**
 * Check if the `prolog` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `prolog` node to test
 * @returns Boolean
 */ const $50b9844d97c8d7c2$var$isPrologNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.PrologFields, value, module.exports.isValidPrologField);
module.exports.isPrologNode = $50b9844d97c8d7c2$var$isPrologNode;
/**
 * Construct a `prolog` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `prolog` node
 */ function $50b9844d97c8d7c2$var$makeProlog(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $gT0BI.makeClass);
}
/**
 * Create a `prolog` node
 *
 * @privateRemarks
 * Delete the default tag name from the BaseNode
 * Is overriding the domNodeName with an empty string intended??
 * TODO: Implement `head > meta`
 * TODO (Y.): Why is `domNodeName` set to an empty string?
 *
 * @decorator `@makeComponent`
 * @param makeProlog - The `prolog` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidPrologField - A boolean value, if the field is valid or not
 * @param fields - A List of valid attributes @see {@link PrologFields}
 * @param childNodes - An Array of allowed child node `metadata*`
 */ let $50b9844d97c8d7c2$var$PrologNode = class PrologNode extends $7Uewc.AbstractBaseNode {
};
module.exports.PrologNode = $50b9844d97c8d7c2$var$PrologNode;
$50b9844d97c8d7c2$var$PrologNode.domNodeName = "";
module.exports.PrologNode = $50b9844d97c8d7c2$var$PrologNode = $50b9844d97c8d7c2$var$__decorate([
    (0, $7Uewc.makeComponent)($50b9844d97c8d7c2$var$makeProlog, "prolog", module.exports.isValidPrologField, module.exports.PrologFields, [
        "metadata*"
    ])
], $50b9844d97c8d7c2$var$PrologNode);

});

parcelRegister("fjtDj", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $b25f9de2b0913b9f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SectionNode = module.exports.isSectionNode = module.exports.isValidSectionField = module.exports.SectionFields = void 0;
module.exports.makeSection = $b25f9de2b0913b9f$var$makeSection;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `section` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`
 */ module.exports.SectionFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `section` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $b25f9de2b0913b9f$var$isValidSectionField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidSectionField = $b25f9de2b0913b9f$var$isValidSectionField;
/**
 * Check if the `section` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `section` node to test
 * @returns Boolean
 */ const $b25f9de2b0913b9f$var$isSectionNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.SectionFields, value, module.exports.isValidSectionField);
module.exports.isSectionNode = $b25f9de2b0913b9f$var$isSectionNode;
/**
 * Construct a `section` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `section` node
 */ function $b25f9de2b0913b9f$var$makeSection(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `section` node and map the `section` node with the LwDita tag name `section`
 *
 * @decorator `@makeComponent`
 * @param makeSection - The `section` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidSectionField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link SectionFields}
 * @param childNodes - An Array of allowed child nodes: `title?`, `%all-blocks*` (`p`, `ul`, `ol`, `dl`, `pre`, `audio`, `video`, `simpletable`, `fig`, `fn`, `note`, `data`)
 */ let $b25f9de2b0913b9f$var$SectionNode = class SectionNode extends $7Uewc.AbstractBaseNode {
};
module.exports.SectionNode = $b25f9de2b0913b9f$var$SectionNode;
$b25f9de2b0913b9f$var$SectionNode.domNodeName = "section";
module.exports.SectionNode = $b25f9de2b0913b9f$var$SectionNode = $b25f9de2b0913b9f$var$__decorate([
    (0, $7Uewc.makeComponent)($b25f9de2b0913b9f$var$makeSection, "section", module.exports.isValidSectionField, module.exports.SectionFields, [
        "title?",
        "%all-blocks*"
    ])
], $b25f9de2b0913b9f$var$SectionNode);

});

parcelRegister("lMYdM", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $fdcccb5726dad92e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ShortDescNode = module.exports.isShortDescNode = module.exports.isValidShortDescField = module.exports.ShortDescFields = void 0;
module.exports.makeShortDesc = $fdcccb5726dad92e$var$makeShortDesc;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $dAWNe = parcelRequire("dAWNe");
/**
 * Define all allowed `shortdesc` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`
 */ module.exports.ShortDescFields = [
    ...$22qJU.FiltersFields,
    ...$dAWNe.ReuseFields,
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `shortdesc` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $fdcccb5726dad92e$var$isValidShortDescField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidShortDescField = $fdcccb5726dad92e$var$isValidShortDescField;
/**
 * Check if the `shortdesc` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `shortdesc` node to test
 * @returns Boolean
 */ const $fdcccb5726dad92e$var$isShortDescNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.ShortDescFields, value, module.exports.isValidShortDescField);
module.exports.isShortDescNode = $fdcccb5726dad92e$var$isShortDescNode;
/**
 * Construct a `shortdesc` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `shortdesc` node
 */ function $fdcccb5726dad92e$var$makeShortDesc(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `shortdesc` node (short description) and map the `shortdesc` node with the LwDita tag name `p`
 *
 * @decorator `@makeComponent`
 * @param makeshortdesc - The `shortdesc` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidSimpleTableField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes
 * @param childNodes - An Array of allowed child node `%inline*` (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `image`, `xref`)
 */ let $fdcccb5726dad92e$var$ShortDescNode = class ShortDescNode extends $7Uewc.AbstractBaseNode {
};
module.exports.ShortDescNode = $fdcccb5726dad92e$var$ShortDescNode;
$fdcccb5726dad92e$var$ShortDescNode.domNodeName = "p";
module.exports.ShortDescNode = $fdcccb5726dad92e$var$ShortDescNode = $fdcccb5726dad92e$var$__decorate([
    (0, $7Uewc.makeComponent)($fdcccb5726dad92e$var$makeShortDesc, "shortdesc", module.exports.isValidShortDescField, module.exports.ShortDescFields, [
        "%inline*"
    ])
], $fdcccb5726dad92e$var$ShortDescNode);

});

parcelRegister("1NVZt", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $150759c585d7f583$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleTableNode = module.exports.isSimpleTableNode = module.exports.isValidSimpleTableField = module.exports.SimpleTableFields = void 0;
module.exports.makeSimpleTable = $150759c585d7f583$var$makeSimpleTable;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `simpletable` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`
 */ module.exports.SimpleTableFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `simpletable` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $150759c585d7f583$var$isValidSimpleTableField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidSimpleTableField = $150759c585d7f583$var$isValidSimpleTableField;
/**
 * Check if the `simpletable` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `simpletable` node to test
 * @returns Boolean
 */ const $150759c585d7f583$var$isSimpleTableNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.SimpleTableFields, value, module.exports.isValidSimpleTableField);
module.exports.isSimpleTableNode = $150759c585d7f583$var$isSimpleTableNode;
/**
 * Construct a `simpletable` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `simpletable` node
 */ function $150759c585d7f583$var$makeSimpleTable(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `simpletable` node (table) and map the `simpletable` node with the LwDita tag name `table`
 *
 * @decorator `@makeComponent`
 * @param makeSimpleTable - The `simpletable` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidSimpleTableField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link SimpleTableFields}
 * @param childNodes - An Array of allowed child nodes `sthead?`, `strow+`
 */ let $150759c585d7f583$var$SimpleTableNode = class SimpleTableNode extends $7Uewc.AbstractBaseNode {
};
module.exports.SimpleTableNode = $150759c585d7f583$var$SimpleTableNode;
$150759c585d7f583$var$SimpleTableNode.domNodeName = "table";
module.exports.SimpleTableNode = $150759c585d7f583$var$SimpleTableNode = $150759c585d7f583$var$__decorate([
    (0, $7Uewc.makeComponent)($150759c585d7f583$var$makeSimpleTable, "simpletable", module.exports.isValidSimpleTableField, module.exports.SimpleTableFields, [
        "title?",
        "sthead?",
        "strow+"
    ])
], $150759c585d7f583$var$SimpleTableNode);

});

parcelRegister("lXNXY", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $ffd5ddea059338b2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StEntryNode = module.exports.isStEntryNode = module.exports.StEntryFields = void 0;
module.exports.isValidStEntryField = $ffd5ddea059338b2$var$isValidStEntryField;
module.exports.makeStEntry = $ffd5ddea059338b2$var$makeStEntry;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");
/**
 * Define all allowed `stentry` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`, `colspan`, `rowspan`, `scope`, `headers`
 */ module.exports.StEntryFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields,
    "colspan",
    "rowspan",
    "scope",
    "headers"
];
/**
 * Check if the given attributes of the `stentry` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $ffd5ddea059338b2$var$isValidStEntryField(field, value) {
    if ((0, $22qJU.isValidFiltersField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value)) return true;
    switch(field){
        case "colspan":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "rowspan":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        case "scope":
            return (0, $lRuta.isOrUndefined)($38z30.isTableScope, value);
        case "headers":
            return (0, $lRuta.isOrUndefined)($38z30.isNMTOKENS, value);
        default:
            return false;
    }
}
/**
 * Check if the `stentry` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `stentry` node to test
 * @returns Boolean
 */ const $ffd5ddea059338b2$var$isStEntryNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.StEntryFields, value, $ffd5ddea059338b2$var$isValidStEntryField);
module.exports.isStEntryNode = $ffd5ddea059338b2$var$isStEntryNode;
/**
 * Construct a `stentry` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `stentry` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ffd5ddea059338b2$var$makeStEntry(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "colspan"() {
            return this.readProp("colspan");
        }
        set "colspan"(value) {
            this.writeProp("colspan", value);
        }
        get "rowspan"() {
            return this.readProp("rowspan");
        }
        set "rowspan"(value) {
            this.writeProp("rowspan", value);
        }
        get "scope"() {
            return this.readProp("scope");
        }
        set "scope"(value) {
            this.writeProp("scope", value);
        }
        get "headers"() {
            return this.readProp("headers");
        }
        set "headers"(value) {
            this.writeProp("headers", value);
        }
    }, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `stentry` node (simple table entry / "table-cell") and map the `stentry` node with the LwDita tag name `td`
 *
 * @privateRemarks
 * TODO: Implement td/th
 *
 * @decorator `@makeComponent`
 * @param makeStEntry - The `stentry` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidStEntryField - A boolean value, if the field is valid or not
 * @param fields - A List of valid attributes @see {@link StEntryFields}
 * @param childNodes - An Array of allowed child node `%simple-blocks*` (`p`, `ul`, `ol`, `dl`, `pre`, `audio`, `video`, `example`, `note`)
 */ let $ffd5ddea059338b2$var$StEntryNode = class StEntryNode extends $7Uewc.AbstractBaseNode {
};
module.exports.StEntryNode = $ffd5ddea059338b2$var$StEntryNode;
$ffd5ddea059338b2$var$StEntryNode.domNodeName = "td";
module.exports.StEntryNode = $ffd5ddea059338b2$var$StEntryNode = $ffd5ddea059338b2$var$__decorate([
    (0, $7Uewc.makeComponent)($ffd5ddea059338b2$var$makeStEntry, "stentry", $ffd5ddea059338b2$var$isValidStEntryField, module.exports.StEntryFields, [
        "%simple-blocks*"
    ])
], $ffd5ddea059338b2$var$StEntryNode);

});

parcelRegister("4lPc1", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $32b0d570b7d0f6c2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StHeadNode = module.exports.isStHeadNode = module.exports.isValidStHeadField = module.exports.StHeadFields = void 0;
module.exports.makeStHead = $32b0d570b7d0f6c2$var$makeStHead;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `sthead` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`
 */ module.exports.StHeadFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `sthead` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $32b0d570b7d0f6c2$var$isValidStHeadField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidStHeadField = $32b0d570b7d0f6c2$var$isValidStHeadField;
/**
 * Check if the `sthead` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `sthead` node to test
 * @returns Boolean
 */ const $32b0d570b7d0f6c2$var$isStHeadNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.StHeadFields, value, module.exports.isValidStHeadField);
module.exports.isStHeadNode = $32b0d570b7d0f6c2$var$isStHeadNode;
/**
 * Construct a `sthead` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `sthead` node
 */ function $32b0d570b7d0f6c2$var$makeStHead(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `sthead` node (Table header row) and map the `sthead` node with the LwDita tag name `thead`
 *
 * @decorator `@makeComponent`
 * @param makeStHead - The `sthead` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidStHeadField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes
 * @param childNodes - An Array of allowed child node `stentry+`
 */ let $32b0d570b7d0f6c2$var$StHeadNode = class StHeadNode extends $7Uewc.AbstractBaseNode {
};
module.exports.StHeadNode = $32b0d570b7d0f6c2$var$StHeadNode;
$32b0d570b7d0f6c2$var$StHeadNode.domNodeName = "thead";
module.exports.StHeadNode = $32b0d570b7d0f6c2$var$StHeadNode = $32b0d570b7d0f6c2$var$__decorate([
    (0, $7Uewc.makeComponent)($32b0d570b7d0f6c2$var$makeStHead, "sthead", module.exports.isValidStHeadField, module.exports.StHeadFields, [
        "stentry+"
    ])
], $32b0d570b7d0f6c2$var$StHeadNode);

});

parcelRegister("7964w", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $533e157179e1f74d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StrongNode = module.exports.isStrongNode = module.exports.isValidStrongField = module.exports.StrongFields = void 0;
module.exports.makeStrong = $533e157179e1f74d$var$makeStrong;

var $kCEGt = parcelRequire("kCEGt");

var $c7Ayi = parcelRequire("c7Ayi");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `strong` (Strong text) fields:
 * `dir`, `xml:lang`, `translate`, `keyref`, `outputclass`, `class`
 */ module.exports.StrongFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given fields of the `strong` node are valid and matches this list:
 * `keyref`, `outputclass`, `class`, `dir`, `xml:lang`, `translate`
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $533e157179e1f74d$var$isValidStrongField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidStrongField = $533e157179e1f74d$var$isValidStrongField;
/**
 * Check if the `strong` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `strong` node to test
 * @returns Boolean
 */ const $533e157179e1f74d$var$isStrongNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.StrongFields, value, module.exports.isValidStrongField);
module.exports.isStrongNode = $533e157179e1f74d$var$isStrongNode;
/**
 * Construct a `strong` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `strong` node
 */ function $533e157179e1f74d$var$makeStrong(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `strong` node
 *
 * @decorator `@makeComponent`
 * @param makeStrong - The `strong` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidEmField - A boolean value, if the field is valid or not
 * @param fields - A List of valid fields
 * @param childNodes - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
 */ let $533e157179e1f74d$var$StrongNode = class StrongNode extends $7Uewc.AbstractBaseNode {
};
module.exports.StrongNode = $533e157179e1f74d$var$StrongNode;
module.exports.StrongNode = $533e157179e1f74d$var$StrongNode = $533e157179e1f74d$var$__decorate([
    (0, $7Uewc.makeComponent)($533e157179e1f74d$var$makeStrong, "strong", module.exports.isValidStrongField, module.exports.StrongFields, [
        "%inline.noimage*"
    ])
], $533e157179e1f74d$var$StrongNode);

});

parcelRegister("l1bn3", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $f4d283019414aa5c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StRowNode = module.exports.isStRowNode = module.exports.isValidStRowField = module.exports.StRowFields = void 0;
module.exports.makeStRow = $f4d283019414aa5c$var$makeStRow;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `strow` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `class`, `outputclass`
 */ module.exports.StRowFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `strow` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $f4d283019414aa5c$var$isValidStRowField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidStRowField = $f4d283019414aa5c$var$isValidStRowField;
/**
 * Check if the `strow` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `strow` node to test
 * @returns Boolean
 */ const $f4d283019414aa5c$var$isStRowNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.StRowFields, value, module.exports.isValidStRowField);
module.exports.isStRowNode = $f4d283019414aa5c$var$isStRowNode;
/**
 * Construct a `strow` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `strow` node
 */ function $f4d283019414aa5c$var$makeStRow(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create a `strow` node (Table row) and map the `strow` node with the LwDita tag name `tr`
 *
 * @decorator `@makeComponent`
 * @param makeStRow - The `strow` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidStRowField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link StRowFields}
 * @param childNodes - An Array of allowed child node `stentry*`
 */ let $f4d283019414aa5c$var$StRowNode = class StRowNode extends $7Uewc.AbstractBaseNode {
};
module.exports.StRowNode = $f4d283019414aa5c$var$StRowNode;
$f4d283019414aa5c$var$StRowNode.domNodeName = "tr";
module.exports.StRowNode = $f4d283019414aa5c$var$StRowNode = $f4d283019414aa5c$var$__decorate([
    (0, $7Uewc.makeComponent)($f4d283019414aa5c$var$makeStRow, "strow", module.exports.isValidStRowField, module.exports.StRowFields, [
        "stentry*"
    ])
], $f4d283019414aa5c$var$StRowNode);

});

parcelRegister("cXyv8", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $96f5c1f3ca016209$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubscriptNode = module.exports.isSubscriptNode = module.exports.isValidSubscriptField = module.exports.SubscriptFields = void 0;
module.exports.makeSubscript = $96f5c1f3ca016209$var$makeSubscript;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `subscript` (Subscript content) attributes:
 * `dir`, `xml:lang`, `translate`, `keyref`, `outputclass`, `class`
 */ module.exports.SubscriptFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `subscript` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $96f5c1f3ca016209$var$isValidSubscriptField = (field, value)=>(0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidSubscriptField = $96f5c1f3ca016209$var$isValidSubscriptField;
/**
 * Check if the `subscript` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `subscript` node to test
 * @returns Boolean
 */ const $96f5c1f3ca016209$var$isSubscriptNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.SubscriptFields, value, module.exports.isValidSubscriptField);
module.exports.isSubscriptNode = $96f5c1f3ca016209$var$isSubscriptNode;
/**
 * Construct a `subscript` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `subscript` node
 */ function $96f5c1f3ca016209$var$makeSubscript(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `subscript` node and map the `subscript` node with the LwDita tag name `sb`
 *
 * @decorator `@makeComponent`
 * @param makeSubscript - The `subscript` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidSubscriptField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link SubscriptFields}
 * @param childNodes - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
 */ let $96f5c1f3ca016209$var$SubscriptNode = class SubscriptNode extends $7Uewc.AbstractBaseNode {
};
module.exports.SubscriptNode = $96f5c1f3ca016209$var$SubscriptNode;
$96f5c1f3ca016209$var$SubscriptNode.domNodeName = "sub";
module.exports.SubscriptNode = $96f5c1f3ca016209$var$SubscriptNode = $96f5c1f3ca016209$var$__decorate([
    (0, $7Uewc.makeComponent)($96f5c1f3ca016209$var$makeSubscript, "sub", module.exports.isValidSubscriptField, module.exports.SubscriptFields, [
        "%inline.noimage*"
    ])
], $96f5c1f3ca016209$var$SubscriptNode);

});

parcelRegister("a9PHc", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $7652d853764ef3b6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SuperscriptNode = module.exports.isSuperscriptNode = module.exports.isValidSuperscriptField = module.exports.SuperscriptFields = void 0;
module.exports.makeSuperscript = $7652d853764ef3b6$var$makeSuperscript;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `superscript` attributes:
 * `dir`, `xml:lang`, `translate`, `keyref`, `class`, `outputclass`
 */ module.exports.SuperscriptFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `superscript` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $7652d853764ef3b6$var$isValidSuperscriptField = (field, value)=>(0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidSuperscriptField = $7652d853764ef3b6$var$isValidSuperscriptField;
/**
 * Check if the `superscript` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `superscript` node to test
 * @returns Boolean
 */ const $7652d853764ef3b6$var$isSuperscriptNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.SuperscriptFields, value, module.exports.isValidSuperscriptField);
module.exports.isSuperscriptNode = $7652d853764ef3b6$var$isSuperscriptNode;
/**
 * Construct a `superscript` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `superscript` node
 */ function $7652d853764ef3b6$var$makeSuperscript(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `superscript` node and map the `superscript` node with the LwDita tag name `sup`
 *
 * @decorator `@makeComponent`
 * @param makeSuperscript - The `superscript` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidSuperscriptField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link SuperscriptFields}
 * @param childNodes - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
 */ let $7652d853764ef3b6$var$SuperscriptNode = class SuperscriptNode extends $7Uewc.AbstractBaseNode {
};
module.exports.SuperscriptNode = $7652d853764ef3b6$var$SuperscriptNode;
$7652d853764ef3b6$var$SuperscriptNode.domNodeName = "sup";
module.exports.SuperscriptNode = $7652d853764ef3b6$var$SuperscriptNode = $7652d853764ef3b6$var$__decorate([
    (0, $7Uewc.makeComponent)($7652d853764ef3b6$var$makeSuperscript, "sup", module.exports.isValidSuperscriptField, module.exports.SuperscriptFields, [
        "%inline.noimage*"
    ])
], $7652d853764ef3b6$var$SuperscriptNode);

});

parcelRegister("b8iNJ", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $81af0691566bd0fd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TitleNode = module.exports.isTitleNode = module.exports.isValidTitleField = module.exports.TitleFields = void 0;
module.exports.makeTitle = $81af0691566bd0fd$var$makeTitle;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `title` attributes:
 * `dir`, `xml:lang`, `translate`, `class`, `outputclass`
 */ module.exports.TitleFields = [
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `title` node are valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ const $81af0691566bd0fd$var$isValidTitleField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidTitleField = $81af0691566bd0fd$var$isValidTitleField;
/**
 * Check if the `title` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `title` node to test
 * @returns Boolean
 */ const $81af0691566bd0fd$var$isTitleNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.TitleFields, value, module.exports.isValidTitleField);
module.exports.isTitleNode = $81af0691566bd0fd$var$isTitleNode;
/**
 * Construct a `title` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `title` node
 */ function $81af0691566bd0fd$var$makeTitle(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $gT0BI.makeClass);
}
/**
 * Create a `title` node and map the `title` node with the LwDita tag name `h1`
 *
 * @decorator `@makeComponent`
 * @param makeTitle - The `title` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidTitleField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link TitleFields}
 * @param childNodes - An Array of allowed child nodes: `%inline.noxref*` (`text`, `b`, `em`,  `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `image`)
 */ let $81af0691566bd0fd$var$TitleNode = class TitleNode extends $7Uewc.AbstractBaseNode {
};
module.exports.TitleNode = $81af0691566bd0fd$var$TitleNode;
$81af0691566bd0fd$var$TitleNode.domNodeName = "h1";
module.exports.TitleNode = $81af0691566bd0fd$var$TitleNode = $81af0691566bd0fd$var$__decorate([
    (0, $7Uewc.makeComponent)($81af0691566bd0fd$var$makeTitle, "title", module.exports.isValidTitleField, module.exports.TitleFields, [
        "%inline.noxref*"
    ])
], $81af0691566bd0fd$var$TitleNode);

});

parcelRegister("k6LQ5", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $ea397a06e4b4be23$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TopicNode = module.exports.isTopicNode = module.exports.TopicFields = void 0;
module.exports.isValidTopicField = $ea397a06e4b4be23$var$isValidTopicField;
module.exports.makeTopic = $ea397a06e4b4be23$var$makeTopic;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");

var $8EJCT = parcelRequire("8EJCT");
/**
 * Define all allowed `topic` attributes:
 * `dir`, `xml:lang`, `translate`, `class`, `outputclass`, `id`, `xmlns:ditaarch`, `ditaarch:DITAArchVersion`
 */ module.exports.TopicFields = [
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields,
    ...$8EJCT.SpecializationsFields,
    "id",
    "xmlns:ditaarch",
    "ditaarch:DITAArchVersion"
];
/**
 * Check if the given attributes of the `topic` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ function $ea397a06e4b4be23$var$isValidTopicField(field, value) {
    if ((0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $8EJCT.isValidSpecializationsField)(field, value)) return true;
    switch(field){
        case "id":
            return (0, $lRuta.isOrUndefined)($38z30.isID, value);
        case "xmlns:ditaarch":
            return (0, $lRuta.isOrUndefined)($38z30.isDITAARCH, value);
        case "ditaarch:DITAArchVersion":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `topic` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `topic` node to test
 * @returns Boolean
 */ const $ea397a06e4b4be23$var$isTopicNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.TopicFields, value, $ea397a06e4b4be23$var$isValidTopicField);
module.exports.isTopicNode = $ea397a06e4b4be23$var$isTopicNode;
/**
 * Construct a `topic` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `topic` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ea397a06e4b4be23$var$makeTopic(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "id"() {
            return this.readProp("id");
        }
        set "id"(value) {
            this.writeProp("id", value);
        }
        get "xmlns:ditaarch"() {
            return this.readProp("xmlns:ditaarch");
        }
        set "xmlns:ditaarch"(value) {
            this.writeProp("xmlns:ditaarch", value);
        }
        get "ditaarch:DITAArchVersion"() {
            return this.readProp("ditaarch:DITAArchVersion");
        }
        set "ditaarch:DITAArchVersion"(value) {
            this.writeProp("ditaarch:DITAArchVersion", value);
        }
    }, $kCEGt.makeLocalization, $gT0BI.makeClass, $8EJCT.makeSpecializations);
}
/**
 * Create a `topic` node (article) and map the `topic` node with the LwDita tag name `article`
 *
 * @decorator `@makeComponent`
 * @param makeTopic - The `topic` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidTopicField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link TopicFields}
 * @param childNodes - An Array of allowed child nodes: `title`, `shortdesc?`, `prolog?`, `body?`
 */ let $ea397a06e4b4be23$var$TopicNode = class TopicNode extends $7Uewc.AbstractBaseNode {
};
module.exports.TopicNode = $ea397a06e4b4be23$var$TopicNode;
$ea397a06e4b4be23$var$TopicNode.domNodeName = "article";
module.exports.TopicNode = $ea397a06e4b4be23$var$TopicNode = $ea397a06e4b4be23$var$__decorate([
    (0, $7Uewc.makeComponent)($ea397a06e4b4be23$var$makeTopic, "topic", $ea397a06e4b4be23$var$isValidTopicField, module.exports.TopicFields, [
        "title",
        "shortdesc?",
        "prolog?",
        "body?"
    ])
], $ea397a06e4b4be23$var$TopicNode);

});

parcelRegister("eDKcN", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $aa888ca64ea4211d$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TopicmetaNode = module.exports.isTopicmetaNode = module.exports.isValidTopicmetaField = module.exports.TopicmetaFields = void 0;
module.exports.makeTopicmeta = $aa888ca64ea4211d$var$makeTopicmeta;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `topicmeta` (Metadata) attributes:
 * `dir`, `xml:lang`, `translate`, `class`, `outputclass`
 */ module.exports.TopicmetaFields = [
    ...$kCEGt.LocalizationFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `topicmeta` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ const $aa888ca64ea4211d$var$isValidTopicmetaField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidTopicmetaField = $aa888ca64ea4211d$var$isValidTopicmetaField;
/**
 * Check if the `topicmeta` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `topicmeta` node to test
 * @returns Boolean
 */ const $aa888ca64ea4211d$var$isTopicmetaNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.TopicmetaFields, value, module.exports.isValidTopicmetaField);
module.exports.isTopicmetaNode = $aa888ca64ea4211d$var$isTopicmetaNode;
/**
 * Construct a `topicmeta` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `topicmeta` node
 */ function $aa888ca64ea4211d$var$makeTopicmeta(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $gT0BI.makeClass);
}
/**
 * Create a `topicmeta` node (Metadata)
 *
 * @decorator `@makeComponent`
 * @param makeTopicmeta - The `topicmeta` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidTopicmetaField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link TopicmetaFields}
 * @param childNodes - An Array of allowed child nodes: `navtitle?`, `keytext?`, `othermeta*`
 */ let $aa888ca64ea4211d$var$TopicmetaNode = class TopicmetaNode extends $7Uewc.AbstractBaseNode {
};
module.exports.TopicmetaNode = $aa888ca64ea4211d$var$TopicmetaNode;
module.exports.TopicmetaNode = $aa888ca64ea4211d$var$TopicmetaNode = $aa888ca64ea4211d$var$__decorate([
    (0, $7Uewc.makeComponent)($aa888ca64ea4211d$var$makeTopicmeta, "topicmeta", module.exports.isValidTopicmetaField, module.exports.TopicmetaFields, [
        "navtitle?",
        "keytext?",
        "othermeta*"
    ])
], $aa888ca64ea4211d$var$TopicmetaNode);

});

parcelRegister("dnRz0", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $9be6f8f17d3968d2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TopicrefNode = module.exports.isTopicrefNode = module.exports.TopicrefFields = void 0;
module.exports.isValidTopicrefField = $9be6f8f17d3968d2$var$isValidTopicrefField;
module.exports.makeTopicref = $9be6f8f17d3968d2$var$makeTopicref;

var $kCEGt = parcelRequire("kCEGt");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $38z30 = parcelRequire("38z30");

var $3rAp4 = parcelRequire("3rAp4");

var $22qJU = parcelRequire("22qJU");

var $dAWNe = parcelRequire("dAWNe");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `topicref` attributes:
 * `dir`, `xml:lang`, `translate`, `props`, `class`, `outputclass`, `id`, `conref`, `href`, `format`, `scope`, `keyref`, `keys`
 */ module.exports.TopicrefFields = [
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$gT0BI.ClassFields,
    ...$3rAp4.ReferenceContentFields,
    ...$dAWNe.ReuseFields,
    ...$c7Ayi.VariableContentFields,
    "keys"
];
/**
 * Check if the given attributes of the `topicref` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ function $9be6f8f17d3968d2$var$isValidTopicrefField(field, value) {
    if ((0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value)) return true;
    switch(field){
        case "keys":
            return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
        default:
            return false;
    }
}
/**
 * Check if the `topicref` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `topicref` node to test
 * @returns Boolean
 */ const $9be6f8f17d3968d2$var$isTopicrefNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.TopicrefFields, value, $9be6f8f17d3968d2$var$isValidTopicrefField);
module.exports.isTopicrefNode = $9be6f8f17d3968d2$var$isTopicrefNode;
/**
 * Construct a `topicref` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `topicref` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9be6f8f17d3968d2$var$makeTopicref(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "keys"() {
            return this.readProp("keys");
        }
        set "keys"(value) {
            this.writeProp("keys", value);
        }
    }, $kCEGt.makeLocalization, $gT0BI.makeClass, $dAWNe.makeReuse, $22qJU.makeFilters, $c7Ayi.makeVariableContent);
}
/**
 * Create a `topicref` node (Topic or Map Reference)
 *
 * @decorator `@makeComponent`
 * @param makeTopicref - The `topicref` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidTopicrefField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes, @see {@link TopicrefFields}
 * @param childNodes - An Array of allowed child nodes: `topicmeta?`
 */ let $9be6f8f17d3968d2$var$TopicrefNode = class TopicrefNode extends $7Uewc.AbstractBaseNode {
};
module.exports.TopicrefNode = $9be6f8f17d3968d2$var$TopicrefNode;
module.exports.TopicrefNode = $9be6f8f17d3968d2$var$TopicrefNode = $9be6f8f17d3968d2$var$__decorate([
    (0, $7Uewc.makeComponent)($9be6f8f17d3968d2$var$makeTopicref, "topicref", $9be6f8f17d3968d2$var$isValidTopicrefField, module.exports.TopicrefFields, [
        "topicmeta?",
        "topicref?"
    ])
], $9be6f8f17d3968d2$var$TopicrefNode);

});

parcelRegister("9XAst", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $7405e79cd549f3a9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TtNode = module.exports.isTtNode = module.exports.isValidTtField = module.exports.TtFields = void 0;
module.exports.makeTt = $7405e79cd549f3a9$var$makeTt;

var $kCEGt = parcelRequire("kCEGt");

var $c7Ayi = parcelRequire("c7Ayi");

var $gT0BI = parcelRequire("gT0BI");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `tt` (Teletype content) fields:
 * `dir`, `xml:lang`, `translate`, `keyref`, `outputclass`, `class`
 */ module.exports.TtFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given fields of the `tt` node are valid and matches this list:
 * `keyref`, `outputclass`, `class`, `dir`, `xml:lang`, `translate`
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $7405e79cd549f3a9$var$isValidTtField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidTtField = $7405e79cd549f3a9$var$isValidTtField;
/**
 * Check if the `tt` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `tt` node to test
 * @returns Boolean
 */ const $7405e79cd549f3a9$var$isTtNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.TtFields, value, module.exports.isValidTtField);
module.exports.isTtNode = $7405e79cd549f3a9$var$isTtNode;
/**
 * Construct an `tt` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `tt` node
 */ function $7405e79cd549f3a9$var$makeTt(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a `tt` node
 *
 * @decorator `@makeComponent`
 * @param makeTt - The `tt` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidEmField - A boolean value, if the field is valid or not
 * @param fields - A List of valid fields
 * @param childNodes - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
 */ let $7405e79cd549f3a9$var$TtNode = class TtNode extends $7Uewc.AbstractBaseNode {
};
module.exports.TtNode = $7405e79cd549f3a9$var$TtNode;
module.exports.TtNode = $7405e79cd549f3a9$var$TtNode = $7405e79cd549f3a9$var$__decorate([
    (0, $7Uewc.makeComponent)($7405e79cd549f3a9$var$makeTt, "tt", module.exports.isValidTtField, module.exports.TtFields, [
        "%inline.noimage*"
    ])
], $7405e79cd549f3a9$var$TtNode);

});

parcelRegister("5QxUx", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $441c1d17b8d5c471$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UlNode = module.exports.isUlNode = module.exports.isValidUlField = module.exports.UlFields = void 0;
module.exports.makeUl = $441c1d17b8d5c471$var$makeUl;

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");
/**
 * Define all allowed `ul` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`, `outputclass`, `class`
 */ module.exports.UlFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `ul` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ const $441c1d17b8d5c471$var$isValidUlField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidUlField = $441c1d17b8d5c471$var$isValidUlField;
/**
 * Check if the `ul` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `ul` node to test
 * @returns Boolean
 */ const $441c1d17b8d5c471$var$isUlNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.UlFields, value, module.exports.isValidUlField);
module.exports.isUlNode = $441c1d17b8d5c471$var$isUlNode;
/**
 * Construct an `ul` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `ul` node
 */ function $441c1d17b8d5c471$var$makeUl(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $dAWNe.makeReuse, $gT0BI.makeClass);
}
/**
 * Create an `ul` node (Unordered list) and map the `ul` node with the LwDita tag name `ul`
 *
 * @decorator `@makeComponent`
 * @param makeUl - The `ul` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidUlField - A boolean value, if the attribute is valid or not
 * @param fields - A List of valid attributes @see {@link UlFields}
 * @param childNodes - An Array of allowed child nodes: `li+`
 */ let $441c1d17b8d5c471$var$UlNode = class UlNode extends $7Uewc.AbstractBaseNode {
};
module.exports.UlNode = $441c1d17b8d5c471$var$UlNode;
$441c1d17b8d5c471$var$UlNode.domNodeName = "ul";
module.exports.UlNode = $441c1d17b8d5c471$var$UlNode = $441c1d17b8d5c471$var$__decorate([
    (0, $7Uewc.makeComponent)($441c1d17b8d5c471$var$makeUl, "ul", module.exports.isValidUlField, module.exports.UlFields, [
        "li+"
    ])
], $441c1d17b8d5c471$var$UlNode);

});

parcelRegister("HIFUh", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $0836abc645da0f9f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderlinedNode = module.exports.isUnderlinedNode = module.exports.isValidUnderlinedField = module.exports.UnderlinedFields = void 0;
module.exports.makeUnderlined = $0836abc645da0f9f$var$makeUnderlined;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `underlined` attributes:
 * `dir`, `xml:lang`, `translate`, `keyref`, `class`, `outputclass`
 */ module.exports.UnderlinedFields = [
    ...$kCEGt.LocalizationFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `underlined` node are valid
 *
 * @param field - A string containing the name of the attributes
 * @param value - A BasicValue-typed value containing the attributes value
 * @returns Boolean
 */ const $0836abc645da0f9f$var$isValidUnderlinedField = (field, value)=>(0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidUnderlinedField = $0836abc645da0f9f$var$isValidUnderlinedField;
/**
 * Check if the `underlined` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `underlined` node to test
 * @returns Boolean
 */ const $0836abc645da0f9f$var$isUnderlinedNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.UnderlinedFields, value, module.exports.isValidUnderlinedField);
module.exports.isUnderlinedNode = $0836abc645da0f9f$var$isUnderlinedNode;
/**
 * Construct an `underlined` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `underlined` node
 */ function $0836abc645da0f9f$var$makeUnderlined(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create an `underlined` node and map the `underlined` node with the LwDita tag name `u`
 *
 * @decorator `@makeComponent`
 * @param makeUnderlined - The `underlined` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidUnderlinedField - A boolean value, if the attributes is valid or not
 * @param fields - A List of valid attributes @see {@link UnderlinedFields}
 * @param childNodes - An Array of allowed child nodes (`text`, `b`, `em`, `i`, `ph`, `strong`, `sub`, `sup`, `tt`, `u`, `xref`)
 */ let $0836abc645da0f9f$var$UnderlinedNode = class UnderlinedNode extends $7Uewc.AbstractBaseNode {
};
module.exports.UnderlinedNode = $0836abc645da0f9f$var$UnderlinedNode;
$0836abc645da0f9f$var$UnderlinedNode.domNodeName = "u";
module.exports.UnderlinedNode = $0836abc645da0f9f$var$UnderlinedNode = $0836abc645da0f9f$var$__decorate([
    (0, $7Uewc.makeComponent)($0836abc645da0f9f$var$makeUnderlined, "u", module.exports.isValidUnderlinedField, module.exports.UnderlinedFields, [
        "%inline.noimage*"
    ])
], $0836abc645da0f9f$var$UnderlinedNode);

});

parcelRegister("fg70N", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $b1bdca0699b0875b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoNode = module.exports.isVideoNode = module.exports.VideoFields = void 0;
module.exports.isValidVideoField = $b1bdca0699b0875b$var$isValidVideoField;
module.exports.makeVideo = $b1bdca0699b0875b$var$makeVideo;

var $22qJU = parcelRequire("22qJU");

var $gT0BI = parcelRequire("gT0BI");

var $dAWNe = parcelRequire("dAWNe");

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $dWUFe = parcelRequire("dWUFe");

var $38z30 = parcelRequire("38z30");

var $3rAp4 = parcelRequire("3rAp4");
/**
 * Define all allowed `video` attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `id`, `conref`,
 * `outputclass`, `class`, `width`, `height`, `href`,
 * `format`, `scope`, `autoplay`, `controls`, `loop`, `muted`, `tabindex`
 */ module.exports.VideoFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$3rAp4.ReferenceContentFields,
    ...$dAWNe.ReuseFields,
    ...$gT0BI.ClassFields,
    ...$dWUFe.SizeFields,
    "autoplay",
    "controls",
    "loop",
    "muted",
    "tabindex"
];
/**
 * Check if the given attributes of the `video` node are valid
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ function $b1bdca0699b0875b$var$isValidVideoField(field, value) {
    if ((0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $dWUFe.isValidSizeField)(field, value)) return true;
    switch(field){
        case "autoplay":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "controls":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "loop":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "muted":
            return (0, $lRuta.isOrUndefined)($38z30.isBooleanString, value);
        case "tabindex":
            return (0, $lRuta.isOrUndefined)($38z30.isNMTOKEN, value);
        default:
            return false;
    }
}
/**
 * Check if the `video` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `video` node to test
 * @returns Boolean
 */ const $b1bdca0699b0875b$var$isVideoNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.VideoFields, value, $b1bdca0699b0875b$var$isValidVideoField);
module.exports.isVideoNode = $b1bdca0699b0875b$var$isVideoNode;
/**
 * Construct a `video` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `video` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b1bdca0699b0875b$var$makeVideo(constructor) {
    return (0, $7Uewc.makeAll)(class extends constructor {
        get "autoplay"() {
            return this.readProp("autoplay");
        }
        set "autoplay"(value) {
            this.writeProp("autoplay", value);
        }
        get "controls"() {
            return this.readProp("controls");
        }
        set "controls"(value) {
            this.writeProp("controls", value);
        }
        get "loop"() {
            return this.readProp("loop");
        }
        set "loop"(value) {
            this.writeProp("loop", value);
        }
        get "muted"() {
            return this.readProp("muted");
        }
        set "muted"(value) {
            this.writeProp("muted", value);
        }
        get "tabindex"() {
            return this.readProp("tabindex");
        }
        set "tabindex"(value) {
            this.writeProp("tabindex", value);
        }
    }, $kCEGt.makeLocalization, $22qJU.makeFilters, $3rAp4.makeReferenceContent, $dAWNe.makeReuse, $gT0BI.makeClass, $dWUFe.makeSize);
}
/**
 * Create a video node
 *
 * @decorator `@makeComponent`
 * @param makeVideo - The `video` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidVideoField - A boolean value, if the field is valid or not
 * @param fields - A List of valid attributes @see {@link VideoFields}
 * @param childNodes - An Array of allowed child nodes: `desc?`, `fallback`, `video-poster?`, `media-source*`, `media-track*`
 */ let $b1bdca0699b0875b$var$VideoNode = class VideoNode extends $7Uewc.AbstractBaseNode {
};
module.exports.VideoNode = $b1bdca0699b0875b$var$VideoNode;
module.exports.VideoNode = $b1bdca0699b0875b$var$VideoNode = $b1bdca0699b0875b$var$__decorate([
    (0, $7Uewc.makeComponent)($b1bdca0699b0875b$var$makeVideo, "video", $b1bdca0699b0875b$var$isValidVideoField, module.exports.VideoFields, [
        "desc?",
        "fallback?",
        "video-poster?",
        "media-source*",
        "media-track*"
    ])
], $b1bdca0699b0875b$var$VideoNode);

});

parcelRegister("1BGxu", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $12ba3e892fd2fc5a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VideoPosterNode = module.exports.isVideoPosterNode = module.exports.isValidVideoPosterField = module.exports.VideoPosterFields = void 0;
module.exports.makeVideoPoster = $12ba3e892fd2fc5a$var$makeVideoPoster;

var $kCEGt = parcelRequire("kCEGt");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $gT0BI = parcelRequire("gT0BI");

var $22qJU = parcelRequire("22qJU");

var $3rAp4 = parcelRequire("3rAp4");

var $dAWNe = parcelRequire("dAWNe");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `video-poster` attributes:
 * `dir`, `xml:lang`, `translate`, `props`,  `href`,
 * `format`, `scope`, `id`, `conref`, `keyref`, `outputclass`, `class`
 */ module.exports.VideoPosterFields = [
    ...$kCEGt.LocalizationFields,
    ...$22qJU.FiltersFields,
    ...$3rAp4.ReferenceContentFields,
    ...$dAWNe.ReuseFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `video-poster` node are valid
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $12ba3e892fd2fc5a$var$isValidVideoPosterField = (field, value)=>(0, $kCEGt.isValidLocalizationField)(field, value) || (0, $22qJU.isValidFiltersField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $dAWNe.isValidReuseField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value) || (0, $gT0BI.isValidClassField)(field, value);
module.exports.isValidVideoPosterField = $12ba3e892fd2fc5a$var$isValidVideoPosterField;
/**
 * Check if the `video-poster` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `video-poster` node to test
 * @returns Boolean
 */ const $12ba3e892fd2fc5a$var$isVideoPosterNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.VideoPosterFields, value, module.exports.isValidVideoPosterField);
module.exports.isVideoPosterNode = $12ba3e892fd2fc5a$var$isVideoPosterNode;
/**
 * Construct a `video-poster` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns A `video-poster` node
 */ function $12ba3e892fd2fc5a$var$makeVideoPoster(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $3rAp4.makeReferenceContent, $dAWNe.makeReuse, $c7Ayi.makeVariableContent, $gT0BI.makeClass);
}
/**
 * Create a video-poster node
 *
 * @decorator `@makeComponent`
 * @param makeVideoPoster - The `video-poster` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidVideoPosterField - A boolean value, if the field is valid or not
 * @param fields - A List of valid attributes @see {@link VideoPosterFields}
 */ let $12ba3e892fd2fc5a$var$VideoPosterNode = class VideoPosterNode extends $7Uewc.AbstractBaseNode {
};
module.exports.VideoPosterNode = $12ba3e892fd2fc5a$var$VideoPosterNode;
module.exports.VideoPosterNode = $12ba3e892fd2fc5a$var$VideoPosterNode = $12ba3e892fd2fc5a$var$__decorate([
    (0, $7Uewc.makeComponent)($12ba3e892fd2fc5a$var$makeVideoPoster, "video-poster", module.exports.isValidVideoPosterField, module.exports.VideoPosterFields)
], $12ba3e892fd2fc5a$var$VideoPosterNode);

});

parcelRegister("jnCMm", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $e1be3f06e299de7b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XRefNode = module.exports.isXRefNode = module.exports.isValidXRefField = module.exports.XRefFields = void 0;
module.exports.makeXRef = $e1be3f06e299de7b$var$makeXRef;

var $gT0BI = parcelRequire("gT0BI");

var $kCEGt = parcelRequire("kCEGt");

var $22qJU = parcelRequire("22qJU");

var $lRuta = parcelRequire("lRuta");

var $7Uewc = parcelRequire("7Uewc");

var $3rAp4 = parcelRequire("3rAp4");

var $c7Ayi = parcelRequire("c7Ayi");
/**
 * Define all allowed `xref` (Reference) attributes:
 * `props`, `dir`, `xml:lang`, `translate`, `href`, `format`, `scope`, `keyref`,`outputclass`, `class`
 */ module.exports.XRefFields = [
    ...$22qJU.FiltersFields,
    ...$kCEGt.LocalizationFields,
    ...$3rAp4.ReferenceContentFields,
    ...$c7Ayi.VariableContentFields,
    ...$gT0BI.ClassFields
];
/**
 * Check if the given attributes of the `xref` node are valid
 *
 * @param field - A string containing the name of the field
 * @param value - A BasicValue-typed value containing the field value
 * @returns Boolean
 */ const $e1be3f06e299de7b$var$isValidXRefField = (field, value)=>(0, $22qJU.isValidFiltersField)(field, value) || (0, $kCEGt.isValidLocalizationField)(field, value) || (0, $gT0BI.isValidClassField)(field, value) || (0, $3rAp4.isValidReferenceContentField)(field, value) || (0, $c7Ayi.isValidVariableContentField)(field, value);
module.exports.isValidXRefField = $e1be3f06e299de7b$var$isValidXRefField;
/**
 * Check if the `xref` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `xref` node to test
 * @returns Boolean
 */ const $e1be3f06e299de7b$var$isXRefNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.XRefFields, value, module.exports.isValidXRefField);
module.exports.isXRefNode = $e1be3f06e299de7b$var$isXRefNode;
/**
 * Construct an `xref` node with all available attributes
 *
 * @param constructor - The constructor
 * @returns An `xref` node
 */ function $e1be3f06e299de7b$var$makeXRef(constructor) {
    return (0, $7Uewc.makeAll)(constructor, $kCEGt.makeLocalization, $22qJU.makeFilters, $gT0BI.makeClass, $3rAp4.makeReferenceContent, $c7Ayi.makeVariableContent);
}
/**
 * Create an xref node (cross reference) and map the `xref` node with the LwDita tag name `a`
 *
 * @decorator `@makeComponent`
 * @param makeXRef - The `xref` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidXRefField - A boolean value, if the attributes is valid or not
 * @param fields - A List of valid attributes @see {@link XRefFields}
 * @param childNodes - An Array of allowed child node `%inline.noxref*`: `text`, `ph`, `image`
 */ let $e1be3f06e299de7b$var$XRefNode = class XRefNode extends $7Uewc.AbstractBaseNode {
};
module.exports.XRefNode = $e1be3f06e299de7b$var$XRefNode;
$e1be3f06e299de7b$var$XRefNode.domNodeName = "a";
module.exports.XRefNode = $e1be3f06e299de7b$var$XRefNode = $e1be3f06e299de7b$var$__decorate([
    (0, $7Uewc.makeComponent)($e1be3f06e299de7b$var$makeXRef, "xref", module.exports.isValidXRefField, module.exports.XRefFields, [
        "%inline.noxref*"
    ])
], $e1be3f06e299de7b$var$XRefNode);

});


parcelRegister("2IpG1", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $1fa39bb79b6ea36e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1fa39bb79b6ea36e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1fa39bb79b6ea36e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("aZ93Y")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("l2MDk")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("7Uewc")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("bxKqZ")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("ijj0O")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("gT0BI")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("41DmS")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("9AVDl")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("9KUto")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("7tEnl")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("1wL3m")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("lvlE5")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("4ehFq")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("hXF6r")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("a6Brx")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("4yNjh")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("7IWky")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("3VZ65")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("eheOG")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("stdZo")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("4b9pi")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("22qJU")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("855Xi")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("b6btC")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("5WqeZ")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("7KFhV")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("f5Obj")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("dOaWj")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("dOaWj")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("8Uhbn")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("kCEGt")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("eY9fH")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("bV8lz")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("23hQz")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("k268p")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("5f1xY")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("cYzuY")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("k4O5A")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("gaX2o")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("g41Dz")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("8jviQ")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("2zXyl")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("6VH7H")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("3rAp4")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("dAWNe")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("fjtDj")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("lMYdM")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("1NVZt")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("dWUFe")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("lXNXY")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("4lPc1")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("7964w")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("l1bn3")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("cXyv8")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("a9PHc")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("91hWj")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("b8iNJ")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("k6LQ5")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("eDKcN")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("dnRz0")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("9XAst")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("5QxUx")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("HIFUh")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("c7Ayi")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("1BGxu")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("fg70N")), module.exports);

$1fa39bb79b6ea36e$var$__exportStar((parcelRequire("jnCMm")), module.exports);

});
parcelRegister("41DmS", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $2ee5cb14f56f7c7c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CDataNode = module.exports.isCDataNode = module.exports.CDataFields = void 0;
module.exports.isValidCDataField = $2ee5cb14f56f7c7c$var$isValidCDataField;
module.exports.makeCData = $2ee5cb14f56f7c7c$var$makeCData;

var $7Uewc = parcelRequire("7Uewc");

var $lRuta = parcelRequire("lRuta");
/**
 * The valid fields for the CDataNode.
 */ module.exports.CDataFields = [
    "content"
];
/**
 * Check if the attribute `content` of the `CDataNode` is valid.
 *
 * @param field - The name of the attribute.
 * @param value - The value of the attribute.
 * @returns A boolean indicating if the attribute is valid.
 */ function $2ee5cb14f56f7c7c$var$isValidCDataField(field, value) {
    switch(field){
        case "content":
            return (0, $lRuta.isOrUndefined)((content)=>typeof content === "string", value);
        default:
            return false;
    }
}
/**
 * Check if the `CDataNode` is valid.
 *
 * @remarks
 * Assert that the CDataNode is an object, has content,
 * and that the content is of type `string`.
 *
 * @param value - The CDataNode to test.
 * @returns A boolean indicating if the CDataNode is valid.
 */ const $2ee5cb14f56f7c7c$var$isCDataNode = (value)=>typeof value === "object" && !!value && "content" in value && typeof value.content === "string";
module.exports.isCDataNode = $2ee5cb14f56f7c7c$var$isCDataNode;
/**
 * Construct a `CDataNode` containing a `content` property.
 *
 * @param constructor - The constructor.
 * @returns The `CDataNode`.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2ee5cb14f56f7c7c$var$makeCData(constructor) {
    return class extends constructor {
        get "content"() {
            return this.readProp("content");
        }
        set "content"(value) {
            this.writeProp("content", value);
        }
    };
}
/**
 * Create a `CDataNode` containing a text content.
 *
 * @decorator `@makeComponent`
 * @param makeCData - The `CDataNode` constructor.
 * @param nodeName - The name of the node.
 * @param isValidTextField - A boolean value indicating if the attribute is valid or not.
 * @param fields - The valid attribute `content` of type string.
 */ let $2ee5cb14f56f7c7c$var$CDataNode = class CDataNode extends $7Uewc.AbstractBaseNode {
    constructor(content){
        super({
            content: content
        });
    }
    get json() {
        return {
            nodeName: this.static.nodeName,
            content: this._props["content"]
        };
    }
};
module.exports.CDataNode = $2ee5cb14f56f7c7c$var$CDataNode;
module.exports.CDataNode = $2ee5cb14f56f7c7c$var$CDataNode = $2ee5cb14f56f7c7c$var$__decorate([
    (0, $7Uewc.makeComponent)($2ee5cb14f56f7c7c$var$makeCData, "cdata", $2ee5cb14f56f7c7c$var$isValidCDataField, module.exports.CDataFields)
], $2ee5cb14f56f7c7c$var$CDataNode);

});

parcelRegister("hXF6r", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DocumentNode = void 0;

var $7Uewc = parcelRequire("7Uewc");

var $lRuta = parcelRequire("lRuta");
/**
 * The `document` node is the root node of the document tree and the entry point for the parser
 *
 * @example
 * ```xml
 * <document>
 *   <topic/>
 * </document>
 * ```
 */ class $d137d48bd1a189c8$var$DocumentNode extends $7Uewc.AbstractBaseNode {
}
module.exports.DocumentNode = $d137d48bd1a189c8$var$DocumentNode;
// TODO rename this to undefined
$d137d48bd1a189c8$var$DocumentNode.nodeName = "document";
$d137d48bd1a189c8$var$DocumentNode.childTypes = (0, $lRuta.stringToChildTypes)([
    "topic"
]);
$d137d48bd1a189c8$var$DocumentNode.fields = [];
$d137d48bd1a189c8$var$DocumentNode.isValidField = ()=>true;

});

parcelRegister("eheOG", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeBooleanField = module.exports.isValidBooleanFieldField = module.exports.makeCDATAField = module.exports.isValidCDATAFieldField = module.exports.isFieldNode = module.exports.isValidFieldField = module.exports.FieldFields = void 0;
module.exports.makeField = $a64e25785151061a$var$makeField;

var $lRuta = parcelRequire("lRuta");

var $38z30 = parcelRequire("38z30");
/**
 * `FieldFields`: `name`, `value`
 */ module.exports.FieldFields = [
    "name",
    "value"
];
/**
 * `isValidFieldField` - Check if the attributes `name`, `value` are valid.
 *
 * @see {@link FieldFields}
 *
 * @param validator - a function that takes a BasicValue and returns a boolean
 * @returns function - The return function takes two parameters `name`, `value` and returns a boolean
 */ const $a64e25785151061a$var$isValidFieldField = (validator = $38z30.isCDATA)=>(field, value)=>{
        switch(field){
            case "name":
                return (0, $lRuta.isOrUndefined)($38z30.isCDATA, value);
            case "value":
                return (0, $lRuta.isOrUndefined)(validator, value);
            default:
                return false;
        }
    };
module.exports.isValidFieldField = $a64e25785151061a$var$isValidFieldField;
/**
 * `isFieldNode` - Check if the `field` node is valid
 *
 * @remarks
 * Assert that the node is an object and has valid attributes
 *
 * @param value - The `field` node to test
 * @returns Boolean
 */ const $a64e25785151061a$var$isFieldNode = (value)=>typeof value === "object" && !!value && (0, $lRuta.areFieldsValid)(module.exports.FieldFields, value, (0, module.exports.isValidFieldField)());
module.exports.isFieldNode = $a64e25785151061a$var$isFieldNode;
/**
 * `makeField` - Create a `field` node
 *
 * @param constructor - The constructor
 * @returns The `field` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a64e25785151061a$var$makeField(constructor) {
    return class extends constructor {
        get "name"() {
            return this.readProp("name");
        }
        set "name"(value) {
            this.writeProp("name", value);
        }
        get "value"() {
            return this.readProp("value");
        }
        set "value"(value) {
            this.writeProp("value", value);
        }
    };
}
/**
 * `isValidCDATAFieldField` - Checks if the field is a CDATA type
 *
 * @param field - the field to check
 * @param value - the value to check
 * @returns boolean
 */ module.exports.isValidCDATAFieldField = (0, module.exports.isValidFieldField)();
/**
 * `makeCDATAField` - Make a CDATA field
 *
 * A function that takes a constructor and returns calls makeField with that constructor
 * @param constructor - The contructor
 * @returns a CDATA field
 */ const $a64e25785151061a$var$makeCDATAField = (constructor)=>$a64e25785151061a$var$makeField(constructor);
module.exports.makeCDATAField = $a64e25785151061a$var$makeCDATAField;
/**
 * isValidBooleanFieldField  -  Checks if the boolean field node is valid
 * by calling `isValidFieldField` with a function `typeof` that checks if the value is a boolean
 */ module.exports.isValidBooleanFieldField = (0, module.exports.isValidFieldField)((val)=>typeof val === "boolean");
/**
 * `makeBooleanField` - Make a boolean field
 *
 * @remarks
 * A function that takes a constructor and returns calls makeField with that constructor
 *
 * @param constructor - The contructor
 * @returns A boolean field
 */ const $a64e25785151061a$var$makeBooleanField = (constructor)=>$a64e25785151061a$var$makeField(constructor);
module.exports.makeBooleanField = $a64e25785151061a$var$makeBooleanField;

});

parcelRegister("91hWj", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $69121f731734e01c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TextNode = module.exports.isTextNode = module.exports.TextFields = void 0;
module.exports.isValidTextField = $69121f731734e01c$var$isValidTextField;
module.exports.makeText = $69121f731734e01c$var$makeText;

var $7Uewc = parcelRequire("7Uewc");

var $lRuta = parcelRequire("lRuta");
/**
 * Define the allowed `text` attribute:
 * The only allowed field is `content`
 */ module.exports.TextFields = [
    "content"
];
/**
 * Check if the attribute `content` of the `text` node is valid
 *
 * @param field - A string containing the name of the attribute
 * @param value - A BasicValue-typed value containing the attribute value
 * @returns Boolean
 */ function $69121f731734e01c$var$isValidTextField(field, value) {
    switch(field){
        case "content":
            return (0, $lRuta.isOrUndefined)((content)=>typeof content === "string", value);
        default:
            return false;
    }
}
/**
 * Check if the `text` node is valid
 *
 * @remarks
 * Assert that the text node is an object, has content,
 * and that the content meets the required type `string`.
 *
 * @param value - The `text` node to test
 * @returns
 */ const $69121f731734e01c$var$isTextNode = (value)=>typeof value === "object" && !!value && "content" in value && typeof value.content === "string";
module.exports.isTextNode = $69121f731734e01c$var$isTextNode;
/**
 * Construct a `text` node containing a `content` property
 *
 * @param constructor - The constructor
 * @returns The `text` node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $69121f731734e01c$var$makeText(constructor) {
    return class extends constructor {
        get "content"() {
            return this.readProp("content");
        }
        set "content"(value) {
            this.writeProp("content", value);
        }
    };
}
/**
 * Create a `text` node containing a text content
 *
 * @decorator `@makeComponent`
 * @param makeText - The `text` node constructor
 * @param nodeName - A string containing the node name
 * @param isValidTextField - A boolean value, if the attribute is valid or not
 * @param fields - The valid attribute `content` of type string
 */ let $69121f731734e01c$var$TextNode = class TextNode extends $7Uewc.AbstractBaseNode {
    constructor(content){
        super({
            content: content
        });
    }
    get json() {
        return {
            nodeName: this.static.nodeName,
            content: this._props["content"]
        };
    }
};
module.exports.TextNode = $69121f731734e01c$var$TextNode;
module.exports.TextNode = $69121f731734e01c$var$TextNode = $69121f731734e01c$var$__decorate([
    (0, $7Uewc.makeComponent)($69121f731734e01c$var$makeText, "text", $69121f731734e01c$var$isValidTextField, module.exports.TextFields)
], $69121f731734e01c$var$TextNode);

});


parcelRegister("eSF03", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("hWgwJ", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DOM_NODES = void 0;
module.exports.getDomNode = $d0f4ac59c8154abc$var$getDomNode;
/**
 * DOM nodes mapping from JDITA to HTML
 */ module.exports.DOM_NODES = {
    alt: "alt",
    audio: "audio",
    body: "div",
    b: "strong",
    //data: 'data',
    desc: (parent)=>parent === "fig" ? "figcaption" : "caption",
    dd: "dd",
    div: "div",
    dl: "dl",
    document: "doc",
    dt: "dt",
    dlentry: "div",
    em: "em",
    example: "div",
    fallback: "p",
    fig: "figure",
    fn: "span",
    i: "em",
    image: "img",
    "media-source": "source",
    "media-track": "track",
    li: "li",
    note: "div",
    ol: "ol",
    p: "p",
    ph: "span",
    pre: "pre",
    prolog: "p",
    section: "section",
    shortdesc: "p",
    simpletable: "table",
    stentry: "td",
    sthead: "thead",
    strow: "tr",
    strong: "strong",
    sub: "sub",
    sup: "sup",
    title: (parent)=>parent === "section" ? "h2" : "h1",
    topic: "article",
    tt: "span",
    u: "u",
    ul: "ul",
    video: "video",
    xref: "a"
};
/**
 * Get the HTML node name for a JDITA node
 *
 * @param node - JDITA node name
 * @param parent - JDITA parent node name
 * @returns HTML node name
 */ function $d0f4ac59c8154abc$var$getDomNode(node, parent) {
    const domName = module.exports.DOM_NODES[node];
    return domName ? typeof domName === "string" ? domName : domName(parent) : "jdita-node-" + node;
}

});

parcelRegister("6B4AI", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $4cd9c27f1eafc914$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $4cd9c27f1eafc914$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $4cd9c27f1eafc914$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "Node", () => $4cd9c27f1eafc914$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $4cd9c27f1eafc914$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $4cd9c27f1eafc914$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $4cd9c27f1eafc914$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $4cd9c27f1eafc914$export$3476b78f8f5a8b72);

var $cR2Z7 = parcelRequire("cR2Z7");
function $4cd9c27f1eafc914$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $4cd9c27f1eafc914$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $4cd9c27f1eafc914$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $4cd9c27f1eafc914$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $4cd9c27f1eafc914$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $4cd9c27f1eafc914$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $4cd9c27f1eafc914$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $4cd9c27f1eafc914$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $4cd9c27f1eafc914$var$retIndex(0, pos);
        if (pos == this.size) return $4cd9c27f1eafc914$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $4cd9c27f1eafc914$var$retIndex(i + 1, end);
                return $4cd9c27f1eafc914$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $4cd9c27f1eafc914$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $4cd9c27f1eafc914$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $4cd9c27f1eafc914$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $4cd9c27f1eafc914$export$ffb0004e005737fa.empty;
        if (nodes instanceof $4cd9c27f1eafc914$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $4cd9c27f1eafc914$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $4cd9c27f1eafc914$export$ffb0004e005737fa.empty = new $4cd9c27f1eafc914$export$ffb0004e005737fa([], 0);
const $4cd9c27f1eafc914$var$found = {
    index: 0,
    offset: 0
};
function $4cd9c27f1eafc914$var$retIndex(index, offset) {
    $4cd9c27f1eafc914$var$found.index = index;
    $4cd9c27f1eafc914$var$found.offset = offset;
    return $4cd9c27f1eafc914$var$found;
}
function $4cd9c27f1eafc914$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$4cd9c27f1eafc914$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$4cd9c27f1eafc914$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $4cd9c27f1eafc914$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $4cd9c27f1eafc914$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none;
        if (marks instanceof $4cd9c27f1eafc914$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $4cd9c27f1eafc914$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $4cd9c27f1eafc914$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e($4cd9c27f1eafc914$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e($4cd9c27f1eafc914$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e.empty = new $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e($4cd9c27f1eafc914$export$ffb0004e005737fa.empty, 0, 0);
function $4cd9c27f1eafc914$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($4cd9c27f1eafc914$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $4cd9c27f1eafc914$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $4cd9c27f1eafc914$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $4cd9c27f1eafc914$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $4cd9c27f1eafc914$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $4cd9c27f1eafc914$export$6de0e778727af3f2("Inconsistent open depths");
    return $4cd9c27f1eafc914$var$replaceOuter($from, $to, slice, 0);
}
function $4cd9c27f1eafc914$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $4cd9c27f1eafc914$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $4cd9c27f1eafc914$var$close(node, $4cd9c27f1eafc914$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $4cd9c27f1eafc914$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $4cd9c27f1eafc914$var$prepareSliceForReplace(slice, $from);
        return $4cd9c27f1eafc914$var$close(node, $4cd9c27f1eafc914$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $4cd9c27f1eafc914$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $4cd9c27f1eafc914$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $4cd9c27f1eafc914$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $4cd9c27f1eafc914$var$checkJoin(node, $after.node(depth));
    return node;
}
function $4cd9c27f1eafc914$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $4cd9c27f1eafc914$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $4cd9c27f1eafc914$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$4cd9c27f1eafc914$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $4cd9c27f1eafc914$var$addNode($end.nodeBefore, target);
}
function $4cd9c27f1eafc914$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $4cd9c27f1eafc914$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $4cd9c27f1eafc914$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $4cd9c27f1eafc914$var$joinable($end, $to, depth + 1);
    let content = [];
    $4cd9c27f1eafc914$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $4cd9c27f1eafc914$var$checkJoin(openStart, openEnd);
        $4cd9c27f1eafc914$var$addNode($4cd9c27f1eafc914$var$close(openStart, $4cd9c27f1eafc914$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $4cd9c27f1eafc914$var$addNode($4cd9c27f1eafc914$var$close(openStart, $4cd9c27f1eafc914$var$replaceTwoWay($from, $start, depth + 1)), content);
        $4cd9c27f1eafc914$var$addRange($start, $end, depth, content);
        if (openEnd) $4cd9c27f1eafc914$var$addNode($4cd9c27f1eafc914$var$close(openEnd, $4cd9c27f1eafc914$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $4cd9c27f1eafc914$var$addRange($to, null, depth, content);
    return new $4cd9c27f1eafc914$export$ffb0004e005737fa(content);
}
function $4cd9c27f1eafc914$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $4cd9c27f1eafc914$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $4cd9c27f1eafc914$var$joinable($from, $to, depth + 1);
        $4cd9c27f1eafc914$var$addNode($4cd9c27f1eafc914$var$close(type, $4cd9c27f1eafc914$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $4cd9c27f1eafc914$var$addRange($to, null, depth, content);
    return new $4cd9c27f1eafc914$export$ffb0004e005737fa(content);
}
function $4cd9c27f1eafc914$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($4cd9c27f1eafc914$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $4cd9c27f1eafc914$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $4cd9c27f1eafc914$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $4cd9c27f1eafc914$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $4cd9c27f1eafc914$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $4cd9c27f1eafc914$var$resolveCache.set(doc, cache = new $4cd9c27f1eafc914$var$ResolveCache);
        let result = cache.elts[cache.i] = $4cd9c27f1eafc914$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $4cd9c27f1eafc914$var$resolveCacheSize;
        return result;
    }
}
class $4cd9c27f1eafc914$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $4cd9c27f1eafc914$var$resolveCacheSize = 12, $4cd9c27f1eafc914$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $4cd9c27f1eafc914$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $4cd9c27f1eafc914$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $4cd9c27f1eafc914$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $4cd9c27f1eafc914$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $4cd9c27f1eafc914$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $4cd9c27f1eafc914$var$emptyAttrs) && $4cd9c27f1eafc914$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $4cd9c27f1eafc914$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $4cd9c27f1eafc914$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $4cd9c27f1eafc914$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $4cd9c27f1eafc914$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $4cd9c27f1eafc914$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $4cd9c27f1eafc914$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $4cd9c27f1eafc914$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$4cd9c27f1eafc914$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $4cd9c27f1eafc914$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$4cd9c27f1eafc914$export$85c928794f8d04d4.prototype.text = undefined;
class $4cd9c27f1eafc914$var$TextNode extends $4cd9c27f1eafc914$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $4cd9c27f1eafc914$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $4cd9c27f1eafc914$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $4cd9c27f1eafc914$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $4cd9c27f1eafc914$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $4cd9c27f1eafc914$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $4cd9c27f1eafc914$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $4cd9c27f1eafc914$export$364ed450558d7ec4.empty;
        let expr = $4cd9c27f1eafc914$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $4cd9c27f1eafc914$var$dfa($4cd9c27f1eafc914$var$nfa(expr));
        $4cd9c27f1eafc914$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $4cd9c27f1eafc914$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $4cd9c27f1eafc914$export$364ed450558d7ec4.empty = new $4cd9c27f1eafc914$export$364ed450558d7ec4(true);
class $4cd9c27f1eafc914$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $4cd9c27f1eafc914$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($4cd9c27f1eafc914$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $4cd9c27f1eafc914$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($4cd9c27f1eafc914$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $4cd9c27f1eafc914$var$parseExprSubscript(stream) {
    let expr = $4cd9c27f1eafc914$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $4cd9c27f1eafc914$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $4cd9c27f1eafc914$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $4cd9c27f1eafc914$var$parseExprRange(stream, expr) {
    let min = $4cd9c27f1eafc914$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $4cd9c27f1eafc914$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $4cd9c27f1eafc914$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $4cd9c27f1eafc914$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $4cd9c27f1eafc914$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $4cd9c27f1eafc914$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $4cd9c27f1eafc914$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $4cd9c27f1eafc914$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $4cd9c27f1eafc914$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($4cd9c27f1eafc914$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $4cd9c27f1eafc914$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($4cd9c27f1eafc914$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $4cd9c27f1eafc914$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $4cd9c27f1eafc914$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($4cd9c27f1eafc914$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $4cd9c27f1eafc914$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $4cd9c27f1eafc914$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $4cd9c27f1eafc914$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $4cd9c27f1eafc914$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $4cd9c27f1eafc914$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $4cd9c27f1eafc914$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $4cd9c27f1eafc914$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $4cd9c27f1eafc914$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $4cd9c27f1eafc914$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $4cd9c27f1eafc914$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $4cd9c27f1eafc914$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $4cd9c27f1eafc914$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $4cd9c27f1eafc914$export$ffb0004e005737fa.from(content), $4cd9c27f1eafc914$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $4cd9c27f1eafc914$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $4cd9c27f1eafc914$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $4cd9c27f1eafc914$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $4cd9c27f1eafc914$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($4cd9c27f1eafc914$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $4cd9c27f1eafc914$export$85c928794f8d04d4(this, attrs, content.append(after), $4cd9c27f1eafc914$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $4cd9c27f1eafc914$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $4cd9c27f1eafc914$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $4cd9c27f1eafc914$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $4cd9c27f1eafc914$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $4cd9c27f1eafc914$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $4cd9c27f1eafc914$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $4cd9c27f1eafc914$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $4cd9c27f1eafc914$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $4cd9c27f1eafc914$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $4cd9c27f1eafc914$export$c9d15bcfc6d42044(this, $4cd9c27f1eafc914$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $4cd9c27f1eafc914$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $4cd9c27f1eafc914$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $4cd9c27f1eafc914$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $cR2Z7.default).from(spec.nodes), instanceSpec.marks = (0, $cR2Z7.default).from(spec.marks || {}), this.nodes = $4cd9c27f1eafc914$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $4cd9c27f1eafc914$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $4cd9c27f1eafc914$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $4cd9c27f1eafc914$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $4cd9c27f1eafc914$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $4cd9c27f1eafc914$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $4cd9c27f1eafc914$var$TextNode(type, type.defaultAttrs, text, $4cd9c27f1eafc914$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $4cd9c27f1eafc914$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $4cd9c27f1eafc914$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $4cd9c27f1eafc914$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $4cd9c27f1eafc914$var$isTagRule(rule) {
    return rule.tag != null;
}
function $4cd9c27f1eafc914$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $4cd9c27f1eafc914$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($4cd9c27f1eafc914$var$isTagRule(rule)) this.tags.push(rule);
            else if ($4cd9c27f1eafc914$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $4cd9c27f1eafc914$var$ParseContext(this, options, false);
        context.addAll(dom, $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $4cd9c27f1eafc914$var$ParseContext(this, options, true);
        context.addAll(dom, $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $4cd9c27f1eafc914$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($4cd9c27f1eafc914$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $4cd9c27f1eafc914$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $4cd9c27f1eafc914$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $4cd9c27f1eafc914$export$1059c6e7d2ce5669(schema, $4cd9c27f1eafc914$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $4cd9c27f1eafc914$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $4cd9c27f1eafc914$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $4cd9c27f1eafc914$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $4cd9c27f1eafc914$var$OPT_PRESERVE_WS = 1, $4cd9c27f1eafc914$var$OPT_PRESERVE_WS_FULL = 2, $4cd9c27f1eafc914$var$OPT_OPEN_LEFT = 4;
function $4cd9c27f1eafc914$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $4cd9c27f1eafc914$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $4cd9c27f1eafc914$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $4cd9c27f1eafc914$var$OPT_PRESERVE_WS | $4cd9c27f1eafc914$var$OPT_PRESERVE_WS_FULL : base & ~$4cd9c27f1eafc914$var$OPT_OPEN_LEFT;
}
class $4cd9c27f1eafc914$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $4cd9c27f1eafc914$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($4cd9c27f1eafc914$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $4cd9c27f1eafc914$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $4cd9c27f1eafc914$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($4cd9c27f1eafc914$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$4cd9c27f1eafc914$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $4cd9c27f1eafc914$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $4cd9c27f1eafc914$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $4cd9c27f1eafc914$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $4cd9c27f1eafc914$var$NodeContext(topNode.type, topNode.attrs, $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $4cd9c27f1eafc914$var$NodeContext(null, null, $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $4cd9c27f1eafc914$var$NodeContext(parser.schema.topNodeType, null, $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $4cd9c27f1eafc914$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $4cd9c27f1eafc914$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $4cd9c27f1eafc914$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($4cd9c27f1eafc914$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $4cd9c27f1eafc914$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $4cd9c27f1eafc914$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($4cd9c27f1eafc914$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                return;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $4cd9c27f1eafc914$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $4cd9c27f1eafc914$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $4cd9c27f1eafc914$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $4cd9c27f1eafc914$var$OPT_OPEN_LEFT;
        let applyMarks = $4cd9c27f1eafc914$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $4cd9c27f1eafc914$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $4cd9c27f1eafc914$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $4cd9c27f1eafc914$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $4cd9c27f1eafc914$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $4cd9c27f1eafc914$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $4cd9c27f1eafc914$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $4cd9c27f1eafc914$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $4cd9c27f1eafc914$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $4cd9c27f1eafc914$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $4cd9c27f1eafc914$var$renderSpec($4cd9c27f1eafc914$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $4cd9c27f1eafc914$var$renderSpec($4cd9c27f1eafc914$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $4cd9c27f1eafc914$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $4cd9c27f1eafc914$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $4cd9c27f1eafc914$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $4cd9c27f1eafc914$var$gatherToDOM(schema.marks);
    }
}
function $4cd9c27f1eafc914$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $4cd9c27f1eafc914$var$doc(options) {
    return options.document || window.document;
}
const $4cd9c27f1eafc914$var$suspiciousAttributeCache = new WeakMap();
function $4cd9c27f1eafc914$var$suspiciousAttributes(attrs) {
    let value = $4cd9c27f1eafc914$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $4cd9c27f1eafc914$var$suspiciousAttributeCache.set(attrs, value = $4cd9c27f1eafc914$var$suspiciousAttributesInner(attrs));
    return value;
}
function $4cd9c27f1eafc914$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $4cd9c27f1eafc914$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $4cd9c27f1eafc914$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $4cd9c27f1eafc914$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("cR2Z7", function(module, exports) {

$parcel$export(module.exports, "default", () => $95bcbff75614fe1e$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $95bcbff75614fe1e$var$OrderedMap(content) {
    this.content = content;
}
$95bcbff75614fe1e$var$OrderedMap.prototype = {
    constructor: $95bcbff75614fe1e$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $95bcbff75614fe1e$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $95bcbff75614fe1e$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $95bcbff75614fe1e$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $95bcbff75614fe1e$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $95bcbff75614fe1e$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $95bcbff75614fe1e$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $95bcbff75614fe1e$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $95bcbff75614fe1e$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $95bcbff75614fe1e$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $95bcbff75614fe1e$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$95bcbff75614fe1e$var$OrderedMap.from = function(value) {
    if (value instanceof $95bcbff75614fe1e$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $95bcbff75614fe1e$var$OrderedMap(content);
};
var $95bcbff75614fe1e$export$2e2bcd8739ae039 = $95bcbff75614fe1e$var$OrderedMap;

});



parcelRegister("bryhC", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._test_private_document = module.exports.NODES = void 0;
module.exports.deleteUndefined = $854ccf3ac99eedf8$var$deleteUndefined;
module.exports.document = $854ccf3ac99eedf8$var$document;

var $5h1Kk = parcelRequire("5h1Kk");
/**
 * Removes undefined attributes from an object
 *
 * @param object  - Generic object
 * @returns object - The object with undefined attributes removed
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $854ccf3ac99eedf8$var$deleteUndefined(object) {
    if (object) {
        for(const key in object)if (typeof object[key] === "undefined") delete object[key];
    }
    return object;
}
/**
 * A map of JDita nodes that require a customized transformation into ProseMirror nodes,
 * e.g. because their content model can't be applied directly as valid HTML:
 * `audio`, `video`, `image`, `text`.
 *
 * Instead of using the defaultTravel function, we use the special node function
 * The following 4 nodes (audio, video, image, text) are
 * treated in a customized way instead of applying the defaultTravel() function:
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
module.exports.NODES = {
    video: (value)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // Create a new object with title and poster attributes, if they exist:
        // the desc and the video-poster children will be assigned as new attributes to the video element
        // undefined attributes will be removed
        const attrs = $854ccf3ac99eedf8$var$deleteUndefined(Object.assign(Object.assign({}, value.attributes), {
            title: (_d = (_c = (_b = (_a = value.children) === null || _a === void 0 ? void 0 : _a.find((child)=>child.nodeName === "desc")) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.content,
            poster: (_g = (_f = (_e = value.children) === null || _e === void 0 ? void 0 : _e.find((child)=>child.nodeName === "video-poster")) === null || _f === void 0 ? void 0 : _f.attributes) === null || _g === void 0 ? void 0 : _g.href
        }));
        // Create a new array with the fallback, media-source and media-track children
        // that will be assigned as the content of the video element
        const content = [];
        (_h = value.children) === null || _h === void 0 || _h.forEach((child)=>{
            if ([
                "fallback",
                "media-source",
                "media-track"
            ].includes(child.nodeName)) content.push(child);
        });
        // Return the video object with the new attributes and content
        return {
            type: value.nodeName,
            attrs: attrs,
            content: content === null || content === void 0 ? void 0 : content.map((child)=>$854ccf3ac99eedf8$var$travel(child, value))
        };
    },
    audio: (value)=>{
        var _a, _b, _c, _d, _e;
        // Create a new object with a title attribute, if it exists:
        // the `desc` child will be assigned as a new attribute to the audio element,
        // undefined attributes will be removed
        const attrs = $854ccf3ac99eedf8$var$deleteUndefined(Object.assign(Object.assign({}, value.attributes), {
            title: (_d = (_c = (_b = (_a = value.children) === null || _a === void 0 ? void 0 : _a.find((child)=>child.nodeName === "desc")) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.content
        }));
        // Create a new array with the fallback, media-source and media-track children
        // that will be assigned as the content of the audio element
        const content = [];
        (_e = value.children) === null || _e === void 0 || _e.forEach((child)=>{
            if ([
                "fallback",
                "media-source",
                "media-track"
            ].includes(child.nodeName)) content.push(child);
        });
        // Return the audio object with the new attributes and content
        return {
            type: value.nodeName,
            attrs: attrs,
            content: content === null || content === void 0 ? void 0 : content.map((child)=>$854ccf3ac99eedf8$var$travel(child, value))
        };
    },
    image: (value)=>{
        var _a;
        if (value.children && value.children[0].nodeName === "alt" && ((_a = value.children[0]) === null || _a === void 0 ? void 0 : _a.children) && value.children[0].children[0].nodeName == "text") {
            const attrs = $854ccf3ac99eedf8$var$deleteUndefined(Object.assign(Object.assign({}, value.attributes), {
                alt: value.children[0].children[0].content
            }));
            const result = {
                type: "image",
                attrs: attrs
            };
            return result;
        }
        return $854ccf3ac99eedf8$var$defaultTravel(value);
    },
    text: (value)=>({
            type: "text",
            text: value.content,
            attrs: {}
        })
};
/**
 * Transforms the JDita document into a proper ProseMirror document
 *
 * @param value - The JDita node
 * @returns The transformed JDita node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $854ccf3ac99eedf8$var$defaultTravel(value) {
    var _a;
    // children will become content
    const content = (_a = value.children) === null || _a === void 0 ? void 0 : _a.map((child)=>$854ccf3ac99eedf8$var$travel(child, value));
    // attributes will become attrs
    const attrs = value.attributes || {};
    // remove undefined attributes
    $854ccf3ac99eedf8$var$deleteUndefined(attrs);
    // node name will become type
    const type = (0, $5h1Kk.defaultNodeName)(value.nodeName);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let result;
    // IS_MARK is the array  `u, s, b, sup, sub`
    if ($5h1Kk.IS_MARK.indexOf(value.nodeName) > -1) {
        if ((content === null || content === void 0 ? void 0 : content.length) === 1) {
            result = content[0];
            result.marks = [
                {
                    type: type
                }
            ];
        }
    } else {
        result = {
            type: type,
            attrs: attrs
        };
        if (content) result.content = content;
    }
    return result;
}
/**
 * Traverses the JDita document and generates a ProseMirror document
 *
 * @param value - The JDita node
 * @param parent - The parent JDita node
 * @returns The transformed JDita node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $854ccf3ac99eedf8$var$travel(value, parent) {
    // if it's a special node, use the special node function,
    // otherwise use the default travel function
    const result = (module.exports.NODES[value.nodeName] || $854ccf3ac99eedf8$var$defaultTravel)(value, parent);
    // if the node is not a document and has attributes, set the parent attribute
    if (value.nodeName !== "doc" && result && result.attrs) result.attrs.parent = parent.nodeName;
    return result;
}
/**
 * Transforms the JDita document
 * into a Schema compliant JDita document
 *
 * @example
 * Here's an example input:
 * ```
 * {
 *   "nodeName": "document",
 *   "children": [
 *     {
 *       "nodeName": "topic",
 *       "attributes": {
 *       "id": "intro-product"
 *     },
 *     {
 *       "nodeName": "title",
 *       "attributes": {},
 *       "children": [
 *         {
 *           "nodeName": "text",
 *           "content": "Overview"
 *         }
 *       ]
 *     }
 *   ]
 * }
 * ```
 *
 * @example
 * Here's an example output of the transformation `travel(jdita, jdita)`:
 * ```
 * {
 *   "type": "doc",
 *   "attrs": {},
 *   "content": [
 *     {
 *       "type": "topic",
 *       "attrs": {
 *         "id": "intro-product",
 *         "parent": "doc"
 *       },
 *       "content": [
 *         {
 *           "type": "title",
 *           "attrs": {
 *             "parent": "topic"
 *           },
 *           "content": [
 *             {
 *               "type": "text",
 *               "text": "Overview",
 *               "attrs": {
 *                 "parent": "title"
 *               }
 *             }
 *           ]
 *         }
 *       ]
 *     }
 *   ]
 * }
 * ```
 *
 * @param jdita - the JDita document
 * @returns transformed JDita document
 */ function $854ccf3ac99eedf8$var$document(jdita) {
    if (jdita.nodeName === "document") {
        jdita.nodeName = "doc";
        /*
        Parameter `jdita` is representing the root of JDita document.
        We pass in the root node as the first parameter, and since it's the root node,
        it's also the parent node, which is passed as the second parameter.
        This will return the output of the transformation.
        */ return $854ccf3ac99eedf8$var$travel(jdita, jdita);
    }
    throw new Error("jdita must be a document");
}
//Escape hatch for Unit Testing due to a lack of “package-private” accessibility scope in TypeScript
module.exports._test_private_document = {
    deleteUndefined: $854ccf3ac99eedf8$var$deleteUndefined,
    defaultTravel: $854ccf3ac99eedf8$var$defaultTravel,
    travel: $854ccf3ac99eedf8$var$travel
};

});

parcelRegister("3qV5N", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shortcuts = $2800162bac12a586$var$shortcuts;
module.exports.menu = $2800162bac12a586$var$menu;
module.exports.doubleClickImagePlugin = $2800162bac12a586$var$doubleClickImagePlugin;

var $4gRXQ = parcelRequire("4gRXQ");

var $6jolL = parcelRequire("6jolL");

var $1t04f = parcelRequire("1t04f");

var $6SXdZ = parcelRequire("6SXdZ");

var $cw5sC = parcelRequire("cw5sC");
/**
 * This is the entire DOM node of the Prosemirror editor that will be observed for DOM mutations
 */ const $2800162bac12a586$var$targetNode = document.getElementById("editor");
/**
 * Set the Observer to watch for changes being made to the editor DOM tree
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver}
 * for more info on the MutationObserver interface
 */ // make sure the editor element exists
if ($2800162bac12a586$var$targetNode) {
    // Options for the observer (which mutations to observe)
    const config = {
        attributes: false,
        childList: true,
        subtree: true
    };
    // Callback function to execute when mutations are observed
    const callback = function(mutationsList) {
        for (const mutation of mutationsList){
            // if the mutation happened on one of the children of the editor
            if (mutation.type === "childList") // if the mutation happened on the menubar
            {
                if (mutation.target.classList.contains("ProseMirror-menubar")) {
                    const separators = [];
                    mutation.addedNodes.forEach((node)=>{
                        // if the node is a separator, add it to the separators array
                        if (node.childNodes[0] && node.childNodes[0].classList.contains("separator")) separators.push(node);
                    });
                    // set the CSS `flex grow` rule of the separators to 1
                    separators.forEach((separator)=>separator.style.flex = "1");
                }
            }
        }
    };
    /**
     * Create an observer instance linked to the callback function
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver}
     * for more info on the MutationObserver interface
     */ const observer = new MutationObserver(callback);
    /**
     * Start observing the target node for configured mutations
     */ observer.observe($2800162bac12a586$var$targetNode, config);
}
/**
 * Provide keyboard shortcuts for the editor
 *
 * @remarks
 * The `newLine` is a custom command and is representing the `enterPressed` command
 * `toggleMark`, `undo`, and `redo` are Prosemirror functions
 *
 * @param localization - localization
 * @param schema - generated schema from JDITA
 * @returns - keymap object of shortcuts
 */ function $2800162bac12a586$var$shortcuts(localization, schema) {
    return (0, $4gRXQ.keymap)({
        "Enter": $1t04f.newLine,
        "Ctrl-b": (0, $1t04f.toggleMark)(schema.marks.b),
        "Ctrl-u": (0, $1t04f.toggleMark)(schema.marks.u),
        "Ctrl-i": (0, $1t04f.toggleMark)(schema.marks.i),
        "Ctrl-=": (0, $1t04f.toggleMark)(schema.marks.sub),
        "Ctrl-+": (0, $1t04f.toggleMark)(schema.marks.sup),
        "Ctrl-z": $6SXdZ.undo,
        "Ctrl-y": $6SXdZ.redo,
        "Ctrl-Shift-z": $6SXdZ.redo,
        "Alt-p": (0, $1t04f.insertImage)(localization, schema.nodes.image)
    });
}
/**
 * Create a new instance of MenuItem and attach a command
 *
 * @example of the returned MenuItem:
 * ```
 * {spec: {class: "ic-undo", enable: undo(state, dispatch), icon:{}, run: undo(state, dispatch), title: "Undo"}}
 * ```
 *
 * @param command - The command associated with the menu item
 * @param props - The properties of the menu item
 * @returns A new MenuItem instance
 */ function $2800162bac12a586$var$commandItem(command, props = {}) {
    return new $6jolL.MenuItem(Object.assign(Object.assign({}, props), {
        run: command,
        enable: command
    }));
}
/**
 * Processes MarkTypes and mark properties
 * and returns a MenuItem containing information about all active
 * and enabled menu mark items and their properties and binds them to a command.
 *
 * @remarks
 * Will be called and populated by menu() to bind mark item commands in the editor menu
 *
 * @param mark - MarkType object containing all values of the instance, e.g. name: 'b', rank: '4' (order in menu)
 * @param props - The properties of the mark item (MenuElement) that will be inserted as HTML attributes
 *  to the menu element in the editor, e.g. title: 'Bold', class: 'ic-bold'
 * @returns The MenuItem object
 */ function $2800162bac12a586$var$markItem(mark, props = {}) {
    const command = (0, $1t04f.toggleMark)(mark);
    return $2800162bac12a586$var$commandItem(command, Object.assign(Object.assign({}, props), {
        active: (state)=>(0, $1t04f.hasMark)(state, mark),
        enable: (state)=>!state.selection.empty
    }));
}
/**
 * Creates a custom instance of class MenuItem
 * when clicked, executes a command
 *
 * @remarks
 * This instance of MenuItem is used for the "Debug Info" icon button in the menu
 *
 * @example of the MenuItem object:
 * ```
 * {spec: {label: 'Show debug info', class: 'ic-bug', css: 'color: #c81200', enable: undefined, run}}
 * ```
 *
 * @example of the callback functions:
 * ```
 * active:() => document.body.classList.contains('debug')
 * call:() => document.body.classList.toggle('debug')
 * ```
 *
 * @param callbacks - callbacks `active`, `call`, e.g.
 * @param props - MenuItem properties
 * @returns The MenuItem object
 */ function $2800162bac12a586$var$simpleCommand(callbacks, props = {}) {
    if (typeof callbacks === "function") callbacks = {
        call: callbacks
    };
    return new $6jolL.MenuItem(Object.assign(Object.assign({}, props), {
        run: (state, dispatch)=>{
            callbacks.call();
            dispatch(state.tr);
        },
        enable: callbacks.enable,
        active: callbacks.active
    }));
}
/**
 * Create a new instance of class MenuItem and provide a classname "separator"
 *
 * @remarks
 * This is used for a simple vertical line as a visual seperator for the items in the menu bar
 *
 * @returns The new instance of MenuItem
 */ function $2800162bac12a586$var$separator() {
    return new $6jolL.MenuItem({
        run: ()=>{},
        enable: ()=>false,
        class: "separator",
        icon: {
            text: ""
        }
    });
}
/**
 * Insert a new item into the menu
 *
 * @param type - NodeType object
 * @param props - MenuItem Configuration object
 * @returns MenuElement
 */ function $2800162bac12a586$var$insertItem(type, props = {}) {
    return $2800162bac12a586$var$commandItem((0, $1t04f.insertNode)(type), Object.assign({}, props));
}
/**
 * Create a menu button for uploading an image
 *
 * @param localization - localization
 * @param type - The NodeType object
 * @param props - The icon object containing the title and the class of the icon
 * @returns A MenuElement containing the HTML node of the entire button element bound to its command
 */ function $2800162bac12a586$var$insertImageItem(localization, type, props = {}) {
    const command = (0, $1t04f.insertImage)(localization, type);
    return $2800162bac12a586$var$commandItem(command, Object.assign({}, props));
}
/**
 * Create a menu bar for the editor
 *
 * @param localization - localization
 * @param schema - Node schema
 * @param param1 - Object that contains the placement of the menu items
 * @returns menuBar
 */ function $2800162bac12a586$var$menu(localization, schema, { start: start, before: before, after: after, end: end } = {}) {
    const debug = [
        $2800162bac12a586$var$separator(),
        $2800162bac12a586$var$simpleCommand({
            call: ()=>document.body.classList.toggle("debug"),
            active: ()=>document.body.classList.contains("debug")
        }, {
            label: "Show debug info",
            class: "ic-bug",
            css: "color: #c81200"
        })
    ];
    const toolbar = [
        [
            $2800162bac12a586$var$commandItem($6SXdZ.undo, {
                icon: {
                    text: ""
                },
                title: "Undo",
                class: "ic-undo"
            }),
            $2800162bac12a586$var$commandItem($6SXdZ.redo, {
                icon: {
                    text: ""
                },
                title: "Redo",
                class: "ic-redo"
            })
        ],
        [
            $2800162bac12a586$var$markItem(schema.marks.b, {
                icon: {
                    text: ""
                },
                title: "Bold",
                class: "ic-bold"
            }),
            $2800162bac12a586$var$markItem(schema.marks.u, {
                icon: {
                    text: ""
                },
                title: "Underlined",
                class: "ic-underline"
            }),
            $2800162bac12a586$var$markItem(schema.marks.i, {
                icon: {
                    text: ""
                },
                title: "Italic",
                class: "ic-italic"
            }),
            $2800162bac12a586$var$markItem(schema.marks.sub, {
                icon: {
                    text: ""
                },
                title: "Subscript",
                class: "ic-subscript"
            }),
            $2800162bac12a586$var$markItem(schema.marks.sup, {
                icon: {
                    text: ""
                },
                title: "Superscript",
                class: "ic-superscript"
            })
        ],
        [
            $2800162bac12a586$var$insertItem(schema.nodes.ol, {
                icon: {
                    text: ""
                },
                title: "Ordered list",
                class: "ic-olist"
            }),
            $2800162bac12a586$var$insertItem(schema.nodes.ul, {
                icon: {
                    text: ""
                },
                title: "Unordered list",
                class: "ic-ulist"
            }),
            $2800162bac12a586$var$insertImageItem(localization, schema.nodes.image, {
                icon: {
                    text: ""
                },
                title: "Insert image",
                class: "ic-image"
            })
        ]
    ];
    if (!start) start = [];
    if (!before) before = [];
    if (!after) after = [];
    if (!end) end = [];
    if (after.length > 0) after[after.length - 1] = [
        ...after[after.length - 1],
        ...debug
    ];
    else toolbar[toolbar.length - 1] = toolbar[toolbar.length - 1].concat(debug);
    if (before.length > 0) before[before.length - 1] = [
        $2800162bac12a586$var$separator(),
        ...before[before.length - 1]
    ];
    else toolbar[0].unshift($2800162bac12a586$var$separator());
    return (0, $6jolL.menuBar)({
        content: [
            ...start,
            ...before,
            ...toolbar,
            ...after,
            ...end
        ]
    });
}
function $2800162bac12a586$var$doubleClickImagePlugin(localization) {
    return new $cw5sC.Plugin({
        props: {
            handleDOMEvents: {
                dblclick: (view, event)=>{
                    const { schema: schema, doc: doc } = view.state;
                    const pos = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if (pos) {
                        const node = doc.nodeAt(pos.pos);
                        const parent = doc.nodeAt(pos.pos - 1);
                        const nodeSize = (parent === null || parent === void 0 ? void 0 : parent.nodeSize) || 0;
                        const { state: state, dispatch: dispatch } = view;
                        if (node && node.type === schema.nodes.image) {
                            (0, $1t04f.imageInputOverlay)(localization, (imageInfo)=>{
                                if (!imageInfo) return false;
                                const newNode = (0, $1t04f.createNode)(schema.nodes["fig"], {
                                    src: imageInfo.src,
                                    scope: imageInfo.scope,
                                    alt: imageInfo.alt,
                                    height: imageInfo.height,
                                    width: imageInfo.width
                                });
                                dispatch(state.tr.replaceWith(pos.pos - 1, pos.pos + nodeSize, newNode));
                                return true;
                            }, node);
                            return true;
                        }
                    }
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("4gRXQ", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $31c2843c323c03bf$export$5043418e2ef368d5);

var $aqDcF = parcelRequire("aqDcF");

var $cw5sC = parcelRequire("cw5sC");
const $31c2843c323c03bf$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $31c2843c323c03bf$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($31c2843c323c03bf$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $31c2843c323c03bf$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$31c2843c323c03bf$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $31c2843c323c03bf$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $31c2843c323c03bf$export$5043418e2ef368d5(bindings) {
    return new (0, $cw5sC.Plugin)({
        props: {
            handleKeyDown: $31c2843c323c03bf$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $31c2843c323c03bf$export$53f558754f8b9fd1(bindings) {
    let map = $31c2843c323c03bf$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $aqDcF.keyName)(event), baseName, direct = map[$31c2843c323c03bf$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$31c2843c323c03bf$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $aqDcF.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$31c2843c323c03bf$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});
parcelRegister("aqDcF", function(module, exports) {

$parcel$export(module.exports, "base", () => $797abe091ac78a78$export$e2253033e6e1df16);
$parcel$export(module.exports, "keyName", () => $797abe091ac78a78$export$fb33aafd75404f4c);
var $797abe091ac78a78$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $797abe091ac78a78$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
};
var $797abe091ac78a78$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $797abe091ac78a78$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $797abe091ac78a78$var$i = 0; $797abe091ac78a78$var$i < 10; $797abe091ac78a78$var$i++)$797abe091ac78a78$export$e2253033e6e1df16[48 + $797abe091ac78a78$var$i] = $797abe091ac78a78$export$e2253033e6e1df16[96 + $797abe091ac78a78$var$i] = String($797abe091ac78a78$var$i);
// The function keys
for(var $797abe091ac78a78$var$i = 1; $797abe091ac78a78$var$i <= 24; $797abe091ac78a78$var$i++)$797abe091ac78a78$export$e2253033e6e1df16[$797abe091ac78a78$var$i + 111] = "F" + $797abe091ac78a78$var$i;
// And the alphabetic keys
for(var $797abe091ac78a78$var$i = 65; $797abe091ac78a78$var$i <= 90; $797abe091ac78a78$var$i++){
    $797abe091ac78a78$export$e2253033e6e1df16[$797abe091ac78a78$var$i] = String.fromCharCode($797abe091ac78a78$var$i + 32);
    $797abe091ac78a78$export$fba63a578e423eb[$797abe091ac78a78$var$i] = String.fromCharCode($797abe091ac78a78$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $797abe091ac78a78$var$code in $797abe091ac78a78$export$e2253033e6e1df16)if (!$797abe091ac78a78$export$fba63a578e423eb.hasOwnProperty($797abe091ac78a78$var$code)) $797abe091ac78a78$export$fba63a578e423eb[$797abe091ac78a78$var$code] = $797abe091ac78a78$export$e2253033e6e1df16[$797abe091ac78a78$var$code];
function $797abe091ac78a78$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $797abe091ac78a78$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $797abe091ac78a78$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $797abe091ac78a78$export$fba63a578e423eb : $797abe091ac78a78$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});

parcelRegister("cw5sC", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $91ccb5903a6f76a0$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $91ccb5903a6f76a0$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $91ccb5903a6f76a0$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $91ccb5903a6f76a0$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $91ccb5903a6f76a0$export$e2940151ac854c0b);
$parcel$export(module.exports, "EditorState", () => $91ccb5903a6f76a0$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $91ccb5903a6f76a0$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $91ccb5903a6f76a0$export$1692d8b0e89cecc3);

var $6B4AI = parcelRequire("6B4AI");

var $4aVzI = parcelRequire("4aVzI");
const $91ccb5903a6f76a0$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $91ccb5903a6f76a0$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $91ccb5903a6f76a0$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $6B4AI.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $6B4AI.Slice).empty : content);
            if (i == 0) $91ccb5903a6f76a0$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $91ccb5903a6f76a0$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $91ccb5903a6f76a0$export$c2b25f346d19bcbb($pos) : $91ccb5903a6f76a0$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $91ccb5903a6f76a0$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $91ccb5903a6f76a0$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $91ccb5903a6f76a0$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $91ccb5903a6f76a0$var$findSelectionIn(doc, doc, 0, 0, 1) || new $91ccb5903a6f76a0$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $91ccb5903a6f76a0$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $91ccb5903a6f76a0$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $91ccb5903a6f76a0$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $91ccb5903a6f76a0$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $91ccb5903a6f76a0$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $91ccb5903a6f76a0$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$91ccb5903a6f76a0$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $91ccb5903a6f76a0$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $91ccb5903a6f76a0$var$warnedAboutTextSelection = false;
function $91ccb5903a6f76a0$var$checkTextSelection($pos) {
    if (!$91ccb5903a6f76a0$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $91ccb5903a6f76a0$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $91ccb5903a6f76a0$export$c2b25f346d19bcbb extends $91ccb5903a6f76a0$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $91ccb5903a6f76a0$var$checkTextSelection($anchor);
        $91ccb5903a6f76a0$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $91ccb5903a6f76a0$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $91ccb5903a6f76a0$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $6B4AI.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $6B4AI.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $91ccb5903a6f76a0$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $91ccb5903a6f76a0$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $91ccb5903a6f76a0$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $91ccb5903a6f76a0$export$52baac22726c72bf.findFrom($head, bias, true) || $91ccb5903a6f76a0$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $91ccb5903a6f76a0$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($91ccb5903a6f76a0$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $91ccb5903a6f76a0$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $91ccb5903a6f76a0$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$91ccb5903a6f76a0$export$52baac22726c72bf.jsonID("text", $91ccb5903a6f76a0$export$c2b25f346d19bcbb);
class $91ccb5903a6f76a0$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $91ccb5903a6f76a0$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $91ccb5903a6f76a0$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $91ccb5903a6f76a0$export$e2940151ac854c0b extends $91ccb5903a6f76a0$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $91ccb5903a6f76a0$export$52baac22726c72bf.near($pos);
        return new $91ccb5903a6f76a0$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $91ccb5903a6f76a0$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $91ccb5903a6f76a0$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $91ccb5903a6f76a0$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $91ccb5903a6f76a0$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$91ccb5903a6f76a0$export$e2940151ac854c0b.prototype.visible = false;
$91ccb5903a6f76a0$export$52baac22726c72bf.jsonID("node", $91ccb5903a6f76a0$export$e2940151ac854c0b);
class $91ccb5903a6f76a0$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $91ccb5903a6f76a0$var$TextBookmark(pos, pos) : new $91ccb5903a6f76a0$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $91ccb5903a6f76a0$export$e2940151ac854c0b.isSelectable(node)) return new $91ccb5903a6f76a0$export$e2940151ac854c0b($pos);
        return $91ccb5903a6f76a0$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $91ccb5903a6f76a0$export$c15d9ba76bdbcd95 extends $91ccb5903a6f76a0$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $6B4AI.Slice).empty) {
        if (content == (0, $6B4AI.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $91ccb5903a6f76a0$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $91ccb5903a6f76a0$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $91ccb5903a6f76a0$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $91ccb5903a6f76a0$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $91ccb5903a6f76a0$var$AllBookmark;
    }
}
$91ccb5903a6f76a0$export$52baac22726c72bf.jsonID("all", $91ccb5903a6f76a0$export$c15d9ba76bdbcd95);
const $91ccb5903a6f76a0$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $91ccb5903a6f76a0$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $91ccb5903a6f76a0$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $91ccb5903a6f76a0$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $91ccb5903a6f76a0$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $91ccb5903a6f76a0$export$e2940151ac854c0b.isSelectable(child)) return $91ccb5903a6f76a0$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $91ccb5903a6f76a0$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $4aVzI.ReplaceStep) || step instanceof (0, $4aVzI.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($91ccb5903a6f76a0$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $91ccb5903a6f76a0$var$UPDATED_SEL = 1, $91ccb5903a6f76a0$var$UPDATED_MARKS = 2, $91ccb5903a6f76a0$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $91ccb5903a6f76a0$export$febc5573c75cefb0 extends (0, $4aVzI.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $91ccb5903a6f76a0$var$UPDATED_SEL) & ~$91ccb5903a6f76a0$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $91ccb5903a6f76a0$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $91ccb5903a6f76a0$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $6B4AI.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $91ccb5903a6f76a0$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$91ccb5903a6f76a0$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $6B4AI.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($91ccb5903a6f76a0$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $91ccb5903a6f76a0$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $91ccb5903a6f76a0$var$UPDATED_SCROLL) > 0;
    }
}
function $91ccb5903a6f76a0$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $91ccb5903a6f76a0$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $91ccb5903a6f76a0$var$bind(desc.init, self);
        this.apply = $91ccb5903a6f76a0$var$bind(desc.apply, self);
    }
}
const $91ccb5903a6f76a0$var$baseFields = [
    new $91ccb5903a6f76a0$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $91ccb5903a6f76a0$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $91ccb5903a6f76a0$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $91ccb5903a6f76a0$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $91ccb5903a6f76a0$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $91ccb5903a6f76a0$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $91ccb5903a6f76a0$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $91ccb5903a6f76a0$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $91ccb5903a6f76a0$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $91ccb5903a6f76a0$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $91ccb5903a6f76a0$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $91ccb5903a6f76a0$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $91ccb5903a6f76a0$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $91ccb5903a6f76a0$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $91ccb5903a6f76a0$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == "object") for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $91ccb5903a6f76a0$var$Configuration(config.schema, config.plugins);
        let instance = new $91ccb5903a6f76a0$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $6B4AI.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $91ccb5903a6f76a0$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $91ccb5903a6f76a0$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $91ccb5903a6f76a0$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $91ccb5903a6f76a0$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $91ccb5903a6f76a0$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $91ccb5903a6f76a0$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $91ccb5903a6f76a0$var$keys = Object.create(null);
function $91ccb5903a6f76a0$var$createKey(name) {
    if (name in $91ccb5903a6f76a0$var$keys) return name + "$" + ++$91ccb5903a6f76a0$var$keys[name];
    $91ccb5903a6f76a0$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $91ccb5903a6f76a0$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $91ccb5903a6f76a0$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("4aVzI", function(module, exports) {

$parcel$export(module.exports, "Mapping", () => $30a4c1d360019810$export$f5f785078011b62);
$parcel$export(module.exports, "ReplaceStep", () => $30a4c1d360019810$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $30a4c1d360019810$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $30a4c1d360019810$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $30a4c1d360019810$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $30a4c1d360019810$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $30a4c1d360019810$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $30a4c1d360019810$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "dropPoint", () => $30a4c1d360019810$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $30a4c1d360019810$export$ed6ac67359824afd);
$parcel$export(module.exports, "Transform", () => $30a4c1d360019810$export$563a914cafbdc389);

var $6B4AI = parcelRequire("6B4AI");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $30a4c1d360019810$var$lower16 = 0xffff;
const $30a4c1d360019810$var$factor16 = Math.pow(2, 16);
function $30a4c1d360019810$var$makeRecover(index, offset) {
    return index + offset * $30a4c1d360019810$var$factor16;
}
function $30a4c1d360019810$var$recoverIndex(value) {
    return value & $30a4c1d360019810$var$lower16;
}
function $30a4c1d360019810$var$recoverOffset(value) {
    return (value - (value & $30a4c1d360019810$var$lower16)) / $30a4c1d360019810$var$factor16;
}
const $30a4c1d360019810$var$DEL_BEFORE = 1, $30a4c1d360019810$var$DEL_AFTER = 2, $30a4c1d360019810$var$DEL_ACROSS = 4, $30a4c1d360019810$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $30a4c1d360019810$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $30a4c1d360019810$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($30a4c1d360019810$var$DEL_BEFORE | $30a4c1d360019810$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($30a4c1d360019810$var$DEL_AFTER | $30a4c1d360019810$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $30a4c1d360019810$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $30a4c1d360019810$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $30a4c1d360019810$export$c53d01c3ab9721b3.empty) return $30a4c1d360019810$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $30a4c1d360019810$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $30a4c1d360019810$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $30a4c1d360019810$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $30a4c1d360019810$var$DEL_AFTER : pos == end ? $30a4c1d360019810$var$DEL_BEFORE : $30a4c1d360019810$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $30a4c1d360019810$var$DEL_SIDE;
                return new $30a4c1d360019810$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $30a4c1d360019810$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $30a4c1d360019810$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $30a4c1d360019810$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $30a4c1d360019810$export$c53d01c3ab9721b3.empty : new $30a4c1d360019810$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $30a4c1d360019810$export$c53d01c3ab9721b3.empty = new $30a4c1d360019810$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $30a4c1d360019810$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $30a4c1d360019810$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $30a4c1d360019810$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $30a4c1d360019810$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $30a4c1d360019810$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $30a4c1d360019810$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $30a4c1d360019810$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $30a4c1d360019810$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $30a4c1d360019810$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $30a4c1d360019810$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $30a4c1d360019810$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $30a4c1d360019810$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $30a4c1d360019810$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $30a4c1d360019810$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $6B4AI.ReplaceError)) return $30a4c1d360019810$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $30a4c1d360019810$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($30a4c1d360019810$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $6B4AI.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $30a4c1d360019810$export$d24ba56b0e3464a9 extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $6B4AI.Slice)($30a4c1d360019810$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $30a4c1d360019810$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $30a4c1d360019810$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $30a4c1d360019810$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $30a4c1d360019810$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $30a4c1d360019810$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $30a4c1d360019810$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("addMark", $30a4c1d360019810$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $30a4c1d360019810$export$94150db1311f67a9 extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $6B4AI.Slice)($30a4c1d360019810$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $30a4c1d360019810$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $30a4c1d360019810$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $30a4c1d360019810$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $30a4c1d360019810$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $30a4c1d360019810$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $30a4c1d360019810$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("removeMark", $30a4c1d360019810$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $30a4c1d360019810$export$adefd16c402fee4e extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $30a4c1d360019810$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $30a4c1d360019810$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $30a4c1d360019810$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $30a4c1d360019810$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $30a4c1d360019810$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $30a4c1d360019810$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $30a4c1d360019810$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("addNodeMark", $30a4c1d360019810$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $30a4c1d360019810$export$fdf7d1dc10724da2 extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $30a4c1d360019810$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $30a4c1d360019810$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $30a4c1d360019810$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $30a4c1d360019810$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $30a4c1d360019810$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("removeNodeMark", $30a4c1d360019810$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $30a4c1d360019810$export$5c860b2e74034756 extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $30a4c1d360019810$var$contentBetween(doc, this.from, this.to)) return $30a4c1d360019810$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $30a4c1d360019810$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $30a4c1d360019810$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $30a4c1d360019810$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $30a4c1d360019810$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $30a4c1d360019810$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $6B4AI.Slice).empty : new (0, $6B4AI.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $30a4c1d360019810$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $6B4AI.Slice).empty : new (0, $6B4AI.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $30a4c1d360019810$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $30a4c1d360019810$export$5c860b2e74034756(json.from, json.to, (0, $6B4AI.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("replace", $30a4c1d360019810$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $30a4c1d360019810$export$444ba800d6024a98 extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($30a4c1d360019810$var$contentBetween(doc, this.from, this.gapFrom) || $30a4c1d360019810$var$contentBetween(doc, this.gapTo, this.to))) return $30a4c1d360019810$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $30a4c1d360019810$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $30a4c1d360019810$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $30a4c1d360019810$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $30a4c1d360019810$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $30a4c1d360019810$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $30a4c1d360019810$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $30a4c1d360019810$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $6B4AI.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("replaceAround", $30a4c1d360019810$export$444ba800d6024a98);
function $30a4c1d360019810$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $30a4c1d360019810$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $30a4c1d360019810$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $30a4c1d360019810$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $30a4c1d360019810$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $6B4AI.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $30a4c1d360019810$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $30a4c1d360019810$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $30a4c1d360019810$export$5c860b2e74034756(cur, end, (0, $6B4AI.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $30a4c1d360019810$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $30a4c1d360019810$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $6B4AI.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $6B4AI.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $30a4c1d360019810$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $30a4c1d360019810$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$30a4c1d360019810$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $30a4c1d360019810$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $6B4AI.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $6B4AI.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $6B4AI.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $6B4AI.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $30a4c1d360019810$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $6B4AI.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $30a4c1d360019810$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $30a4c1d360019810$var$findWrappingOutside(range, nodeType);
    let inner = around && $30a4c1d360019810$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($30a4c1d360019810$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($30a4c1d360019810$var$withAttrs));
}
function $30a4c1d360019810$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $30a4c1d360019810$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $30a4c1d360019810$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $30a4c1d360019810$var$wrap(tr, range, wrappers) {
    let content = (0, $6B4AI.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $6B4AI.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $30a4c1d360019810$export$444ba800d6024a98(start, end, start, end, new (0, $6B4AI.Slice)(content, 0, 0), wrappers.length, true));
}
function $30a4c1d360019810$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $30a4c1d360019810$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $30a4c1d360019810$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $30a4c1d360019810$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $30a4c1d360019810$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $30a4c1d360019810$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $30a4c1d360019810$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $30a4c1d360019810$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $30a4c1d360019810$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $30a4c1d360019810$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $30a4c1d360019810$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $30a4c1d360019810$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $30a4c1d360019810$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $6B4AI.Fragment).empty, after = (0, $6B4AI.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $6B4AI.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $6B4AI.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $30a4c1d360019810$export$5c860b2e74034756(pos, pos, new (0, $6B4AI.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $30a4c1d360019810$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $30a4c1d360019810$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $30a4c1d360019810$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $30a4c1d360019810$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $30a4c1d360019810$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $30a4c1d360019810$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $30a4c1d360019810$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $30a4c1d360019810$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $30a4c1d360019810$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $30a4c1d360019810$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $30a4c1d360019810$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $6B4AI.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $30a4c1d360019810$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $30a4c1d360019810$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $30a4c1d360019810$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $30a4c1d360019810$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $6B4AI.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($30a4c1d360019810$var$fitsTrivially($from, $to, slice)) return new $30a4c1d360019810$export$5c860b2e74034756(from, to, slice);
    return new $30a4c1d360019810$var$Fitter($from, $to, slice).fit();
}
function $30a4c1d360019810$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $30a4c1d360019810$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $6B4AI.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $6B4AI.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $6B4AI.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $30a4c1d360019810$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $30a4c1d360019810$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $30a4c1d360019810$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $6B4AI.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $30a4c1d360019810$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $6B4AI.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $30a4c1d360019810$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $6B4AI.Slice)($30a4c1d360019810$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $6B4AI.Slice)($30a4c1d360019810$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($30a4c1d360019810$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $30a4c1d360019810$var$addToFragment(this.placed, frontierDepth, (0, $6B4AI.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $6B4AI.Slice)($30a4c1d360019810$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $6B4AI.Slice).empty : new (0, $6B4AI.Slice)($30a4c1d360019810$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$30a4c1d360019810$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $30a4c1d360019810$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $30a4c1d360019810$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $30a4c1d360019810$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $30a4c1d360019810$var$addToFragment(this.placed, this.depth, (0, $6B4AI.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $6B4AI.Fragment).empty, true);
        if (add.childCount) this.placed = $30a4c1d360019810$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $30a4c1d360019810$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($30a4c1d360019810$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $30a4c1d360019810$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($30a4c1d360019810$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $30a4c1d360019810$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $30a4c1d360019810$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $30a4c1d360019810$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $6B4AI.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $30a4c1d360019810$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$30a4c1d360019810$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $30a4c1d360019810$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $30a4c1d360019810$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $30a4c1d360019810$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($30a4c1d360019810$var$fitsTrivially($from, $to, slice)) return tr.step(new $30a4c1d360019810$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $30a4c1d360019810$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $30a4c1d360019810$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $6B4AI.Slice)($30a4c1d360019810$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $30a4c1d360019810$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($30a4c1d360019810$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $6B4AI.Fragment).empty, true));
    }
    return fragment;
}
function $30a4c1d360019810$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $30a4c1d360019810$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(node), 0, 0));
}
function $30a4c1d360019810$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $30a4c1d360019810$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $30a4c1d360019810$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $30a4c1d360019810$export$626399c38172f669 extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $30a4c1d360019810$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $30a4c1d360019810$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $30a4c1d360019810$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $30a4c1d360019810$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $30a4c1d360019810$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $30a4c1d360019810$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("attr", $30a4c1d360019810$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $30a4c1d360019810$export$f50707b396300ac9 extends $30a4c1d360019810$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $30a4c1d360019810$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $30a4c1d360019810$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $30a4c1d360019810$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $30a4c1d360019810$export$f50707b396300ac9(json.attr, json.value);
    }
}
$30a4c1d360019810$export$fd55ce593607084a.jsonID("docAttr", $30a4c1d360019810$export$f50707b396300ac9);
/**
@internal
*/ let $30a4c1d360019810$export$88cc3a1dfce48dd3 = class extends Error {
};
$30a4c1d360019810$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$30a4c1d360019810$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$30a4c1d360019810$export$88cc3a1dfce48dd3.prototype.constructor = $30a4c1d360019810$export$88cc3a1dfce48dd3;
$30a4c1d360019810$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $30a4c1d360019810$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $30a4c1d360019810$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $30a4c1d360019810$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $6B4AI.Slice).empty) {
        let step = $30a4c1d360019810$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $6B4AI.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $30a4c1d360019810$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $30a4c1d360019810$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $30a4c1d360019810$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $30a4c1d360019810$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $30a4c1d360019810$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $30a4c1d360019810$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $30a4c1d360019810$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $30a4c1d360019810$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $30a4c1d360019810$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $30a4c1d360019810$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $30a4c1d360019810$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $6B4AI.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $30a4c1d360019810$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $30a4c1d360019810$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $30a4c1d360019810$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $30a4c1d360019810$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $30a4c1d360019810$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});



parcelRegister("6jolL", function(module, exports) {

$parcel$export(module.exports, "MenuItem", () => $498767db22b1b651$export$2ce376c2cc3355c8);
$parcel$export(module.exports, "menuBar", () => $498767db22b1b651$export$4bada28d90893e2d);

var $dxqi9 = parcelRequire("dxqi9");

var $1ZnZi = parcelRequire("1ZnZi");

var $6SXdZ = parcelRequire("6SXdZ");

var $cw5sC = parcelRequire("cw5sC");
const $498767db22b1b651$var$SVG = "http://www.w3.org/2000/svg";
const $498767db22b1b651$var$XLINK = "http://www.w3.org/1999/xlink";
const $498767db22b1b651$var$prefix$2 = "ProseMirror-icon";
function $498767db22b1b651$var$hashPath(path) {
    let hash = 0;
    for(let i = 0; i < path.length; i++)hash = (hash << 5) - hash + path.charCodeAt(i) | 0;
    return hash;
}
function $498767db22b1b651$var$getIcon(root, icon) {
    let doc = (root.nodeType == 9 ? root : root.ownerDocument) || document;
    let node = doc.createElement("div");
    node.className = $498767db22b1b651$var$prefix$2;
    if (icon.path) {
        let { path: path, width: width, height: height } = icon;
        let name = "pm-icon-" + $498767db22b1b651$var$hashPath(path).toString(16);
        if (!doc.getElementById(name)) $498767db22b1b651$var$buildSVG(root, name, icon);
        let svg = node.appendChild(doc.createElementNS($498767db22b1b651$var$SVG, "svg"));
        svg.style.width = width / height + "em";
        let use = svg.appendChild(doc.createElementNS($498767db22b1b651$var$SVG, "use"));
        use.setAttributeNS($498767db22b1b651$var$XLINK, "href", /([^#]*)/.exec(doc.location.toString())[1] + "#" + name);
    } else if (icon.dom) node.appendChild(icon.dom.cloneNode(true));
    else {
        let { text: text, css: css } = icon;
        node.appendChild(doc.createElement("span")).textContent = text || "";
        if (css) node.firstChild.style.cssText = css;
    }
    return node;
}
function $498767db22b1b651$var$buildSVG(root, name, data) {
    let [doc, top] = root.nodeType == 9 ? [
        root,
        root.body
    ] : [
        root.ownerDocument || document,
        root
    ];
    let collection = doc.getElementById($498767db22b1b651$var$prefix$2 + "-collection");
    if (!collection) {
        collection = doc.createElementNS($498767db22b1b651$var$SVG, "svg");
        collection.id = $498767db22b1b651$var$prefix$2 + "-collection";
        collection.style.display = "none";
        top.insertBefore(collection, top.firstChild);
    }
    let sym = doc.createElementNS($498767db22b1b651$var$SVG, "symbol");
    sym.id = name;
    sym.setAttribute("viewBox", "0 0 " + data.width + " " + data.height);
    let path = sym.appendChild(doc.createElementNS($498767db22b1b651$var$SVG, "path"));
    path.setAttribute("d", data.path);
    collection.appendChild(sym);
}
const $498767db22b1b651$var$prefix$1 = "ProseMirror-menu";
/**
An icon or label that, when clicked, executes a command.
*/ class $498767db22b1b651$export$2ce376c2cc3355c8 {
    /**
    Create a menu item.
    */ constructor(/**
    The spec used to create this item.
    */ spec){
        this.spec = spec;
    }
    /**
    Renders the icon according to its [display
    spec](https://prosemirror.net/docs/ref/#menu.MenuItemSpec.display), and adds an event handler which
    executes the command when the representation is clicked.
    */ render(view) {
        let spec = this.spec;
        let dom = spec.render ? spec.render(view) : spec.icon ? $498767db22b1b651$var$getIcon(view.root, spec.icon) : spec.label ? (0, $dxqi9.default)("div", null, $498767db22b1b651$var$translate(view, spec.label)) : null;
        if (!dom) throw new RangeError("MenuItem without icon or label property");
        if (spec.title) {
            const title = typeof spec.title === "function" ? spec.title(view.state) : spec.title;
            dom.setAttribute("title", $498767db22b1b651$var$translate(view, title));
        }
        if (spec.class) dom.classList.add(spec.class);
        if (spec.css) dom.style.cssText += spec.css;
        dom.addEventListener("mousedown", (e)=>{
            e.preventDefault();
            if (!dom.classList.contains($498767db22b1b651$var$prefix$1 + "-disabled")) spec.run(view.state, view.dispatch, view, e);
        });
        function update(state) {
            if (spec.select) {
                let selected = spec.select(state);
                dom.style.display = selected ? "" : "none";
                if (!selected) return false;
            }
            let enabled = true;
            if (spec.enable) {
                enabled = spec.enable(state) || false;
                $498767db22b1b651$var$setClass(dom, $498767db22b1b651$var$prefix$1 + "-disabled", !enabled);
            }
            if (spec.active) {
                let active = enabled && spec.active(state) || false;
                $498767db22b1b651$var$setClass(dom, $498767db22b1b651$var$prefix$1 + "-active", active);
            }
            return true;
        }
        return {
            dom: dom,
            update: update
        };
    }
}
function $498767db22b1b651$var$translate(view, text) {
    return view._props.translate ? view._props.translate(text) : text;
}
let $498767db22b1b651$var$lastMenuEvent = {
    time: 0,
    node: null
};
function $498767db22b1b651$var$markMenuEvent(e) {
    $498767db22b1b651$var$lastMenuEvent.time = Date.now();
    $498767db22b1b651$var$lastMenuEvent.node = e.target;
}
function $498767db22b1b651$var$isMenuEvent(wrapper) {
    return Date.now() - 100 < $498767db22b1b651$var$lastMenuEvent.time && $498767db22b1b651$var$lastMenuEvent.node && wrapper.contains($498767db22b1b651$var$lastMenuEvent.node);
}
/**
A drop-down menu, displayed as a label with a downwards-pointing
triangle to the right of it.
*/ class $498767db22b1b651$export$931cbfb6bfb85fc {
    /**
    Create a dropdown wrapping the elements.
    */ constructor(content, /**
    @internal
    */ options = {}){
        this.options = options;
        this.options = options || {};
        this.content = Array.isArray(content) ? content : [
            content
        ];
    }
    /**
    Render the dropdown menu and sub-items.
    */ render(view) {
        let content = $498767db22b1b651$var$renderDropdownItems(this.content, view);
        let win = view.dom.ownerDocument.defaultView || window;
        let label = (0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix$1 + "-dropdown " + (this.options.class || ""),
            style: this.options.css
        }, $498767db22b1b651$var$translate(view, this.options.label || ""));
        if (this.options.title) label.setAttribute("title", $498767db22b1b651$var$translate(view, this.options.title));
        let wrap = (0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix$1 + "-dropdown-wrap"
        }, label);
        let open = null;
        let listeningOnClose = null;
        let close = ()=>{
            if (open && open.close()) {
                open = null;
                win.removeEventListener("mousedown", listeningOnClose);
            }
        };
        label.addEventListener("mousedown", (e)=>{
            e.preventDefault();
            $498767db22b1b651$var$markMenuEvent(e);
            if (open) close();
            else {
                open = this.expand(wrap, content.dom);
                win.addEventListener("mousedown", listeningOnClose = ()=>{
                    if (!$498767db22b1b651$var$isMenuEvent(wrap)) close();
                });
            }
        });
        function update(state) {
            let inner = content.update(state);
            wrap.style.display = inner ? "" : "none";
            return inner;
        }
        return {
            dom: wrap,
            update: update
        };
    }
    /**
    @internal
    */ expand(dom, items) {
        let menuDOM = (0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix$1 + "-dropdown-menu " + (this.options.class || "")
        }, items);
        let done = false;
        function close() {
            if (done) return false;
            done = true;
            dom.removeChild(menuDOM);
            return true;
        }
        dom.appendChild(menuDOM);
        return {
            close: close,
            node: menuDOM
        };
    }
}
function $498767db22b1b651$var$renderDropdownItems(items, view) {
    let rendered = [], updates = [];
    for(let i = 0; i < items.length; i++){
        let { dom: dom, update: update } = items[i].render(view);
        rendered.push((0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix$1 + "-dropdown-item"
        }, dom));
        updates.push(update);
    }
    return {
        dom: rendered,
        update: $498767db22b1b651$var$combineUpdates(updates, rendered)
    };
}
function $498767db22b1b651$var$combineUpdates(updates, nodes) {
    return (state)=>{
        let something = false;
        for(let i = 0; i < updates.length; i++){
            let up = updates[i](state);
            nodes[i].style.display = up ? "" : "none";
            if (up) something = true;
        }
        return something;
    };
}
/**
Represents a submenu wrapping a group of elements that start
hidden and expand to the right when hovered over or tapped.
*/ class $498767db22b1b651$export$ef5c18bf09e4884f {
    /**
    Creates a submenu for the given group of menu elements. The
    following options are recognized:
    */ constructor(content, /**
    @internal
    */ options = {}){
        this.options = options;
        this.content = Array.isArray(content) ? content : [
            content
        ];
    }
    /**
    Renders the submenu.
    */ render(view) {
        let items = $498767db22b1b651$var$renderDropdownItems(this.content, view);
        let win = view.dom.ownerDocument.defaultView || window;
        let label = (0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix$1 + "-submenu-label"
        }, $498767db22b1b651$var$translate(view, this.options.label || ""));
        let wrap = (0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix$1 + "-submenu-wrap"
        }, label, (0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix$1 + "-submenu"
        }, items.dom));
        let listeningOnClose = null;
        label.addEventListener("mousedown", (e)=>{
            e.preventDefault();
            $498767db22b1b651$var$markMenuEvent(e);
            $498767db22b1b651$var$setClass(wrap, $498767db22b1b651$var$prefix$1 + "-submenu-wrap-active", false);
            if (!listeningOnClose) win.addEventListener("mousedown", listeningOnClose = ()=>{
                if (!$498767db22b1b651$var$isMenuEvent(wrap)) {
                    wrap.classList.remove($498767db22b1b651$var$prefix$1 + "-submenu-wrap-active");
                    win.removeEventListener("mousedown", listeningOnClose);
                    listeningOnClose = null;
                }
            });
        });
        function update(state) {
            let inner = items.update(state);
            wrap.style.display = inner ? "" : "none";
            return inner;
        }
        return {
            dom: wrap,
            update: update
        };
    }
}
/**
Render the given, possibly nested, array of menu elements into a
document fragment, placing separators between them (and ensuring no
superfluous separators appear when some of the groups turn out to
be empty).
*/ function $498767db22b1b651$export$32280ef9552def7c(view, content) {
    let result = document.createDocumentFragment();
    let updates = [], separators = [];
    for(let i = 0; i < content.length; i++){
        let items = content[i], localUpdates = [], localNodes = [];
        for(let j = 0; j < items.length; j++){
            let { dom: dom, update: update } = items[j].render(view);
            let span = (0, $dxqi9.default)("span", {
                class: $498767db22b1b651$var$prefix$1 + "item"
            }, dom);
            result.appendChild(span);
            localNodes.push(span);
            localUpdates.push(update);
        }
        if (localUpdates.length) {
            updates.push($498767db22b1b651$var$combineUpdates(localUpdates, localNodes));
            if (i < content.length - 1) separators.push(result.appendChild($498767db22b1b651$var$separator()));
        }
    }
    function update(state) {
        let something = false, needSep = false;
        for(let i = 0; i < updates.length; i++){
            let hasContent = updates[i](state);
            if (i) separators[i - 1].style.display = needSep && hasContent ? "" : "none";
            needSep = hasContent;
            if (hasContent) something = true;
        }
        return something;
    }
    return {
        dom: result,
        update: update
    };
}
function $498767db22b1b651$var$separator() {
    return (0, $dxqi9.default)("span", {
        class: $498767db22b1b651$var$prefix$1 + "separator"
    });
}
/**
A set of basic editor-related icons. Contains the properties
`join`, `lift`, `selectParentNode`, `undo`, `redo`, `strong`, `em`,
`code`, `link`, `bulletList`, `orderedList`, and `blockquote`, each
holding an object that can be used as the `icon` option to
`MenuItem`.
*/ const $498767db22b1b651$export$df03f54e09e486fa = {
    join: {
        width: 800,
        height: 900,
        path: "M0 75h800v125h-800z M0 825h800v-125h-800z M250 400h100v-100h100v100h100v100h-100v100h-100v-100h-100z"
    },
    lift: {
        width: 1024,
        height: 1024,
        path: "M219 310v329q0 7-5 12t-12 5q-8 0-13-5l-164-164q-5-5-5-13t5-13l164-164q5-5 13-5 7 0 12 5t5 12zM1024 749v109q0 7-5 12t-12 5h-987q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h987q7 0 12 5t5 12zM1024 530v109q0 7-5 12t-12 5h-621q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h621q7 0 12 5t5 12zM1024 310v109q0 7-5 12t-12 5h-621q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h621q7 0 12 5t5 12zM1024 91v109q0 7-5 12t-12 5h-987q-7 0-12-5t-5-12v-109q0-7 5-12t12-5h987q7 0 12 5t5 12z"
    },
    selectParentNode: {
        text: "\u2B1A",
        css: "font-weight: bold"
    },
    undo: {
        width: 1024,
        height: 1024,
        path: "M761 1024c113-206 132-520-313-509v253l-384-384 384-384v248c534-13 594 472 313 775z"
    },
    redo: {
        width: 1024,
        height: 1024,
        path: "M576 248v-248l384 384-384 384v-253c-446-10-427 303-313 509-280-303-221-789 313-775z"
    },
    strong: {
        width: 805,
        height: 1024,
        path: "M317 869q42 18 80 18 214 0 214-191 0-65-23-102-15-25-35-42t-38-26-46-14-48-6-54-1q-41 0-57 5 0 30-0 90t-0 90q0 4-0 38t-0 55 2 47 6 38zM309 442q24 4 62 4 46 0 81-7t62-25 42-51 14-81q0-40-16-70t-45-46-61-24-70-8q-28 0-74 7 0 28 2 86t2 86q0 15-0 45t-0 45q0 26 0 39zM0 950l1-53q8-2 48-9t60-15q4-6 7-15t4-19 3-18 1-21 0-19v-37q0-561-12-585-2-4-12-8t-25-6-28-4-27-2-17-1l-2-47q56-1 194-6t213-5q13 0 39 0t38 0q40 0 78 7t73 24 61 40 42 59 16 78q0 29-9 54t-22 41-36 32-41 25-48 22q88 20 146 76t58 141q0 57-20 102t-53 74-78 48-93 27-100 8q-25 0-75-1t-75-1q-60 0-175 6t-132 6z"
    },
    em: {
        width: 585,
        height: 1024,
        path: "M0 949l9-48q3-1 46-12t63-21q16-20 23-57 0-4 35-165t65-310 29-169v-14q-13-7-31-10t-39-4-33-3l10-58q18 1 68 3t85 4 68 1q27 0 56-1t69-4 56-3q-2 22-10 50-17 5-58 16t-62 19q-4 10-8 24t-5 22-4 26-3 24q-15 84-50 239t-44 203q-1 5-7 33t-11 51-9 47-3 32l0 10q9 2 105 17-1 25-9 56-6 0-18 0t-18 0q-16 0-49-5t-49-5q-78-1-117-1-29 0-81 5t-69 6z"
    },
    code: {
        width: 896,
        height: 1024,
        path: "M608 192l-96 96 224 224-224 224 96 96 288-320-288-320zM288 192l-288 320 288 320 96-96-224-224 224-224-96-96z"
    },
    link: {
        width: 951,
        height: 1024,
        path: "M832 694q0-22-16-38l-118-118q-16-16-38-16-24 0-41 18 1 1 10 10t12 12 8 10 7 14 2 15q0 22-16 38t-38 16q-8 0-15-2t-14-7-10-8-12-12-10-10q-18 17-18 41 0 22 16 38l117 118q15 15 38 15 22 0 38-14l84-83q16-16 16-38zM430 292q0-22-16-38l-117-118q-16-16-38-16-22 0-38 15l-84 83q-16 16-16 38 0 22 16 38l118 118q15 15 38 15 24 0 41-17-1-1-10-10t-12-12-8-10-7-14-2-15q0-22 16-38t38-16q8 0 15 2t14 7 10 8 12 12 10 10q18-17 18-41zM941 694q0 68-48 116l-84 83q-47 47-116 47-69 0-116-48l-117-118q-47-47-47-116 0-70 50-119l-50-50q-49 50-118 50-68 0-116-48l-118-118q-48-48-48-116t48-116l84-83q47-47 116-47 69 0 116 48l117 118q47 47 47 116 0 70-50 119l50 50q49-50 118-50 68 0 116 48l118 118q48 48 48 116z"
    },
    bulletList: {
        width: 768,
        height: 896,
        path: "M0 512h128v-128h-128v128zM0 256h128v-128h-128v128zM0 768h128v-128h-128v128zM256 512h512v-128h-512v128zM256 256h512v-128h-512v128zM256 768h512v-128h-512v128z"
    },
    orderedList: {
        width: 768,
        height: 896,
        path: "M320 512h448v-128h-448v128zM320 768h448v-128h-448v128zM320 128v128h448v-128h-448zM79 384h78v-256h-36l-85 23v50l43-2v185zM189 590c0-36-12-78-96-78-33 0-64 6-83 16l1 66c21-10 42-15 67-15s32 11 32 28c0 26-30 58-110 112v50h192v-67l-91 2c49-30 87-66 87-113l1-1z"
    },
    blockquote: {
        width: 640,
        height: 896,
        path: "M0 448v256h256v-256h-128c0 0 0-128 128-128v-128c0 0-256 0-256 256zM640 320v-128c0 0-256 0-256 256v256h256v-256h-128c0 0 0-128 128-128z"
    }
};
/**
Menu item for the `joinUp` command.
*/ const $498767db22b1b651$export$11baffb4edd2ca7f = new $498767db22b1b651$export$2ce376c2cc3355c8({
    title: "Join with above block",
    run: (0, $1ZnZi.joinUp),
    select: (state)=>(0, $1ZnZi.joinUp)(state),
    icon: $498767db22b1b651$export$df03f54e09e486fa.join
});
/**
Menu item for the `lift` command.
*/ const $498767db22b1b651$export$58f79fea701cb352 = new $498767db22b1b651$export$2ce376c2cc3355c8({
    title: "Lift out of enclosing block",
    run: (0, $1ZnZi.lift),
    select: (state)=>(0, $1ZnZi.lift)(state),
    icon: $498767db22b1b651$export$df03f54e09e486fa.lift
});
/**
Menu item for the `selectParentNode` command.
*/ const $498767db22b1b651$export$e7da091474561953 = new $498767db22b1b651$export$2ce376c2cc3355c8({
    title: "Select parent node",
    run: (0, $1ZnZi.selectParentNode),
    select: (state)=>(0, $1ZnZi.selectParentNode)(state),
    icon: $498767db22b1b651$export$df03f54e09e486fa.selectParentNode
});
/**
Menu item for the `undo` command.
*/ let $498767db22b1b651$export$e59d9ce4b90da7a2 = new $498767db22b1b651$export$2ce376c2cc3355c8({
    title: "Undo last change",
    run: (0, $6SXdZ.undo),
    enable: (state)=>(0, $6SXdZ.undo)(state),
    icon: $498767db22b1b651$export$df03f54e09e486fa.undo
});
/**
Menu item for the `redo` command.
*/ let $498767db22b1b651$export$fdbfb7c42a1822a2 = new $498767db22b1b651$export$2ce376c2cc3355c8({
    title: "Redo last undone change",
    run: (0, $6SXdZ.redo),
    enable: (state)=>(0, $6SXdZ.redo)(state),
    icon: $498767db22b1b651$export$df03f54e09e486fa.redo
});
/**
Build a menu item for wrapping the selection in a given node type.
Adds `run` and `select` properties to the ones present in
`options`. `options.attrs` may be an object that provides
attributes for the wrapping node.
*/ function $498767db22b1b651$export$8f5e79e4d0433569(nodeType, options) {
    let passedOptions = {
        run (state, dispatch) {
            return (0, $1ZnZi.wrapIn)(nodeType, options.attrs)(state, dispatch);
        },
        select (state) {
            return (0, $1ZnZi.wrapIn)(nodeType, options.attrs)(state);
        }
    };
    for(let prop in options)passedOptions[prop] = options[prop];
    return new $498767db22b1b651$export$2ce376c2cc3355c8(passedOptions);
}
/**
Build a menu item for changing the type of the textblock around the
selection to the given type. Provides `run`, `active`, and `select`
properties. Others must be given in `options`. `options.attrs` may
be an object to provide the attributes for the textblock node.
*/ function $498767db22b1b651$export$92aed8e2efb56f10(nodeType, options) {
    let command = (0, $1ZnZi.setBlockType)(nodeType, options.attrs);
    let passedOptions = {
        run: command,
        enable (state) {
            return command(state);
        },
        active (state) {
            let { $from: $from, to: to, node: node } = state.selection;
            if (node) return node.hasMarkup(nodeType, options.attrs);
            return to <= $from.end() && $from.parent.hasMarkup(nodeType, options.attrs);
        }
    };
    for(let prop in options)passedOptions[prop] = options[prop];
    return new $498767db22b1b651$export$2ce376c2cc3355c8(passedOptions);
}
// Work around classList.toggle being broken in IE11
function $498767db22b1b651$var$setClass(dom, cls, on) {
    if (on) dom.classList.add(cls);
    else dom.classList.remove(cls);
}
const $498767db22b1b651$var$prefix = "ProseMirror-menubar";
function $498767db22b1b651$var$isIOS() {
    if (typeof navigator == "undefined") return false;
    let agent = navigator.userAgent;
    return !/Edge\/\d/.test(agent) && /AppleWebKit/.test(agent) && /Mobile\/\w+/.test(agent);
}
/**
A plugin that will place a menu bar above the editor. Note that
this involves wrapping the editor in an additional `<div>`.
*/ function $498767db22b1b651$export$4bada28d90893e2d(options) {
    return new (0, $cw5sC.Plugin)({
        view (editorView) {
            return new $498767db22b1b651$var$MenuBarView(editorView, options);
        }
    });
}
class $498767db22b1b651$var$MenuBarView {
    constructor(editorView, options){
        this.editorView = editorView;
        this.options = options;
        this.spacer = null;
        this.maxHeight = 0;
        this.widthForMaxHeight = 0;
        this.floating = false;
        this.scrollHandler = null;
        this.wrapper = (0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix + "-wrapper"
        });
        this.menu = this.wrapper.appendChild((0, $dxqi9.default)("div", {
            class: $498767db22b1b651$var$prefix
        }));
        this.menu.className = $498767db22b1b651$var$prefix;
        if (editorView.dom.parentNode) editorView.dom.parentNode.replaceChild(this.wrapper, editorView.dom);
        this.wrapper.appendChild(editorView.dom);
        let { dom: dom, update: update } = $498767db22b1b651$export$32280ef9552def7c(this.editorView, this.options.content);
        this.contentUpdate = update;
        this.menu.appendChild(dom);
        this.update();
        if (options.floating && !$498767db22b1b651$var$isIOS()) {
            this.updateFloat();
            let potentialScrollers = $498767db22b1b651$var$getAllWrapping(this.wrapper);
            this.scrollHandler = (e)=>{
                let root = this.editorView.root;
                if (!(root.body || root).contains(this.wrapper)) potentialScrollers.forEach((el)=>el.removeEventListener("scroll", this.scrollHandler));
                else this.updateFloat(e.target.getBoundingClientRect ? e.target : undefined);
            };
            potentialScrollers.forEach((el)=>el.addEventListener("scroll", this.scrollHandler));
        }
    }
    update() {
        this.contentUpdate(this.editorView.state);
        if (this.floating) this.updateScrollCursor();
        else {
            if (this.menu.offsetWidth != this.widthForMaxHeight) {
                this.widthForMaxHeight = this.menu.offsetWidth;
                this.maxHeight = 0;
            }
            if (this.menu.offsetHeight > this.maxHeight) {
                this.maxHeight = this.menu.offsetHeight;
                this.menu.style.minHeight = this.maxHeight + "px";
            }
        }
    }
    updateScrollCursor() {
        let selection = this.editorView.root.getSelection();
        if (!selection.focusNode) return;
        let rects = selection.getRangeAt(0).getClientRects();
        let selRect = rects[$498767db22b1b651$var$selectionIsInverted(selection) ? 0 : rects.length - 1];
        if (!selRect) return;
        let menuRect = this.menu.getBoundingClientRect();
        if (selRect.top < menuRect.bottom && selRect.bottom > menuRect.top) {
            let scrollable = $498767db22b1b651$var$findWrappingScrollable(this.wrapper);
            if (scrollable) scrollable.scrollTop -= menuRect.bottom - selRect.top;
        }
    }
    updateFloat(scrollAncestor) {
        let parent = this.wrapper, editorRect = parent.getBoundingClientRect(), top = scrollAncestor ? Math.max(0, scrollAncestor.getBoundingClientRect().top) : 0;
        if (this.floating) {
            if (editorRect.top >= top || editorRect.bottom < this.menu.offsetHeight + 10) {
                this.floating = false;
                this.menu.style.position = this.menu.style.left = this.menu.style.top = this.menu.style.width = "";
                this.menu.style.display = "";
                this.spacer.parentNode.removeChild(this.spacer);
                this.spacer = null;
            } else {
                let border = (parent.offsetWidth - parent.clientWidth) / 2;
                this.menu.style.left = editorRect.left + border + "px";
                this.menu.style.display = editorRect.top > (this.editorView.dom.ownerDocument.defaultView || window).innerHeight ? "none" : "";
                if (scrollAncestor) this.menu.style.top = top + "px";
            }
        } else if (editorRect.top < top && editorRect.bottom >= this.menu.offsetHeight + 10) {
            this.floating = true;
            let menuRect = this.menu.getBoundingClientRect();
            this.menu.style.left = menuRect.left + "px";
            this.menu.style.width = menuRect.width + "px";
            if (scrollAncestor) this.menu.style.top = top + "px";
            this.menu.style.position = "fixed";
            this.spacer = (0, $dxqi9.default)("div", {
                class: $498767db22b1b651$var$prefix + "-spacer",
                style: `height: ${menuRect.height}px`
            });
            parent.insertBefore(this.spacer, this.menu);
        }
    }
    destroy() {
        if (this.wrapper.parentNode) this.wrapper.parentNode.replaceChild(this.editorView.dom, this.wrapper);
    }
}
// Not precise, but close enough
function $498767db22b1b651$var$selectionIsInverted(selection) {
    if (selection.anchorNode == selection.focusNode) return selection.anchorOffset > selection.focusOffset;
    return selection.anchorNode.compareDocumentPosition(selection.focusNode) == Node.DOCUMENT_POSITION_FOLLOWING;
}
function $498767db22b1b651$var$findWrappingScrollable(node) {
    for(let cur = node.parentNode; cur; cur = cur.parentNode)if (cur.scrollHeight > cur.clientHeight) return cur;
}
function $498767db22b1b651$var$getAllWrapping(node) {
    let res = [
        node.ownerDocument.defaultView || window
    ];
    for(let cur = node.parentNode; cur; cur = cur.parentNode)res.push(cur);
    return res;
}

});
parcelRegister("dxqi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db2c06efbc263c2$export$2e2bcd8739ae039);
function $9db2c06efbc263c2$export$2e2bcd8739ae039() {
    var elt = arguments[0];
    if (typeof elt == "string") elt = document.createElement(elt);
    var i = 1, next = arguments[1];
    if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
        for(var name in next)if (Object.prototype.hasOwnProperty.call(next, name)) {
            var value = next[name];
            if (typeof value == "string") elt.setAttribute(name, value);
            else if (value != null) elt[name] = value;
        }
        i++;
    }
    for(; i < arguments.length; i++)$9db2c06efbc263c2$var$add(elt, arguments[i]);
    return elt;
}
function $9db2c06efbc263c2$var$add(elt, child) {
    if (typeof child == "string") elt.appendChild(document.createTextNode(child));
    else if (child == null) ;
    else if (child.nodeType != null) elt.appendChild(child);
    else if (Array.isArray(child)) for(var i = 0; i < child.length; i++)$9db2c06efbc263c2$var$add(elt, child[i]);
    else throw new RangeError("Unsupported child node: " + child);
}

});

parcelRegister("1ZnZi", function(module, exports) {

$parcel$export(module.exports, "joinUp", () => $172e186c3afc9346$export$4bb15e6d4372b393);
$parcel$export(module.exports, "lift", () => $172e186c3afc9346$export$590e8b2c435046d9);
$parcel$export(module.exports, "selectParentNode", () => $172e186c3afc9346$export$a37f6aaa9169911d);
$parcel$export(module.exports, "wrapIn", () => $172e186c3afc9346$export$6e5e3c49755affd0);
$parcel$export(module.exports, "setBlockType", () => $172e186c3afc9346$export$36987f561c736aad);
$parcel$export(module.exports, "toggleMark", () => $172e186c3afc9346$export$797ad2667b8015a8);
$parcel$export(module.exports, "chainCommands", () => $172e186c3afc9346$export$146a774cdef7663a);

var $4aVzI = parcelRequire("4aVzI");

var $6B4AI = parcelRequire("6B4AI");

var $cw5sC = parcelRequire("cw5sC");
/**
Delete the selection, if there is one.
*/ const $172e186c3afc9346$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $172e186c3afc9346$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $172e186c3afc9346$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $172e186c3afc9346$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $172e186c3afc9346$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $4aVzI.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($172e186c3afc9346$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($172e186c3afc9346$var$textblockAt(before, "end") || (0, $cw5sC.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $4aVzI.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $6B4AI.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($172e186c3afc9346$var$textblockAt(before, "end") ? (0, $cw5sC.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $cw5sC.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $172e186c3afc9346$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $172e186c3afc9346$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $172e186c3afc9346$var$findCutBefore($cursor);
    return $cut ? $172e186c3afc9346$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $172e186c3afc9346$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $172e186c3afc9346$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $172e186c3afc9346$var$findCutAfter($cursor);
    return $cut ? $172e186c3afc9346$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $172e186c3afc9346$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $4aVzI.replaceStep)(state.doc, beforePos, afterPos, (0, $6B4AI.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $4aVzI.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $cw5sC.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $172e186c3afc9346$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $172e186c3afc9346$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $172e186c3afc9346$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $cw5sC.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $cw5sC.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $172e186c3afc9346$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $172e186c3afc9346$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $172e186c3afc9346$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $172e186c3afc9346$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $172e186c3afc9346$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($172e186c3afc9346$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($172e186c3afc9346$var$textblockAt(after, "start") || (0, $cw5sC.NodeSelection).isSelectable(after))) {
        let delStep = (0, $4aVzI.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $6B4AI.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($172e186c3afc9346$var$textblockAt(after, "start") ? (0, $cw5sC.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $cw5sC.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $172e186c3afc9346$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $172e186c3afc9346$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $cw5sC.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $cw5sC.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $172e186c3afc9346$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $172e186c3afc9346$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $cw5sC.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $4aVzI.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $4aVzI.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $cw5sC.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $172e186c3afc9346$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $cw5sC.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $4aVzI.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $4aVzI.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $172e186c3afc9346$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $4aVzI.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $172e186c3afc9346$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $172e186c3afc9346$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $172e186c3afc9346$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $172e186c3afc9346$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $cw5sC.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $172e186c3afc9346$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $cw5sC.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $172e186c3afc9346$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $cw5sC.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $172e186c3afc9346$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $4aVzI.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $4aVzI.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $172e186c3afc9346$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $cw5sC.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $4aVzI.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $172e186c3afc9346$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $cw5sC.TextSelection) || state.selection instanceof (0, $cw5sC.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $4aVzI.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $4aVzI.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $172e186c3afc9346$export$e99155638ff4dff0 = $172e186c3afc9346$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $172e186c3afc9346$export$eeb429476568b72b = (state, dispatch)=>{
    return $172e186c3afc9346$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $172e186c3afc9346$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $cw5sC.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $172e186c3afc9346$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $cw5sC.AllSelection)(state.doc)));
    return true;
};
function $172e186c3afc9346$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $4aVzI.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $172e186c3afc9346$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $172e186c3afc9346$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $6B4AI.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $6B4AI.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $6B4AI.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $4aVzI.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $6B4AI.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $4aVzI.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $cw5sC.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $4aVzI.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $172e186c3afc9346$var$textblockAt(after, "start", true) && $172e186c3afc9346$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $6B4AI.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $6B4AI.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $4aVzI.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $6B4AI.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $172e186c3afc9346$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $cw5sC.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $172e186c3afc9346$export$c3a64f3c9604a1b1 = $172e186c3afc9346$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $172e186c3afc9346$export$a66c1876556415e5 = $172e186c3afc9346$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $172e186c3afc9346$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $4aVzI.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $172e186c3afc9346$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $172e186c3afc9346$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $172e186c3afc9346$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $cw5sC.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $cw5sC.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $172e186c3afc9346$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$172e186c3afc9346$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $172e186c3afc9346$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $172e186c3afc9346$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $4aVzI.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $172e186c3afc9346$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $172e186c3afc9346$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $172e186c3afc9346$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $172e186c3afc9346$var$backspace = $172e186c3afc9346$export$146a774cdef7663a($172e186c3afc9346$export$e9a518a637d1e641, $172e186c3afc9346$export$979097b097459299, $172e186c3afc9346$export$52b8a4af68d19794);
let $172e186c3afc9346$var$del = $172e186c3afc9346$export$146a774cdef7663a($172e186c3afc9346$export$e9a518a637d1e641, $172e186c3afc9346$export$bf432e340007f9ef, $172e186c3afc9346$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $172e186c3afc9346$export$eb36e8971b04df36 = {
    "Enter": $172e186c3afc9346$export$146a774cdef7663a($172e186c3afc9346$export$a5d02b4b65e94f91, $172e186c3afc9346$export$d0f80ac1b4510888, $172e186c3afc9346$export$a3574cc681852c08, $172e186c3afc9346$export$e99155638ff4dff0),
    "Mod-Enter": $172e186c3afc9346$export$634b78845598ff5b,
    "Backspace": $172e186c3afc9346$var$backspace,
    "Mod-Backspace": $172e186c3afc9346$var$backspace,
    "Shift-Backspace": $172e186c3afc9346$var$backspace,
    "Delete": $172e186c3afc9346$var$del,
    "Mod-Delete": $172e186c3afc9346$var$del,
    "Mod-a": $172e186c3afc9346$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $172e186c3afc9346$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $172e186c3afc9346$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $172e186c3afc9346$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $172e186c3afc9346$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $172e186c3afc9346$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $172e186c3afc9346$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $172e186c3afc9346$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $172e186c3afc9346$export$c3a64f3c9604a1b1,
    "Ctrl-e": $172e186c3afc9346$export$a66c1876556415e5
};
for(let key in $172e186c3afc9346$export$eb36e8971b04df36)$172e186c3afc9346$export$f292ad8dbd5063c8[key] = $172e186c3afc9346$export$eb36e8971b04df36[key];
const $172e186c3afc9346$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $172e186c3afc9346$export$4a0c2b85b1f0a889 = $172e186c3afc9346$var$mac ? $172e186c3afc9346$export$f292ad8dbd5063c8 : $172e186c3afc9346$export$eb36e8971b04df36;

});

parcelRegister("6SXdZ", function(module, exports) {

$parcel$export(module.exports, "history", () => $5035ba0465878a1b$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $5035ba0465878a1b$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $5035ba0465878a1b$export$1688e416fee0a49e);

var $dW2R4 = parcelRequire("dW2R4");

var $4aVzI = parcelRequire("4aVzI");

var $cw5sC = parcelRequire("cw5sC");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $5035ba0465878a1b$var$max_empty_items = 500;
class $5035ba0465878a1b$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $5035ba0465878a1b$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $5035ba0465878a1b$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $5035ba0465878a1b$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $5035ba0465878a1b$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $5035ba0465878a1b$var$DEPTH_OVERFLOW) {
            oldItems = $5035ba0465878a1b$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $5035ba0465878a1b$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $4aVzI.Mapping);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $5035ba0465878a1b$var$Branch(this.items.append(array.map((map)=>new $5035ba0465878a1b$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $5035ba0465878a1b$var$Item(map, step, selection));
            } else rebasedItems.push(new $5035ba0465878a1b$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $5035ba0465878a1b$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $5035ba0465878a1b$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $5035ba0465878a1b$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $5035ba0465878a1b$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $5035ba0465878a1b$var$Branch((0, $dW2R4.default).from(items.reverse()), events);
    }
}
$5035ba0465878a1b$var$Branch.empty = new $5035ba0465878a1b$var$Branch((0, $dW2R4.default).empty, 0);
function $5035ba0465878a1b$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $5035ba0465878a1b$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $5035ba0465878a1b$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $5035ba0465878a1b$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $5035ba0465878a1b$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $5035ba0465878a1b$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($5035ba0465878a1b$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($5035ba0465878a1b$var$closeHistoryKey)) history = new $5035ba0465878a1b$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($5035ba0465878a1b$var$historyKey)) {
        if (appended.getMeta($5035ba0465878a1b$var$historyKey).redo) return new $5035ba0465878a1b$var$HistoryState(history.done.addTransform(tr, undefined, options, $5035ba0465878a1b$var$mustPreserveItems(state)), history.undone, $5035ba0465878a1b$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $5035ba0465878a1b$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $5035ba0465878a1b$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$5035ba0465878a1b$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $5035ba0465878a1b$var$mapRanges(history.prevRanges, tr.mapping) : $5035ba0465878a1b$var$rangesFor(tr.mapping.maps);
        return new $5035ba0465878a1b$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $5035ba0465878a1b$var$mustPreserveItems(state)), $5035ba0465878a1b$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $5035ba0465878a1b$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $5035ba0465878a1b$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $5035ba0465878a1b$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $5035ba0465878a1b$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $5035ba0465878a1b$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $5035ba0465878a1b$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $5035ba0465878a1b$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $5035ba0465878a1b$var$histTransaction(history, state, redo) {
    let preserveItems = $5035ba0465878a1b$var$mustPreserveItems(state);
    let histOptions = $5035ba0465878a1b$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $5035ba0465878a1b$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($5035ba0465878a1b$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $5035ba0465878a1b$var$cachedPreserveItems = false, $5035ba0465878a1b$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $5035ba0465878a1b$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($5035ba0465878a1b$var$cachedPreserveItemsPlugins != plugins) {
        $5035ba0465878a1b$var$cachedPreserveItems = false;
        $5035ba0465878a1b$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $5035ba0465878a1b$var$cachedPreserveItems = true;
            break;
        }
    }
    return $5035ba0465878a1b$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $5035ba0465878a1b$export$181a649d919c589e(tr) {
    return tr.setMeta($5035ba0465878a1b$var$closeHistoryKey, true);
}
const $5035ba0465878a1b$var$historyKey = new (0, $cw5sC.PluginKey)("history");
const $5035ba0465878a1b$var$closeHistoryKey = new (0, $cw5sC.PluginKey)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $5035ba0465878a1b$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $cw5sC.Plugin)({
        key: $5035ba0465878a1b$var$historyKey,
        state: {
            init () {
                return new $5035ba0465878a1b$var$HistoryState($5035ba0465878a1b$var$Branch.empty, $5035ba0465878a1b$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $5035ba0465878a1b$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $5035ba0465878a1b$export$21f930c44940fd98 : inputType == "historyRedo" ? $5035ba0465878a1b$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $5035ba0465878a1b$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $5035ba0465878a1b$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $5035ba0465878a1b$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $5035ba0465878a1b$export$21f930c44940fd98 = $5035ba0465878a1b$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $5035ba0465878a1b$export$1688e416fee0a49e = $5035ba0465878a1b$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $5035ba0465878a1b$export$24b5d280435f3a3f = $5035ba0465878a1b$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $5035ba0465878a1b$export$3774e54bae7be19b = $5035ba0465878a1b$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $5035ba0465878a1b$export$f8a176c2b9a10bdb(state) {
    let hist = $5035ba0465878a1b$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $5035ba0465878a1b$export$3ffe6b288e7d941b(state) {
    let hist = $5035ba0465878a1b$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("dW2R4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a252e81708ab95db$export$2e2bcd8739ae039);
var $a252e81708ab95db$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $a252e81708ab95db$var$RopeSequence = function RopeSequence() {};
$a252e81708ab95db$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $a252e81708ab95db$var$RopeSequence.from(other);
    return !this.length && other || other.length < $a252e81708ab95db$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $a252e81708ab95db$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$a252e81708ab95db$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $a252e81708ab95db$var$RopeSequence.from(other).append(this);
};
$a252e81708ab95db$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $a252e81708ab95db$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$a252e81708ab95db$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $a252e81708ab95db$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$a252e81708ab95db$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$a252e81708ab95db$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$a252e81708ab95db$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$a252e81708ab95db$var$RopeSequence.from = function from(values) {
    if (values instanceof $a252e81708ab95db$var$RopeSequence) return values;
    return values && values.length ? new $a252e81708ab95db$var$Leaf(values) : $a252e81708ab95db$var$RopeSequence.empty;
};
var $a252e81708ab95db$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $a252e81708ab95db$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $a252e81708ab95db$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($a252e81708ab95db$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$a252e81708ab95db$var$RopeSequence.empty = new $a252e81708ab95db$var$Leaf([]);
var $a252e81708ab95db$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($a252e81708ab95db$var$RopeSequence);
var $a252e81708ab95db$export$2e2bcd8739ae039 = $a252e81708ab95db$var$RopeSequence;

});



parcelRegister("1t04f", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._test_private_commands = module.exports.newLine = module.exports.InputContainer = module.exports.toggleMark = void 0;
module.exports.createNode = $11188d4417578e2f$var$createNode;
module.exports.createNodesTree = $11188d4417578e2f$var$createNodesTree;
module.exports.insertNode = $11188d4417578e2f$var$insertNode;
module.exports.renderPrDialog = $11188d4417578e2f$var$renderPrDialog;
module.exports.imageInputOverlay = $11188d4417578e2f$var$imageInputOverlay;
module.exports.insertImage = $11188d4417578e2f$var$insertImage;
module.exports.enterEOL = $11188d4417578e2f$var$enterEOL;
module.exports.deleteEmptyLine = $11188d4417578e2f$var$deleteEmptyLine;
module.exports.enterEmpty = $11188d4417578e2f$var$enterEmpty;
module.exports.enterSplit = $11188d4417578e2f$var$enterSplit;
module.exports.isEOL = $11188d4417578e2f$var$isEOL;
module.exports.isEmpty = $11188d4417578e2f$var$isEmpty;
module.exports.isPrevEmpty = $11188d4417578e2f$var$isPrevEmpty;
module.exports.getDepth = $11188d4417578e2f$var$getDepth;
module.exports.getPrevDepth = $11188d4417578e2f$var$getPrevDepth;
module.exports.getTree = $11188d4417578e2f$var$getTree;
module.exports.enterPressed = $11188d4417578e2f$var$enterPressed;
module.exports.hasMark = $11188d4417578e2f$var$hasMark;

var $1ZnZi = parcelRequire("1ZnZi");
Object.defineProperty(module.exports, "toggleMark", {
    enumerable: true,
    get: function() {
        return $1ZnZi.toggleMark;
    }
});

var $4aVzI = parcelRequire("4aVzI");

var $1ZnZi = parcelRequire("1ZnZi");

var $6B4AI = parcelRequire("6B4AI");

var $cw5sC = parcelRequire("cw5sC");

var $aSs4u = parcelRequire("aSs4u");

var $is3B8 = parcelRequire("is3B8");
/**
 * Create a new Node and fill it with the args as attributes.
 * Fill the node with child nodes if they're required.
 *
 * @privateRemarks
 * An image node is only retrieving the `href` attribute from the source, the according `alt` tag is not implemented yet.
 *
 * @param type - NodeType
 * @param args - Node attributes
 * @returns a new Node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $11188d4417578e2f$var$createNode(type, args = {}) {
    switch(type.name){
        case "p":
            return type.createAndFill();
        case "simpletable":
            return type.createAndFill({}, $11188d4417578e2f$var$createNode(type.schema.nodes["strow"]));
        case "li":
            return type.createAndFill({}, $11188d4417578e2f$var$createNode(type.schema.nodes["p"]));
        case "stentry":
            return type.createAndFill({}, $11188d4417578e2f$var$createNode(type.schema.nodes["p"]));
        case "ul":
        case "ol":
            return type.createAndFill({}, $11188d4417578e2f$var$createNode(type.schema.nodes["li"]));
        case "section":
            return type.createAndFill({}, $11188d4417578e2f$var$createNode(type.schema.nodes["ul"]));
        case "strow":
            return type.createAndFill({}, $11188d4417578e2f$var$createNode(type.schema.nodes["stentry"]));
        case "image":
            return type.createAndFill({
                href: args.src,
                height: args.height,
                width: args.width,
                scope: args.scope,
                alt: args.alt
            });
        case "fig":
            return type.createAndFill({}, $11188d4417578e2f$var$createNode(type.schema.nodes["image"], args));
    }
    throw new Error("unkown node type: " + type.name);
}
/**
 * Creates a node tree from the given NodeType array.
 *
 * @param tree - The node tree of type `NodeType` that has been passed
 * @returns The node object
 */ function $11188d4417578e2f$var$createNodesTree(tree) {
    let result;
    // Go through the NodeType array ("tree")
    // and call `createAndFill()` on each item.
    tree.forEach((type)=>{
        // Create a node object.
        // If needed, create a new one to the start or
        // end of the given fragment to make it fit the node.
        // If no fitting wrapping can be found, return null.
        // Assign the result to variable "result".
        result = type.createAndFill({}, result);
    });
    // Return the node object
    return result;
}
/**
 * Creates a command to insert a new node at the current cursor position.
 *
 * @remarks
 * This function will be called by `insertItem()` which again will be called by `menu()`.
 * `insertNode` will help to create editor buttons in the editor menu bar,
 * currently these are the buttons for creating new ordered and unordered lists.
 * menu() -\> insertItem() -\> insertNode()
 *
 * @param type - NodeType
 * @returns Command
 */ function $11188d4417578e2f$var$insertNode(type) {
    // type = the NodeTypes that have been initialized in the menu,
    // currently the types are `ol` and `ul` nodes (that can be inserted via the menu buttons)
    // state = the current EditorState
    // dispatch = without any interaction it will be undefined at runtime, but if triggered by clicking one of the
    // buttons with the according `type`, the Prosemirror `dispatch` function will be called:
    // this will dispatch a transaction
    return function(state, dispatch) {
        try {
            // If the cursors selection is not empty, return false
            if (!state.selection.empty) return false;
            // "dispatch" becomes "true" when a button in the menu
            // has been clicked that matches the required NodeType, e.g. "ol" or "ul"
            if (dispatch) {
                // create a new node for the according type
                const node = $11188d4417578e2f$var$createNode(type);
                // update the the transaction object and thus the EditorState
                const tr = state.tr.insert(state.selection.$to.end() + 1, node);
                // with the information about exact position and selection
                const pos = tr.selection.$to.doc.resolve(tr.selection.$to.pos + 2);
                // create a new text section at the given position info
                const newSelection = new $cw5sC.TextSelection(pos, pos);
                // and update the transaction's current selection - it will determine the
                // selection that the editor gets when the transaction is applied.
                // Scroll to the updated node in the browser's editor window.
                dispatch(tr.setSelection(newSelection).scrollIntoView());
            }
            return true;
        } catch (e) {
            console.error(e);
            return false;
        }
    };
}
/**
 * Create a new class `InputContainer` to handle uploading of images
 * currently used in `insertImageItem()` as a new instance
 */ class $11188d4417578e2f$var$InputContainer {
    constructor(){
        // Type parameters for Record are string and HTMLInputElement + Event,
        // both by default set to an empty object
        this.listeners = {};
    }
    // bind object property "_el" to a function of type HTMLInputElement
    // or undefined that will be called when that property is looked up
    // class methods:
    get el() {
        return this._el;
    }
    // setter function with arguments of type HTMLInputElement or undefined
    set el(value) {
        var _a;
        // will not do anything, if the the current HTML input element equals the to-be-set element
        if (this._el === value) return;
        this._el = value;
        (_a = this._el) === null || _a === void 0 || _a.addEventListener("change", this.change.bind(this));
    }
    change(event) {
        if (this._el) {
            const el = this._el;
            // method "keys" returns the names of the enumerable string properties and methods of object "this.listeners"
            Object.keys(this.listeners)// and returns the keys of the listeners array with value "function"
            .filter((key)=>typeof this.listeners[key] === "function")// and binds those to the change event
            .forEach((key)=>this.listeners[key].bind(el)(event));
        }
    }
    // enable the input container to listen to events
    on(key, listener) {
        this.off(key);
        this.listeners[key] = listener;
    }
    // disable the input container events
    off(key) {
        if (this.listeners[key]) delete this.listeners[key];
    }
}
module.exports.InputContainer = $11188d4417578e2f$var$InputContainer;
/**
 * Render a dialog form for inserting the PR metadata
 *
 * @param config - configuration
 * @param localization - localization
 * @param ghrepo - The GitHub repository in the format "owner/repo".
 * @param source - The source file path in the repository.
 * @param branch - The Base branch name for the PR.
 * @param updatedXdita - The updated XDITA content.
 */ function $11188d4417578e2f$var$renderPrDialog(config, localization, ghrepo, source, branch, updatedXdita) {
    const overlay = document.createElement("section");
    overlay.id = "prOverlay";
    document.body.appendChild(overlay);
    const dialog = document.createElement("div");
    dialog.id = "prDialog";
    const dialogHtml = `
    <h1>Please describe your changes</h1>
    <form id="prForm">
      <div class="pt__form-field pt__flex--column">
        <label class="pt__label" for="titleInput">Title <br><span class="pt__label--info">Required, max. 50 characters</span></label>
        <input type="text" id="titleInput" name="prData" required size="50" maxLength="50" minLength="1">
      </div>
      <div class="pt__form-field pt__flex--column">
        <label class="pt__label" for="descField">Description <br><span class="pt__label--info">Optional</span></label>
        <textarea id="descField" name="prData" rows="5" cols="48"></textarea>
      </div>
      <div id="btnContainer" class="pt__form-field pt__flex--row">
        <input type="button" class="pt__button" id="closeButton" value="Cancel & return to Editor">
        <input type="submit" class="pt__button" id="okButton" value="Publish your changes">
      </div>
    </form>
  `;
    dialog.innerHTML = dialogHtml;
    document.body.appendChild(overlay);
    overlay.appendChild(dialog);
    overlay.addEventListener("click", function(e) {
        if (e.target.matches("#closeButton")) {
            document.body.removeChild(overlay);
            return null;
        }
    });
    overlay.addEventListener("click", function(e) {
        if (e.target === overlay) {
            document.body.removeChild(overlay);
            return null;
        }
    });
    dialog.addEventListener("submit", function(e) {
        e.preventDefault();
        const titleInput = document.getElementById("titleInput");
        const descField = document.getElementById("descField");
        if (titleInput && descField) {
            const title = titleInput.value;
            const description = descField.value;
            // Create a PR from the contribution
            (0, $aSs4u.createPrFromContribution)(config, localization, ghrepo, source, branch, updatedXdita, title, description).then((prURL)=>{
                console.log("The document has been published to GitHub.");
                console.log("pr url:", prURL);
                // Show a user notification with the successful result and a link to the PR
                (0, $is3B8.showPublicationResultSuccess)(localization, prURL);
            }).catch((error)=>{
                console.error("Error:", error);
                // show error dialog
                (0, $is3B8.showPublicationResultError)(localization, error.message);
            });
            document.body.removeChild(overlay);
        }
    });
}
/**
 * Render an image upload dialog with an overlay
 * upload an image from the local file system or a URL
 * set the image attributes like height, width, alt text
 * @param localization - localization
 * @param callback - callback function to handle the image attributes
 * @param node - Node selected node to edit
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $11188d4417578e2f$var$imageInputOverlay(localization, callback, node) {
    var _a;
    // show the image upload dialog
    // Create overlay
    const overlay = document.createElement("div");
    overlay.id = "overlay";
    // Create dialog
    const dialog = document.createElement("div");
    dialog.id = "dialog";
    // Create dialog content
    const title = document.createElement("h1");
    title.textContent = "Upload Image";
    const fileLabel = document.createElement("label");
    fileLabel.textContent = "File:";
    fileLabel.htmlFor = "fileInput";
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.id = "fileInput";
    fileInput.accept = "image/*";
    const urlLabel = document.createElement("label");
    urlLabel.textContent = "URL:";
    urlLabel.htmlFor = "urlInput";
    const urlInput = document.createElement("input");
    urlInput.type = "text";
    urlInput.id = "urlInput";
    urlInput.placeholder = "url";
    const embeddedLabel = document.createElement("label");
    embeddedLabel.textContent = "Embed a copy:";
    embeddedLabel.htmlFor = "embeddedInput";
    const embeddedInput = document.createElement("input");
    embeddedInput.type = "checkbox";
    embeddedInput.id = "embeddedInput";
    embeddedInput.title = "this option will embed the image from an external source and store a copy in the document as base64 string";
    const heightLabel = document.createElement("label");
    heightLabel.textContent = "Height:";
    heightLabel.htmlFor = "heightInput";
    const heightInput = document.createElement("input");
    heightInput.type = "number";
    heightInput.id = "heightInput";
    heightInput.placeholder = "Height";
    const widthLabel = document.createElement("label");
    widthLabel.textContent = "Width:";
    widthLabel.htmlFor = "widthInput";
    const widthInput = document.createElement("input");
    widthInput.type = "number";
    widthInput.id = "widthInput";
    widthInput.placeholder = "Width";
    const altTextLabel = document.createElement("label");
    altTextLabel.textContent = "Alt Text:";
    altTextLabel.htmlFor = "altTextInput";
    const altTextInput = document.createElement("input");
    altTextInput.type = "text";
    altTextInput.id = "altTextInput";
    altTextInput.placeholder = "Alt Text";
    const btnConatiner = document.createElement("div");
    btnConatiner.id = "btnConatiner";
    const closeButton = document.createElement("button");
    closeButton.id = "closeButton";
    closeButton.textContent = "Dismiss";
    const okButton = document.createElement("button");
    okButton.id = "okButton";
    okButton.textContent = "Insert";
    btnConatiner.appendChild(closeButton);
    btnConatiner.appendChild(okButton);
    // Append dialog content to dialog
    dialog.appendChild(title);
    const fields = [
        {
            label: fileLabel,
            input: fileInput
        },
        {
            label: urlLabel,
            input: urlInput
        },
        {
            label: embeddedLabel,
            input: embeddedInput
        },
        {
            label: heightLabel,
            input: heightInput
        },
        {
            label: widthLabel,
            input: widthInput
        },
        {
            label: altTextLabel,
            input: altTextInput
        }
    ];
    fields.forEach((field)=>{
        const container = document.createElement("div");
        container.classList.add("field-container");
        container.appendChild(field.label);
        container.appendChild(field.input);
        dialog.appendChild(container);
    });
    dialog.appendChild(btnConatiner);
    // Append dialog to overlay
    overlay.appendChild(dialog);
    if (document.getElementById("overlay") === null) // Append overlay to body
    document.body.appendChild(overlay);
    if (node) {
        //extract the image attributes
        const src = node.attrs.href;
        const alt = ((_a = node.firstChild) === null || _a === void 0 ? void 0 : _a.textContent) || "";
        const height = node.attrs.height;
        const width = node.attrs.width;
        //set the input fields
        urlInput.value = src;
        altTextInput.value = alt;
        heightInput.value = height;
        widthInput.value = width;
    }
    // Add event listener to close button
    closeButton.addEventListener("click", function() {
        document.body.removeChild(overlay);
        return null;
    });
    urlInput.addEventListener("change", ()=>{});
    overlay.addEventListener("click", function(e) {
        if (e.target === overlay) {
            document.body.removeChild(overlay);
            return null;
        }
    });
    // Add event listener to ok button
    fileInput.addEventListener("change", function() {
        if (!fileInput.files || !fileInput.files.length) return false;
        const file = fileInput.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onerror = ()=>{
            (0, $is3B8.showToast)(localization.t("error.toastImageUpload"), "error");
        };
        reader.onload = ()=>{
            const img = new Image();
            img.onload = function() {
                const width = img.width;
                const height = img.height;
                // Update the input fields with the image dimensions
                widthInput.value = width;
                heightInput.value = height;
            };
            img.src = reader.result;
        };
    });
    okButton.addEventListener("click", ()=>{
        var _a;
        if ((_a = fileInput.files) === null || _a === void 0 ? void 0 : _a.length) {
            const reader = new FileReader();
            const file = fileInput.files[0];
            reader.readAsDataURL(file);
            reader.onload = ()=>{
                // capture the file name in the base64 string
                // edit the image base64 to include a url copy
                const imageBuffer = reader.result;
                const base64 = imageBuffer.split(",");
                const base64withName = base64[0] + `;filename=${file.name}` + "," + base64[1];
                callback({
                    src: base64withName,
                    scope: "peer",
                    alt: altTextInput.value,
                    height: heightInput.value,
                    width: widthInput.value
                });
            };
            reader.onerror = ()=>{
                (0, $is3B8.showToast)(localization.t("error.toastImageUpload"), "error");
            };
        } else if (urlInput.value.length && !embeddedInput.checked) callback({
            src: urlInput.value,
            scope: "external",
            alt: altTextInput.value,
            height: heightInput.value,
            width: widthInput.value
        });
        else if (urlInput.value.length && embeddedInput.checked) // handled the case where the user wants to embed the image from an external source
        fetch(urlInput.value).then((response)=>response.blob()).then((blob)=>{
            const reader = new FileReader();
            reader.onloadend = ()=>{
                // edit the image base64 to include a url copy
                const imageBuffer = reader.result;
                const base64 = imageBuffer.split(",");
                const base64withurl = base64[0] + `;url=${urlInput.value}` + "," + base64[1];
                callback({
                    src: base64withurl,
                    scope: "peer",
                    alt: altTextInput.value,
                    height: heightInput.value,
                    width: widthInput.value
                });
            };
            reader.readAsDataURL(blob);
        });
        document.body.removeChild(overlay);
    });
}
/**
 * Creates a command to insert a new Image node at the current cursor position.
 *
 * @remarks
 * Will be triggered onload via function menu() in example.ts
 *
 * @privateRemarks
 * Error handling should be improved in `reader.onerror = () => {};`
 *
 * @param localization - localization
 * @param type - NodeType
 * @returns Command
 */ function $11188d4417578e2f$var$insertImage(localization, type) {
    return function(state, dispatch) {
        // on click, the cursor selection should be empty
        try {
            if (!state.selection.empty) return false;
            if (dispatch) // show the image upload dialog
            $11188d4417578e2f$var$imageInputOverlay(localization, (imageInfo)=>{
                if (!imageInfo) return false;
                const node = $11188d4417578e2f$var$createNode(type.schema.nodes["fig"], {
                    src: imageInfo.src,
                    scope: imageInfo.scope,
                    alt: imageInfo.alt,
                    height: imageInfo.height,
                    width: imageInfo.width
                });
                const tr = state.tr.insert(state.selection.$to.pos, node);
                dispatch(tr.scrollIntoView());
            });
            return true;
        } catch (e) {
            console.error(e);
            (0, $is3B8.showToast)(localization.t("error.toastImageInsert"), "error");
            return false;
        }
    };
}
/**
 * Check the node in allowed nodes list and return the index of the node.
 * This function also ensures that the order of the nodes is correct.
 *
 * @param type - NodeType or nodeName
 * @returns node index from the list of nodes
 */ function $11188d4417578e2f$var$canCreateIndex(type) {
    return [
        "ul",
        "li",
        "p",
        "section",
        "stentry",
        "strow",
        "simpletable"
    ].indexOf(type.name);
}
/**
 * Check if the node can be created or not.
 *
 * @param type - NodeType object, contains the node name
 * @returns Boolean of whether the node can be created or not
 */ function $11188d4417578e2f$var$canCreate(type) {
    return $11188d4417578e2f$var$canCreateIndex(type) > -1;
}
/**
 * Create an array of NodeTypes that are "allowed" nodes to be
 * added at the current curser position.
 *
 * @remarks
 * `defaultBlocks` will be triggered on key "press enter", function `enterEOL()`
 * which calls `defaultBlocksAt()`, in which `defaultBlocks()` is finally called.
 *
 *
 * @param pos - Cursor position
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns List of NodeTypes that can be created
 */ function $11188d4417578e2f$var$defaultBlocks(pos, depth = 0) {
    // Get the content match at the current cursor position
    const match = pos.node(-depth - 1).contentMatchAt(pos.indexAfter(-depth - 1));
    const result = [];
    // loop through the possible content matches
    for(let i = 0; i < match.edgeCount; i++){
        const edge = match.edge(i);
        // check if the node can be created
        if ($11188d4417578e2f$var$canCreate(edge.type)) // if success, then add new NodeType object to the array
        result.push(edge.type);
    }
    return result;
}
/**
 * Get the Node that can be created at the current cursor position.
 *
 * @param pos - ResolvedPos current cursor position
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @param preferred - preferred NodeType
 * @returns NodeType
 */ function $11188d4417578e2f$var$defaultBlockAt(pos, depth = 0, preferred) {
    let index = -1;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let type = null;
    // assign all allowed NodeType objects to variable `blocks`
    const blocks = $11188d4417578e2f$var$defaultBlocks(pos, depth || undefined);
    // if the preferred node is contained in the default node blocks, then return the current node
    if (preferred && blocks.find((block)=>block.name === preferred.name)) return preferred;
    // loop through the allowed blocks and return the first block that can be created
    blocks.forEach((newType)=>{
        const newIndex = $11188d4417578e2f$var$canCreateIndex(newType);
        if (newIndex > index) {
            index = newIndex;
            type = newType;
        }
    });
    return type;
}
/**
 * Handle the enter key event when the cursor is at the end of the line.
 *
 *
 * @param tr - The transaction object
 * @param dispatch - dispatch function
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns Boolean - true if the transaction is triggered
 */ function $11188d4417578e2f$var$enterEOL(tr, dispatch = false, depth = 0) {
    const { $from: $from, $to: $to } = tr.selection;
    const parent = $to.node(-depth || undefined);
    // get the allowed node types that can be created at the current cursor position
    const type = $11188d4417578e2f$var$defaultBlockAt($to, depth, parent.type);
    // if the transaction is triggered from the last function call
    if (dispatch) {
        //if we have a possible node type to create
        if (type) {
            // get the new cursor position
            const side = (!$from.parentOffset && $to.index() < parent.childCount ? $from : $to).pos + depth + 1;
            // create and insert the new node
            tr = tr.insert(side, $11188d4417578e2f$var$createNodesTree($11188d4417578e2f$var$getTree($from, depth)));
            // select the new node
            tr = tr.setSelection($cw5sC.TextSelection.create(tr.doc, side + depth + 1));
            // complete the transaction
            return tr.scrollIntoView();
        }
        return false;
    }
    return false;
}
/**
 * Deletes the empty line in the current cursor position
 *
 * @param tr - The transaction object
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @param shift - cursor shift value to sleect the empty line
 * @returns deleteSelection transaction object
 */ function $11188d4417578e2f$var$deleteEmptyLine(tr, depth = 0, shift = 0) {
    // select the empty line and delete it
    return tr.setSelection($cw5sC.TextSelection.create(tr.doc, tr.selection.anchor - depth * 2 + shift, tr.selection.anchor + shift)).deleteSelection();
}
/**
 * Handle the enter key event when the cursor is at empty line.
 *
 * @param tr - The Transaction object
 * @param dispatch - A boolean, set to `false`
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns transaction of EnterEOL or false
 */ function $11188d4417578e2f$var$enterEmpty(tr, dispatch = false, depth = 0) {
    // if we are trying to go deeper in a empty node.
    if (depth > 0) // delete the empty line
    $11188d4417578e2f$var$deleteEmptyLine(tr, depth);
    return $11188d4417578e2f$var$enterEOL(tr, dispatch, depth);
}
/**
 * Handle the enter key event when the cursor is in the middle of a node.
 *
 * @param tr - transaction object
 * @param dispatch - dispatch function
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns boolean - true if the transaction is triggered
 */ function $11188d4417578e2f$var$enterSplit(tr, dispatch = false, depth = 0) {
    depth++;
    let { $from: $from, $to: $to } = tr.selection;
    // if the transaction is triggered from the last function call
    if (dispatch) {
        // check if the cursor is at the end of the line
        const atEnd = $to.parentOffset == $to.parent.content.size;
        // check if the previous node is empty
        const prevDepth = $11188d4417578e2f$var$getPrevDepth(tr);
        if (prevDepth > 0) {
            // setting $from and $to is not necessary here, as they are already set above
            $from = tr.selection.$from;
            $to = tr.selection.$to;
            depth++;
            // split the parent node
            tr = tr.split(tr.mapping.map($from.pos), depth);
            const pos = tr.selection.from;
            const selStart = pos - prevDepth * 2 - 2;
            const selEnd = selStart - prevDepth * 2 - 2;
            tr.setSelection($cw5sC.TextSelection.create(tr.doc, selStart, selEnd));
            // delete the empty node
            tr = tr.deleteSelection();
            tr.setSelection($cw5sC.TextSelection.create(tr.doc, tr.mapping.map(pos - depth * 2)));
            // complete the transaction
            return tr;
        }
        if (atEnd && depth > 1 && $from.depth - depth > 2) {
            const defaultType = $from.node(-depth + 1).type;
            return $11188d4417578e2f$var$deleteEmptyLine(tr, depth - 1)// eslint-disable-next-line @typescript-eslint/no-explicit-any
            .split(tr.mapping.map($from.pos), depth, [
                {
                    type: defaultType
                }
            ]);
        }
        if (tr.selection instanceof $cw5sC.TextSelection) tr.deleteSelection();
        // Object containing the information about parent (and name of grand-parent)
        // `parent` is returning the parent level (in this case `-depth` = -1)
        const parent = $to.node(-depth || undefined);
        // "$from": https://prosemirror.net/docs/ref/#state.Selection.$from
        // `parent.type`: It's giving us the current NodeType, where the cursor has been set to split the lines
        // @see {@link https://prosemirror.net/docs/ref/#model.NodeType}
        const defaultType = $from.depth == 0 ? null : $11188d4417578e2f$var$defaultBlockAt($from, depth, parent.type);
        if (defaultType) {
            let types = atEnd ? [
                {
                    type: defaultType
                }
            ] : null;
            // "can": Check whether splitting at the given position is allowed
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let can = (0, $4aVzI.canSplit)(tr.doc, tr.mapping.map($from.pos), depth, types);
            if (!types && !can && (0, $4aVzI.canSplit)(tr.doc, tr.mapping.map($from.pos), depth, [
                {
                    type: defaultType
                }
            ])) {
                types = [
                    {
                        type: defaultType
                    }
                ];
                can = true;
            }
            // if we can split, then split the node
            if (can) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                tr.split(tr.mapping.map($from.pos), depth, types);
                if (!atEnd && !$from.parentOffset && $from.parent.type != defaultType && $from.node(-depth).canReplace($from.index(-depth), $from.indexAfter(-depth), $6B4AI.Fragment.from([
                    defaultType.create(),
                    $from.parent
                ]))) // update the previous node markups
                tr.setNodeMarkup(tr.mapping.map($from.before()), defaultType);
            }
            // complete the transaction and scroll into view
            return tr.scrollIntoView();
        }
    }
    // return false if the transaction is not triggered.
    return false;
}
/**
 * Check if the cursor is at the end of the line.
 *
 * @param tr - The Transaction object
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns Boolean - true if the cursor is at the end of the line
 */ function $11188d4417578e2f$var$isEOL(tr, depth = 0) {
    const { $to: $to } = tr.selection;
    let parent = $to.parent;
    if ($to.parentOffset < parent.content.size) return false;
    for(let i = 1; i <= depth; i++){
        const grandParent = $to.node(-i);
        if (grandParent.childCount !== 1 + $to.index(-i)) return false;
        parent = grandParent;
    }
    return true;
}
/**
 * Checks whether the cursor is at an empty line or not.
 *
 * @param tr - The Transaction object
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns Boolean, e.g. true, if the the parent node has no content
 */ function $11188d4417578e2f$var$isEmpty(tr, depth = 0) {
    const { $to: $to } = tr.selection;
    let parent = $to.parent;
    if (parent.content.size) return false;
    for(let i = 1; i <= depth; i++){
        const grandParent = $to.node(-i);
        if (parent.childCount > 1) return false;
        parent = grandParent;
    }
    return true;
}
/**
 * Checks if the previous node is empty or not when the cursor is at the beginning of the line.
 *
 * @param tr - The Transaction object
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns Boolean
 */ function $11188d4417578e2f$var$isPrevEmpty(tr, depth = 0) {
    const pos = tr.doc.resolve(tr.selection.to - 2);
    let parent = pos.parent;
    if (parent.content.size) return false;
    for(let i = 1; i <= depth; i++){
        const grandParent = pos.node(-i);
        if (parent.childCount > 1) return false;
        parent = grandParent;
    }
    return true;
}
/**
 * Get the distance from the current cursor position to the closest parent Node with children.
 *
 * @param tr - The Transaction object
 * @param empty - A Boolean, set to `false`
 * @returns A number containing the depth of the tested
 */ function $11188d4417578e2f$var$getDepth(tr, empty = false) {
    let depth = 0;
    while((empty ? $11188d4417578e2f$var$isEmpty : $11188d4417578e2f$var$isEOL)(tr, depth + 1))depth++;
    return depth;
}
/**
 * Get the previous node distance from the first parent with children.
 *
 * @param tr - The Transaction object
 * @returns number - the depth of the previous node
 */ function $11188d4417578e2f$var$getPrevDepth(tr) {
    let depth = 0;
    while($11188d4417578e2f$var$isPrevEmpty(tr, depth + 1))depth++;
    return depth;
}
/**
 * Get the tree of nodes starting from the current cursor position, and going up to first parent node with children.
 *
 * @param pos - The ResolvedPos object containing position, path, depth and parentOffset
 * @param depth - distance from the current cursor position to the closest parent Node with children
 * @returns NodeType array
 */ function $11188d4417578e2f$var$getTree(pos, depth = 0) {
    const result = [
        pos.parent.type
    ];
    for(let i = 1; i <= depth; i++)result.push(pos.node(-i).type);
    return result;
}
/**
 * Handle pressing the `enter` key in the editor.
 * This contains an editor state, an optional `dispatch`
 * function that it can use to dispatch a transaction and
 * an `EditorView` instance. It returns a boolean that indicates
 * whether it could perform any action.
 * When no `dispatch` callback is
 * passed, the newLine command should do a 'dry run', determining whether it is
 * applicable, but not actually doing anything.
 *
 * @param state - The EditorState object
 * @param dispatch - A function to be used to dispatch a transaction
 * @returns Boolean
 */ function $11188d4417578e2f$var$enterPressed(state, dispatch) {
    let { $from: $from } = state.selection;
    const { empty: empty } = state.selection;
    // check if the node is empty.
    // if the node is empty, then the depth is 1
    const depth = $11188d4417578e2f$var$getDepth(state.tr, true);
    // get the current transaction
    let tr = state.tr;
    // if the cursor selection is not empty, delete the selection
    if (dispatch && !empty) {
        tr = tr.deleteSelection();
        $from = tr.selection.$from;
    }
    // prepare the transaction
    let resultTr;
    if ($11188d4417578e2f$var$isEOL(state.tr, depth)) {
        if ($from.parentOffset === 0) resultTr = $11188d4417578e2f$var$enterEmpty(tr, !!dispatch, depth);
        else resultTr = $11188d4417578e2f$var$enterEOL(tr, !!dispatch, depth);
    } else if ($from.parentOffset === 0) resultTr = $11188d4417578e2f$var$enterSplit(tr, !!dispatch, depth);
    else resultTr = tr.replaceSelectionWith(state.schema.nodes.hard_break.create()).scrollIntoView();
    // if the transaction is triggered, then dispatch the transaction
    if (dispatch && resultTr !== false) {
        dispatch(resultTr);
        return true;
    }
    // return false if the transaction is not triggered
    return false;
}
/**
 * A chain of commands that are triggered on each "press Enter" key event in the editor.
 * in this instance it's only representing the `enterPressed` command.
 */ module.exports.newLine = (0, $1ZnZi.chainCommands)($11188d4417578e2f$var$enterPressed);
/**
 * Checks the state of any mark against the
 * list of all marks in the editor menu
 * This function will be triggered on any key event in the editor to run the check.
 * Returns a boolean, if there is a mark of this type in the given set, or
 * if a given mark or mark type occurs in the selected text1.
 *
 * @param state - The EditorState object
 * @param mark - The MarkType object
 * @returns Boolean
 */ function $11188d4417578e2f$var$hasMark(state, mark) {
    return state.selection.empty ? !!mark.isInSet(state.storedMarks || state.selection.$from.marks()) : state.doc.rangeHasMark(state.selection.from, state.selection.to, mark);
}
//Escape hatch for Unit Testing due to a lack of “package-private” accessibility scope in TypeScript
module.exports._test_private_commands = {
    canCreateIndex: $11188d4417578e2f$var$canCreateIndex,
    canCreate: $11188d4417578e2f$var$canCreate,
    defaultBlocks: $11188d4417578e2f$var$defaultBlocks
};

});
parcelRegister("aSs4u", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $7eb4b8ec7aa10365$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7eb4b8ec7aa10365$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createPrFromContribution = module.exports.getUserInfo = module.exports.exchangeOAuthCodeForAccessToken = module.exports.fetchAndTransform = module.exports.transformGitHubDocumentToProsemirrorJson = module.exports.fetchRawDocumentFromGitHub = void 0;

var $iFY8P = parcelRequire("iFY8P");

var $bryhC = parcelRequire("bryhC");

var $6FTYo = parcelRequire("6FTYo");

var $is3B8 = parcelRequire("is3B8");

const $7eb4b8ec7aa10365$var$urijs_1 = $7eb4b8ec7aa10365$var$__importDefault((parcelRequire("gEPNU")));
/**
 * Fetches the raw content of a document from a GitHub repository.
 *
 * @param config - configuration
 * @param ghrepo - The GitHub repository in the format "owner/repo".
 * @param source - The path to the file within the repository.
 * @param branch - The branch from which to fetch the document.
 * @returns A promise that resolves to the raw content of the document as a string.
 *
 * @remarks
 * This function currently fetches the document from the 'main' branch of the repository.
 * should use the GitHub API to dynamically determine the default branch of the repository.
 */ const $7eb4b8ec7aa10365$var$fetchRawDocumentFromGitHub = (config, ghrepo, source, branch)=>$7eb4b8ec7aa10365$var$__awaiter(void 0, void 0, void 0, function*() {
        // GitHub changes the raw api URL from `main` to `refs/heads/main` 
        // https://raw.githubusercontent.com/evolvedbinary/prosemirror-lwdita/main/packages/prosemirror-lwdita-demo/example-xdita/02-short-file.xml
        // https://raw.githubusercontent.com/evolvedbinary/prosemirror-lwdita/refs/heads/main/packages/prosemirror-lwdita-demo/example-xdita/02-short-file.xml
        const url = `https://raw.githubusercontent.com/${ghrepo}/refs/heads/${branch}/${source}`;
        const response = yield fetch(url);
        if (!response.ok) (0, $6FTYo.showErrorPage)(config, "fileNotFound", "", response.statusText);
        //TODO: Handle errors
        return response.text();
    });
module.exports.fetchRawDocumentFromGitHub = $7eb4b8ec7aa10365$var$fetchRawDocumentFromGitHub;
/**
 * Transforms a raw GitHub document into a ProseMirror state save.
 *
 * @param rawDocument - The raw xdita document as a string.
 * @returns A promise that resolves to a record containing the ProseMirror state save.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7eb4b8ec7aa10365$var$transformGitHubDocumentToProsemirrorJson = (rawDocument)=>$7eb4b8ec7aa10365$var$__awaiter(void 0, void 0, void 0, function*() {
        // convert the raw xdita document to jdita
        const jdita = yield (0, $iFY8P.xditaToJdita)(rawDocument);
        // convert the jdita document to prosemirror state save
        const prosemirrorJson = yield (0, $bryhC.document)(jdita);
        return prosemirrorJson;
    });
module.exports.transformGitHubDocumentToProsemirrorJson = $7eb4b8ec7aa10365$var$transformGitHubDocumentToProsemirrorJson;
/**
 * Fetches a raw document from a GitHub repository and transforms it into a ProseMirror JSON document.
 *
 * @param config - configuration
 * @param ghrepo - The GitHub repository from which to fetch the document.
 * @param source - The source path of the document within the repository.
 * @param branch - The branch from which to fetch the document.
 * @returns A promise that resolves to the transformed ProseMirror JSON document.
 */ const $7eb4b8ec7aa10365$var$fetchAndTransform = (config, ghrepo, source, branch, referer)=>$7eb4b8ec7aa10365$var$__awaiter(void 0, void 0, void 0, function*() {
        const rawDoc = yield (0, module.exports.fetchRawDocumentFromGitHub)(config, ghrepo, source, branch);
        // update the document with the relative path
        const updatedDoc = rawDoc.replace(/href="([^"]+)"/g, (_match, url)=>{
            // https://www.npmjs.com/package/urijs
            return `href="${(0, $7eb4b8ec7aa10365$var$urijs_1.default)(url).absoluteTo(referer).href()}"`;
        });
        const jsonDoc = yield (0, module.exports.transformGitHubDocumentToProsemirrorJson)(updatedDoc);
        return jsonDoc;
    });
module.exports.fetchAndTransform = $7eb4b8ec7aa10365$var$fetchAndTransform;
/**
 * Exchanges an OAuth code for an access token.
 *
 * @param config - configuration
 * @param localization - localization
 * @param code - The OAuth code to exchange for an access token.
 * @returns A promise that resolves to the access token as a string.
 * @throws Will throw an error if the fetch request fails or if the response is not in the expected format.
 */ const $7eb4b8ec7aa10365$var$exchangeOAuthCodeForAccessToken = (config, localization, code)=>$7eb4b8ec7aa10365$var$__awaiter(void 0, void 0, void 0, function*() {
        // build the URL to exchange the code for an access token
        const url = config.server.api.baseUrl + config.server.api.endpoint.token + `?code=${code}`;
        // fetch the access token
        const response = yield fetch(url);
        // TODO (AvC): This error type might be changed to be more specific depending on
        // further error handling
        if (!response.ok) (0, $is3B8.showToast)(localization.t("error.toastGitHubToken") + response.statusText, "error");
        const json = yield response.json();
        //TODO: Handle errors
        return {
            token: json.token,
            installation: json.installation
        };
    });
module.exports.exchangeOAuthCodeForAccessToken = $7eb4b8ec7aa10365$var$exchangeOAuthCodeForAccessToken;
/**
 * Fetches user information from the backend API.
 *
 * @param config - configuration
 * @param localization - localization
 * @param token - The authorization token to access the GitHub API.
 * @returns A promise that resolves to a record containing user information.
 */ const $7eb4b8ec7aa10365$var$getUserInfo = (config, localization, token)=>$7eb4b8ec7aa10365$var$__awaiter(void 0, void 0, void 0, function*() {
        const url = config.server.api.baseUrl + config.server.api.endpoint.user;
        const response = yield fetch(url, {
            headers: {
                "authorization": `Bearer ${token}`
            }
        });
        // TODO (AvC): This error type might be changed to be more specific depending on
        // further error handling
        if (!response.ok) (0, $is3B8.showToast)(localization.t("error.toastGitHubUserEndpoint") + response.statusText, "error");
        const json = yield response.json();
        return json;
    });
module.exports.getUserInfo = $7eb4b8ec7aa10365$var$getUserInfo;
/**
 * Publishes a document to a specified GitHub repository.
 * Makes a POST request to the `/api/github/integration` endpoint with the necessary details to create a pull request.
 *
 * @param config - configuration
 * @param localization - localization
 * @param ghrepo - The GitHub repository in the format "owner/repo".
 * @param source - The path to the source document.
 * @param branch - The branch used as base for the PR.
 * @param title - The title of the pull request and the commit message.
 * @param desc - The description of the pull request.
 * @param changedDocument - The content of the changed document.
 * @returns A promise that resolves when the document has been published.
 */ const $7eb4b8ec7aa10365$var$createPrFromContribution = (config, localization, ghrepo, source, branch, changedDocument, title, desc)=>$7eb4b8ec7aa10365$var$__awaiter(void 0, void 0, void 0, function*() {
        const authenticatedUserInfo = yield (0, module.exports.getUserInfo)(config, localization, localStorage.getItem("token"));
        const owner = ghrepo.split("/")[0];
        const repo = ghrepo.split("/")[1];
        const newOwner = authenticatedUserInfo.login;
        const date = new Date();
        const newBranch = config.git.branchPrefix + `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getHours()}${date.getMinutes()}${date.getSeconds()}`;
        const commitMessage = title;
        const path = source;
        const content = changedDocument;
        const change = {
            path: path,
            content: content
        };
        const body = `${desc}` + config.git.commitMessageSuffix;
        // get the token from the local storage
        const token = localStorage.getItem("token");
        // make a post request to  /api/github/integration
        const response = yield fetch(config.server.api.baseUrl + config.server.api.endpoint.integration, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                owner: owner,
                repo: repo,
                newOwner: newOwner,
                branch: branch,
                newBranch: newBranch,
                commitMessage: commitMessage,
                change: change,
                title: title,
                body: body
            })
        });
        // TODO (AvC): This error type might be changed to be more specific depending on
        // further error handling
        if (!response.ok) (0, $is3B8.showToast)(localization.t("error.toastGitHubPR") + response.statusText, "error");
        const json = yield response.json();
        return json.url;
    });
module.exports.createPrFromContribution = $7eb4b8ec7aa10365$var$createPrFromContribution;

});
parcelRegister("iFY8P", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $d98ab527643467f0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d98ab527643467f0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d98ab527643467f0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d98ab527643467f0$var$__exportStar((parcelRequire("lk7dR")), module.exports);

$d98ab527643467f0$var$__exportStar((parcelRequire("fbi1N")), module.exports);

$d98ab527643467f0$var$__exportStar((parcelRequire("hFvgk")), module.exports);

$d98ab527643467f0$var$__exportStar((parcelRequire("sgwDg")), module.exports);

});
parcelRegister("lk7dR", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fbi1N", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $b0d5de171ecc5391$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storeOutputXML = $b0d5de171ecc5391$var$storeOutputXML;

const $b0d5de171ecc5391$var$fs_1 = $b0d5de171ecc5391$var$__importDefault((parcelRequire("kYrsL")));
/**
 * Store Xml documents in the file system.
 *
 * @privateRemarks
 * TODO:  Checkout which platform this is running on, We are not sure yet if this would be running in the browser?
 * TODO: Get file name info from input XML
 * TODO: Check if the parser has support for reading the XML & Doctype Declaration,
 * if it can then, set the values from the XML Declaration and the Doctype Declaration
 * as properties on the root node of the AST tree.
 *
 * @param xml - The xml input string to store
 * @param path - The path in the filesystem to store the output array
 */ function $b0d5de171ecc5391$var$storeOutputXML(xml, path) {
    // This is a static & generic XML & DOCTYPE Declaration for the output XML,
    // see above's TODO for a future implementation
    $b0d5de171ecc5391$var$fs_1.default.writeFileSync(path, xml);
}

});
parcelRegister("kYrsL", function(module, exports) {
"use strict";

});


parcelRegister("hFvgk", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $cdce841127df26f1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cdce841127df26f1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cdce841127df26f1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cdce841127df26f1$var$__createBinding(result, mod, k);
    }
    $cdce841127df26f1$var$__setModuleDefault(result, mod);
    return result;
};
var $cdce841127df26f1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.xditaToAst = $cdce841127df26f1$var$xditaToAst;
module.exports.xditaToJdita = $cdce841127df26f1$var$xditaToJdita;
module.exports.astToJdita = $cdce841127df26f1$var$astToJdita;
module.exports.jditaToAst = $cdce841127df26f1$var$jditaToAst;
module.exports.serializeToXdita = $cdce841127df26f1$var$serializeToXdita;

const $cdce841127df26f1$var$saxes = $cdce841127df26f1$var$__importStar((parcelRequire("cxlri")));

var $1LZFg = parcelRequire("1LZFg");

var $57yyk = parcelRequire("57yyk");

var $16ZiD = parcelRequire("16ZiD");

var $sgwDg = parcelRequire("sgwDg");
/**
 * Converts XML to an AST document tree
 *
 * @param xml - XML string
 * @param abortOnError - If true, abort on error
 * @returns - Promise of a DocumentNode
 */ function $cdce841127df26f1$var$xditaToAst(xml_1) {
    return $cdce841127df26f1$var$__awaiter(this, arguments, void 0, function*(xml, abortOnError = true) {
        return new Promise((resolve, reject)=>{
            const errors = [];
            // Create a Parser Object
            const parser = new $cdce841127df26f1$var$saxes.SaxesParser({
                xmlns: true,
                fragment: false,
                position: true
            });
            // simple regex to detemine if string is only whitespace
            const wsRegEx = new RegExp("^\\s+$");
            // Create a new document node
            const doc = new $57yyk.DocumentNode();
            // Create an array of Document nodes (type BaseNode)
            const stack = [
                doc
            ];
            // Look for the XML declaration and the DOCTYPE declaration
            parser.on("xmldecl", function(xmlDecl) {
                doc.xmlDecl = xmlDecl;
            });
            parser.on("doctype", function(doctype) {
                doc.doctype = doctype;
            });
            // Parse the text and add a new node item to the node-array
            // `text` is the content of any text node in the parsed xml document
            parser.on("text", function(text) {
                const parentNode = stack[stack.length - 1];
                const node = (0, $1LZFg.createNode)(text);
                // if the 'text' string is only whitespace characters,
                // and the parent node cannot accept a text node (i.e. it does not support #PCDATA),
                // then the whitespace is non-significant as far as the DTD is concerned... so just discard it!
                // see: https://github.com/evolvedbinary/lwdita/issues/129#issuecomment-2150243338
                if (wsRegEx.test(text) && !parentNode.allowsMixedContent()) return;
                // add the text node to the parent
                stack[stack.length - 1].add(node, abortOnError);
            });
            // Look for the first open tag `<` and add the node to the array
            /**
             * `node` is the node object
             * @example
             * ```json
             * node {
             *   name: 'topic',
             *   attributes: [Object: null prototype] {
             *     id: {
             *       name: 'id', prefix: '',
             *       local: 'id', value: 'topicID', uri: ''
             *     }
             *   },
             *   ns: [Object: null prototype] {},
             *   prefix: '',
             *   local: 'topic',
             *   uri: '',
             *   isSelfClosing: false
             * }
             * ```
             * @example
             * The `obj` is an object containing all the node's corresponding properties like
             * ```json
             * obj _a: { _props: { id: 'topicID', 'xml:lang': undefined,... }}
             * ```
             */ parser.on("opentag", function(node) {
                try {
                    const obj = (0, $1LZFg.createNode)(node);
                    stack[stack.length - 1].add(obj, abortOnError);
                    stack.push(obj);
                } catch (e) {
                    console.log("invalid:", e);
                }
            });
            // Look for the close tag `>` and delete the node from the array
            parser.on("closetag", function() {
                stack.pop();
            });
            // Look for CDATA and add the node to the array
            parser.on("cdata", (cdata)=>{
                try {
                    const obj = (0, $1LZFg.createCDataSectionNode)(cdata);
                    stack[stack.length - 1].add(obj, abortOnError);
                } catch (e) {
                    console.log("invalid:", e);
                }
            });
            // return the document tree if run without errors
            parser.on("end", function() {
                if (errors.length && abortOnError) reject(errors);
                else resolve(doc);
            });
            parser.on("error", function(e) {
                errors.push(e);
            });
            // process the xml using the parser
            parser.write(xml).close();
        });
    });
}
/**
 * Convert the document tree to JDita object
 *
 * @param xml - The XML input as string
 * @param abortOnError - Boolean, if true, stop execution and report errors
 * @returns JDita object
 */ function $cdce841127df26f1$var$xditaToJdita(xml_1) {
    return $cdce841127df26f1$var$__awaiter(this, arguments, void 0, function*(xml, abortOnError = true) {
        return $cdce841127df26f1$var$xditaToAst(xml, abortOnError).then($cdce841127df26f1$var$astToJdita);
    });
}
/**
 * Convert the document node to JDita object
 *
 * @param document - DocumentNode
 * @returns JDita object
 */ function $cdce841127df26f1$var$astToJdita(document) {
    return document.json;
}
/**
 * Convert JDita attributes to Saxes attributes.
 *
 * @param attr - JDita attributes
 * @returns
 */ function $cdce841127df26f1$var$jditaAttrToSaxesAttr(attr) {
    if (!attr) return {};
    for(const key in attr)if (!attr[key]) delete attr[key];
    const attributes = {};
    for(const key in attr)attributes[key] = {
        name: key,
        value: attr[key],
        local: key,
        prefix: "",
        uri: ""
    };
    return attributes;
}
/**
 * Convert JDita object to AST
 *
 * @param jdita - JDita object
 * @returns DocumentNode
 */ function $cdce841127df26f1$var$jditaToAst(jdita) {
    var _a, _b;
    if (jdita.nodeName === "document") {
        const doc = new $57yyk.DocumentNode();
        (_a = jdita.children) === null || _a === void 0 || _a.forEach((child)=>{
            doc.add($cdce841127df26f1$var$jditaToAst(child));
        });
        return doc;
    }
    if (jdita.nodeName === "text") return new $57yyk.TextNode(jdita.content);
    if (jdita.nodeName === "cdata") return new $57yyk.CDataNode(jdita.content);
    const classType = (0, $57yyk.getNodeClass)(jdita.nodeName);
    const node = new classType($cdce841127df26f1$var$jditaAttrToSaxesAttr(jdita.attributes));
    (_b = jdita.children) === null || _b === void 0 || _b.forEach((child)=>{
        node.add($cdce841127df26f1$var$jditaToAst(child));
    });
    return node;
}
/**
 * `serializeToXML` - Serialize the AST and transform it into XDITA
 * The serialization is providing three options to output the document:
 * 1. No indentation/formatting - all is output in one line (default)
 * 2. Indentation with tabs
 * 3. Indentation with Spaces - You can modify the desired number of spaces by setting `indentationSize`, per default it's set to 4 spaces.
 *
 * @example
 * ```
 * // 1. No formatting
 *    serializeToXML(result);
 * // 2. Indentation with tabs
 *    serializeToXML(result, '\t');
 * // 3. Indentation with Spaces
 *    serializeToXML(result, ' ', 4);
 * ```
 *
 * @param root - The document root
 * @param indentationChar - The indentation character to be used (tabs or spaces). If none is provided, no indentation is used.
 * @param tabSize - The number of spaces to be used for indentation when an indentation character other than tab is used, the default is 4 spaces
 * @returns The transformed document as an array of XMLTag objects
 */ function $cdce841127df26f1$var$serializeToXdita(root, indentationChar, tabSize) {
    const outStream = new $16ZiD.InMemoryTextSimpleOutputStreamCollector();
    let visitor;
    if (indentationChar === "	") visitor = new $sgwDg.XditaSerializer(outStream, true, "	");
    else if (indentationChar) {
        tabSize = tabSize ? tabSize : 4;
        visitor = new $sgwDg.XditaSerializer(outStream, true, indentationChar, tabSize);
    } else visitor = new $sgwDg.XditaSerializer(outStream, false);
    visitor.serialize(root);
    return outStream.getText();
}

});
parcelRegister("cxlri", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SaxesParser = module.exports.EVENTS = void 0;

var $2sP1M = parcelRequire("2sP1M");

var $idmti = parcelRequire("idmti");

var $2KyNd = parcelRequire("2KyNd");
var $92093278557b2366$var$isS = $2sP1M.isS;
var $92093278557b2366$var$isChar10 = $2sP1M.isChar;
var $92093278557b2366$var$isNameStartChar = $2sP1M.isNameStartChar;
var $92093278557b2366$var$isNameChar = $2sP1M.isNameChar;
var $92093278557b2366$var$S_LIST = $2sP1M.S_LIST;
var $92093278557b2366$var$NAME_RE = $2sP1M.NAME_RE;
var $92093278557b2366$var$isChar11 = $idmti.isChar;
var $92093278557b2366$var$isNCNameStartChar = $2KyNd.isNCNameStartChar;
var $92093278557b2366$var$isNCNameChar = $2KyNd.isNCNameChar;
var $92093278557b2366$var$NC_NAME_RE = $2KyNd.NC_NAME_RE;
const $92093278557b2366$var$XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
const $92093278557b2366$var$XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
const $92093278557b2366$var$rootNS = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    __proto__: null,
    xml: $92093278557b2366$var$XML_NAMESPACE,
    xmlns: $92093278557b2366$var$XMLNS_NAMESPACE
};
const $92093278557b2366$var$XML_ENTITIES = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
    __proto__: null,
    amp: "&",
    gt: ">",
    lt: "<",
    quot: '"',
    apos: "'"
};
// EOC: end-of-chunk
const $92093278557b2366$var$EOC = -1;
const $92093278557b2366$var$NL_LIKE = -2;
const $92093278557b2366$var$S_BEGIN = 0; // Initial state.
const $92093278557b2366$var$S_BEGIN_WHITESPACE = 1; // leading whitespace
const $92093278557b2366$var$S_DOCTYPE = 2; // <!DOCTYPE
const $92093278557b2366$var$S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
const $92093278557b2366$var$S_DTD = 4; // <!DOCTYPE "//blah" [ ...
const $92093278557b2366$var$S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
const $92093278557b2366$var$S_DTD_OPEN_WAKA = 6;
const $92093278557b2366$var$S_DTD_OPEN_WAKA_BANG = 7;
const $92093278557b2366$var$S_DTD_COMMENT = 8; // <!--
const $92093278557b2366$var$S_DTD_COMMENT_ENDING = 9; // <!-- blah -
const $92093278557b2366$var$S_DTD_COMMENT_ENDED = 10; // <!-- blah --
const $92093278557b2366$var$S_DTD_PI = 11; // <?
const $92093278557b2366$var$S_DTD_PI_ENDING = 12; // <?hi "there" ?
const $92093278557b2366$var$S_TEXT = 13; // general stuff
const $92093278557b2366$var$S_ENTITY = 14; // &amp and such
const $92093278557b2366$var$S_OPEN_WAKA = 15; // <
const $92093278557b2366$var$S_OPEN_WAKA_BANG = 16; // <!...
const $92093278557b2366$var$S_COMMENT = 17; // <!--
const $92093278557b2366$var$S_COMMENT_ENDING = 18; // <!-- blah -
const $92093278557b2366$var$S_COMMENT_ENDED = 19; // <!-- blah --
const $92093278557b2366$var$S_CDATA = 20; // <![CDATA[ something
const $92093278557b2366$var$S_CDATA_ENDING = 21; // ]
const $92093278557b2366$var$S_CDATA_ENDING_2 = 22; // ]]
const $92093278557b2366$var$S_PI_FIRST_CHAR = 23; // <?hi, first char
const $92093278557b2366$var$S_PI_REST = 24; // <?hi, rest of the name
const $92093278557b2366$var$S_PI_BODY = 25; // <?hi there
const $92093278557b2366$var$S_PI_ENDING = 26; // <?hi "there" ?
const $92093278557b2366$var$S_XML_DECL_NAME_START = 27; // <?xml
const $92093278557b2366$var$S_XML_DECL_NAME = 28; // <?xml foo
const $92093278557b2366$var$S_XML_DECL_EQ = 29; // <?xml foo=
const $92093278557b2366$var$S_XML_DECL_VALUE_START = 30; // <?xml foo=
const $92093278557b2366$var$S_XML_DECL_VALUE = 31; // <?xml foo="bar"
const $92093278557b2366$var$S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
const $92093278557b2366$var$S_XML_DECL_ENDING = 33; // <?xml ... ?
const $92093278557b2366$var$S_OPEN_TAG = 34; // <strong
const $92093278557b2366$var$S_OPEN_TAG_SLASH = 35; // <strong /
const $92093278557b2366$var$S_ATTRIB = 36; // <a
const $92093278557b2366$var$S_ATTRIB_NAME = 37; // <a foo
const $92093278557b2366$var$S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
const $92093278557b2366$var$S_ATTRIB_VALUE = 39; // <a foo=
const $92093278557b2366$var$S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
const $92093278557b2366$var$S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
const $92093278557b2366$var$S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
const $92093278557b2366$var$S_CLOSE_TAG = 43; // </a
const $92093278557b2366$var$S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
const $92093278557b2366$var$TAB = 9;
const $92093278557b2366$var$NL = 0xA;
const $92093278557b2366$var$CR = 0xD;
const $92093278557b2366$var$SPACE = 0x20;
const $92093278557b2366$var$BANG = 0x21;
const $92093278557b2366$var$DQUOTE = 0x22;
const $92093278557b2366$var$AMP = 0x26;
const $92093278557b2366$var$SQUOTE = 0x27;
const $92093278557b2366$var$MINUS = 0x2D;
const $92093278557b2366$var$FORWARD_SLASH = 0x2F;
const $92093278557b2366$var$SEMICOLON = 0x3B;
const $92093278557b2366$var$LESS = 0x3C;
const $92093278557b2366$var$EQUAL = 0x3D;
const $92093278557b2366$var$GREATER = 0x3E;
const $92093278557b2366$var$QUESTION = 0x3F;
const $92093278557b2366$var$OPEN_BRACKET = 0x5B;
const $92093278557b2366$var$CLOSE_BRACKET = 0x5D;
const $92093278557b2366$var$NEL = 0x85;
const $92093278557b2366$var$LS = 0x2028; // Line Separator
const $92093278557b2366$var$isQuote = (c)=>c === $92093278557b2366$var$DQUOTE || c === $92093278557b2366$var$SQUOTE;
const $92093278557b2366$var$QUOTES = [
    $92093278557b2366$var$DQUOTE,
    $92093278557b2366$var$SQUOTE
];
const $92093278557b2366$var$DOCTYPE_TERMINATOR = [
    ...$92093278557b2366$var$QUOTES,
    $92093278557b2366$var$OPEN_BRACKET,
    $92093278557b2366$var$GREATER
];
const $92093278557b2366$var$DTD_TERMINATOR = [
    ...$92093278557b2366$var$QUOTES,
    $92093278557b2366$var$LESS,
    $92093278557b2366$var$CLOSE_BRACKET
];
const $92093278557b2366$var$XML_DECL_NAME_TERMINATOR = [
    $92093278557b2366$var$EQUAL,
    $92093278557b2366$var$QUESTION,
    ...$92093278557b2366$var$S_LIST
];
const $92093278557b2366$var$ATTRIB_VALUE_UNQUOTED_TERMINATOR = [
    ...$92093278557b2366$var$S_LIST,
    $92093278557b2366$var$GREATER,
    $92093278557b2366$var$AMP,
    $92093278557b2366$var$LESS
];
function $92093278557b2366$var$nsPairCheck(parser, prefix, uri) {
    switch(prefix){
        case "xml":
            if (uri !== $92093278557b2366$var$XML_NAMESPACE) parser.fail(`xml prefix must be bound to ${$92093278557b2366$var$XML_NAMESPACE}.`);
            break;
        case "xmlns":
            if (uri !== $92093278557b2366$var$XMLNS_NAMESPACE) parser.fail(`xmlns prefix must be bound to ${$92093278557b2366$var$XMLNS_NAMESPACE}.`);
            break;
        default:
    }
    switch(uri){
        case $92093278557b2366$var$XMLNS_NAMESPACE:
            parser.fail(prefix === "" ? `the default namespace may not be set to ${uri}.` : `may not assign a prefix (even "xmlns") to the URI \
${$92093278557b2366$var$XMLNS_NAMESPACE}.`);
            break;
        case $92093278557b2366$var$XML_NAMESPACE:
            switch(prefix){
                case "xml":
                    break;
                case "":
                    parser.fail(`the default namespace may not be set to ${uri}.`);
                    break;
                default:
                    parser.fail("may not assign the xml namespace to another prefix.");
            }
            break;
        default:
    }
}
function $92093278557b2366$var$nsMappingCheck(parser, mapping) {
    for (const local of Object.keys(mapping))$92093278557b2366$var$nsPairCheck(parser, local, mapping[local]);
}
const $92093278557b2366$var$isNCName = (name)=>$92093278557b2366$var$NC_NAME_RE.test(name);
const $92093278557b2366$var$isName = (name)=>$92093278557b2366$var$NAME_RE.test(name);
const $92093278557b2366$var$FORBIDDEN_START = 0;
const $92093278557b2366$var$FORBIDDEN_BRACKET = 1;
const $92093278557b2366$var$FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */ module.exports.EVENTS = [
    "xmldecl",
    "text",
    "processinginstruction",
    "doctype",
    "comment",
    "opentagstart",
    "attribute",
    "opentag",
    "closetag",
    "cdata",
    "error",
    "end",
    "ready"
];
const $92093278557b2366$var$EVENT_NAME_TO_HANDLER_NAME = {
    xmldecl: "xmldeclHandler",
    text: "textHandler",
    processinginstruction: "piHandler",
    doctype: "doctypeHandler",
    comment: "commentHandler",
    opentagstart: "openTagStartHandler",
    attribute: "attributeHandler",
    opentag: "openTagHandler",
    closetag: "closeTagHandler",
    cdata: "cdataHandler",
    error: "errorHandler",
    end: "endHandler",
    ready: "readyHandler"
};
// eslint-disable-next-line @typescript-eslint/ban-types
class $92093278557b2366$var$SaxesParser {
    /**
     * Indicates whether or not the parser is closed. If ``true``, wait for
     * the ``ready`` event to write again.
     */ get closed() {
        return this._closed;
    }
    /**
     * @param opt The parser options.
     */ constructor(opt){
        this.opt = opt !== null && opt !== void 0 ? opt : {};
        this.fragmentOpt = !!this.opt.fragment;
        const xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
        this.trackPosition = this.opt.position !== false;
        this.fileName = this.opt.fileName;
        if (xmlnsOpt) {
            // This is the function we use to perform name checks on PIs and entities.
            // When namespaces are used, colons are not allowed in PI target names or
            // entity names. So the check depends on whether namespaces are used. See:
            //
            // https://www.w3.org/XML/xml-names-19990114-errata.html
            // NE08
            //
            this.nameStartCheck = $92093278557b2366$var$isNCNameStartChar;
            this.nameCheck = $92093278557b2366$var$isNCNameChar;
            this.isName = $92093278557b2366$var$isNCName;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.processAttribs = this.processAttribsNS;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.pushAttrib = this.pushAttribNS;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
            this.ns = Object.assign({
                __proto__: null
            }, $92093278557b2366$var$rootNS);
            const additional = this.opt.additionalNamespaces;
            if (additional != null) {
                $92093278557b2366$var$nsMappingCheck(this, additional);
                Object.assign(this.ns, additional);
            }
        } else {
            this.nameStartCheck = $92093278557b2366$var$isNameStartChar;
            this.nameCheck = $92093278557b2366$var$isNameChar;
            this.isName = $92093278557b2366$var$isName;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.processAttribs = this.processAttribsPlain;
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.pushAttrib = this.pushAttribPlain;
        }
        //
        // The order of the members in this table needs to correspond to the state
        // numbers given to the states that correspond to the methods being recorded
        // here.
        //
        this.stateTable = [
            /* eslint-disable @typescript-eslint/unbound-method */ this.sBegin,
            this.sBeginWhitespace,
            this.sDoctype,
            this.sDoctypeQuote,
            this.sDTD,
            this.sDTDQuoted,
            this.sDTDOpenWaka,
            this.sDTDOpenWakaBang,
            this.sDTDComment,
            this.sDTDCommentEnding,
            this.sDTDCommentEnded,
            this.sDTDPI,
            this.sDTDPIEnding,
            this.sText,
            this.sEntity,
            this.sOpenWaka,
            this.sOpenWakaBang,
            this.sComment,
            this.sCommentEnding,
            this.sCommentEnded,
            this.sCData,
            this.sCDataEnding,
            this.sCDataEnding2,
            this.sPIFirstChar,
            this.sPIRest,
            this.sPIBody,
            this.sPIEnding,
            this.sXMLDeclNameStart,
            this.sXMLDeclName,
            this.sXMLDeclEq,
            this.sXMLDeclValueStart,
            this.sXMLDeclValue,
            this.sXMLDeclSeparator,
            this.sXMLDeclEnding,
            this.sOpenTag,
            this.sOpenTagSlash,
            this.sAttrib,
            this.sAttribName,
            this.sAttribNameSawWhite,
            this.sAttribValue,
            this.sAttribValueQuoted,
            this.sAttribValueClosed,
            this.sAttribValueUnquoted,
            this.sCloseTag,
            this.sCloseTagSawWhite
        ];
        this._init();
    }
    _init() {
        var _a;
        this.openWakaBang = "";
        this.text = "";
        this.name = "";
        this.piTarget = "";
        this.entity = "";
        this.q = null;
        this.tags = [];
        this.tag = null;
        this.topNS = null;
        this.chunk = "";
        this.chunkPosition = 0;
        this.i = 0;
        this.prevI = 0;
        this.carriedFromPrevious = undefined;
        this.forbiddenState = $92093278557b2366$var$FORBIDDEN_START;
        this.attribList = [];
        // The logic is organized so as to minimize the need to check
        // this.opt.fragment while parsing.
        const { fragmentOpt: fragmentOpt } = this;
        this.state = fragmentOpt ? $92093278557b2366$var$S_TEXT : $92093278557b2366$var$S_BEGIN;
        // We want these to be all true if we are dealing with a fragment.
        this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
        // An XML declaration is intially possible only when parsing whole
        // documents.
        this.xmlDeclPossible = !fragmentOpt;
        this.xmlDeclExpects = [
            "version"
        ];
        this.entityReturnState = undefined;
        let { defaultXMLVersion: defaultXMLVersion } = this.opt;
        if (defaultXMLVersion === undefined) {
            if (this.opt.forceXMLVersion === true) throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
            defaultXMLVersion = "1.0";
        }
        this.setXMLVersion(defaultXMLVersion);
        this.positionAtNewLine = 0;
        this.doctype = false;
        this._closed = false;
        this.xmlDecl = {
            version: undefined,
            encoding: undefined,
            standalone: undefined
        };
        this.line = 1;
        this.column = 0;
        this.ENTITIES = Object.create($92093278557b2366$var$XML_ENTITIES);
        (_a = this.readyHandler) === null || _a === void 0 || _a.call(this);
    }
    /**
     * The stream position the parser is currently looking at. This field is
     * zero-based.
     *
     * This field is not based on counting Unicode characters but is to be
     * interpreted as a plain index into a JavaScript string.
     */ get position() {
        return this.chunkPosition + this.i;
    }
    /**
     * The column number of the next character to be read by the parser.  *
     * This field is zero-based. (The first column in a line is 0.)
     *
     * This field reports the index at which the next character would be in the
     * line if the line were represented as a JavaScript string.  Note that this
     * *can* be different to a count based on the number of *Unicode characters*
     * due to how JavaScript handles astral plane characters.
     *
     * See [[column]] for a number that corresponds to a count of Unicode
     * characters.
     */ get columnIndex() {
        return this.position - this.positionAtNewLine;
    }
    /**
     * Set an event listener on an event. The parser supports one handler per
     * event type. If you try to set an event handler over an existing handler,
     * the old handler is silently overwritten.
     *
     * @param name The event to listen to.
     *
     * @param handler The handler to set.
     */ on(name, handler) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this[$92093278557b2366$var$EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
    }
    /**
     * Unset an event handler.
     *
     * @parma name The event to stop listening to.
     */ off(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        this[$92093278557b2366$var$EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
    }
    /**
     * Make an error object. The error object will have a message that contains
     * the ``fileName`` option passed at the creation of the parser. If position
     * tracking was turned on, it will also have line and column number
     * information.
     *
     * @param message The message describing the error to report.
     *
     * @returns An error object with a properly formatted message.
     */ makeError(message) {
        var _a;
        let msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
        if (this.trackPosition) {
            if (msg.length > 0) msg += ":";
            msg += `${this.line}:${this.column}`;
        }
        if (msg.length > 0) msg += ": ";
        return new Error(msg + message);
    }
    /**
     * Report a parsing error. This method is made public so that client code may
     * check for issues that are outside the scope of this project and can report
     * errors.
     *
     * @param message The error to report.
     *
     * @returns this
     */ fail(message) {
        const err = this.makeError(message);
        const handler = this.errorHandler;
        if (handler === undefined) throw err;
        else handler(err);
        return this;
    }
    /**
     * Write a XML data to the parser.
     *
     * @param chunk The XML data to write.
     *
     * @returns this
     */ // We do need object for the type here. Yes, it often causes problems
    // but not in this case.
    write(chunk) {
        if (this.closed) return this.fail("cannot write after close; assign an onready handler.");
        let end = false;
        if (chunk === null) {
            // We cannot return immediately because carriedFromPrevious may need
            // processing.
            end = true;
            chunk = "";
        } else if (typeof chunk === "object") chunk = chunk.toString();
        // We checked if performing a pre-decomposition of the string into an array
        // of single complete characters (``Array.from(chunk)``) would be faster
        // than the current repeated calls to ``charCodeAt``. As of August 2018, it
        // isn't. (There may be Node-specific code that would perform faster than
        // ``Array.from`` but don't want to be dependent on Node.)
        if (this.carriedFromPrevious !== undefined) {
            // The previous chunk had char we must carry over.
            chunk = `${this.carriedFromPrevious}${chunk}`;
            this.carriedFromPrevious = undefined;
        }
        let limit = chunk.length;
        const lastCode = chunk.charCodeAt(limit - 1);
        if (!end && // A trailing CR or surrogate must be carried over to the next
        // chunk.
        (lastCode === $92093278557b2366$var$CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
            // The chunk ends with a character that must be carried over. We cannot
            // know how to handle it until we get the next chunk or the end of the
            // stream. So save it for later.
            this.carriedFromPrevious = chunk[limit - 1];
            limit--;
            chunk = chunk.slice(0, limit);
        }
        const { stateTable: stateTable } = this;
        this.chunk = chunk;
        this.i = 0;
        while(this.i < limit)// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
        stateTable[this.state].call(this);
        this.chunkPosition += limit;
        return end ? this.end() : this;
    }
    /**
     * Close the current stream. Perform final well-formedness checks and reset
     * the parser tstate.
     *
     * @returns this
     */ close() {
        return this.write(null);
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.0.
     *
     * @returns The character read.
     */ getCode10() {
        const { chunk: chunk, i: i } = this;
        this.prevI = i;
        // Yes, we do this instead of doing this.i++. Doing it this way, we do not
        // read this.i again, which is a bit faster.
        this.i = i + 1;
        if (i >= chunk.length) return $92093278557b2366$var$EOC;
        // Using charCodeAt and handling the surrogates ourselves is faster
        // than using codePointAt.
        const code = chunk.charCodeAt(i);
        this.column++;
        if (code < 0xD800) {
            if (code >= $92093278557b2366$var$SPACE || code === $92093278557b2366$var$TAB) return code;
            switch(code){
                case $92093278557b2366$var$NL:
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $92093278557b2366$var$NL;
                case $92093278557b2366$var$CR:
                    // We may get NaN if we read past the end of the chunk, which is fine.
                    if (chunk.charCodeAt(i + 1) === $92093278557b2366$var$NL) // A \r\n sequence is converted to \n so we have to skip over the
                    // next character. We already know it has a size of 1 so ++ is fine
                    // here.
                    this.i = i + 2;
                    // Otherwise, a \r is just converted to \n, so we don't have to skip
                    // ahead.
                    // In either case, \r becomes \n.
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $92093278557b2366$var$NL_LIKE;
                default:
                    // If we get here, then code < SPACE and it is not NL CR or TAB.
                    this.fail("disallowed character.");
                    return code;
            }
        }
        if (code > 0xDBFF) {
            // This is a specialized version of isChar10 that takes into account
            // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
            // test cases that don't need testing.
            if (!(code >= 0xE000 && code <= 0xFFFD)) this.fail("disallowed character.");
            return code;
        }
        const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
        this.i = i + 2;
        // This is a specialized version of isChar10 that takes into account that in
        // this context necessarily final >= 0x10000.
        if (final > 0x10FFFF) this.fail("disallowed character.");
        return final;
    }
    /**
     * Get a single code point out of the current chunk. This updates the current
     * position if we do position tracking.
     *
     * This is the algorithm to use for XML 1.1.
     *
     * @returns {number} The character read.
     */ getCode11() {
        const { chunk: chunk, i: i } = this;
        this.prevI = i;
        // Yes, we do this instead of doing this.i++. Doing it this way, we do not
        // read this.i again, which is a bit faster.
        this.i = i + 1;
        if (i >= chunk.length) return $92093278557b2366$var$EOC;
        // Using charCodeAt and handling the surrogates ourselves is faster
        // than using codePointAt.
        const code = chunk.charCodeAt(i);
        this.column++;
        if (code < 0xD800) {
            if (code > 0x1F && code < 0x7F || code > 0x9F && code !== $92093278557b2366$var$LS || code === $92093278557b2366$var$TAB) return code;
            switch(code){
                case $92093278557b2366$var$NL:
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $92093278557b2366$var$NL;
                case $92093278557b2366$var$CR:
                    {
                        // We may get NaN if we read past the end of the chunk, which is
                        // fine.
                        const next = chunk.charCodeAt(i + 1);
                        if (next === $92093278557b2366$var$NL || next === $92093278557b2366$var$NEL) // A CR NL or CR NEL sequence is converted to NL so we have to skip
                        // over the next character. We already know it has a size of 1.
                        this.i = i + 2;
                    // Otherwise, a CR is just converted to NL, no skip.
                    }
                /* yes, fall through */ case $92093278557b2366$var$NEL:
                case $92093278557b2366$var$LS:
                    this.line++;
                    this.column = 0;
                    this.positionAtNewLine = this.position;
                    return $92093278557b2366$var$NL_LIKE;
                default:
                    this.fail("disallowed character.");
                    return code;
            }
        }
        if (code > 0xDBFF) {
            // This is a specialized version of isCharAndNotRestricted that takes into
            // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
            // does not test cases that don't need testing.
            if (!(code >= 0xE000 && code <= 0xFFFD)) this.fail("disallowed character.");
            return code;
        }
        const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
        this.i = i + 2;
        // This is a specialized version of isCharAndNotRestricted that takes into
        // account that in this context necessarily final >= 0x10000.
        if (final > 0x10FFFF) this.fail("disallowed character.");
        return final;
    }
    /**
     * Like ``getCode`` but with the return value normalized so that ``NL`` is
     * returned for ``NL_LIKE``.
     */ getCodeNorm() {
        const c = this.getCode();
        return c === $92093278557b2366$var$NL_LIKE ? $92093278557b2366$var$NL : c;
    }
    unget() {
        this.i = this.prevI;
        this.column--;
    }
    /**
     * Capture characters into a buffer until encountering one of a set of
     * characters.
     *
     * @param chars An array of codepoints. Encountering a character in the array
     * ends the capture. (``chars`` may safely contain ``NL``.)
     *
     * @return The character code that made the capture end, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ captureTo(chars) {
        let { i: start } = this;
        const { chunk: chunk } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCode();
            const isNLLike = c === $92093278557b2366$var$NL_LIKE;
            const final = isNLLike ? $92093278557b2366$var$NL : c;
            if (final === $92093278557b2366$var$EOC || chars.includes(final)) {
                this.text += chunk.slice(start, this.prevI);
                return final;
            }
            if (isNLLike) {
                this.text += `${chunk.slice(start, this.prevI)}\n`;
                start = this.i;
            }
        }
    }
    /**
     * Capture characters into a buffer until encountering a character.
     *
     * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
     * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
     *
     * @return ``true`` if we ran into the character. Otherwise, we ran into the
     * end of the current chunk.
     */ captureToChar(char) {
        let { i: start } = this;
        const { chunk: chunk } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            let c = this.getCode();
            switch(c){
                case $92093278557b2366$var$NL_LIKE:
                    this.text += `${chunk.slice(start, this.prevI)}\n`;
                    start = this.i;
                    c = $92093278557b2366$var$NL;
                    break;
                case $92093278557b2366$var$EOC:
                    this.text += chunk.slice(start);
                    return false;
                default:
            }
            if (c === char) {
                this.text += chunk.slice(start, this.prevI);
                return true;
            }
        }
    }
    /**
     * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
     * this parser.
     *
     * @return The character code that made the test fail, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ captureNameChars() {
        const { chunk: chunk, i: start } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCode();
            if (c === $92093278557b2366$var$EOC) {
                this.name += chunk.slice(start);
                return $92093278557b2366$var$EOC;
            }
            // NL is not a name char so we don't have to test specifically for it.
            if (!$92093278557b2366$var$isNameChar(c)) {
                this.name += chunk.slice(start, this.prevI);
                return c === $92093278557b2366$var$NL_LIKE ? $92093278557b2366$var$NL : c;
            }
        }
    }
    /**
     * Skip white spaces.
     *
     * @return The character that ended the skip, or ``EOC`` if we hit
     * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
     * instead.
     */ skipSpaces() {
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCodeNorm();
            if (c === $92093278557b2366$var$EOC || !$92093278557b2366$var$isS(c)) return c;
        }
    }
    setXMLVersion(version) {
        this.currentXMLVersion = version;
        /*  eslint-disable @typescript-eslint/unbound-method */ if (version === "1.0") {
            this.isChar = $92093278557b2366$var$isChar10;
            this.getCode = this.getCode10;
        } else {
            this.isChar = $92093278557b2366$var$isChar11;
            this.getCode = this.getCode11;
        }
    /* eslint-enable @typescript-eslint/unbound-method */ }
    // STATE ENGINE METHODS
    // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
    // to be sure never to come back to this state later.
    sBegin() {
        // We are essentially peeking at the first character of the chunk. Since
        // S_BEGIN can be in effect only when we start working on the first chunk,
        // the index at which we must look is necessarily 0. Note also that the
        // following test does not depend on decoding surrogates.
        // If the initial character is 0xFEFF, ignore it.
        if (this.chunk.charCodeAt(0) === 0xFEFF) {
            this.i++;
            this.column++;
        }
        this.state = $92093278557b2366$var$S_BEGIN_WHITESPACE;
    }
    sBeginWhitespace() {
        // We need to know whether we've encountered spaces or not because as soon
        // as we run into a space, an XML declaration is no longer possible. Rather
        // than slow down skipSpaces even in places where we don't care whether it
        // skipped anything or not, we check whether prevI is equal to the value of
        // i from before we skip spaces.
        const iBefore = this.i;
        const c = this.skipSpaces();
        if (this.prevI !== iBefore) this.xmlDeclPossible = false;
        switch(c){
            case $92093278557b2366$var$LESS:
                this.state = $92093278557b2366$var$S_OPEN_WAKA;
                // We could naively call closeText but in this state, it is not normal
                // to have text be filled with any data.
                if (this.text.length !== 0) throw new Error("no-empty text at start");
                break;
            case $92093278557b2366$var$EOC:
                break;
            default:
                this.unget();
                this.state = $92093278557b2366$var$S_TEXT;
                this.xmlDeclPossible = false;
        }
    }
    sDoctype() {
        var _a;
        const c = this.captureTo($92093278557b2366$var$DOCTYPE_TERMINATOR);
        switch(c){
            case $92093278557b2366$var$GREATER:
                (_a = this.doctypeHandler) === null || _a === void 0 || _a.call(this, this.text);
                this.text = "";
                this.state = $92093278557b2366$var$S_TEXT;
                this.doctype = true; // just remember that we saw it.
                break;
            case $92093278557b2366$var$EOC:
                break;
            default:
                this.text += String.fromCodePoint(c);
                if (c === $92093278557b2366$var$OPEN_BRACKET) this.state = $92093278557b2366$var$S_DTD;
                else if ($92093278557b2366$var$isQuote(c)) {
                    this.state = $92093278557b2366$var$S_DOCTYPE_QUOTE;
                    this.q = c;
                }
        }
    }
    sDoctypeQuote() {
        const q = this.q;
        if (this.captureToChar(q)) {
            this.text += String.fromCodePoint(q);
            this.q = null;
            this.state = $92093278557b2366$var$S_DOCTYPE;
        }
    }
    sDTD() {
        const c = this.captureTo($92093278557b2366$var$DTD_TERMINATOR);
        if (c === $92093278557b2366$var$EOC) return;
        this.text += String.fromCodePoint(c);
        if (c === $92093278557b2366$var$CLOSE_BRACKET) this.state = $92093278557b2366$var$S_DOCTYPE;
        else if (c === $92093278557b2366$var$LESS) this.state = $92093278557b2366$var$S_DTD_OPEN_WAKA;
        else if ($92093278557b2366$var$isQuote(c)) {
            this.state = $92093278557b2366$var$S_DTD_QUOTED;
            this.q = c;
        }
    }
    sDTDQuoted() {
        const q = this.q;
        if (this.captureToChar(q)) {
            this.text += String.fromCodePoint(q);
            this.state = $92093278557b2366$var$S_DTD;
            this.q = null;
        }
    }
    sDTDOpenWaka() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        switch(c){
            case $92093278557b2366$var$BANG:
                this.state = $92093278557b2366$var$S_DTD_OPEN_WAKA_BANG;
                this.openWakaBang = "";
                break;
            case $92093278557b2366$var$QUESTION:
                this.state = $92093278557b2366$var$S_DTD_PI;
                break;
            default:
                this.state = $92093278557b2366$var$S_DTD;
        }
    }
    sDTDOpenWakaBang() {
        const char = String.fromCodePoint(this.getCodeNorm());
        const owb = this.openWakaBang += char;
        this.text += char;
        if (owb !== "-") {
            this.state = owb === "--" ? $92093278557b2366$var$S_DTD_COMMENT : $92093278557b2366$var$S_DTD;
            this.openWakaBang = "";
        }
    }
    sDTDComment() {
        if (this.captureToChar($92093278557b2366$var$MINUS)) {
            this.text += "-";
            this.state = $92093278557b2366$var$S_DTD_COMMENT_ENDING;
        }
    }
    sDTDCommentEnding() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        this.state = c === $92093278557b2366$var$MINUS ? $92093278557b2366$var$S_DTD_COMMENT_ENDED : $92093278557b2366$var$S_DTD_COMMENT;
    }
    sDTDCommentEnded() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        if (c === $92093278557b2366$var$GREATER) this.state = $92093278557b2366$var$S_DTD;
        else {
            this.fail("malformed comment.");
            // <!-- blah -- bloo --> will be recorded as
            // a comment of " blah -- bloo "
            this.state = $92093278557b2366$var$S_DTD_COMMENT;
        }
    }
    sDTDPI() {
        if (this.captureToChar($92093278557b2366$var$QUESTION)) {
            this.text += "?";
            this.state = $92093278557b2366$var$S_DTD_PI_ENDING;
        }
    }
    sDTDPIEnding() {
        const c = this.getCodeNorm();
        this.text += String.fromCodePoint(c);
        if (c === $92093278557b2366$var$GREATER) this.state = $92093278557b2366$var$S_DTD;
    }
    sText() {
        //
        // We did try a version of saxes where the S_TEXT state was split in two
        // states: one for text inside the root element, and one for text
        // outside. This was avoiding having to test this.tags.length to decide
        // what implementation to actually use.
        //
        // Peformance testing on gigabyte-size files did not show any advantage to
        // using the two states solution instead of the current one. Conversely, it
        // made the code a bit more complicated elsewhere. For instance, a comment
        // can appear before the root element so when a comment ended it was
        // necessary to determine whether to return to the S_TEXT state or to the
        // new text-outside-root state.
        //
        if (this.tags.length !== 0) this.handleTextInRoot();
        else this.handleTextOutsideRoot();
    }
    sEntity() {
        // This is essentially a specialized version of captureToChar(SEMICOLON...)
        let { i: start } = this;
        const { chunk: chunk } = this;
        // eslint-disable-next-line no-labels, no-restricted-syntax
        loop: // eslint-disable-next-line no-constant-condition
        while(true)switch(this.getCode()){
            case $92093278557b2366$var$NL_LIKE:
                this.entity += `${chunk.slice(start, this.prevI)}\n`;
                start = this.i;
                break;
            case $92093278557b2366$var$SEMICOLON:
                {
                    const { entityReturnState: entityReturnState } = this;
                    const entity = this.entity + chunk.slice(start, this.prevI);
                    this.state = entityReturnState;
                    let parsed;
                    if (entity === "") {
                        this.fail("empty entity name.");
                        parsed = "&;";
                    } else {
                        parsed = this.parseEntity(entity);
                        this.entity = "";
                    }
                    if (entityReturnState !== $92093278557b2366$var$S_TEXT || this.textHandler !== undefined) this.text += parsed;
                    break loop;
                }
            case $92093278557b2366$var$EOC:
                this.entity += chunk.slice(start);
                break loop;
            default:
        }
    }
    sOpenWaka() {
        // Reminder: a state handler is called with at least one character
        // available in the current chunk. So the first call to get code inside of
        // a state handler cannot return ``EOC``. That's why we don't test
        // for it.
        const c = this.getCode();
        // either a /, ?, !, or text is coming next.
        if ($92093278557b2366$var$isNameStartChar(c)) {
            this.state = $92093278557b2366$var$S_OPEN_TAG;
            this.unget();
            this.xmlDeclPossible = false;
        } else switch(c){
            case $92093278557b2366$var$FORWARD_SLASH:
                this.state = $92093278557b2366$var$S_CLOSE_TAG;
                this.xmlDeclPossible = false;
                break;
            case $92093278557b2366$var$BANG:
                this.state = $92093278557b2366$var$S_OPEN_WAKA_BANG;
                this.openWakaBang = "";
                this.xmlDeclPossible = false;
                break;
            case $92093278557b2366$var$QUESTION:
                this.state = $92093278557b2366$var$S_PI_FIRST_CHAR;
                break;
            default:
                this.fail("disallowed character in tag name");
                this.state = $92093278557b2366$var$S_TEXT;
                this.xmlDeclPossible = false;
        }
    }
    sOpenWakaBang() {
        this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
        switch(this.openWakaBang){
            case "[CDATA[":
                if (!this.sawRoot && !this.reportedTextBeforeRoot) {
                    this.fail("text data outside of root node.");
                    this.reportedTextBeforeRoot = true;
                }
                if (this.closedRoot && !this.reportedTextAfterRoot) {
                    this.fail("text data outside of root node.");
                    this.reportedTextAfterRoot = true;
                }
                this.state = $92093278557b2366$var$S_CDATA;
                this.openWakaBang = "";
                break;
            case "--":
                this.state = $92093278557b2366$var$S_COMMENT;
                this.openWakaBang = "";
                break;
            case "DOCTYPE":
                this.state = $92093278557b2366$var$S_DOCTYPE;
                if (this.doctype || this.sawRoot) this.fail("inappropriately located doctype declaration.");
                this.openWakaBang = "";
                break;
            default:
                // 7 happens to be the maximum length of the string that can possibly
                // match one of the cases above.
                if (this.openWakaBang.length >= 7) this.fail("incorrect syntax.");
        }
    }
    sComment() {
        if (this.captureToChar($92093278557b2366$var$MINUS)) this.state = $92093278557b2366$var$S_COMMENT_ENDING;
    }
    sCommentEnding() {
        var _a;
        const c = this.getCodeNorm();
        if (c === $92093278557b2366$var$MINUS) {
            this.state = $92093278557b2366$var$S_COMMENT_ENDED;
            (_a = this.commentHandler) === null || _a === void 0 || _a.call(this, this.text);
            this.text = "";
        } else {
            this.text += `-${String.fromCodePoint(c)}`;
            this.state = $92093278557b2366$var$S_COMMENT;
        }
    }
    sCommentEnded() {
        const c = this.getCodeNorm();
        if (c !== $92093278557b2366$var$GREATER) {
            this.fail("malformed comment.");
            // <!-- blah -- bloo --> will be recorded as
            // a comment of " blah -- bloo "
            this.text += `--${String.fromCodePoint(c)}`;
            this.state = $92093278557b2366$var$S_COMMENT;
        } else this.state = $92093278557b2366$var$S_TEXT;
    }
    sCData() {
        if (this.captureToChar($92093278557b2366$var$CLOSE_BRACKET)) this.state = $92093278557b2366$var$S_CDATA_ENDING;
    }
    sCDataEnding() {
        const c = this.getCodeNorm();
        if (c === $92093278557b2366$var$CLOSE_BRACKET) this.state = $92093278557b2366$var$S_CDATA_ENDING_2;
        else {
            this.text += `]${String.fromCodePoint(c)}`;
            this.state = $92093278557b2366$var$S_CDATA;
        }
    }
    sCDataEnding2() {
        var _a;
        const c = this.getCodeNorm();
        switch(c){
            case $92093278557b2366$var$GREATER:
                (_a = this.cdataHandler) === null || _a === void 0 || _a.call(this, this.text);
                this.text = "";
                this.state = $92093278557b2366$var$S_TEXT;
                break;
            case $92093278557b2366$var$CLOSE_BRACKET:
                this.text += "]";
                break;
            default:
                this.text += `]]${String.fromCodePoint(c)}`;
                this.state = $92093278557b2366$var$S_CDATA;
        }
    }
    // We need this separate state to check the first character fo the pi target
    // with this.nameStartCheck which allows less characters than this.nameCheck.
    sPIFirstChar() {
        const c = this.getCodeNorm();
        // This is first because in the case where the file is well-formed this is
        // the branch taken. We optimize for well-formedness.
        if (this.nameStartCheck(c)) {
            this.piTarget += String.fromCodePoint(c);
            this.state = $92093278557b2366$var$S_PI_REST;
        } else if (c === $92093278557b2366$var$QUESTION || $92093278557b2366$var$isS(c)) {
            this.fail("processing instruction without a target.");
            this.state = c === $92093278557b2366$var$QUESTION ? $92093278557b2366$var$S_PI_ENDING : $92093278557b2366$var$S_PI_BODY;
        } else {
            this.fail("disallowed character in processing instruction name.");
            this.piTarget += String.fromCodePoint(c);
            this.state = $92093278557b2366$var$S_PI_REST;
        }
    }
    sPIRest() {
        // Capture characters into a piTarget while ``this.nameCheck`` run on the
        // character read returns true.
        const { chunk: chunk, i: start } = this;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const c = this.getCodeNorm();
            if (c === $92093278557b2366$var$EOC) {
                this.piTarget += chunk.slice(start);
                return;
            }
            // NL cannot satisfy this.nameCheck so we don't have to test specifically
            // for it.
            if (!this.nameCheck(c)) {
                this.piTarget += chunk.slice(start, this.prevI);
                const isQuestion = c === $92093278557b2366$var$QUESTION;
                if (isQuestion || $92093278557b2366$var$isS(c)) {
                    if (this.piTarget === "xml") {
                        if (!this.xmlDeclPossible) this.fail("an XML declaration must be at the start of the document.");
                        this.state = isQuestion ? $92093278557b2366$var$S_XML_DECL_ENDING : $92093278557b2366$var$S_XML_DECL_NAME_START;
                    } else this.state = isQuestion ? $92093278557b2366$var$S_PI_ENDING : $92093278557b2366$var$S_PI_BODY;
                } else {
                    this.fail("disallowed character in processing instruction name.");
                    this.piTarget += String.fromCodePoint(c);
                }
                break;
            }
        }
    }
    sPIBody() {
        if (this.text.length === 0) {
            const c = this.getCodeNorm();
            if (c === $92093278557b2366$var$QUESTION) this.state = $92093278557b2366$var$S_PI_ENDING;
            else if (!$92093278557b2366$var$isS(c)) this.text = String.fromCodePoint(c);
        } else if (this.captureToChar($92093278557b2366$var$QUESTION)) this.state = $92093278557b2366$var$S_PI_ENDING;
    }
    sPIEnding() {
        var _a;
        const c = this.getCodeNorm();
        if (c === $92093278557b2366$var$GREATER) {
            const { piTarget: piTarget } = this;
            if (piTarget.toLowerCase() === "xml") this.fail("the XML declaration must appear at the start of the document.");
            (_a = this.piHandler) === null || _a === void 0 || _a.call(this, {
                target: piTarget,
                body: this.text
            });
            this.piTarget = this.text = "";
            this.state = $92093278557b2366$var$S_TEXT;
        } else if (c === $92093278557b2366$var$QUESTION) // We ran into ?? as part of a processing instruction. We initially took
        // the first ? as a sign that the PI was ending, but it is not. So we have
        // to add it to the body but we take the new ? as a sign that the PI is
        // ending.
        this.text += "?";
        else {
            this.text += `?${String.fromCodePoint(c)}`;
            this.state = $92093278557b2366$var$S_PI_BODY;
        }
        this.xmlDeclPossible = false;
    }
    sXMLDeclNameStart() {
        const c = this.skipSpaces();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $92093278557b2366$var$QUESTION) {
            // It is valid to go to S_XML_DECL_ENDING from this state.
            this.state = $92093278557b2366$var$S_XML_DECL_ENDING;
            return;
        }
        if (c !== $92093278557b2366$var$EOC) {
            this.state = $92093278557b2366$var$S_XML_DECL_NAME;
            this.name = String.fromCodePoint(c);
        }
    }
    sXMLDeclName() {
        const c = this.captureTo($92093278557b2366$var$XML_DECL_NAME_TERMINATOR);
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $92093278557b2366$var$QUESTION) {
            this.state = $92093278557b2366$var$S_XML_DECL_ENDING;
            this.name += this.text;
            this.text = "";
            this.fail("XML declaration is incomplete.");
            return;
        }
        if (!($92093278557b2366$var$isS(c) || c === $92093278557b2366$var$EQUAL)) return;
        this.name += this.text;
        this.text = "";
        if (!this.xmlDeclExpects.includes(this.name)) switch(this.name.length){
            case 0:
                this.fail("did not expect any more name/value pairs.");
                break;
            case 1:
                this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
                break;
            default:
                this.fail(`expected one of ${this.xmlDeclExpects.join(", ")}`);
        }
        this.state = c === $92093278557b2366$var$EQUAL ? $92093278557b2366$var$S_XML_DECL_VALUE_START : $92093278557b2366$var$S_XML_DECL_EQ;
    }
    sXMLDeclEq() {
        const c = this.getCodeNorm();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $92093278557b2366$var$QUESTION) {
            this.state = $92093278557b2366$var$S_XML_DECL_ENDING;
            this.fail("XML declaration is incomplete.");
            return;
        }
        if ($92093278557b2366$var$isS(c)) return;
        if (c !== $92093278557b2366$var$EQUAL) this.fail("value required.");
        this.state = $92093278557b2366$var$S_XML_DECL_VALUE_START;
    }
    sXMLDeclValueStart() {
        const c = this.getCodeNorm();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $92093278557b2366$var$QUESTION) {
            this.state = $92093278557b2366$var$S_XML_DECL_ENDING;
            this.fail("XML declaration is incomplete.");
            return;
        }
        if ($92093278557b2366$var$isS(c)) return;
        if (!$92093278557b2366$var$isQuote(c)) {
            this.fail("value must be quoted.");
            this.q = $92093278557b2366$var$SPACE;
        } else this.q = c;
        this.state = $92093278557b2366$var$S_XML_DECL_VALUE;
    }
    sXMLDeclValue() {
        const c = this.captureTo([
            this.q,
            $92093278557b2366$var$QUESTION
        ]);
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $92093278557b2366$var$QUESTION) {
            this.state = $92093278557b2366$var$S_XML_DECL_ENDING;
            this.text = "";
            this.fail("XML declaration is incomplete.");
            return;
        }
        if (c === $92093278557b2366$var$EOC) return;
        const value = this.text;
        this.text = "";
        switch(this.name){
            case "version":
                {
                    this.xmlDeclExpects = [
                        "encoding",
                        "standalone"
                    ];
                    const version = value;
                    this.xmlDecl.version = version;
                    // This is the test specified by XML 1.0 but it is fine for XML 1.1.
                    if (!/^1\.[0-9]+$/.test(version)) this.fail("version number must match /^1\\.[0-9]+$/.");
                    else if (!this.opt.forceXMLVersion) this.setXMLVersion(version);
                    break;
                }
            case "encoding":
                if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) this.fail("encoding value must match /^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
                this.xmlDeclExpects = [
                    "standalone"
                ];
                this.xmlDecl.encoding = value;
                break;
            case "standalone":
                if (value !== "yes" && value !== "no") this.fail('standalone value must match "yes" or "no".');
                this.xmlDeclExpects = [];
                this.xmlDecl.standalone = value;
                break;
            default:
        }
        this.name = "";
        this.state = $92093278557b2366$var$S_XML_DECL_SEPARATOR;
    }
    sXMLDeclSeparator() {
        const c = this.getCodeNorm();
        // The question mark character is not valid inside any of the XML
        // declaration name/value pairs.
        if (c === $92093278557b2366$var$QUESTION) {
            // It is valid to go to S_XML_DECL_ENDING from this state.
            this.state = $92093278557b2366$var$S_XML_DECL_ENDING;
            return;
        }
        if (!$92093278557b2366$var$isS(c)) {
            this.fail("whitespace required.");
            this.unget();
        }
        this.state = $92093278557b2366$var$S_XML_DECL_NAME_START;
    }
    sXMLDeclEnding() {
        var _a;
        const c = this.getCodeNorm();
        if (c === $92093278557b2366$var$GREATER) {
            if (this.piTarget !== "xml") this.fail("processing instructions are not allowed before root.");
            else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) this.fail("XML declaration must contain a version.");
            (_a = this.xmldeclHandler) === null || _a === void 0 || _a.call(this, this.xmlDecl);
            this.name = "";
            this.piTarget = this.text = "";
            this.state = $92093278557b2366$var$S_TEXT;
        } else // We got here because the previous character was a ?, but the question
        // mark character is not valid inside any of the XML declaration
        // name/value pairs.
        this.fail("The character ? is disallowed anywhere in XML declarations.");
        this.xmlDeclPossible = false;
    }
    sOpenTag() {
        var _a;
        const c = this.captureNameChars();
        if (c === $92093278557b2366$var$EOC) return;
        const tag = this.tag = {
            name: this.name,
            attributes: Object.create(null)
        };
        this.name = "";
        if (this.xmlnsOpt) this.topNS = tag.ns = Object.create(null);
        (_a = this.openTagStartHandler) === null || _a === void 0 || _a.call(this, tag);
        this.sawRoot = true;
        if (!this.fragmentOpt && this.closedRoot) this.fail("documents may contain only one root.");
        switch(c){
            case $92093278557b2366$var$GREATER:
                this.openTag();
                break;
            case $92093278557b2366$var$FORWARD_SLASH:
                this.state = $92093278557b2366$var$S_OPEN_TAG_SLASH;
                break;
            default:
                if (!$92093278557b2366$var$isS(c)) this.fail("disallowed character in tag name.");
                this.state = $92093278557b2366$var$S_ATTRIB;
        }
    }
    sOpenTagSlash() {
        if (this.getCode() === $92093278557b2366$var$GREATER) this.openSelfClosingTag();
        else {
            this.fail("forward-slash in opening tag not followed by >.");
            this.state = $92093278557b2366$var$S_ATTRIB;
        }
    }
    sAttrib() {
        const c = this.skipSpaces();
        if (c === $92093278557b2366$var$EOC) return;
        if ($92093278557b2366$var$isNameStartChar(c)) {
            this.unget();
            this.state = $92093278557b2366$var$S_ATTRIB_NAME;
        } else if (c === $92093278557b2366$var$GREATER) this.openTag();
        else if (c === $92093278557b2366$var$FORWARD_SLASH) this.state = $92093278557b2366$var$S_OPEN_TAG_SLASH;
        else this.fail("disallowed character in attribute name.");
    }
    sAttribName() {
        const c = this.captureNameChars();
        if (c === $92093278557b2366$var$EQUAL) this.state = $92093278557b2366$var$S_ATTRIB_VALUE;
        else if ($92093278557b2366$var$isS(c)) this.state = $92093278557b2366$var$S_ATTRIB_NAME_SAW_WHITE;
        else if (c === $92093278557b2366$var$GREATER) {
            this.fail("attribute without value.");
            this.pushAttrib(this.name, this.name);
            this.name = this.text = "";
            this.openTag();
        } else if (c !== $92093278557b2366$var$EOC) this.fail("disallowed character in attribute name.");
    }
    sAttribNameSawWhite() {
        const c = this.skipSpaces();
        switch(c){
            case $92093278557b2366$var$EOC:
                return;
            case $92093278557b2366$var$EQUAL:
                this.state = $92093278557b2366$var$S_ATTRIB_VALUE;
                break;
            default:
                this.fail("attribute without value.");
                // Should we do this???
                // this.tag.attributes[this.name] = "";
                this.text = "";
                this.name = "";
                if (c === $92093278557b2366$var$GREATER) this.openTag();
                else if ($92093278557b2366$var$isNameStartChar(c)) {
                    this.unget();
                    this.state = $92093278557b2366$var$S_ATTRIB_NAME;
                } else {
                    this.fail("disallowed character in attribute name.");
                    this.state = $92093278557b2366$var$S_ATTRIB;
                }
        }
    }
    sAttribValue() {
        const c = this.getCodeNorm();
        if ($92093278557b2366$var$isQuote(c)) {
            this.q = c;
            this.state = $92093278557b2366$var$S_ATTRIB_VALUE_QUOTED;
        } else if (!$92093278557b2366$var$isS(c)) {
            this.fail("unquoted attribute value.");
            this.state = $92093278557b2366$var$S_ATTRIB_VALUE_UNQUOTED;
            this.unget();
        }
    }
    sAttribValueQuoted() {
        // We deliberately do not use captureTo here. The specialized code we use
        // here is faster than using captureTo.
        const { q: q, chunk: chunk } = this;
        let { i: start } = this;
        // eslint-disable-next-line no-constant-condition
        while(true)switch(this.getCode()){
            case q:
                this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
                this.name = this.text = "";
                this.q = null;
                this.state = $92093278557b2366$var$S_ATTRIB_VALUE_CLOSED;
                return;
            case $92093278557b2366$var$AMP:
                this.text += chunk.slice(start, this.prevI);
                this.state = $92093278557b2366$var$S_ENTITY;
                this.entityReturnState = $92093278557b2366$var$S_ATTRIB_VALUE_QUOTED;
                return;
            case $92093278557b2366$var$NL:
            case $92093278557b2366$var$NL_LIKE:
            case $92093278557b2366$var$TAB:
                this.text += `${chunk.slice(start, this.prevI)} `;
                start = this.i;
                break;
            case $92093278557b2366$var$LESS:
                this.text += chunk.slice(start, this.prevI);
                this.fail("disallowed character.");
                return;
            case $92093278557b2366$var$EOC:
                this.text += chunk.slice(start);
                return;
            default:
        }
    }
    sAttribValueClosed() {
        const c = this.getCodeNorm();
        if ($92093278557b2366$var$isS(c)) this.state = $92093278557b2366$var$S_ATTRIB;
        else if (c === $92093278557b2366$var$GREATER) this.openTag();
        else if (c === $92093278557b2366$var$FORWARD_SLASH) this.state = $92093278557b2366$var$S_OPEN_TAG_SLASH;
        else if ($92093278557b2366$var$isNameStartChar(c)) {
            this.fail("no whitespace between attributes.");
            this.unget();
            this.state = $92093278557b2366$var$S_ATTRIB_NAME;
        } else this.fail("disallowed character in attribute name.");
    }
    sAttribValueUnquoted() {
        // We don't do anything regarding EOL or space handling for unquoted
        // attributes. We already have failed by the time we get here, and the
        // contract that saxes upholds states that upon failure, it is not safe to
        // rely on the data passed to event handlers (other than
        // ``onerror``). Passing "bad" data is not a problem.
        const c = this.captureTo($92093278557b2366$var$ATTRIB_VALUE_UNQUOTED_TERMINATOR);
        switch(c){
            case $92093278557b2366$var$AMP:
                this.state = $92093278557b2366$var$S_ENTITY;
                this.entityReturnState = $92093278557b2366$var$S_ATTRIB_VALUE_UNQUOTED;
                break;
            case $92093278557b2366$var$LESS:
                this.fail("disallowed character.");
                break;
            case $92093278557b2366$var$EOC:
                break;
            default:
                if (this.text.includes("]]>")) this.fail('the string "]]>" is disallowed in char data.');
                this.pushAttrib(this.name, this.text);
                this.name = this.text = "";
                if (c === $92093278557b2366$var$GREATER) this.openTag();
                else this.state = $92093278557b2366$var$S_ATTRIB;
        }
    }
    sCloseTag() {
        const c = this.captureNameChars();
        if (c === $92093278557b2366$var$GREATER) this.closeTag();
        else if ($92093278557b2366$var$isS(c)) this.state = $92093278557b2366$var$S_CLOSE_TAG_SAW_WHITE;
        else if (c !== $92093278557b2366$var$EOC) this.fail("disallowed character in closing tag.");
    }
    sCloseTagSawWhite() {
        switch(this.skipSpaces()){
            case $92093278557b2366$var$GREATER:
                this.closeTag();
                break;
            case $92093278557b2366$var$EOC:
                break;
            default:
                this.fail("disallowed character in closing tag.");
        }
    }
    // END OF STATE ENGINE METHODS
    handleTextInRoot() {
        // This is essentially a specialized version of captureTo which is optimized
        // for performing the ]]> check. A previous version of this code, checked
        // ``this.text`` for the presence of ]]>. It simplified the code but was
        // very costly when character data contained a lot of entities to be parsed.
        //
        // Since we are using a specialized loop, we also keep track of the presence
        // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
        //
        let { i: start, forbiddenState: forbiddenState } = this;
        const { chunk: chunk, textHandler: handler } = this;
        // eslint-disable-next-line no-labels, no-restricted-syntax
        scanLoop: // eslint-disable-next-line no-constant-condition
        while(true)switch(this.getCode()){
            case $92093278557b2366$var$LESS:
                this.state = $92093278557b2366$var$S_OPEN_WAKA;
                if (handler !== undefined) {
                    const { text: text } = this;
                    const slice = chunk.slice(start, this.prevI);
                    if (text.length !== 0) {
                        handler(text + slice);
                        this.text = "";
                    } else if (slice.length !== 0) handler(slice);
                }
                forbiddenState = $92093278557b2366$var$FORBIDDEN_START;
                break scanLoop;
            case $92093278557b2366$var$AMP:
                this.state = $92093278557b2366$var$S_ENTITY;
                this.entityReturnState = $92093278557b2366$var$S_TEXT;
                if (handler !== undefined) this.text += chunk.slice(start, this.prevI);
                forbiddenState = $92093278557b2366$var$FORBIDDEN_START;
                break scanLoop;
            case $92093278557b2366$var$CLOSE_BRACKET:
                switch(forbiddenState){
                    case $92093278557b2366$var$FORBIDDEN_START:
                        forbiddenState = $92093278557b2366$var$FORBIDDEN_BRACKET;
                        break;
                    case $92093278557b2366$var$FORBIDDEN_BRACKET:
                        forbiddenState = $92093278557b2366$var$FORBIDDEN_BRACKET_BRACKET;
                        break;
                    case $92093278557b2366$var$FORBIDDEN_BRACKET_BRACKET:
                        break;
                    default:
                        throw new Error("impossible state");
                }
                break;
            case $92093278557b2366$var$GREATER:
                if (forbiddenState === $92093278557b2366$var$FORBIDDEN_BRACKET_BRACKET) this.fail('the string "]]>" is disallowed in char data.');
                forbiddenState = $92093278557b2366$var$FORBIDDEN_START;
                break;
            case $92093278557b2366$var$NL_LIKE:
                if (handler !== undefined) this.text += `${chunk.slice(start, this.prevI)}\n`;
                start = this.i;
                forbiddenState = $92093278557b2366$var$FORBIDDEN_START;
                break;
            case $92093278557b2366$var$EOC:
                if (handler !== undefined) this.text += chunk.slice(start);
                break scanLoop;
            default:
                forbiddenState = $92093278557b2366$var$FORBIDDEN_START;
        }
        this.forbiddenState = forbiddenState;
    }
    handleTextOutsideRoot() {
        // This is essentially a specialized version of captureTo which is optimized
        // for a specialized task. We keep track of the presence of non-space
        // characters in the text since these are errors when appearing outside the
        // document root element.
        let { i: start } = this;
        const { chunk: chunk, textHandler: handler } = this;
        let nonSpace = false;
        // eslint-disable-next-line no-labels, no-restricted-syntax
        outRootLoop: // eslint-disable-next-line no-constant-condition
        while(true){
            const code = this.getCode();
            switch(code){
                case $92093278557b2366$var$LESS:
                    this.state = $92093278557b2366$var$S_OPEN_WAKA;
                    if (handler !== undefined) {
                        const { text: text } = this;
                        const slice = chunk.slice(start, this.prevI);
                        if (text.length !== 0) {
                            handler(text + slice);
                            this.text = "";
                        } else if (slice.length !== 0) handler(slice);
                    }
                    break outRootLoop;
                case $92093278557b2366$var$AMP:
                    this.state = $92093278557b2366$var$S_ENTITY;
                    this.entityReturnState = $92093278557b2366$var$S_TEXT;
                    if (handler !== undefined) this.text += chunk.slice(start, this.prevI);
                    nonSpace = true;
                    break outRootLoop;
                case $92093278557b2366$var$NL_LIKE:
                    if (handler !== undefined) this.text += `${chunk.slice(start, this.prevI)}\n`;
                    start = this.i;
                    break;
                case $92093278557b2366$var$EOC:
                    if (handler !== undefined) this.text += chunk.slice(start);
                    break outRootLoop;
                default:
                    if (!$92093278557b2366$var$isS(code)) nonSpace = true;
            }
        }
        if (!nonSpace) return;
        // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
        // to avoid reporting errors for every single character that is out of
        // place.
        if (!this.sawRoot && !this.reportedTextBeforeRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextBeforeRoot = true;
        }
        if (this.closedRoot && !this.reportedTextAfterRoot) {
            this.fail("text data outside of root node.");
            this.reportedTextAfterRoot = true;
        }
    }
    pushAttribNS(name, value) {
        var _a;
        const { prefix: prefix, local: local } = this.qname(name);
        const attr = {
            name: name,
            prefix: prefix,
            local: local,
            value: value
        };
        this.attribList.push(attr);
        (_a = this.attributeHandler) === null || _a === void 0 || _a.call(this, attr);
        if (prefix === "xmlns") {
            const trimmed = value.trim();
            if (this.currentXMLVersion === "1.0" && trimmed === "") this.fail("invalid attempt to undefine prefix in XML 1.0");
            this.topNS[local] = trimmed;
            $92093278557b2366$var$nsPairCheck(this, local, trimmed);
        } else if (name === "xmlns") {
            const trimmed = value.trim();
            this.topNS[""] = trimmed;
            $92093278557b2366$var$nsPairCheck(this, "", trimmed);
        }
    }
    pushAttribPlain(name, value) {
        var _a;
        const attr = {
            name: name,
            value: value
        };
        this.attribList.push(attr);
        (_a = this.attributeHandler) === null || _a === void 0 || _a.call(this, attr);
    }
    /**
     * End parsing. This performs final well-formedness checks and resets the
     * parser to a clean state.
     *
     * @returns this
     */ end() {
        var _a, _b;
        if (!this.sawRoot) this.fail("document must contain a root element.");
        const { tags: tags } = this;
        while(tags.length > 0){
            const tag = tags.pop();
            this.fail(`unclosed tag: ${tag.name}`);
        }
        if (this.state !== $92093278557b2366$var$S_BEGIN && this.state !== $92093278557b2366$var$S_TEXT) this.fail("unexpected end.");
        const { text: text } = this;
        if (text.length !== 0) {
            (_a = this.textHandler) === null || _a === void 0 || _a.call(this, text);
            this.text = "";
        }
        this._closed = true;
        (_b = this.endHandler) === null || _b === void 0 || _b.call(this);
        this._init();
        return this;
    }
    /**
     * Resolve a namespace prefix.
     *
     * @param prefix The prefix to resolve.
     *
     * @returns The namespace URI or ``undefined`` if the prefix is not defined.
     */ resolve(prefix) {
        var _a, _b;
        let uri = this.topNS[prefix];
        if (uri !== undefined) return uri;
        const { tags: tags } = this;
        for(let index = tags.length - 1; index >= 0; index--){
            uri = tags[index].ns[prefix];
            if (uri !== undefined) return uri;
        }
        uri = this.ns[prefix];
        if (uri !== undefined) return uri;
        return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
    }
    /**
     * Parse a qname into its prefix and local name parts.
     *
     * @param name The name to parse
     *
     * @returns
     */ qname(name) {
        // This is faster than using name.split(":").
        const colon = name.indexOf(":");
        if (colon === -1) return {
            prefix: "",
            local: name
        };
        const local = name.slice(colon + 1);
        const prefix = name.slice(0, colon);
        if (prefix === "" || local === "" || local.includes(":")) this.fail(`malformed name: ${name}.`);
        return {
            prefix: prefix,
            local: local
        };
    }
    processAttribsNS() {
        var _a;
        const { attribList: attribList } = this;
        const tag = this.tag;
        {
            // add namespace info to tag
            const { prefix: prefix, local: local } = this.qname(tag.name);
            tag.prefix = prefix;
            tag.local = local;
            const uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
            if (prefix !== "") {
                if (prefix === "xmlns") this.fail('tags may not have "xmlns" as prefix.');
                if (uri === "") {
                    this.fail(`unbound namespace prefix: ${JSON.stringify(prefix)}.`);
                    tag.uri = prefix;
                }
            }
        }
        if (attribList.length === 0) return;
        const { attributes: attributes } = tag;
        const seen = new Set();
        // Note: do not apply default ns to attributes:
        //   http://www.w3.org/TR/REC-xml-names/#defaulting
        for (const attr of attribList){
            const { name: name, prefix: prefix, local: local } = attr;
            let uri;
            let eqname;
            if (prefix === "") {
                uri = name === "xmlns" ? $92093278557b2366$var$XMLNS_NAMESPACE : "";
                eqname = name;
            } else {
                uri = this.resolve(prefix);
                // if there's any attributes with an undefined namespace,
                // then fail on them now.
                if (uri === undefined) {
                    this.fail(`unbound namespace prefix: ${JSON.stringify(prefix)}.`);
                    uri = prefix;
                }
                eqname = `{${uri}}${local}`;
            }
            if (seen.has(eqname)) this.fail(`duplicate attribute: ${eqname}.`);
            seen.add(eqname);
            attr.uri = uri;
            attributes[name] = attr;
        }
        this.attribList = [];
    }
    processAttribsPlain() {
        const { attribList: attribList } = this;
        // eslint-disable-next-line prefer-destructuring
        const attributes = this.tag.attributes;
        for (const { name: name, value: value } of attribList){
            if (attributes[name] !== undefined) this.fail(`duplicate attribute: ${name}.`);
            attributes[name] = value;
        }
        this.attribList = [];
    }
    /**
     * Handle a complete open tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onopentag``.
     */ openTag() {
        var _a;
        this.processAttribs();
        const { tags: tags } = this;
        const tag = this.tag;
        tag.isSelfClosing = false;
        // There cannot be any pending text here due to the onopentagstart that was
        // necessarily emitted before we get here. So we do not check text.
        (_a = this.openTagHandler) === null || _a === void 0 || _a.call(this, tag);
        tags.push(tag);
        this.state = $92093278557b2366$var$S_TEXT;
        this.name = "";
    }
    /**
     * Handle a complete self-closing tag. This parser code calls this once it has
     * seen the whole tag. This method checks for well-formeness and then emits
     * ``onopentag`` and ``onclosetag``.
     */ openSelfClosingTag() {
        var _a, _b, _c;
        this.processAttribs();
        const { tags: tags } = this;
        const tag = this.tag;
        tag.isSelfClosing = true;
        // There cannot be any pending text here due to the onopentagstart that was
        // necessarily emitted before we get here. So we do not check text.
        (_a = this.openTagHandler) === null || _a === void 0 || _a.call(this, tag);
        (_b = this.closeTagHandler) === null || _b === void 0 || _b.call(this, tag);
        const top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
        if (top === null) this.closedRoot = true;
        this.state = $92093278557b2366$var$S_TEXT;
        this.name = "";
    }
    /**
     * Handle a complete close tag. This parser code calls this once it has seen
     * the whole tag. This method checks for well-formeness and then emits
     * ``onclosetag``.
     */ closeTag() {
        const { tags: tags, name: name } = this;
        // Our state after this will be S_TEXT, no matter what, and we can clear
        // tagName now.
        this.state = $92093278557b2366$var$S_TEXT;
        this.name = "";
        if (name === "") {
            this.fail("weird empty close tag.");
            this.text += "</>";
            return;
        }
        const handler = this.closeTagHandler;
        let l = tags.length;
        while(l-- > 0){
            const tag = this.tag = tags.pop();
            this.topNS = tag.ns;
            handler === null || handler === void 0 || handler(tag);
            if (tag.name === name) break;
            this.fail("unexpected close tag.");
        }
        if (l === 0) this.closedRoot = true;
        else if (l < 0) {
            this.fail(`unmatched closing tag: ${name}.`);
            this.text += `</${name}>`;
        }
    }
    /**
     * Resolves an entity. Makes any necessary well-formedness checks.
     *
     * @param entity The entity to resolve.
     *
     * @returns The parsed entity.
     */ parseEntity(entity) {
        // startsWith would be significantly slower for this test.
        if (entity[0] !== "#") {
            const defined = this.ENTITIES[entity];
            if (defined !== undefined) return defined;
            this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
            return `&${entity};`;
        }
        let num = NaN;
        if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) num = parseInt(entity.slice(2), 16);
        else if (/^#[0-9]+$/.test(entity)) num = parseInt(entity.slice(1), 10);
        // The character reference is required to match the CHAR production.
        if (!this.isChar(num)) {
            this.fail("malformed character entity.");
            return `&${entity};`;
        }
        return String.fromCodePoint(num);
    }
}
module.exports.SaxesParser = $92093278557b2366$var$SaxesParser;

});
parcelRegister("2sP1M", function(module, exports) {
"use strict";
/**
 * Character classes and associated utilities for the 5th edition of XML 1.0.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
module.exports.CHAR = "	\n\r -\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
module.exports.S = " 	\r\n";
// tslint:disable-next-line:max-line-length
module.exports.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NAME_CHAR = "-" + module.exports.NAME_START_CHAR + ".0-9\xb7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.CHAR_RE = new RegExp("^[" + module.exports.CHAR + "]$", "u");
module.exports.S_RE = new RegExp("^[" + module.exports.S + "]+$", "u");
module.exports.NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "]$", "u");
module.exports.NAME_CHAR_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]$", "u");
module.exports.NAME_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "][" + module.exports.NAME_CHAR + "]*$", "u");
module.exports.NMTOKEN_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]+$", "u");
var $1cb5c7505cbb9e57$var$TAB = 9;
var $1cb5c7505cbb9e57$var$NL = 0xA;
var $1cb5c7505cbb9e57$var$CR = 0xD;
var $1cb5c7505cbb9e57$var$SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */ module.exports.S_LIST = [
    $1cb5c7505cbb9e57$var$SPACE,
    $1cb5c7505cbb9e57$var$NL,
    $1cb5c7505cbb9e57$var$CR,
    $1cb5c7505cbb9e57$var$TAB
];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */ function $1cb5c7505cbb9e57$var$isChar(c) {
    return c >= $1cb5c7505cbb9e57$var$SPACE && c <= 0xD7FF || c === $1cb5c7505cbb9e57$var$NL || c === $1cb5c7505cbb9e57$var$CR || c === $1cb5c7505cbb9e57$var$TAB || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isChar = $1cb5c7505cbb9e57$var$isChar;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */ function $1cb5c7505cbb9e57$var$isS(c) {
    return c === $1cb5c7505cbb9e57$var$SPACE || c === $1cb5c7505cbb9e57$var$NL || c === $1cb5c7505cbb9e57$var$CR || c === $1cb5c7505cbb9e57$var$TAB;
}
module.exports.isS = $1cb5c7505cbb9e57$var$isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */ function $1cb5c7505cbb9e57$var$isNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNameStartChar = $1cb5c7505cbb9e57$var$isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */ function $1cb5c7505cbb9e57$var$isNameChar(c) {
    return $1cb5c7505cbb9e57$var$isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNameChar = $1cb5c7505cbb9e57$var$isNameChar;

});

parcelRegister("idmti", function(module, exports) {
"use strict";
/**
 * Character classes and associated utilities for the 2nd edition of XML 1.1.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
module.exports.CHAR = "\x01-\uD7FF\uE000-\uFFFD\uD800\uDC00-\uDBFF\uDFFF";
module.exports.RESTRICTED_CHAR = "\x01-\b\v\f\x0e-\x1f\x7f-\x84\x86-\x9f";
module.exports.S = " 	\r\n";
// tslint:disable-next-line:max-line-length
module.exports.NAME_START_CHAR = ":A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NAME_CHAR = "-" + module.exports.NAME_START_CHAR + ".0-9\xb7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.CHAR_RE = new RegExp("^[" + module.exports.CHAR + "]$", "u");
module.exports.RESTRICTED_CHAR_RE = new RegExp("^[" + module.exports.RESTRICTED_CHAR + "]$", "u");
module.exports.S_RE = new RegExp("^[" + module.exports.S + "]+$", "u");
module.exports.NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "]$", "u");
module.exports.NAME_CHAR_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]$", "u");
module.exports.NAME_RE = new RegExp("^[" + module.exports.NAME_START_CHAR + "][" + module.exports.NAME_CHAR + "]*$", "u");
module.exports.NMTOKEN_RE = new RegExp("^[" + module.exports.NAME_CHAR + "]+$", "u");
var $d42adf461ee3ac4d$var$TAB = 9;
var $d42adf461ee3ac4d$var$NL = 0xA;
var $d42adf461ee3ac4d$var$CR = 0xD;
var $d42adf461ee3ac4d$var$SPACE = 0x20;
//
// Lists.
//
/** All characters in the ``S`` production. */ module.exports.S_LIST = [
    $d42adf461ee3ac4d$var$SPACE,
    $d42adf461ee3ac4d$var$NL,
    $d42adf461ee3ac4d$var$CR,
    $d42adf461ee3ac4d$var$TAB
];
/**
 * Determines whether a codepoint matches the ``CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR``.
 */ function $d42adf461ee3ac4d$var$isChar(c) {
    return c >= 0x0001 && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isChar = $d42adf461ee3ac4d$var$isChar;
/**
 * Determines whether a codepoint matches the ``RESTRICTED_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``RESTRICTED_CHAR``.
 */ function $d42adf461ee3ac4d$var$isRestrictedChar(c) {
    return c >= 0x1 && c <= 0x8 || c === 0xB || c === 0xC || c >= 0xE && c <= 0x1F || c >= 0x7F && c <= 0x84 || c >= 0x86 && c <= 0x9F;
}
module.exports.isRestrictedChar = $d42adf461ee3ac4d$var$isRestrictedChar;
/**
 * Determines whether a codepoint matches the ``CHAR`` production and does not
 * match the ``RESTRICTED_CHAR`` production. ``isCharAndNotRestricted(x)`` is
 * equivalent to ``isChar(x) && !isRestrictedChar(x)``. This function is faster
 * than running the two-call equivalent.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``CHAR`` and does not match
 * ``RESTRICTED_CHAR``.
 */ function $d42adf461ee3ac4d$var$isCharAndNotRestricted(c) {
    return c === 0x9 || c === 0xA || c === 0xD || c > 0x1F && c < 0x7F || c === 0x85 || c > 0x9F && c <= 0xD7FF || c >= 0xE000 && c <= 0xFFFD || c >= 0x10000 && c <= 0x10FFFF;
}
module.exports.isCharAndNotRestricted = $d42adf461ee3ac4d$var$isCharAndNotRestricted;
/**
 * Determines whether a codepoint matches the ``S`` (space) production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``S``.
 */ function $d42adf461ee3ac4d$var$isS(c) {
    return c === $d42adf461ee3ac4d$var$SPACE || c === $d42adf461ee3ac4d$var$NL || c === $d42adf461ee3ac4d$var$CR || c === $d42adf461ee3ac4d$var$TAB;
}
module.exports.isS = $d42adf461ee3ac4d$var$isS;
/**
 * Determines whether a codepoint matches the ``NAME_START_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_START_CHAR``.
 */ // tslint:disable-next-line:cyclomatic-complexity
function $d42adf461ee3ac4d$var$isNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c >= 0x61 && c <= 0x7A || c === 0x3A || c === 0x5F || c === 0x200C || c === 0x200D || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNameStartChar = $d42adf461ee3ac4d$var$isNameStartChar;
/**
 * Determines whether a codepoint matches the ``NAME_CHAR`` production.
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches ``NAME_CHAR``.
 */ function $d42adf461ee3ac4d$var$isNameChar(c) {
    return $d42adf461ee3ac4d$var$isNameStartChar(c) || c >= 0x30 && c <= 0x39 || c === 0x2D || c === 0x2E || c === 0xB7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNameChar = $d42adf461ee3ac4d$var$isNameChar;

});

parcelRegister("2KyNd", function(module, exports) {
"use strict";
/**
 * Character class utilities for XML NS 1.0 edition 3.
 *
 * @author Louis-Dominique Dubeau
 * @license MIT
 * @copyright Louis-Dominique Dubeau
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
//
// Fragments.
//
// tslint:disable-next-line:max-line-length
module.exports.NC_NAME_START_CHAR = "A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\uD800\uDC00-\uDB7F\uDFFF";
module.exports.NC_NAME_CHAR = "-" + module.exports.NC_NAME_START_CHAR + ".0-9\xb7\u0300-\u036F\u203F-\u2040";
//
// Regular expressions.
//
module.exports.NC_NAME_START_CHAR_RE = new RegExp("^[" + module.exports.NC_NAME_START_CHAR + "]$", "u");
module.exports.NC_NAME_CHAR_RE = new RegExp("^[" + module.exports.NC_NAME_CHAR + "]$", "u");
module.exports.NC_NAME_RE = new RegExp("^[" + module.exports.NC_NAME_START_CHAR + "][" + module.exports.NC_NAME_CHAR + "]*$", "u");
/**
 * Determines whether a codepoint matches [[NC_NAME_START_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */ // tslint:disable-next-line:cyclomatic-complexity
function $200addc5f46471df$var$isNCNameStartChar(c) {
    return c >= 0x41 && c <= 0x5A || c === 0x5F || c >= 0x61 && c <= 0x7A || c >= 0xC0 && c <= 0xD6 || c >= 0xD8 && c <= 0xF6 || c >= 0x00F8 && c <= 0x02FF || c >= 0x0370 && c <= 0x037D || c >= 0x037F && c <= 0x1FFF || c >= 0x200C && c <= 0x200D || c >= 0x2070 && c <= 0x218F || c >= 0x2C00 && c <= 0x2FEF || c >= 0x3001 && c <= 0xD7FF || c >= 0xF900 && c <= 0xFDCF || c >= 0xFDF0 && c <= 0xFFFD || c >= 0x10000 && c <= 0xEFFFF;
}
module.exports.isNCNameStartChar = $200addc5f46471df$var$isNCNameStartChar;
/**
 * Determines whether a codepoint matches [[NC_NAME_CHAR]].
 *
 * @param c The code point.
 *
 * @returns ``true`` if the codepoint matches.
 */ function $200addc5f46471df$var$isNCNameChar(c) {
    return $200addc5f46471df$var$isNCNameStartChar(c) || c === 0x2D || c === 0x2E || c >= 0x30 && c <= 0x39 || c === 0x00B7 || c >= 0x0300 && c <= 0x036F || c >= 0x203F && c <= 0x2040;
}
module.exports.isNCNameChar = $200addc5f46471df$var$isNCNameChar;

});


parcelRegister("1LZFg", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createNode = $14aa03831bf62d06$var$createNode;
module.exports.createCDataSectionNode = $14aa03831bf62d06$var$createCDataSectionNode;

var $57yyk = parcelRequire("57yyk");

var $57yyk = parcelRequire("57yyk");

var $57yyk = parcelRequire("57yyk");
function $14aa03831bf62d06$var$createNode(node) {
    let nodeObject;
    /**
     * @example
     * `node`is an object containing the node name, its attributes, and their values.
     * ```json
     * {
     *   name: 'topic',
     *   attributes: [Object: null prototype] {},
     *   ns: [Object: null prototype] {},
     *   prefix: '',
     *   local: 'topic',
     *   uri: '',
     *   isSelfClosing: false
     * }
     * ```
     * If the node is a text node, it will simply contain its string content.
     */ if (typeof node === "string") nodeObject = new $57yyk.TextNode(node);
    else {
        const classType = (0, $57yyk.getNodeClass)(node.name);
        return new classType(node.attributes);
    }
    return nodeObject;
}
function $14aa03831bf62d06$var$createCDataSectionNode(cdata) {
    return new $57yyk.CDataNode(cdata);
}

});

parcelRegister("16ZiD", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemoryTextSimpleOutputStreamCollector = void 0;
/**
 * An implementation of a TextSimpleOutputStream that just collects
 * all of the items into an in-memory buffer.
 *
 * The string items are appended to an in-memory buffer
 * until the stream is closed. The content of the buffer
 * can be retrieved by calling `getText()`.
 */ class $0cf5e6cdddea341b$var$InMemoryTextSimpleOutputStreamCollector {
    constructor(){
        this.buffer = "";
        this.closed = false;
    }
    emit(item) {
        if (!this.closed) this.buffer += item;
    }
    close() {
        this.closed = true;
    }
    isClosed() {
        return this.closed;
    }
    /**
     * Get the content of the in-memory buffer.
     *
     * @returns the content of the in-memory buffer.
     */ getText() {
        return this.buffer;
    }
}
module.exports.InMemoryTextSimpleOutputStreamCollector = $0cf5e6cdddea341b$var$InMemoryTextSimpleOutputStreamCollector;

});

parcelRegister("sgwDg", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XditaSerializer = void 0;

var $57yyk = parcelRequire("57yyk");
/**
 * Serializer for XDITA.
 * Takes an AST and serializes it to XDITA.
 */ class $054f6f39ab609589$var$XditaSerializer {
    /**
     * Constructor
     *
     * @param outputStream - The output stream.
     * @param indent - enable indentation
     * @param indentation - the character (or string) to use as the indent
     * @param tabSize - size of the tab, only used when the `indentation` is not a `\t` character.
     */ constructor(outputStream, indent = false, indentation = " ", tabSize = 4){
        this.depth = 0;
        this.outputStream = outputStream;
        this.indent = indent;
        this.tabSize = tabSize;
        this.indentation = indentation;
        if (indentation === "	") this.tabSize = 1;
        this.EOL = "\n";
    }
    // Temporary fix for the serializer of images and fallback nodes see:
    // https://evolvedbinaryltd.kanbanize.com/ctrl_board/16/cards/3516/details/
    serializeMixedContent(node) {
        //This is a temporary solution REMOVE the alt node as it's not mixed content
        // by YB, signed-off by AR.
        const alt = new $57yyk.AltNode();
        return node.allowsMixedContent() || node.canAddNode(alt);
    }
    /**
     * Emit the indentation to the output stream
     *
     * @param node - the node to check if indentation can be added
     */ serializeIndentation(node) {
        if (!this.indent || !node) return;
        if (this.serializeMixedContent(node)) return;
        this.outputStream.emit(this.indentation.repeat(this.depth * this.tabSize));
    }
    /**
     * Emit the End of Line (EOL) character to the output stream
     *
     * @param node - the node to check if EOL can be added
     */ serializeEOL(node) {
        if (!this.indent || !node) return;
        if (this.serializeMixedContent(node)) return;
        this.outputStream.emit(this.EOL);
    }
    /**
     * Serialize a document node to the output stream.
     *
     * @param node - the document node to serialize
     */ serializeDocument(node) {
        var _a, _b;
        // emit the XML declaration and doctype declaration
        const xmlDeclaration = `<?xml version="${((_a = node.xmlDecl) === null || _a === void 0 ? void 0 : _a.version) || "1.0"}" encoding="${((_b = node.xmlDecl) === null || _b === void 0 ? void 0 : _b.encoding) || "UTF-8"}"?>`;
        const docTypeDeclaration = `<!DOCTYPE${node.doctype || ' topic PUBLIC "-//OASIS//DTD LIGHTWEIGHT DITA Topic//EN" "lw-topic.dtd"'}>`;
        this.outputStream.emit(xmlDeclaration);
        this.outputStream.emit(this.EOL);
        this.outputStream.emit(docTypeDeclaration);
        this.outputStream.emit(this.EOL);
        // a document node has no string representation, so move on to its children
        node.children.forEach((child)=>this.serialize(child, node));
    }
    /**
     * Serialize an element node to the output stream.
     *
     * @param node - the element node to serialize
     */ serializeElement(node) {
        var _a;
        // serialize the start of the element start tag
        this.outputStream.emit(`<${node.static.nodeName}`);
        // serialize the attributes
        this.serializeAttributes(node);
        if ((_a = node.children) === null || _a === void 0 ? void 0 : _a.length) {
            // as the element has children or attributes, serialize the remainder of the element start tag
            this.outputStream.emit(`>`);
            this.serializeEOL(node);
            // increment the depth after starting an element
            this.depth++;
            // visit the element's children
            node.children.forEach((child)=>this.serialize(child, node));
            // decrement the depth after serializing the elements children
            this.depth--;
            this.serializeIndentation(node);
            this.outputStream.emit(`</${node.static.nodeName}>`);
        } else // element has no attributes or children, so the remainder of the element start tag as a self-closing element
        this.outputStream.emit(`/>`);
    }
    /**
     * Serialize the attributes to the output stream
     *
     * @param node - the node to serialize the attributes of
     */ serializeAttributes(node) {
        let attrsStr = "";
        const props = node.getProps();
        if (props) {
            const attr = props;
            attrsStr = Object.keys(props).filter((key)=>attr[key]).map((key)=>`${key}="${attr[key]}"`).join(" ");
        }
        if (attrsStr.length) attrsStr = ` ${attrsStr}`;
        this.outputStream.emit(attrsStr);
    }
    /**
     * Serialize the text content of the text node to the output stream
     *
     * @param node - the text node to serialize the content of
     */ serializeText(node) {
        const props = node.getProps();
        if (props["content"]) this.outputStream.emit(String(props["content"]));
    }
    /**
     * Serialize the content of cdata to the output stream
     *
     * @param node - the node to serialize the content of
     */ serializeCData(node) {
        const props = node.getProps();
        if (props["content"]) {
            const cdataOpen = `<![CDATA[`;
            const cdataClose = `]]>`;
            this.outputStream.emit(cdataOpen + String(props["content"]) + cdataClose);
        }
    }
    /**
     * Visit a node and serialize it to the output stream
     *
     * @param node - the node to serialize
     * @param parent - the parent node of the node being serialized
     */ serialize(node, parent) {
        if (node instanceof $57yyk.DocumentNode) {
            this.serializeDocument(node);
            // close the output stream as we have now serialized the document
            this.outputStream.close();
        } else {
            // serialize any indentation
            this.serializeIndentation(parent);
            if (node instanceof $57yyk.TextNode) // if the node is a text node, serialize its text content
            this.serializeText(node);
            else if (node instanceof $57yyk.CDataNode) // if the node is a text node, serialize its text content
            this.serializeCData(node);
            else // TODO(AR) ideally we should have `node instanceof ElementNode` type guard here
            this.serializeElement(node);
            // serialize any EOL
            this.serializeEOL(parent);
        }
    }
}
module.exports.XditaSerializer = $054f6f39ab609589$var$XditaSerializer;

});



parcelRegister("6FTYo", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validKeys = void 0;
module.exports.getAndValidateParameterValues = $4dc1fd80852b0a53$var$getAndValidateParameterValues;
module.exports.isValidParam = $4dc1fd80852b0a53$var$isValidParam;
module.exports.isOAuthCodeParam = $4dc1fd80852b0a53$var$isOAuthCodeParam;
module.exports.isInstallationParam = $4dc1fd80852b0a53$var$isInstallationParam;
module.exports.showNotification = $4dc1fd80852b0a53$var$showNotification;
module.exports.redirectToGitHubOAuth = $4dc1fd80852b0a53$var$redirectToGitHubOAuth;
module.exports.redirectToGitHubAppInstall = $4dc1fd80852b0a53$var$redirectToGitHubAppInstall;
module.exports.showErrorPage = $4dc1fd80852b0a53$var$showErrorPage;
module.exports.handleInvalidRequest = $4dc1fd80852b0a53$var$handleInvalidRequest;
module.exports.processRequest = $4dc1fd80852b0a53$var$processRequest;

var $aSs4u = parcelRequire("aSs4u");

var $is3B8 = parcelRequire("is3B8");
/**
 * List of valid URL key names in parameters
 * ghrepo = GitHub repository,
 * source = GitHub resource,
 * branch = Branch of the repository to fetch the document from, and use as base branch for PRs
 * referer = Referer of the request
 */ module.exports.validKeys = [
    "ghrepo",
    "source",
    "branch",
    "referer"
];
/**
 * Retrieves the values of the valid URL parameters `ghrepo`, `source`, and `referer`
 * and returns a status string for handling the notifications
 * in case the URL has missing values or invalid parameters
 *
 * @param url - URL string
 * @returns An array with key-value objects of the URL parameter values or a status string for handling the notifications
 */ function $4dc1fd80852b0a53$var$getAndValidateParameterValues(url) {
    const parameters = [];
    const urlParts = url.split("?");
    if (urlParts.length === 1) return "noParams";
    const queryString = urlParts[1];
    const params = new URLSearchParams(queryString);
    // Loop through the parameters and add them to the array
    for (const [key, value] of params.entries())parameters.push({
        key: key,
        value: value
    });
    // check if the URL parameters are from oauth redirect
    for (const param of parameters){
        if ($4dc1fd80852b0a53$var$isOAuthCodeParam(param.key)) return parameters;
    }
    // TODO (AvC): Define all expected and allowed parameters in endpoints
    // and handle everything else as a redirect to the error page with e.g. error-type `unknownError`.
    // Currently all parameters that are not explicitly handled
    // are treated as a `missingReferer` error, because we are simply
    // checking if the referer is missing as a catch-all case.
    // Check if referer parameter is missing
    const hasMissingReferer = !params.has("referer");
    const hasMissingValues = parameters.some(({ value: value })=>value === null || value === "");
    const hasInvalidParams = module.exports.validKeys.some((key)=>!params.has(key));
    // Return the status string for the notifications
    if (hasMissingReferer) return "missingReferer";
    if (hasMissingValues || hasInvalidParams) return "invalidParams";
    return parameters;
}
/**
 * Helper function to check if the URL parameter key is valid
 * Returns true if the key is valid, false otherwise
 *
 * @param key - URL parameter key
 * @returns Boolean
 */ function $4dc1fd80852b0a53$var$isValidParam(key) {
    return module.exports.validKeys.includes(key);
}
function $4dc1fd80852b0a53$var$isOAuthCodeParam(key) {
    return key === "code" || key === "error";
}
function $4dc1fd80852b0a53$var$isInstallationParam(key) {
    return key === "installation_id" || key === "setup_action";
}
/**
 * Shows a toast notification based on the given parameters
 *
 * @param parameters - The URL parameters
 */ function $4dc1fd80852b0a53$var$showNotification(parameters) {
    if (typeof parameters === "object") (0, $is3B8.showToast)("Success! You will be redirected to GitHub OAuth", "success");
    else if (parameters === "invalidParams") (0, $is3B8.showToast)("Your request is invalid.", "error");
    else if (parameters === "missingReferer") (0, $is3B8.showToast)("Missing referer parameter.", "error");
    else if (parameters === "authenticated") (0, $is3B8.showToast)("You are authenticated.", "success");
}
/**
 * Redirects the user to GitHub OAuth
 */ function $4dc1fd80852b0a53$var$redirectToGitHubOAuth(config, parameters) {
    // Store the parameters in state to pass them to the redirect URL
    const state = btoa(`${JSON.stringify(Object.assign({}, parameters))}`);
    const redirectURL = config.server.frontend.url;
    window.location.href = `https://github.com/login/oauth/authorize?client_id=${config.gitHub.clientId}&state=${state}&redirect_uri=${redirectURL}`;
}
function $4dc1fd80852b0a53$var$redirectToGitHubAppInstall(config, parameters) {
    const redirectURL = config.server.frontend.url;
    window.location.href = `https://github.com/apps/petal-bot/installations/new?state=${parameters.state}&redirect_uri=${redirectURL}`;
}
/**
 * Redirects the user to the error page
 * If a referer, error type, or error message parameter are provided,
 * they will be passed to the error page
 *
 * @param config - configuration
 * @param errorType - Error type
 * @param referer - Referer of the request
 * @param errorMsg - Error message
 */ function $4dc1fd80852b0a53$var$showErrorPage(config, errorType, referer, errorMsg) {
    const errorPageUrl = `${config.server.frontend.url}/error.html?error-type=${encodeURIComponent(errorType)}&referer=${encodeURIComponent(referer || "")}&error-msg=${encodeURIComponent(errorMsg || "")}`;
    window.location.href = errorPageUrl;
}
/**
 * Redirects the user to the referer parameter from URL params
 * If a referer parameter is not provided, it will be passed to the error page
 */ function $4dc1fd80852b0a53$var$handleInvalidRequest(config, referer) {
    if (referer) $4dc1fd80852b0a53$var$showErrorPage(config, "invalidParams", referer, "");
    else $4dc1fd80852b0a53$var$showErrorPage(config, "missingReferer");
}
/**
 * Process the URL parameters and handle the notifications
 * and redirects to the GitHub OAuth page or the error page
 *
 * @param config - config
 * @param localization - localization
 */ function $4dc1fd80852b0a53$var$processRequest(config, localization) {
    // Check if the window object is defined (i.e. it is not in Mocha tests!)
    if (typeof window !== "undefined") {
        const currentUrl = window.location.href;
        try {
            const parameters = $4dc1fd80852b0a53$var$getAndValidateParameterValues(currentUrl);
            // Requests with string parameters from e.g. 'Petal Edit Button'
            if (typeof parameters === "string") {
                if (parameters === "invalidParams") {
                    const referer = new URLSearchParams(window.location.search).get("referer");
                    $4dc1fd80852b0a53$var$handleInvalidRequest(config, referer);
                }
                if (parameters === "missingReferer") $4dc1fd80852b0a53$var$showErrorPage(config, "missingReferer");
            // Requests with object parameters from e.g. Git
            } else if (typeof parameters === "object") {
                const returnParams = {};
                for (const param of parameters)returnParams[param.key] = param.value;
                if (!parameters.some((param)=>$4dc1fd80852b0a53$var$isOAuthCodeParam(param.key))) // Petal was called with github parameters but not with the OAuth code
                // Redirect to GitHub OAuth page
                $4dc1fd80852b0a53$var$redirectToGitHubOAuth(config, returnParams);
                else if (parameters.some((param)=>$4dc1fd80852b0a53$var$isInstallationParam(param.key))) // The user has authenticated and installed the app
                // return the parameters from the URL
                return JSON.parse(atob(returnParams.state));
                else {
                    // in case of an error, the user did not authenticate the app
                    const errorParam = parameters.find((param)=>param.key === "error");
                    if (errorParam) {
                        // TODO (AvC): Parse the referer from the state object if available and pass it to the error page
                        // TODO (AvC): Provide the authentication redirect URL and pass it to the error page (or extend redirectToGitHubOAuth()?)
                        // FIXME (AvC): The error page should prompt the user to authenticate again,
                        // this is currently not implemeted, thus a simple toast notification for now
                        // showErrorPage('missingAuthentication', '', errorParam.value);
                        (0, $is3B8.showToast)("Please authenticate with GitHub", "error");
                        console.log("processRequest(): error", errorParam.value);
                    }
                    (0, $aSs4u.exchangeOAuthCodeForAccessToken)(config, localization, returnParams.code).then(({ token: token, installation: installation })=>{
                        localStorage.setItem("token", token);
                        if (!installation) // redirect to the OAuth error page and show the error message with instructions to install the app
                        $4dc1fd80852b0a53$var$redirectToGitHubAppInstall(config, returnParams);
                    }).catch((e)=>{
                        console.error(e);
                        //TODO(YB): make sure the error page can redirect back to the referer
                        //TODO(YB): the error page should prompt the user to authenticate again
                        // TODO (AvC): Parse the referer from the state object if available and pass it to the error page
                        $4dc1fd80852b0a53$var$showErrorPage(config, "missingAuthentication", "", e);
                    });
                    return JSON.parse(atob(returnParams.state));
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                //showErrorPage('unknownError', '', error.message);
                (0, $is3B8.showToast)("processRequest(): " + error.message, "error");
                console.error(error.message);
            } else {
                //showErrorPage('unknownError');
                (0, $is3B8.showToast)("processRequest(): Unknown error", "error");
                console.error("Unknown error:", "", error);
            }
        }
    }
    return undefined;
}

});
parcelRegister("is3B8", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $d6eda2011a329a6b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.showWelcomeNote = void 0;
module.exports.showToast = $d6eda2011a329a6b$var$showToast;
module.exports.hasConfirmedNotification = $d6eda2011a329a6b$var$hasConfirmedNotification;
module.exports.showPublicationResultSuccess = $d6eda2011a329a6b$var$showPublicationResultSuccess;
module.exports.showPublicationResultError = $d6eda2011a329a6b$var$showPublicationResultError;

/* eslint-disable @typescript-eslint/no-unused-vars */ const $d6eda2011a329a6b$var$toastify_js_1 = $d6eda2011a329a6b$var$__importDefault((parcelRequire("8eWNt")));
/**
 * Displays a simple and basic toast message with 'Toastify' library.
 * Requires a message string
 * and a type string ('success', 'error', 'warning', 'info')
 * for setting the appropriate background color.
 * Will stick at the bottom right of the screen,
 * disappears after 5 seconds, and is not dismissible.
 *
 * @see {@link https://github.com/apvarun/toastify-js/blob/master/README.md#api}
 *
 * @param message - Message to display
 * @param type - Type of toast
 */ function $d6eda2011a329a6b$var$showToast(message, type) {
    const toast = (0, $d6eda2011a329a6b$var$toastify_js_1.default)({
        text: message,
        duration: 5000,
        gravity: "bottom",
        position: "right",
        className: `toast toast--${type}`
    }).showToast();
}
/**
 * Displays a customized Tostify message
 * with customized markup
 * that users can confirm to never show again
 * by storing it in the localStorage
 *
 * @param localization - localization
 */ const $d6eda2011a329a6b$var$showWelcomeNote = (localization)=>{
    const customNote = document.createElement("section");
    customNote.innerHTML = `
  <h2>${localization.t("welcomeNote.title")}</h2>
  <p>${localization.t("welcomeNote.paragraph1")}</p>
  <p>${localization.t("welcomeNote.paragraph2")}</p>
  <button type="button" class="toast--dismiss">${localization.t("welcomeNote.buttonLabel")}</button>
  `;
    const parentNode = document.body;
    parentNode.appendChild(customNote);
    (0, $d6eda2011a329a6b$var$toastify_js_1.default)({
        text: "",
        duration: -1,
        gravity: "top",
        position: "right",
        className: "toast toast__panel toast--welcome",
        close: true,
        node: customNote,
        onClick: function() {
            const toastElement = document.querySelector(".toast--welcome");
            if (toastElement) {
                toastElement.remove();
                localStorage.setItem("welcomeNoteConfirmed", "true");
            }
        }
    }).showToast();
};
module.exports.showWelcomeNote = $d6eda2011a329a6b$var$showWelcomeNote;
/**
 * Checks if the welcome note has been confirmed
 * @returns True if the welcome note has been confirmed
 */ function $d6eda2011a329a6b$var$hasConfirmedNotification() {
    return localStorage.getItem("welcomeNoteConfirmed") === "true";
}
/**
 * Shows a user notification containing a custom,
 * static message and a dynamic link
 *
 * @param localization - localization
 * @param destination - URL to which the browser should be navigated on click of the toast
 */ function $d6eda2011a329a6b$var$showPublicationResultSuccess(localization, destination) {
    const customNote = document.createElement("section");
    customNote.innerHTML = `
  <h2>${localization.t("resultNote.titleSuccess")}</h2>
  <p>${localization.t("resultNote.paragraphSuccess")}</p>
  <a target="_blank" href="${destination}"></span>${destination}</a>
  `;
    const parentNode = document.body;
    parentNode.appendChild(customNote);
    (0, $d6eda2011a329a6b$var$toastify_js_1.default)({
        text: "",
        duration: -1,
        gravity: "top",
        position: "right",
        className: `toast__panel toast--success`,
        close: true,
        destination: destination,
        newWindow: true,
        node: customNote
    }).showToast();
}
/**
 * Shows a user notification containing a dynamic message
 *
 * @param localization - localization
 * @param message - Error message
 */ function $d6eda2011a329a6b$var$showPublicationResultError(localization, message) {
    const customNote = document.createElement("section");
    customNote.innerHTML = `
  <h2>${localization.t("resultNote.titleError")}</h2>
  <p>${localization.t("resultNote.paragraphError")}</p>
  <p>${message}</p>`;
    const parentNode = document.body;
    parentNode.appendChild(customNote);
    (0, $d6eda2011a329a6b$var$toastify_js_1.default)({
        text: message,
        duration: -1,
        gravity: "top",
        position: "right",
        className: `toast__panel toast--error`,
        close: true,
        node: customNote
    }).showToast();
}

});
parcelRegister("8eWNt", function(module, exports) {
/*!
 * Toastify js 1.12.0
 * https://github.com/apvarun/toastify-js
 * @license MIT licensed
 *
 * Copyright (C) 2018 Varun A P
 */ (function(root, factory) {
    if (0, module.exports) module.exports = factory();
    else root.Toastify = factory();
})(module.exports, function(global) {
    // Object initialization
    var Toastify = function(options) {
        // Returning a new init object
        return new Toastify.lib.init(options);
    }, // Library version
    version = "1.12.0";
    // Set the default global options
    Toastify.defaults = {
        oldestFirst: true,
        text: "Toastify is awesome!",
        node: undefined,
        duration: 3000,
        selector: undefined,
        callback: function() {},
        destination: undefined,
        newWindow: false,
        close: false,
        gravity: "toastify-top",
        positionLeft: false,
        position: "",
        backgroundColor: "",
        avatar: "",
        className: "",
        stopOnFocus: true,
        onClick: function() {},
        offset: {
            x: 0,
            y: 0
        },
        escapeMarkup: true,
        ariaLive: "polite",
        style: {
            background: ""
        }
    };
    // Defining the prototype of the object
    Toastify.lib = Toastify.prototype = {
        toastify: version,
        constructor: Toastify,
        // Initializing the object with required parameters
        init: function(options) {
            // Verifying and validating the input object
            if (!options) options = {};
            // Creating the options object
            this.options = {};
            this.toastElement = null;
            // Validating the options
            this.options.text = options.text || Toastify.defaults.text; // Display message
            this.options.node = options.node || Toastify.defaults.node; // Display content as node
            this.options.duration = options.duration === 0 ? 0 : options.duration || Toastify.defaults.duration; // Display duration
            this.options.selector = options.selector || Toastify.defaults.selector; // Parent selector
            this.options.callback = options.callback || Toastify.defaults.callback; // Callback after display
            this.options.destination = options.destination || Toastify.defaults.destination; // On-click destination
            this.options.newWindow = options.newWindow || Toastify.defaults.newWindow; // Open destination in new window
            this.options.close = options.close || Toastify.defaults.close; // Show toast close icon
            this.options.gravity = options.gravity === "bottom" ? "toastify-bottom" : Toastify.defaults.gravity; // toast position - top or bottom
            this.options.positionLeft = options.positionLeft || Toastify.defaults.positionLeft; // toast position - left or right
            this.options.position = options.position || Toastify.defaults.position; // toast position - left or right
            this.options.backgroundColor = options.backgroundColor || Toastify.defaults.backgroundColor; // toast background color
            this.options.avatar = options.avatar || Toastify.defaults.avatar; // img element src - url or a path
            this.options.className = options.className || Toastify.defaults.className; // additional class names for the toast
            this.options.stopOnFocus = options.stopOnFocus === undefined ? Toastify.defaults.stopOnFocus : options.stopOnFocus; // stop timeout on focus
            this.options.onClick = options.onClick || Toastify.defaults.onClick; // Callback after click
            this.options.offset = options.offset || Toastify.defaults.offset; // toast offset
            this.options.escapeMarkup = options.escapeMarkup !== undefined ? options.escapeMarkup : Toastify.defaults.escapeMarkup;
            this.options.ariaLive = options.ariaLive || Toastify.defaults.ariaLive;
            this.options.style = options.style || Toastify.defaults.style;
            if (options.backgroundColor) this.options.style.background = options.backgroundColor;
            // Returning the current object for chaining functions
            return this;
        },
        // Building the DOM element
        buildToast: function() {
            // Validating if the options are defined
            if (!this.options) throw "Toastify is not initialized";
            // Creating the DOM object
            var divElement = document.createElement("div");
            divElement.className = "toastify on " + this.options.className;
            // Positioning toast to left or right or center
            if (!!this.options.position) divElement.className += " toastify-" + this.options.position;
            else // To be depreciated in further versions
            if (this.options.positionLeft === true) {
                divElement.className += " toastify-left";
                console.warn("Property `positionLeft` will be depreciated in further versions. Please use `position` instead.");
            } else // Default position
            divElement.className += " toastify-right";
            // Assigning gravity of element
            divElement.className += " " + this.options.gravity;
            if (this.options.backgroundColor) // This is being deprecated in favor of using the style HTML DOM property
            console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
            // Loop through our style object and apply styles to divElement
            for(var property in this.options.style)divElement.style[property] = this.options.style[property];
            // Announce the toast to screen readers
            if (this.options.ariaLive) divElement.setAttribute("aria-live", this.options.ariaLive);
            // Adding the toast message/node
            if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE) // If we have a valid node, we insert it
            divElement.appendChild(this.options.node);
            else {
                if (this.options.escapeMarkup) divElement.innerText = this.options.text;
                else divElement.innerHTML = this.options.text;
                if (this.options.avatar !== "") {
                    var avatarElement = document.createElement("img");
                    avatarElement.src = this.options.avatar;
                    avatarElement.className = "toastify-avatar";
                    if (this.options.position == "left" || this.options.positionLeft === true) // Adding close icon on the left of content
                    divElement.appendChild(avatarElement);
                    else // Adding close icon on the right of content
                    divElement.insertAdjacentElement("afterbegin", avatarElement);
                }
            }
            // Adding a close icon to the toast
            if (this.options.close === true) {
                // Create a span for close element
                var closeElement = document.createElement("button");
                closeElement.type = "button";
                closeElement.setAttribute("aria-label", "Close");
                closeElement.className = "toast-close";
                closeElement.innerHTML = "&#10006;";
                // Triggering the removal of toast from DOM on close click
                closeElement.addEventListener("click", (function(event) {
                    event.stopPropagation();
                    this.removeElement(this.toastElement);
                    window.clearTimeout(this.toastElement.timeOutValue);
                }).bind(this));
                //Calculating screen width
                var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
                // Adding the close icon to the toast element
                // Display on the right if screen width is less than or equal to 360px
                if ((this.options.position == "left" || this.options.positionLeft === true) && width > 360) // Adding close icon on the left of content
                divElement.insertAdjacentElement("afterbegin", closeElement);
                else // Adding close icon on the right of content
                divElement.appendChild(closeElement);
            }
            // Clear timeout while toast is focused
            if (this.options.stopOnFocus && this.options.duration > 0) {
                var self = this;
                // stop countdown
                divElement.addEventListener("mouseover", function(event) {
                    window.clearTimeout(divElement.timeOutValue);
                });
                // add back the timeout
                divElement.addEventListener("mouseleave", function() {
                    divElement.timeOutValue = window.setTimeout(function() {
                        // Remove the toast from DOM
                        self.removeElement(divElement);
                    }, self.options.duration);
                });
            }
            // Adding an on-click destination path
            if (typeof this.options.destination !== "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                if (this.options.newWindow === true) window.open(this.options.destination, "_blank");
                else window.location = this.options.destination;
            }).bind(this));
            if (typeof this.options.onClick === "function" && typeof this.options.destination === "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                this.options.onClick();
            }).bind(this));
            // Adding offset
            if (typeof this.options.offset === "object") {
                var x = getAxisOffsetAValue("x", this.options);
                var y = getAxisOffsetAValue("y", this.options);
                var xOffset = this.options.position == "left" ? x : "-" + x;
                var yOffset = this.options.gravity == "toastify-top" ? y : "-" + y;
                divElement.style.transform = "translate(" + xOffset + "," + yOffset + ")";
            }
            // Returning the generated element
            return divElement;
        },
        // Displaying the toast
        showToast: function() {
            // Creating the DOM object for the toast
            this.toastElement = this.buildToast();
            // Getting the root element to with the toast needs to be added
            var rootElement;
            if (typeof this.options.selector === "string") rootElement = document.getElementById(this.options.selector);
            else if (this.options.selector instanceof HTMLElement || typeof ShadowRoot !== "undefined" && this.options.selector instanceof ShadowRoot) rootElement = this.options.selector;
            else rootElement = document.body;
            // Validating if root element is present in DOM
            if (!rootElement) throw "Root element is not defined";
            // Adding the DOM element
            var elementToInsert = Toastify.defaults.oldestFirst ? rootElement.firstChild : rootElement.lastChild;
            rootElement.insertBefore(this.toastElement, elementToInsert);
            // Repositioning the toasts in case multiple toasts are present
            Toastify.reposition();
            if (this.options.duration > 0) this.toastElement.timeOutValue = window.setTimeout((function() {
                // Remove the toast from DOM
                this.removeElement(this.toastElement);
            }).bind(this), this.options.duration); // Binding `this` for function invocation
            // Supporting function chaining
            return this;
        },
        hideToast: function() {
            if (this.toastElement.timeOutValue) clearTimeout(this.toastElement.timeOutValue);
            this.removeElement(this.toastElement);
        },
        // Removing the element from the DOM
        removeElement: function(toastElement) {
            // Hiding the element
            // toastElement.classList.remove("on");
            toastElement.className = toastElement.className.replace(" on", "");
            // Removing the element from DOM after transition end
            window.setTimeout((function() {
                // remove options node if any
                if (this.options.node && this.options.node.parentNode) this.options.node.parentNode.removeChild(this.options.node);
                // Remove the element from the DOM, only when the parent node was not removed before.
                if (toastElement.parentNode) toastElement.parentNode.removeChild(toastElement);
                // Calling the callback function
                this.options.callback.call(toastElement);
                // Repositioning the toasts again
                Toastify.reposition();
            }).bind(this), 400); // Binding `this` for function invocation
        }
    };
    // Positioning the toasts on the DOM
    Toastify.reposition = function() {
        // Top margins with gravity
        var topLeftOffsetSize = {
            top: 15,
            bottom: 15
        };
        var topRightOffsetSize = {
            top: 15,
            bottom: 15
        };
        var offsetSize = {
            top: 15,
            bottom: 15
        };
        // Get all toast messages on the DOM
        var allToasts = document.getElementsByClassName("toastify");
        var classUsed;
        // Modifying the position of each toast element
        for(var i = 0; i < allToasts.length; i++){
            // Getting the applied gravity
            if (containsClass(allToasts[i], "toastify-top") === true) classUsed = "toastify-top";
            else classUsed = "toastify-bottom";
            var height = allToasts[i].offsetHeight;
            classUsed = classUsed.substr(9, classUsed.length - 1);
            // Spacing between toasts
            var offset = 15;
            var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
            // Show toast in center if screen with less than or equal to 360px
            if (width <= 360) {
                // Setting the position
                allToasts[i].style[classUsed] = offsetSize[classUsed] + "px";
                offsetSize[classUsed] += height + offset;
            } else if (containsClass(allToasts[i], "toastify-left") === true) {
                // Setting the position
                allToasts[i].style[classUsed] = topLeftOffsetSize[classUsed] + "px";
                topLeftOffsetSize[classUsed] += height + offset;
            } else {
                // Setting the position
                allToasts[i].style[classUsed] = topRightOffsetSize[classUsed] + "px";
                topRightOffsetSize[classUsed] += height + offset;
            }
        }
        // Supporting function chaining
        return this;
    };
    // Helper function to get offset.
    function getAxisOffsetAValue(axis, options) {
        if (options.offset[axis]) {
            if (isNaN(options.offset[axis])) return options.offset[axis];
            else return options.offset[axis] + "px";
        }
        return "0px";
    }
    function containsClass(elem, yourClass) {
        if (!elem || typeof yourClass !== "string") return false;
        else if (elem.className && elem.className.trim().split(/\s+/gi).indexOf(yourClass) > -1) return true;
        else return false;
    }
    // Setting up the prototype for the init object
    Toastify.lib.init.prototype = Toastify.lib;
    // Returning the Toastify function to be assigned to the window object/module
    return Toastify;
});

});



parcelRegister("gEPNU", function(module, exports) {



/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory((parcelRequire("63OAe")), (parcelRequire("eK0Np")), (parcelRequire("2969v")));
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "./punycode",
        "./IPv6",
        "./SecondLevelDomains"
    ], factory);
    else // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
})(module.exports, function(punycode, IPv6, SLD, root) {
    "use strict";
    /*global location, escape, unescape */ // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
    /*jshint camelcase: false */ // save current URI variable, if any
    var _URI = root && root.URI;
    function URI(url, base) {
        var _urlSupplied = arguments.length >= 1;
        var _baseSupplied = arguments.length >= 2;
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof URI)) {
            if (_urlSupplied) {
                if (_baseSupplied) return new URI(url, base);
                return new URI(url);
            }
            return new URI();
        }
        if (url === undefined) {
            if (_urlSupplied) throw new TypeError("undefined is not a valid argument for URI");
            if (typeof location !== "undefined") url = location.href + "";
            else url = "";
        }
        if (url === null) {
            if (_urlSupplied) throw new TypeError("null is not a valid argument for URI");
        }
        this.href(url);
        // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
        if (base !== undefined) return this.absoluteTo(base);
        return this;
    }
    function isInteger(value) {
        return /^[0-9]+$/.test(value);
    }
    URI.version = "1.19.11";
    var p = URI.prototype;
    var hasOwn = Object.prototype.hasOwnProperty;
    function escapeRegEx(string) {
        // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
        return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
    }
    function getType(value) {
        // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
        if (value === undefined) return "Undefined";
        return String(Object.prototype.toString.call(value)).slice(8, -1);
    }
    function isArray(obj) {
        return getType(obj) === "Array";
    }
    function filterArrayValues(data, value) {
        var lookup = {};
        var i, length;
        if (getType(value) === "RegExp") lookup = null;
        else if (isArray(value)) for(i = 0, length = value.length; i < length; i++)lookup[value[i]] = true;
        else lookup[value] = true;
        for(i = 0, length = data.length; i < length; i++){
            /*jshint laxbreak: true */ var _match = lookup && lookup[data[i]] !== undefined || !lookup && value.test(data[i]);
            /*jshint laxbreak: false */ if (_match) {
                data.splice(i, 1);
                length--;
                i--;
            }
        }
        return data;
    }
    function arrayContains(list, value) {
        var i, length;
        // value may be string, number, array, regexp
        if (isArray(value)) {
            // Note: this can be optimized to O(n) (instead of current O(m * n))
            for(i = 0, length = value.length; i < length; i++){
                if (!arrayContains(list, value[i])) return false;
            }
            return true;
        }
        var _type = getType(value);
        for(i = 0, length = list.length; i < length; i++){
            if (_type === "RegExp") {
                if (typeof list[i] === "string" && list[i].match(value)) return true;
            } else if (list[i] === value) return true;
        }
        return false;
    }
    function arraysEqual(one, two) {
        if (!isArray(one) || !isArray(two)) return false;
        // arrays can't be equal if they have different amount of content
        if (one.length !== two.length) return false;
        one.sort();
        two.sort();
        for(var i = 0, l = one.length; i < l; i++){
            if (one[i] !== two[i]) return false;
        }
        return true;
    }
    function trimSlashes(text) {
        var trim_expression = /^\/+|\/+$/g;
        return text.replace(trim_expression, "");
    }
    URI._parts = function() {
        return {
            protocol: null,
            username: null,
            password: null,
            hostname: null,
            urn: null,
            port: null,
            path: null,
            query: null,
            fragment: null,
            // state
            preventInvalidHostname: URI.preventInvalidHostname,
            duplicateQueryParameters: URI.duplicateQueryParameters,
            escapeQuerySpace: URI.escapeQuerySpace
        };
    };
    // state: throw on invalid hostname
    // see https://github.com/medialize/URI.js/pull/345
    // and https://github.com/medialize/URI.js/issues/354
    URI.preventInvalidHostname = false;
    // state: allow duplicate query parameters (a=1&a=1)
    URI.duplicateQueryParameters = false;
    // state: replaces + with %20 (space in query strings)
    URI.escapeQuerySpace = true;
    // static properties
    URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
    URI.idn_expression = /[^a-z0-9\._-]/i;
    URI.punycode_expression = /(xn--)/i;
    // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
    URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
    // credits to Rich Brown
    // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
    // specification: http://www.ietf.org/rfc/rfc4291.txt
    URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
    // expression used is "gruber revised" (@gruber v2) determined to be the
    // best solution in a regex-golf we did a couple of ages ago at
    // * http://mathiasbynens.be/demo/url-regex
    // * http://rodneyrehm.de/t/url-regex.html
    URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
    URI.findUri = {
        // valid "scheme://" or "www."
        start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
        // everything up to the next whitespace
        end: /[\s\r\n]|$/,
        // trim trailing punctuation captured by end RegExp
        trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
        // balanced parens inclusion (), [], {}, <>
        parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g
    };
    URI.leading_whitespace_expression = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/;
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    URI.ascii_tab_whitespace = /[\u0009\u000A\u000D]+/g;
    // http://www.iana.org/assignments/uri-schemes.html
    // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
    URI.defaultPorts = {
        http: "80",
        https: "443",
        ftp: "21",
        gopher: "70",
        ws: "80",
        wss: "443"
    };
    // list of protocols which always require a hostname
    URI.hostProtocols = [
        "http",
        "https"
    ];
    // allowed hostname characters according to RFC 3986
    // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
    // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
    URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
    // map DOM Elements to their URI attribute
    URI.domAttributes = {
        "a": "href",
        "blockquote": "cite",
        "link": "href",
        "base": "href",
        "script": "src",
        "form": "action",
        "img": "src",
        "area": "href",
        "iframe": "src",
        "embed": "src",
        "source": "src",
        "track": "src",
        "input": "src",
        "audio": "src",
        "video": "src"
    };
    URI.getDomAttribute = function(node) {
        if (!node || !node.nodeName) return undefined;
        var nodeName = node.nodeName.toLowerCase();
        // <input> should only expose src for type="image"
        if (nodeName === "input" && node.type !== "image") return undefined;
        return URI.domAttributes[nodeName];
    };
    function escapeForDumbFirefox36(value) {
        // https://github.com/medialize/URI.js/issues/91
        return escape(value);
    }
    // encoding / decoding according to RFC3986
    function strictEncodeURIComponent(string) {
        // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
        return encodeURIComponent(string).replace(/[!'()*]/g, escapeForDumbFirefox36).replace(/\*/g, "%2A");
    }
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
    URI.iso8859 = function() {
        URI.encode = escape;
        URI.decode = unescape;
    };
    URI.unicode = function() {
        URI.encode = strictEncodeURIComponent;
        URI.decode = decodeURIComponent;
    };
    URI.characters = {
        pathname: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
                map: {
                    // -._~!'()*
                    "%24": "$",
                    "%26": "&",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "=",
                    "%3A": ":",
                    "%40": "@"
                }
            },
            decode: {
                expression: /[\/\?#]/g,
                map: {
                    "/": "%2F",
                    "?": "%3F",
                    "#": "%23"
                }
            }
        },
        reserved: {
            encode: {
                // RFC3986 2.1: For consistency, URI producers and normalizers should
                // use uppercase hexadecimal digits for all percent-encodings.
                expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
                map: {
                    // gen-delims
                    "%3A": ":",
                    "%2F": "/",
                    "%3F": "?",
                    "%23": "#",
                    "%5B": "[",
                    "%5D": "]",
                    "%40": "@",
                    // sub-delims
                    "%21": "!",
                    "%24": "$",
                    "%26": "&",
                    "%27": "'",
                    "%28": "(",
                    "%29": ")",
                    "%2A": "*",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "="
                }
            }
        },
        urnpath: {
            // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
            // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
            // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
            // note that the colon character is not featured in the encoding map; this is because URI.js
            // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
            // should not appear unencoded in a segment itself.
            // See also the note above about RFC3986 and capitalalized hex digits.
            encode: {
                expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
                map: {
                    "%21": "!",
                    "%24": "$",
                    "%27": "'",
                    "%28": "(",
                    "%29": ")",
                    "%2A": "*",
                    "%2B": "+",
                    "%2C": ",",
                    "%3B": ";",
                    "%3D": "=",
                    "%40": "@"
                }
            },
            // These characters are the characters called out by RFC2141 as "reserved" characters that
            // should never appear in a URN, plus the colon character (see note above).
            decode: {
                expression: /[\/\?#:]/g,
                map: {
                    "/": "%2F",
                    "?": "%3F",
                    "#": "%23",
                    ":": "%3A"
                }
            }
        }
    };
    URI.encodeQuery = function(string, escapeQuerySpace) {
        var escaped = URI.encode(string + "");
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        return escapeQuerySpace ? escaped.replace(/%20/g, "+") : escaped;
    };
    URI.decodeQuery = function(string, escapeQuerySpace) {
        string += "";
        if (escapeQuerySpace === undefined) escapeQuerySpace = URI.escapeQuerySpace;
        try {
            return URI.decode(escapeQuerySpace ? string.replace(/\+/g, "%20") : string);
        } catch (e) {
            // we're not going to mess with weird encodings,
            // give up and return the undecoded original string
            // see https://github.com/medialize/URI.js/issues/87
            // see https://github.com/medialize/URI.js/issues/92
            return string;
        }
    };
    // generate encode/decode path functions
    var _parts = {
        "encode": "encode",
        "decode": "decode"
    };
    var _part;
    var generateAccessor = function(_group, _part) {
        return function(string) {
            try {
                return URI[_part](string + "").replace(URI.characters[_group][_part].expression, function(c) {
                    return URI.characters[_group][_part].map[c];
                });
            } catch (e) {
                // we're not going to mess with weird encodings,
                // give up and return the undecoded original string
                // see https://github.com/medialize/URI.js/issues/87
                // see https://github.com/medialize/URI.js/issues/92
                return string;
            }
        };
    };
    for(_part in _parts){
        URI[_part + "PathSegment"] = generateAccessor("pathname", _parts[_part]);
        URI[_part + "UrnPathSegment"] = generateAccessor("urnpath", _parts[_part]);
    }
    var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
        return function(string) {
            // Why pass in names of functions, rather than the function objects themselves? The
            // definitions of some functions (but in particular, URI.decode) will occasionally change due
            // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
            // that the functions we use here are "fresh".
            var actualCodingFunc;
            if (!_innerCodingFuncName) actualCodingFunc = URI[_codingFuncName];
            else actualCodingFunc = function(string) {
                return URI[_codingFuncName](URI[_innerCodingFuncName](string));
            };
            var segments = (string + "").split(_sep);
            for(var i = 0, length = segments.length; i < length; i++)segments[i] = actualCodingFunc(segments[i]);
            return segments.join(_sep);
        };
    };
    // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
    URI.decodePath = generateSegmentedPathFunction("/", "decodePathSegment");
    URI.decodeUrnPath = generateSegmentedPathFunction(":", "decodeUrnPathSegment");
    URI.recodePath = generateSegmentedPathFunction("/", "encodePathSegment", "decode");
    URI.recodeUrnPath = generateSegmentedPathFunction(":", "encodeUrnPathSegment", "decode");
    URI.encodeReserved = generateAccessor("reserved", "encode");
    URI.parse = function(string, parts) {
        var pos;
        if (!parts) parts = {
            preventInvalidHostname: URI.preventInvalidHostname
        };
        string = string.replace(URI.leading_whitespace_expression, "");
        // https://infra.spec.whatwg.org/#ascii-tab-or-newline
        string = string.replace(URI.ascii_tab_whitespace, "");
        // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]
        // extract fragment
        pos = string.indexOf("#");
        if (pos > -1) {
            // escaping?
            parts.fragment = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // extract query
        pos = string.indexOf("?");
        if (pos > -1) {
            // escaping?
            parts.query = string.substring(pos + 1) || null;
            string = string.substring(0, pos);
        }
        // slashes and backslashes have lost all meaning for the web protocols (https, http, wss, ws)
        string = string.replace(/^(https?|ftp|wss?)?:+[/\\]*/i, "$1://");
        // slashes and backslashes have lost all meaning for scheme relative URLs
        string = string.replace(/^[/\\]{2,}/i, "//");
        // extract protocol
        if (string.substring(0, 2) === "//") {
            // relative-scheme
            parts.protocol = null;
            string = string.substring(2);
            // extract "user:pass@host:port"
            string = URI.parseAuthority(string, parts);
        } else {
            pos = string.indexOf(":");
            if (pos > -1) {
                parts.protocol = string.substring(0, pos) || null;
                if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) // : may be within the path
                parts.protocol = undefined;
                else if (string.substring(pos + 1, pos + 3).replace(/\\/g, "/") === "//") {
                    string = string.substring(pos + 3);
                    // extract "user:pass@host:port"
                    string = URI.parseAuthority(string, parts);
                } else {
                    string = string.substring(pos + 1);
                    parts.urn = true;
                }
            }
        }
        // what's left must be the path
        parts.path = string;
        // and we're done
        return parts;
    };
    URI.parseHost = function(string, parts) {
        if (!string) string = "";
        // Copy chrome, IE, opera backslash-handling behavior.
        // Back slashes before the query string get converted to forward slashes
        // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
        // See: https://code.google.com/p/chromium/issues/detail?id=25916
        // https://github.com/medialize/URI.js/pull/233
        string = string.replace(/\\/g, "/");
        // extract host:port
        var pos = string.indexOf("/");
        var bracketPos;
        var t;
        if (pos === -1) pos = string.length;
        if (string.charAt(0) === "[") {
            // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
            // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
            // IPv6+port in the format [2001:db8::1]:80 (for the time being)
            bracketPos = string.indexOf("]");
            parts.hostname = string.substring(1, bracketPos) || null;
            parts.port = string.substring(bracketPos + 2, pos) || null;
            if (parts.port === "/") parts.port = null;
        } else {
            var firstColon = string.indexOf(":");
            var firstSlash = string.indexOf("/");
            var nextColon = string.indexOf(":", firstColon + 1);
            if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
                // IPv6 host contains multiple colons - but no port
                // this notation is actually not allowed by RFC 3986, but we're a liberal parser
                parts.hostname = string.substring(0, pos) || null;
                parts.port = null;
            } else {
                t = string.substring(0, pos).split(":");
                parts.hostname = t[0] || null;
                parts.port = t[1] || null;
            }
        }
        if (parts.hostname && string.substring(pos).charAt(0) !== "/") {
            pos++;
            string = "/" + string;
        }
        if (parts.preventInvalidHostname) URI.ensureValidHostname(parts.hostname, parts.protocol);
        if (parts.port) URI.ensureValidPort(parts.port);
        return string.substring(pos) || "/";
    };
    URI.parseAuthority = function(string, parts) {
        string = URI.parseUserinfo(string, parts);
        return URI.parseHost(string, parts);
    };
    URI.parseUserinfo = function(string, parts) {
        // extract username:password
        var _string = string;
        var firstBackSlash = string.indexOf("\\");
        if (firstBackSlash !== -1) string = string.replace(/\\/g, "/");
        var firstSlash = string.indexOf("/");
        var pos = string.lastIndexOf("@", firstSlash > -1 ? firstSlash : string.length - 1);
        var t;
        // authority@ must come before /path or \path
        if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
            t = string.substring(0, pos).split(":");
            parts.username = t[0] ? URI.decode(t[0]) : null;
            t.shift();
            parts.password = t[0] ? URI.decode(t.join(":")) : null;
            string = _string.substring(pos + 1);
        } else {
            parts.username = null;
            parts.password = null;
        }
        return string;
    };
    URI.parseQuery = function(string, escapeQuerySpace) {
        if (!string) return {};
        // throw out the funky business - "?"[name"="value"&"]+
        string = string.replace(/&+/g, "&").replace(/^\?*&*|&+$/g, "");
        if (!string) return {};
        var items = {};
        var splits = string.split("&");
        var length = splits.length;
        var v, name, value;
        for(var i = 0; i < length; i++){
            v = splits[i].split("=");
            name = URI.decodeQuery(v.shift(), escapeQuerySpace);
            // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
            value = v.length ? URI.decodeQuery(v.join("="), escapeQuerySpace) : null;
            if (name === "__proto__") continue;
            else if (hasOwn.call(items, name)) {
                if (typeof items[name] === "string" || items[name] === null) items[name] = [
                    items[name]
                ];
                items[name].push(value);
            } else items[name] = value;
        }
        return items;
    };
    URI.build = function(parts) {
        var t = "";
        var requireAbsolutePath = false;
        if (parts.protocol) t += parts.protocol + ":";
        if (!parts.urn && (t || parts.hostname)) {
            t += "//";
            requireAbsolutePath = true;
        }
        t += URI.buildAuthority(parts) || "";
        if (typeof parts.path === "string") {
            if (parts.path.charAt(0) !== "/" && requireAbsolutePath) t += "/";
            t += parts.path;
        }
        if (typeof parts.query === "string" && parts.query) t += "?" + parts.query;
        if (typeof parts.fragment === "string" && parts.fragment) t += "#" + parts.fragment;
        return t;
    };
    URI.buildHost = function(parts) {
        var t = "";
        if (!parts.hostname) return "";
        else if (URI.ip6_expression.test(parts.hostname)) t += "[" + parts.hostname + "]";
        else t += parts.hostname;
        if (parts.port) t += ":" + parts.port;
        return t;
    };
    URI.buildAuthority = function(parts) {
        return URI.buildUserinfo(parts) + URI.buildHost(parts);
    };
    URI.buildUserinfo = function(parts) {
        var t = "";
        if (parts.username) t += URI.encode(parts.username);
        if (parts.password) t += ":" + URI.encode(parts.password);
        if (t) t += "@";
        return t;
    };
    URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
        // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
        // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
        // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
        // URI.js treats the query string as being application/x-www-form-urlencoded
        // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type
        var t = "";
        var unique, key, i, length;
        for(key in data){
            if (key === "__proto__") continue;
            else if (hasOwn.call(data, key)) {
                if (isArray(data[key])) {
                    unique = {};
                    for(i = 0, length = data[key].length; i < length; i++)if (data[key][i] !== undefined && unique[data[key][i] + ""] === undefined) {
                        t += "&" + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
                        if (duplicateQueryParameters !== true) unique[data[key][i] + ""] = true;
                    }
                } else if (data[key] !== undefined) t += "&" + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
            }
        }
        return t.substring(1);
    };
    URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
        // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
        // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
        return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? "=" + URI.encodeQuery(value, escapeQuerySpace) : "");
    };
    URI.addQuery = function(data, name, value) {
        if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) URI.addQuery(data, key, name[key]);
        } else if (typeof name === "string") {
            if (data[name] === undefined) {
                data[name] = value;
                return;
            } else if (typeof data[name] === "string") data[name] = [
                data[name]
            ];
            if (!isArray(value)) value = [
                value
            ];
            data[name] = (data[name] || []).concat(value);
        } else throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
    };
    URI.setQuery = function(data, name, value) {
        if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) URI.setQuery(data, key, name[key]);
        } else if (typeof name === "string") data[name] = value === undefined ? null : value;
        else throw new TypeError("URI.setQuery() accepts an object, string as the name parameter");
    };
    URI.removeQuery = function(data, name, value) {
        var i, length, key;
        if (isArray(name)) for(i = 0, length = name.length; i < length; i++)data[name[i]] = undefined;
        else if (getType(name) === "RegExp") {
            for(key in data)if (name.test(key)) data[key] = undefined;
        } else if (typeof name === "object") {
            for(key in name)if (hasOwn.call(name, key)) URI.removeQuery(data, key, name[key]);
        } else if (typeof name === "string") {
            if (value !== undefined) {
                if (getType(value) === "RegExp") {
                    if (!isArray(data[name]) && value.test(data[name])) data[name] = undefined;
                    else data[name] = filterArrayValues(data[name], value);
                } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) data[name] = undefined;
                else if (isArray(data[name])) data[name] = filterArrayValues(data[name], value);
            } else data[name] = undefined;
        } else throw new TypeError("URI.removeQuery() accepts an object, string, RegExp as the first parameter");
    };
    URI.hasQuery = function(data, name, value, withinArray) {
        switch(getType(name)){
            case "String":
                break;
            case "RegExp":
                for(var key in data)if (hasOwn.call(data, key)) {
                    if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) return true;
                }
                return false;
            case "Object":
                for(var _key in name)if (hasOwn.call(name, _key)) {
                    if (!URI.hasQuery(data, _key, name[_key])) return false;
                }
                return true;
            default:
                throw new TypeError("URI.hasQuery() accepts a string, regular expression or object as the name parameter");
        }
        switch(getType(value)){
            case "Undefined":
                // true if exists (but may be empty)
                return name in data; // data[name] !== undefined;
            case "Boolean":
                // true if exists and non-empty
                var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
                return value === _booly;
            case "Function":
                // allow complex comparison
                return !!value(data[name], name, data);
            case "Array":
                if (!isArray(data[name])) return false;
                var op = withinArray ? arrayContains : arraysEqual;
                return op(data[name], value);
            case "RegExp":
                if (!isArray(data[name])) return Boolean(data[name] && data[name].match(value));
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            case "Number":
                value = String(value);
            /* falls through */ case "String":
                if (!isArray(data[name])) return data[name] === value;
                if (!withinArray) return false;
                return arrayContains(data[name], value);
            default:
                throw new TypeError("URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter");
        }
    };
    URI.joinPaths = function() {
        var input = [];
        var segments = [];
        var nonEmptySegments = 0;
        for(var i = 0; i < arguments.length; i++){
            var url = new URI(arguments[i]);
            input.push(url);
            var _segments = url.segment();
            for(var s = 0; s < _segments.length; s++){
                if (typeof _segments[s] === "string") segments.push(_segments[s]);
                if (_segments[s]) nonEmptySegments++;
            }
        }
        if (!segments.length || !nonEmptySegments) return new URI("");
        var uri = new URI("").segment(segments);
        if (input[0].path() === "" || input[0].path().slice(0, 1) === "/") uri.path("/" + uri.path());
        return uri.normalize();
    };
    URI.commonPath = function(one, two) {
        var length = Math.min(one.length, two.length);
        var pos;
        // find first non-matching character
        for(pos = 0; pos < length; pos++)if (one.charAt(pos) !== two.charAt(pos)) {
            pos--;
            break;
        }
        if (pos < 1) return one.charAt(0) === two.charAt(0) && one.charAt(0) === "/" ? "/" : "";
        // revert to last /
        if (one.charAt(pos) !== "/" || two.charAt(pos) !== "/") pos = one.substring(0, pos).lastIndexOf("/");
        return one.substring(0, pos + 1);
    };
    URI.withinString = function(string, callback, options) {
        options || (options = {});
        var _start = options.start || URI.findUri.start;
        var _end = options.end || URI.findUri.end;
        var _trim = options.trim || URI.findUri.trim;
        var _parens = options.parens || URI.findUri.parens;
        var _attributeOpen = /[a-z0-9-]=["']?$/i;
        _start.lastIndex = 0;
        while(true){
            var match = _start.exec(string);
            if (!match) break;
            var start = match.index;
            if (options.ignoreHtml) {
                // attribut(e=["']?$)
                var attributeOpen = string.slice(Math.max(start - 3, 0), start);
                if (attributeOpen && _attributeOpen.test(attributeOpen)) continue;
            }
            var end = start + string.slice(start).search(_end);
            var slice = string.slice(start, end);
            // make sure we include well balanced parens
            var parensEnd = -1;
            while(true){
                var parensMatch = _parens.exec(slice);
                if (!parensMatch) break;
                var parensMatchEnd = parensMatch.index + parensMatch[0].length;
                parensEnd = Math.max(parensEnd, parensMatchEnd);
            }
            if (parensEnd > -1) slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, "");
            else slice = slice.replace(_trim, "");
            if (slice.length <= match[0].length) continue;
            if (options.ignore && options.ignore.test(slice)) continue;
            end = start + slice.length;
            var result = callback(slice, start, end, string);
            if (result === undefined) {
                _start.lastIndex = end;
                continue;
            }
            result = String(result);
            string = string.slice(0, start) + result + string.slice(end);
            _start.lastIndex = start + result.length;
        }
        _start.lastIndex = 0;
        return string;
    };
    URI.ensureValidHostname = function(v, protocol) {
        // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
        // they are not part of DNS and therefore ignored by URI.js
        var hasHostname = !!v; // not null and not an empty string
        var hasProtocol = !!protocol;
        var rejectEmptyHostname = false;
        if (hasProtocol) rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
        if (rejectEmptyHostname && !hasHostname) throw new TypeError("Hostname cannot be empty, if protocol is " + protocol);
        else if (v && v.match(URI.invalid_hostname_characters)) {
            // test punycode
            if (!punycode) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
            if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
        }
    };
    URI.ensureValidPort = function(v) {
        if (!v) return;
        var port = Number(v);
        if (isInteger(port) && port > 0 && port < 65536) return;
        throw new TypeError('Port "' + v + '" is not a valid port');
    };
    // noConflict
    URI.noConflict = function(removeAll) {
        if (removeAll) {
            var unconflicted = {
                URI: this.noConflict()
            };
            if (root.URITemplate && typeof root.URITemplate.noConflict === "function") unconflicted.URITemplate = root.URITemplate.noConflict();
            if (root.IPv6 && typeof root.IPv6.noConflict === "function") unconflicted.IPv6 = root.IPv6.noConflict();
            if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === "function") unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
            return unconflicted;
        } else if (root.URI === this) root.URI = _URI;
        return this;
    };
    p.build = function(deferBuild) {
        if (deferBuild === true) this._deferred_build = true;
        else if (deferBuild === undefined || this._deferred_build) {
            this._string = URI.build(this._parts);
            this._deferred_build = false;
        }
        return this;
    };
    p.clone = function() {
        return new URI(this);
    };
    p.valueOf = p.toString = function() {
        return this.build(false)._string;
    };
    function generateSimpleAccessor(_part) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || "";
            else {
                this._parts[_part] = v || null;
                this.build(!build);
                return this;
            }
        };
    }
    function generatePrefixAccessor(_part, _key) {
        return function(v, build) {
            if (v === undefined) return this._parts[_part] || "";
            else {
                if (v !== null) {
                    v = v + "";
                    if (v.charAt(0) === _key) v = v.substring(1);
                }
                this._parts[_part] = v;
                this.build(!build);
                return this;
            }
        };
    }
    p.protocol = generateSimpleAccessor("protocol");
    p.username = generateSimpleAccessor("username");
    p.password = generateSimpleAccessor("password");
    p.hostname = generateSimpleAccessor("hostname");
    p.port = generateSimpleAccessor("port");
    p.query = generatePrefixAccessor("query", "?");
    p.fragment = generatePrefixAccessor("fragment", "#");
    p.search = function(v, build) {
        var t = this.query(v, build);
        return typeof t === "string" && t.length ? "?" + t : t;
    };
    p.hash = function(v, build) {
        var t = this.fragment(v, build);
        return typeof t === "string" && t.length ? "#" + t : t;
    };
    p.pathname = function(v, build) {
        if (v === undefined || v === true) {
            var res = this._parts.path || (this._parts.hostname ? "/" : "");
            return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
        } else {
            if (this._parts.urn) this._parts.path = v ? URI.recodeUrnPath(v) : "";
            else this._parts.path = v ? URI.recodePath(v) : "/";
            this.build(!build);
            return this;
        }
    };
    p.path = p.pathname;
    p.href = function(href, build) {
        var key;
        if (href === undefined) return this.toString();
        this._string = "";
        this._parts = URI._parts();
        var _URI = href instanceof URI;
        var _object = typeof href === "object" && (href.hostname || href.path || href.pathname);
        if (href.nodeName) {
            var attribute = URI.getDomAttribute(href);
            href = href[attribute] || "";
            _object = false;
        }
        // window.location is reported to be an object, but it's not the sort
        // of object we're looking for:
        // * location.protocol ends with a colon
        // * location.query != object.search
        // * location.hash != object.fragment
        // simply serializing the unknown object should do the trick
        // (for location, not for everything...)
        if (!_URI && _object && href.pathname !== undefined) href = href.toString();
        if (typeof href === "string" || href instanceof String) this._parts = URI.parse(String(href), this._parts);
        else if (_URI || _object) {
            var src = _URI ? href._parts : href;
            for(key in src){
                if (key === "query") continue;
                if (hasOwn.call(this._parts, key)) this._parts[key] = src[key];
            }
            if (src.query) this.query(src.query, false);
        } else throw new TypeError("invalid input");
        this.build(!build);
        return this;
    };
    // identification accessors
    p.is = function(what) {
        var ip = false;
        var ip4 = false;
        var ip6 = false;
        var name = false;
        var sld = false;
        var idn = false;
        var punycode = false;
        var relative = !this._parts.urn;
        if (this._parts.hostname) {
            relative = false;
            ip4 = URI.ip4_expression.test(this._parts.hostname);
            ip6 = URI.ip6_expression.test(this._parts.hostname);
            ip = ip4 || ip6;
            name = !ip;
            sld = name && SLD && SLD.has(this._parts.hostname);
            idn = name && URI.idn_expression.test(this._parts.hostname);
            punycode = name && URI.punycode_expression.test(this._parts.hostname);
        }
        switch(what.toLowerCase()){
            case "relative":
                return relative;
            case "absolute":
                return !relative;
            // hostname identification
            case "domain":
            case "name":
                return name;
            case "sld":
                return sld;
            case "ip":
                return ip;
            case "ip4":
            case "ipv4":
            case "inet4":
                return ip4;
            case "ip6":
            case "ipv6":
            case "inet6":
                return ip6;
            case "idn":
                return idn;
            case "url":
                return !this._parts.urn;
            case "urn":
                return !!this._parts.urn;
            case "punycode":
                return punycode;
        }
        return null;
    };
    // component specific input validation
    var _protocol = p.protocol;
    var _port = p.port;
    var _hostname = p.hostname;
    p.protocol = function(v, build) {
        if (v) {
            // accept trailing ://
            v = v.replace(/:(\/\/)?$/, "");
            if (!v.match(URI.protocol_expression)) throw new TypeError('Protocol "' + v + "\" contains characters other than [A-Z0-9.+-] or doesn't start with [A-Z]");
        }
        return _protocol.call(this, v, build);
    };
    p.scheme = p.protocol;
    p.port = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v !== undefined) {
            if (v === 0) v = null;
            if (v) {
                v += "";
                if (v.charAt(0) === ":") v = v.substring(1);
                URI.ensureValidPort(v);
            }
        }
        return _port.call(this, v, build);
    };
    p.hostname = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v !== undefined) {
            var x = {
                preventInvalidHostname: this._parts.preventInvalidHostname
            };
            var res = URI.parseHost(v, x);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            v = x.hostname;
            if (this._parts.preventInvalidHostname) URI.ensureValidHostname(v, this._parts.protocol);
        }
        return _hostname.call(this, v, build);
    };
    // compound accessors
    p.origin = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) {
            var protocol = this.protocol();
            var authority = this.authority();
            if (!authority) return "";
            return (protocol ? protocol + "://" : "") + this.authority();
        } else {
            var origin = URI(v);
            this.protocol(origin.protocol()).authority(origin.authority()).build(!build);
            return this;
        }
    };
    p.host = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) return this._parts.hostname ? URI.buildHost(this._parts) : "";
        else {
            var res = URI.parseHost(v, this._parts);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.authority = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) return this._parts.hostname ? URI.buildAuthority(this._parts) : "";
        else {
            var res = URI.parseAuthority(v, this._parts);
            if (res !== "/") throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
            this.build(!build);
            return this;
        }
    };
    p.userinfo = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined) {
            var t = URI.buildUserinfo(this._parts);
            return t ? t.substring(0, t.length - 1) : t;
        } else {
            if (v[v.length - 1] !== "@") v += "@";
            URI.parseUserinfo(v, this._parts);
            this.build(!build);
            return this;
        }
    };
    p.resource = function(v, build) {
        var parts;
        if (v === undefined) return this.path() + this.search() + this.hash();
        parts = URI.parse(v);
        this._parts.path = parts.path;
        this._parts.query = parts.query;
        this._parts.fragment = parts.fragment;
        this.build(!build);
        return this;
    };
    // fraction accessors
    p.subdomain = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        // convenience, return "www" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            // grab domain and add another segment
            var end = this._parts.hostname.length - this.domain().length - 1;
            return this._parts.hostname.substring(0, end) || "";
        } else {
            var e = this._parts.hostname.length - this.domain().length;
            var sub = this._parts.hostname.substring(0, e);
            var replace = new RegExp("^" + escapeRegEx(sub));
            if (v && v.charAt(v.length - 1) !== ".") v += ".";
            if (v.indexOf(":") !== -1) throw new TypeError("Domains cannot contain colons");
            if (v) URI.ensureValidHostname(v, this._parts.protocol);
            this._parts.hostname = this._parts.hostname.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.domain = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v === "boolean") {
            build = v;
            v = undefined;
        }
        // convenience, return "example.org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            // if hostname consists of 1 or 2 segments, it must be the domain
            var t = this._parts.hostname.match(/\./g);
            if (t && t.length < 2) return this._parts.hostname;
            // grab tld and add another segment
            var end = this._parts.hostname.length - this.tld(build).length - 1;
            end = this._parts.hostname.lastIndexOf(".", end - 1) + 1;
            return this._parts.hostname.substring(end) || "";
        } else {
            if (!v) throw new TypeError("cannot set domain empty");
            if (v.indexOf(":") !== -1) throw new TypeError("Domains cannot contain colons");
            URI.ensureValidHostname(v, this._parts.protocol);
            if (!this._parts.hostname || this.is("IP")) this._parts.hostname = v;
            else {
                var replace = new RegExp(escapeRegEx(this.domain()) + "$");
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.tld = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v === "boolean") {
            build = v;
            v = undefined;
        }
        // return "org" from "www.example.org"
        if (v === undefined) {
            if (!this._parts.hostname || this.is("IP")) return "";
            var pos = this._parts.hostname.lastIndexOf(".");
            var tld = this._parts.hostname.substring(pos + 1);
            if (build !== true && SLD && SLD.list[tld.toLowerCase()]) return SLD.get(this._parts.hostname) || tld;
            return tld;
        } else {
            var replace;
            if (!v) throw new TypeError("cannot set TLD empty");
            else if (v.match(/[^a-zA-Z0-9-]/)) {
                if (SLD && SLD.is(v)) {
                    replace = new RegExp(escapeRegEx(this.tld()) + "$");
                    this._parts.hostname = this._parts.hostname.replace(replace, v);
                } else throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
            } else if (!this._parts.hostname || this.is("IP")) throw new ReferenceError("cannot set TLD on non-domain host");
            else {
                replace = new RegExp(escapeRegEx(this.tld()) + "$");
                this._parts.hostname = this._parts.hostname.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.directory = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined || v === true) {
            if (!this._parts.path && !this._parts.hostname) return "";
            if (this._parts.path === "/") return "/";
            var end = this._parts.path.length - this.filename().length - 1;
            var res = this._parts.path.substring(0, end) || (this._parts.hostname ? "/" : "");
            return v ? URI.decodePath(res) : res;
        } else {
            var e = this._parts.path.length - this.filename().length;
            var directory = this._parts.path.substring(0, e);
            var replace = new RegExp("^" + escapeRegEx(directory));
            // fully qualifier directories begin with a slash
            if (!this.is("relative")) {
                if (!v) v = "/";
                if (v.charAt(0) !== "/") v = "/" + v;
            }
            // directories always end with a slash
            if (v && v.charAt(v.length - 1) !== "/") v += "/";
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            this.build(!build);
            return this;
        }
    };
    p.filename = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (typeof v !== "string") {
            if (!this._parts.path || this._parts.path === "/") return "";
            var pos = this._parts.path.lastIndexOf("/");
            var res = this._parts.path.substring(pos + 1);
            return v ? URI.decodePathSegment(res) : res;
        } else {
            var mutatedDirectory = false;
            if (v.charAt(0) === "/") v = v.substring(1);
            if (v.match(/\.?\//)) mutatedDirectory = true;
            var replace = new RegExp(escapeRegEx(this.filename()) + "$");
            v = URI.recodePath(v);
            this._parts.path = this._parts.path.replace(replace, v);
            if (mutatedDirectory) this.normalizePath(build);
            else this.build(!build);
            return this;
        }
    };
    p.suffix = function(v, build) {
        if (this._parts.urn) return v === undefined ? "" : this;
        if (v === undefined || v === true) {
            if (!this._parts.path || this._parts.path === "/") return "";
            var filename = this.filename();
            var pos = filename.lastIndexOf(".");
            var s, res;
            if (pos === -1) return "";
            // suffix may only contain alnum characters (yup, I made this up.)
            s = filename.substring(pos + 1);
            res = /^[a-z0-9%]+$/i.test(s) ? s : "";
            return v ? URI.decodePathSegment(res) : res;
        } else {
            if (v.charAt(0) === ".") v = v.substring(1);
            var suffix = this.suffix();
            var replace;
            if (!suffix) {
                if (!v) return this;
                this._parts.path += "." + URI.recodePath(v);
            } else if (!v) replace = new RegExp(escapeRegEx("." + suffix) + "$");
            else replace = new RegExp(escapeRegEx(suffix) + "$");
            if (replace) {
                v = URI.recodePath(v);
                this._parts.path = this._parts.path.replace(replace, v);
            }
            this.build(!build);
            return this;
        }
    };
    p.segment = function(segment, v, build) {
        var separator = this._parts.urn ? ":" : "/";
        var path = this.path();
        var absolute = path.substring(0, 1) === "/";
        var segments = path.split(separator);
        if (segment !== undefined && typeof segment !== "number") {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (segment !== undefined && typeof segment !== "number") throw new Error('Bad segment "' + segment + '", must be 0-based integer');
        if (absolute) segments.shift();
        if (segment < 0) // allow negative indexes to address from the end
        segment = Math.max(segments.length + segment, 0);
        if (v === undefined) /*jshint laxbreak: true */ return segment === undefined ? segments : segments[segment];
        else if (segment === null || segments[segment] === undefined) {
            if (isArray(v)) {
                segments = [];
                // collapse empty elements within array
                for(var i = 0, l = v.length; i < l; i++){
                    if (!v[i].length && (!segments.length || !segments[segments.length - 1].length)) continue;
                    if (segments.length && !segments[segments.length - 1].length) segments.pop();
                    segments.push(trimSlashes(v[i]));
                }
            } else if (v || typeof v === "string") {
                v = trimSlashes(v);
                if (segments[segments.length - 1] === "") // empty trailing elements have to be overwritten
                // to prevent results such as /foo//bar
                segments[segments.length - 1] = v;
                else segments.push(v);
            }
        } else if (v) segments[segment] = trimSlashes(v);
        else segments.splice(segment, 1);
        if (absolute) segments.unshift("");
        return this.path(segments.join(separator), build);
    };
    p.segmentCoded = function(segment, v, build) {
        var segments, i, l;
        if (typeof segment !== "number") {
            build = v;
            v = segment;
            segment = undefined;
        }
        if (v === undefined) {
            segments = this.segment(segment, v, build);
            if (!isArray(segments)) segments = segments !== undefined ? URI.decode(segments) : undefined;
            else for(i = 0, l = segments.length; i < l; i++)segments[i] = URI.decode(segments[i]);
            return segments;
        }
        if (!isArray(v)) v = typeof v === "string" || v instanceof String ? URI.encode(v) : v;
        else for(i = 0, l = v.length; i < l; i++)v[i] = URI.encode(v[i]);
        return this.segment(segment, v, build);
    };
    // mutating query string
    var q = p.query;
    p.query = function(v, build) {
        if (v === true) return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        else if (typeof v === "function") {
            var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
            var result = v.call(this, data);
            this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else if (v !== undefined && typeof v !== "string") {
            this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
            this.build(!build);
            return this;
        } else return q.call(this, v, build);
    };
    p.setQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        if (typeof name === "string" || name instanceof String) data[name] = value !== undefined ? value : null;
        else if (typeof name === "object") {
            for(var key in name)if (hasOwn.call(name, key)) data[key] = name[key];
        } else throw new TypeError("URI.addQuery() accepts an object, string as the name parameter");
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.addQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.addQuery(data, name, value === undefined ? null : value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.removeQuery = function(name, value, build) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        URI.removeQuery(data, name, value);
        this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
        if (typeof name !== "string") build = value;
        this.build(!build);
        return this;
    };
    p.hasQuery = function(name, value, withinArray) {
        var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
        return URI.hasQuery(data, name, value, withinArray);
    };
    p.setSearch = p.setQuery;
    p.addSearch = p.addQuery;
    p.removeSearch = p.removeQuery;
    p.hasSearch = p.hasQuery;
    // sanitizing URLs
    p.normalize = function() {
        if (this._parts.urn) return this.normalizeProtocol(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
        return this.normalizeProtocol(false).normalizeHostname(false).normalizePort(false).normalizePath(false).normalizeQuery(false).normalizeFragment(false).build();
    };
    p.normalizeProtocol = function(build) {
        if (typeof this._parts.protocol === "string") {
            this._parts.protocol = this._parts.protocol.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizeHostname = function(build) {
        if (this._parts.hostname) {
            if (this.is("IDN") && punycode) this._parts.hostname = punycode.toASCII(this._parts.hostname);
            else if (this.is("IPv6") && IPv6) this._parts.hostname = IPv6.best(this._parts.hostname);
            this._parts.hostname = this._parts.hostname.toLowerCase();
            this.build(!build);
        }
        return this;
    };
    p.normalizePort = function(build) {
        // remove port of it's the protocol's default
        if (typeof this._parts.protocol === "string" && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
            this._parts.port = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizePath = function(build) {
        var _path = this._parts.path;
        if (!_path) return this;
        if (this._parts.urn) {
            this._parts.path = URI.recodeUrnPath(this._parts.path);
            this.build(!build);
            return this;
        }
        if (this._parts.path === "/") return this;
        _path = URI.recodePath(_path);
        var _was_relative;
        var _leadingParents = "";
        var _parent, _pos;
        // handle relative paths
        if (_path.charAt(0) !== "/") {
            _was_relative = true;
            _path = "/" + _path;
        }
        // handle relative files (as opposed to directories)
        if (_path.slice(-3) === "/.." || _path.slice(-2) === "/.") _path += "/";
        // resolve simples
        _path = _path.replace(/(\/(\.\/)+)|(\/\.$)/g, "/").replace(/\/{2,}/g, "/");
        // remember leading parents
        if (_was_relative) {
            _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || "";
            if (_leadingParents) _leadingParents = _leadingParents[0];
        }
        // resolve parents
        while(true){
            _parent = _path.search(/\/\.\.(\/|$)/);
            if (_parent === -1) break;
            else if (_parent === 0) {
                // top level cannot be relative, skip it
                _path = _path.substring(3);
                continue;
            }
            _pos = _path.substring(0, _parent).lastIndexOf("/");
            if (_pos === -1) _pos = _parent;
            _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
        }
        // revert to relative
        if (_was_relative && this.is("relative")) _path = _leadingParents + _path.substring(1);
        this._parts.path = _path;
        this.build(!build);
        return this;
    };
    p.normalizePathname = p.normalizePath;
    p.normalizeQuery = function(build) {
        if (typeof this._parts.query === "string") {
            if (!this._parts.query.length) this._parts.query = null;
            else this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
            this.build(!build);
        }
        return this;
    };
    p.normalizeFragment = function(build) {
        if (!this._parts.fragment) {
            this._parts.fragment = null;
            this.build(!build);
        }
        return this;
    };
    p.normalizeSearch = p.normalizeQuery;
    p.normalizeHash = p.normalizeFragment;
    p.iso8859 = function() {
        // expect unicode input, iso8859 output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = escape;
        URI.decode = decodeURIComponent;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.unicode = function() {
        // expect iso8859 input, unicode output
        var e = URI.encode;
        var d = URI.decode;
        URI.encode = strictEncodeURIComponent;
        URI.decode = unescape;
        try {
            this.normalize();
        } finally{
            URI.encode = e;
            URI.decode = d;
        }
        return this;
    };
    p.readable = function() {
        var uri = this.clone();
        // removing username, password, because they shouldn't be displayed according to RFC 3986
        uri.username("").password("").normalize();
        var t = "";
        if (uri._parts.protocol) t += uri._parts.protocol + "://";
        if (uri._parts.hostname) {
            if (uri.is("punycode") && punycode) {
                t += punycode.toUnicode(uri._parts.hostname);
                if (uri._parts.port) t += ":" + uri._parts.port;
            } else t += uri.host();
        }
        if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== "/") t += "/";
        t += uri.path(true);
        if (uri._parts.query) {
            var q = "";
            for(var i = 0, qp = uri._parts.query.split("&"), l = qp.length; i < l; i++){
                var kv = (qp[i] || "").split("=");
                q += "&" + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace).replace(/&/g, "%26");
                if (kv[1] !== undefined) q += "=" + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace).replace(/&/g, "%26");
            }
            t += "?" + q.substring(1);
        }
        t += URI.decodeQuery(uri.hash(), true);
        return t;
    };
    // resolving relative and absolute URLs
    p.absoluteTo = function(base) {
        var resolved = this.clone();
        var properties = [
            "protocol",
            "username",
            "password",
            "hostname",
            "port"
        ];
        var basedir, i, p;
        if (this._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
        if (!(base instanceof URI)) base = new URI(base);
        if (resolved._parts.protocol) // Directly returns even if this._parts.hostname is empty.
        return resolved;
        else resolved._parts.protocol = base._parts.protocol;
        if (this._parts.hostname) return resolved;
        for(i = 0; p = properties[i]; i++)resolved._parts[p] = base._parts[p];
        if (!resolved._parts.path) {
            resolved._parts.path = base._parts.path;
            if (!resolved._parts.query) resolved._parts.query = base._parts.query;
        } else {
            if (resolved._parts.path.substring(-2) === "..") resolved._parts.path += "/";
            if (resolved.path().charAt(0) !== "/") {
                basedir = base.directory();
                basedir = basedir ? basedir : base.path().indexOf("/") === 0 ? "/" : "";
                resolved._parts.path = (basedir ? basedir + "/" : "") + resolved._parts.path;
                resolved.normalizePath();
            }
        }
        resolved.build();
        return resolved;
    };
    p.relativeTo = function(base) {
        var relative = this.clone().normalize();
        var relativeParts, baseParts, common, relativePath, basePath;
        if (relative._parts.urn) throw new Error("URNs do not have any generally defined hierarchical components");
        base = new URI(base).normalize();
        relativeParts = relative._parts;
        baseParts = base._parts;
        relativePath = relative.path();
        basePath = base.path();
        if (relativePath.charAt(0) !== "/") throw new Error("URI is already relative");
        if (basePath.charAt(0) !== "/") throw new Error("Cannot calculate a URI relative to another relative URI");
        if (relativeParts.protocol === baseParts.protocol) relativeParts.protocol = null;
        if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) return relative.build();
        if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) return relative.build();
        if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
            relativeParts.hostname = null;
            relativeParts.port = null;
        } else return relative.build();
        if (relativePath === basePath) {
            relativeParts.path = "";
            return relative.build();
        }
        // determine common sub path
        common = URI.commonPath(relativePath, basePath);
        // If the paths have nothing in common, return a relative URL with the absolute path.
        if (!common) return relative.build();
        var parents = baseParts.path.substring(common.length).replace(/[^\/]*$/, "").replace(/.*?\//g, "../");
        relativeParts.path = parents + relativeParts.path.substring(common.length) || "./";
        return relative.build();
    };
    // comparing URIs
    p.equals = function(uri) {
        var one = this.clone();
        var two = new URI(uri);
        var one_map = {};
        var two_map = {};
        var checked = {};
        var one_query, two_query, key;
        one.normalize();
        two.normalize();
        // exact match
        if (one.toString() === two.toString()) return true;
        // extract query string
        one_query = one.query();
        two_query = two.query();
        one.query("");
        two.query("");
        // definitely not equal if not even non-query parts match
        if (one.toString() !== two.toString()) return false;
        // query parameters have the same length, even if they're permuted
        if (one_query.length !== two_query.length) return false;
        one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
        two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);
        for(key in one_map)if (hasOwn.call(one_map, key)) {
            if (!isArray(one_map[key])) {
                if (one_map[key] !== two_map[key]) return false;
            } else if (!arraysEqual(one_map[key], two_map[key])) return false;
            checked[key] = true;
        }
        for(key in two_map)if (hasOwn.call(two_map, key)) {
            if (!checked[key]) // two contains a parameter not present in one
            return false;
        }
        return true;
    };
    // state
    p.preventInvalidHostname = function(v) {
        this._parts.preventInvalidHostname = !!v;
        return this;
    };
    p.duplicateQueryParameters = function(v) {
        this._parts.duplicateQueryParameters = !!v;
        return this;
    };
    p.escapeQuerySpace = function(v) {
        this._parts.escapeQuerySpace = !!v;
        return this;
    };
    return URI;
});

});
parcelRegister("63OAe", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("eK0Np", function(module, exports) {
/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory();
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.IPv6 = factory(root);
})(module.exports, function(root) {
    "use strict";
    /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */ // save current IPv6 variable, if any
    var _IPv6 = root && root.IPv6;
    function bestPresentation(address) {
        // based on:
        // Javascript to test an IPv6 address for proper format, and to
        // present the "best text representation" according to IETF Draft RFC at
        // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
        // 8 Feb 2010 Rich Brown, Dartware, LLC
        // Please feel free to use this code as long as you provide a link to
        // http://www.intermapper.com
        // http://intermapper.com/support/tools/IPV6-Validator.aspx
        // http://download.dartware.com/thirdparty/ipv6validator.js
        var _address = address.toLowerCase();
        var segments = _address.split(":");
        var length = segments.length;
        var total = 8;
        // trim colons (:: or ::a:b:c… or …a:b:c::)
        if (segments[0] === "" && segments[1] === "" && segments[2] === "") {
            // must have been ::
            // remove first two items
            segments.shift();
            segments.shift();
        } else if (segments[0] === "" && segments[1] === "") // must have been ::xxxx
        // remove the first item
        segments.shift();
        else if (segments[length - 1] === "" && segments[length - 2] === "") // must have been xxxx::
        segments.pop();
        length = segments.length;
        // adjust total segments for IPv4 trailer
        if (segments[length - 1].indexOf(".") !== -1) // found a "." which means IPv4
        total = 7;
        // fill empty segments them with "0000"
        var pos;
        for(pos = 0; pos < length; pos++){
            if (segments[pos] === "") break;
        }
        if (pos < total) {
            segments.splice(pos, 1, "0000");
            while(segments.length < total)segments.splice(pos, 0, "0000");
        }
        // strip leading zeros
        var _segments;
        for(var i = 0; i < total; i++){
            _segments = segments[i].split("");
            for(var j = 0; j < 3; j++){
                if (_segments[0] === "0" && _segments.length > 1) _segments.splice(0, 1);
                else break;
            }
            segments[i] = _segments.join("");
        }
        // find longest sequence of zeroes and coalesce them into one segment
        var best = -1;
        var _best = 0;
        var _current = 0;
        var current = -1;
        var inzeroes = false;
        // i; already declared
        for(i = 0; i < total; i++){
            if (inzeroes) {
                if (segments[i] === "0") _current += 1;
                else {
                    inzeroes = false;
                    if (_current > _best) {
                        best = current;
                        _best = _current;
                    }
                }
            } else if (segments[i] === "0") {
                inzeroes = true;
                current = i;
                _current = 1;
            }
        }
        if (_current > _best) {
            best = current;
            _best = _current;
        }
        if (_best > 1) segments.splice(best, _best, "");
        length = segments.length;
        // assemble remaining segments
        var result = "";
        if (segments[0] === "") result = ":";
        for(i = 0; i < length; i++){
            result += segments[i];
            if (i === length - 1) break;
            result += ":";
        }
        if (segments[length - 1] === "") result += ":";
        return result;
    }
    function noConflict() {
        /*jshint validthis: true */ if (root.IPv6 === this) root.IPv6 = _IPv6;
        return this;
    }
    return {
        best: bestPresentation,
        noConflict: noConflict
    };
});

});

parcelRegister("2969v", function(module, exports) {
/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.11
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */ (function(root, factory) {
    "use strict";
    // https://github.com/umdjs/umd/blob/master/returnExports.js
    if (0, module.exports) // Node
    module.exports = factory();
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
})(module.exports, function(root) {
    "use strict";
    // save current SecondLevelDomains variable, if any
    var _SecondLevelDomains = root && root.SecondLevelDomains;
    var SLD = {
        // list of known Second Level Domains
        // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
        // ----
        // publicsuffix.org is more current and actually used by a couple of browsers internally.
        // downside is it also contains domains like "dyndns.org" - which is fine for the security
        // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
        // ----
        list: {
            "ac": " com gov mil net org ",
            "ae": " ac co gov mil name net org pro sch ",
            "af": " com edu gov net org ",
            "al": " com edu gov mil net org ",
            "ao": " co ed gv it og pb ",
            "ar": " com edu gob gov int mil net org tur ",
            "at": " ac co gv or ",
            "au": " asn com csiro edu gov id net org ",
            "ba": " co com edu gov mil net org rs unbi unmo unsa untz unze ",
            "bb": " biz co com edu gov info net org store tv ",
            "bh": " biz cc com edu gov info net org ",
            "bn": " com edu gov net org ",
            "bo": " com edu gob gov int mil net org tv ",
            "br": " adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ",
            "bs": " com edu gov net org ",
            "bz": " du et om ov rg ",
            "ca": " ab bc mb nb nf nl ns nt nu on pe qc sk yk ",
            "ck": " biz co edu gen gov info net org ",
            "cn": " ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ",
            "co": " com edu gov mil net nom org ",
            "cr": " ac c co ed fi go or sa ",
            "cy": " ac biz com ekloges gov ltd name net org parliament press pro tm ",
            "do": " art com edu gob gov mil net org sld web ",
            "dz": " art asso com edu gov net org pol ",
            "ec": " com edu fin gov info med mil net org pro ",
            "eg": " com edu eun gov mil name net org sci ",
            "er": " com edu gov ind mil net org rochest w ",
            "es": " com edu gob nom org ",
            "et": " biz com edu gov info name net org ",
            "fj": " ac biz com info mil name net org pro ",
            "fk": " ac co gov net nom org ",
            "fr": " asso com f gouv nom prd presse tm ",
            "gg": " co net org ",
            "gh": " com edu gov mil org ",
            "gn": " ac com gov net org ",
            "gr": " com edu gov mil net org ",
            "gt": " com edu gob ind mil net org ",
            "gu": " com edu gov net org ",
            "hk": " com edu gov idv net org ",
            "hu": " 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ",
            "id": " ac co go mil net or sch web ",
            "il": " ac co gov idf k12 muni net org ",
            "in": " ac co edu ernet firm gen gov i ind mil net nic org res ",
            "iq": " com edu gov i mil net org ",
            "ir": " ac co dnssec gov i id net org sch ",
            "it": " edu gov ",
            "je": " co net org ",
            "jo": " com edu gov mil name net org sch ",
            "jp": " ac ad co ed go gr lg ne or ",
            "ke": " ac co go info me mobi ne or sc ",
            "kh": " com edu gov mil net org per ",
            "ki": " biz com de edu gov info mob net org tel ",
            "km": " asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ",
            "kn": " edu gov net org ",
            "kr": " ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ",
            "kw": " com edu gov net org ",
            "ky": " com edu gov net org ",
            "kz": " com edu gov mil net org ",
            "lb": " com edu gov net org ",
            "lk": " assn com edu gov grp hotel int ltd net ngo org sch soc web ",
            "lr": " com edu gov net org ",
            "lv": " asn com conf edu gov id mil net org ",
            "ly": " com edu gov id med net org plc sch ",
            "ma": " ac co gov m net org press ",
            "mc": " asso tm ",
            "me": " ac co edu gov its net org priv ",
            "mg": " com edu gov mil nom org prd tm ",
            "mk": " com edu gov inf name net org pro ",
            "ml": " com edu gov net org presse ",
            "mn": " edu gov org ",
            "mo": " com edu gov net org ",
            "mt": " com edu gov net org ",
            "mv": " aero biz com coop edu gov info int mil museum name net org pro ",
            "mw": " ac co com coop edu gov int museum net org ",
            "mx": " com edu gob net org ",
            "my": " com edu gov mil name net org sch ",
            "nf": " arts com firm info net other per rec store web ",
            "ng": " biz com edu gov mil mobi name net org sch ",
            "ni": " ac co com edu gob mil net nom org ",
            "np": " com edu gov mil net org ",
            "nr": " biz com edu gov info net org ",
            "om": " ac biz co com edu gov med mil museum net org pro sch ",
            "pe": " com edu gob mil net nom org sld ",
            "ph": " com edu gov i mil net ngo org ",
            "pk": " biz com edu fam gob gok gon gop gos gov net org web ",
            "pl": " art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ",
            "pr": " ac biz com edu est gov info isla name net org pro prof ",
            "ps": " com edu gov net org plo sec ",
            "pw": " belau co ed go ne or ",
            "ro": " arts com firm info nom nt org rec store tm www ",
            "rs": " ac co edu gov in org ",
            "sb": " com edu gov net org ",
            "sc": " com edu gov net org ",
            "sh": " co com edu gov net nom org ",
            "sl": " com edu gov net org ",
            "st": " co com consulado edu embaixada gov mil net org principe saotome store ",
            "sv": " com edu gob org red ",
            "sz": " ac co org ",
            "tr": " av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ",
            "tt": " aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ",
            "tw": " club com ebiz edu game gov idv mil net org ",
            "mu": " ac co com gov net or org ",
            "mz": " ac co edu gov org ",
            "na": " co com ",
            "nz": " ac co cri geek gen govt health iwi maori mil net org parliament school ",
            "pa": " abo ac com edu gob ing med net nom org sld ",
            "pt": " com edu gov int net nome org publ ",
            "py": " com edu gov mil net org ",
            "qa": " com edu gov mil net org ",
            "re": " asso com nom ",
            "ru": " ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ",
            "rw": " ac co com edu gouv gov int mil net ",
            "sa": " com edu gov med net org pub sch ",
            "sd": " com edu gov info med net org tv ",
            "se": " a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ",
            "sg": " com edu gov idn net org per ",
            "sn": " art com edu gouv org perso univ ",
            "sy": " com edu gov mil net news org ",
            "th": " ac co go in mi net or ",
            "tj": " ac biz co com edu go gov info int mil name net nic org test web ",
            "tn": " agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ",
            "tz": " ac co go ne or ",
            "ua": " biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ",
            "ug": " ac co go ne or org sc ",
            "uk": " ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ",
            "us": " dni fed isa kids nsn ",
            "uy": " com edu gub mil net org ",
            "ve": " co com edu gob info mil net org web ",
            "vi": " co com k12 net org ",
            "vn": " ac biz com edu gov health info int name net org pro ",
            "ye": " co com gov ltd me net org plc ",
            "yu": " ac co edu gov org ",
            "za": " ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ",
            "zm": " ac co com edu gov net org sch ",
            // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
            "com": "ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ",
            "net": "gb jp se uk ",
            "org": "ae",
            "de": "com "
        },
        // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
        // in both performance and memory footprint. No initialization required.
        // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
        // Following methods use lastIndexOf() rather than array.split() in order
        // to avoid any memory allocations.
        has: function(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(" " + domain.slice(sldOffset + 1, tldOffset) + " ") >= 0;
        },
        is: function(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return false;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset >= 0) return false;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return false;
            return sldList.indexOf(" " + domain.slice(0, tldOffset) + " ") >= 0;
        },
        get: function(domain) {
            var tldOffset = domain.lastIndexOf(".");
            if (tldOffset <= 0 || tldOffset >= domain.length - 1) return null;
            var sldOffset = domain.lastIndexOf(".", tldOffset - 1);
            if (sldOffset <= 0 || sldOffset >= tldOffset - 1) return null;
            var sldList = SLD.list[domain.slice(tldOffset + 1)];
            if (!sldList) return null;
            if (sldList.indexOf(" " + domain.slice(sldOffset + 1, tldOffset) + " ") < 0) return null;
            return domain.slice(sldOffset + 1);
        },
        noConflict: function() {
            if (root.SecondLevelDomains === this) root.SecondLevelDomains = _SecondLevelDomains;
            return this;
        }
    };
    return SLD;
});

});





parcelRegister("15gHg", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unTravel = $0ca335b36e5a028a$var$unTravel;

var $bryhC = parcelRequire("bryhC");

var $4Q5jk = parcelRequire("4Q5jk");
/**
* Recursively traverse through all items in the Prosemirror DOM
* and create a JDITA object
*
* @param prosemirrorDocument - The Prosemirror DOM object
* @returns The JDITA object
*/ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ca335b36e5a028a$var$unTravel(prosemirrorDocument) {
    var _a;
    // Prosemirror content will become JDITA children
    const children = (_a = prosemirrorDocument.content) === null || _a === void 0 ? void 0 : _a.map($0ca335b36e5a028a$var$unTravel);
    // attrs will become attributes
    const attributes = prosemirrorDocument.attrs || {};
    // get the node name
    const nodeName = $0ca335b36e5a028a$var$getJditaNodeName(prosemirrorDocument.type);
    if (nodeName === "video" || nodeName === "audio" || nodeName === "image") return $0ca335b36e5a028a$var$createMediaJDITAObject(nodeName, attributes, children);
    // handle the attributes
    delete attributes["parent"];
    for(const key in attributes)if (!attributes[key]) delete attributes[key];
    if (nodeName === "hard-break") return {
        nodeName: "text",
        content: "\n"
    };
    if (nodeName === "text") {
        // check for marks and wrap the content in the mark node
        if (prosemirrorDocument.marks) {
            const mark = prosemirrorDocument.marks[0].type;
            return {
                nodeName: mark,
                attributes: (0, $bryhC.deleteUndefined)(attributes),
                children: [
                    {
                        nodeName: "text",
                        content: prosemirrorDocument.text
                    }
                ]
            };
        }
        return {
            nodeName: nodeName,
            "content": prosemirrorDocument.text
        };
    }
    const nodeObject = {
        nodeName: nodeName,
        attributes: attributes,
        children: children
    };
    return nodeObject;
}
/**
 * Replace underscores with hyphens in node names
 *
 * @param type - The string to be modified
 * @returns The sanitized node name with hyphens
 */ function $0ca335b36e5a028a$var$getJditaNodeName(type) {
    return type.replace(/_/g, "-");
}
/**
 * Special untravel function for media nodes.
 * Reverses the transformation done by the NODES[value.nodeName] in the travel function
 *
 * @param nodeName - string node name
 * @param attributes - node attributes
 * @param children - JDita[] node children
 * @param prosemirrorDocument - prosemirror document
 * @returns JDita node
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0ca335b36e5a028a$var$createMediaJDITAObject(nodeName, attributes, children) {
    if (nodeName === "video") {
        // we must populate the video node with the necessary attributes and children
        const allVideoAttributes = {
            props: attributes.props,
            dir: attributes.dir,
            "xml:lang": attributes["xml:lang"],
            translate: attributes.translate,
            href: attributes.href,
            format: attributes.format,
            scope: attributes.scope,
            id: attributes.id,
            conref: attributes.conref,
            outputclass: attributes.outputclass,
            class: attributes.class,
            width: attributes.width,
            height: attributes.height,
            autoplay: attributes.autoplay,
            controls: attributes.controls,
            loop: attributes.loop,
            muted: attributes.muted,
            tabindex: attributes.tabindex
        };
        const allVideoChildren = [];
        if (attributes.title !== undefined) {
            const desc = $0ca335b36e5a028a$var$createMediaChild("desc", attributes.title);
            allVideoChildren.unshift(desc); // Add 'desc' at the beginning of the array to create the expected order
        }
        const fallbackChild = children.find((child)=>child.nodeName === "fallback");
        if (fallbackChild) {
            const fallback = fallbackChild;
            allVideoChildren.push(fallback);
        }
        if (attributes.poster !== undefined) {
            const poster = $0ca335b36e5a028a$var$createMediaChild("video-poster", attributes.poster);
            allVideoChildren.push(poster);
        }
        const mediaSourceChild = children.find((child)=>child.nodeName === "media-source");
        if (mediaSourceChild) {
            const mediaSource = mediaSourceChild;
            allVideoChildren.push(mediaSource);
        }
        const mediaTrackChild = children.find((child)=>child.nodeName === "media-track");
        if (mediaTrackChild) {
            const track = mediaTrackChild;
            allVideoChildren.push(track);
        }
        // return the created video node
        return {
            nodeName: nodeName,
            "attributes": (0, $bryhC.deleteUndefined)(allVideoAttributes),
            "children": allVideoChildren
        };
    }
    if (nodeName === "audio") {
        // Note: The order of attributes determines their ordering in the object structure
        // Important for creating unit test data
        const allAudioAttributes = {
            class: attributes.class,
            conref: attributes.conref,
            "xml:lang": attributes["xml:lang"],
            dir: attributes.dir,
            id: attributes.id,
            outputclass: attributes.outputclass,
            props: attributes.props,
            translate: attributes.translate,
            autoplay: attributes.autoplay,
            controls: attributes.controls,
            loop: attributes.loop,
            muted: attributes.muted,
            source: attributes.source,
            href: attributes.href,
            format: attributes.format,
            scope: attributes.scope,
            tabindex: attributes.tabindex
        };
        const allAudioChildren = [];
        if (attributes.title !== undefined) {
            const desc = $0ca335b36e5a028a$var$createMediaChild("desc", attributes.title);
            allAudioChildren.push(desc);
        }
        const mediaFallbackChild = children.find((child)=>child.nodeName === "fallback");
        if (mediaFallbackChild) {
            const fallback = mediaFallbackChild;
            allAudioChildren.push(fallback);
        }
        const mediaSourceChild = children.find((child)=>child.nodeName === "media-source");
        if (mediaSourceChild) {
            const mediaSource = mediaSourceChild;
            allAudioChildren.push(mediaSource);
        }
        // "source" can be an audio attribute, or a source element, both is allowed
        if (attributes.source !== undefined) {
            const source = $0ca335b36e5a028a$var$createMediaChild("media-source", attributes.source);
            allAudioChildren.push(source);
        }
        const mediaTrackChild = children.find((child)=>child.nodeName === "media-track");
        if (mediaTrackChild) {
            const track = mediaTrackChild;
            allAudioChildren.push(track);
        }
        return {
            nodeName: nodeName,
            "attributes": (0, $bryhC.deleteUndefined)(allAudioAttributes),
            "children": allAudioChildren
        };
    }
    if (nodeName === "image") {
        const allImageAttributes = {
            // %localization
            dir: attributes.dir,
            "xml:lang": attributes["xml:lang"],
            translate: attributes.translate,
            // %reference-content
            href: attributes.href,
            format: attributes.format,
            scope: attributes.scope,
            class: attributes.class,
            keyref: attributes.keyref,
            width: attributes.width,
            height: attributes.height,
            outputclass: attributes.outputclass
        };
        const allImageChildren = [];
        allImageChildren.push({
            nodeName: "alt",
            // all of the attributes will be undefined as the alt node only contains text
            attributes: {
                dir: undefined,
                "xml:lang": undefined,
                translate: undefined,
                keyref: undefined,
                outputclass: undefined,
                class: undefined
            },
            // FIXME: allowed children of `alt` are: 'b', 'em', 'i', 'ph', 'strong', 'sub', 'sup', 'tt', 'u'
            children: [
                {
                    nodeName: "text",
                    content: attributes.alt
                }
            ]
        });
        return {
            nodeName: nodeName,
            "attributes": (0, $bryhC.deleteUndefined)(allImageAttributes),
            "children": allImageChildren
        };
    }
    throw new Error("Invalid node name");
}
/**
 * Creates a media child node based on the provided node name, value, and additional attributes.
 *
 * @param nodeName - The name of the node to be created
 * @param value - The value associated with the node
 * @param additionalAttributes - Additional attributes for the node (optional)
 * @returns The created media child node (JDita)
 */ function $0ca335b36e5a028a$var$createMediaChild(nodeName, value, additionalAttributes) {
    // create an attributes object by merging the commonAttributes object,
    // and additional attributes based on the nodeName,
    // for media-source and video-poster add a href attribute
    const attributes = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, $4Q5jk.commonAttributes), nodeName === "desc" ? $4Q5jk.descAttributes : {}), nodeName === "fallback" ? $4Q5jk.fallbackAttributes : {}), nodeName === "video-poster" ? {
        href: value
    } : {}), nodeName === "media-source" ? {
        href: value
    } : {}), nodeName === "media-track" ? $4Q5jk.mediaTrackAttributes : {}), additionalAttributes || {});
    // create a node object based on the nodeName and attributes
    // in case of desc the value will be wrapped in a text node
    const node = {
        nodeName: nodeName,
        attributes: attributes,
        children: (()=>{
            if (nodeName === "desc") return [
                {
                    nodeName: "text",
                    content: `${value}`
                }
            ];
            else return undefined;
        })()
    };
    // return the created child node
    return {
        nodeName: nodeName,
        attributes: attributes,
        children: node.children
    };
}

});
parcelRegister("4Q5jk", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.descAttributes = module.exports.mediaTrackAttributes = module.exports.mediaSourceAttributes = module.exports.videoPosterAttributes = module.exports.fallbackAttributes = module.exports.videoAttributes = module.exports.audioAttributes = module.exports.imageAttributes = module.exports.commonAttributes = void 0;
/**
 * Common attributes for all media nodes
 */ module.exports.commonAttributes = {
    // %localization;
    dir: undefined,
    "xml:lang": undefined,
    translate: undefined,
    // classes
    outputclass: undefined,
    class: undefined
};
/**
 * Attributes for image nodes
 */ module.exports.imageAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    height: undefined,
    width: undefined,
    keyref: undefined,
    // %reference-content;
    href: undefined,
    format: undefined,
    scope: undefined
});
/**
 * Attributes for audio nodes
 */ module.exports.audioAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    autoplay: undefined,
    controls: undefined,
    loop: undefined,
    muted: undefined,
    tabindex: undefined,
    keyref: undefined,
    // %reference-content;
    href: undefined,
    format: undefined,
    scope: undefined,
    // %filters;
    props: undefined,
    // %reuse;
    id: undefined,
    conref: undefined
});
/**
 * Attributes for video nodes
 */ module.exports.videoAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    autoplay: undefined,
    controls: undefined,
    loop: undefined,
    muted: undefined,
    tabindex: undefined,
    height: undefined,
    width: undefined,
    // %reference-content;
    href: undefined,
    format: undefined,
    scope: undefined,
    // %filters;
    props: undefined,
    // %reuse;
    id: undefined,
    conref: undefined
});
/**
 * Attributes for fallback nodes
 */ module.exports.fallbackAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    props: undefined
});
/**
 * Attributes for video-poster nodes
 */ module.exports.videoPosterAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    href: undefined
});
/**
 * Attributes for media-source nodes
 */ module.exports.mediaSourceAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    keyref: undefined,
    // %reference-content;
    href: undefined,
    format: undefined,
    scope: undefined
});
/**
 * Attributes for media-track nodes
 */ module.exports.mediaTrackAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    // %reference-content;
    href: undefined,
    format: undefined,
    scope: undefined,
    keyref: undefined,
    kind: undefined,
    srclang: undefined
});
/**
 * Attributes for desc nodes
 */ module.exports.descAttributes = Object.assign(Object.assign({}, module.exports.commonAttributes), {
    props: undefined
});

});


parcelRegister("xZx54", function(module, exports) {
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $0662d04466c5d0ae$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfig = $0662d04466c5d0ae$var$parseConfig;

const $0662d04466c5d0ae$var$jtd_1 = $0662d04466c5d0ae$var$__importDefault((parcelRequire("gPlol")));
const $0662d04466c5d0ae$var$configJsonSchema = {
    properties: {
        server: {
            properties: {
                frontend: {
                    properties: {
                        url: {
                            type: "string"
                        }
                    }
                },
                api: {
                    properties: {
                        baseUrl: {
                            type: "string"
                        },
                        endpoint: {
                            properties: {
                                token: {
                                    type: "string"
                                },
                                user: {
                                    type: "string"
                                },
                                integration: {
                                    type: "string"
                                }
                            }
                        }
                    }
                }
            }
        },
        git: {
            properties: {
                branchPrefix: {
                    type: "string"
                },
                commitMessageSuffix: {
                    type: "string"
                }
            }
        },
        gitHub: {
            properties: {
                clientId: {
                    type: "string"
                }
            }
        }
    },
    additionalProperties: false
};
/**
 * Parse the configuration from JSON.
 *
 * @param jsonConfig - the JSON containing the config.
 *
 * @returns a Config object.
 */ function $0662d04466c5d0ae$var$parseConfig(jsonConfig) {
    // create a validating parser
    const ajv = new $0662d04466c5d0ae$var$jtd_1.default();
    const parse = ajv.compileParser($0662d04466c5d0ae$var$configJsonSchema);
    // parse the json
    const data = parse(jsonConfig);
    if (data === undefined) throw new Error("Unable to parse JSON: [" + parse.position + "] " + parse.message);
    else return data;
}

});
parcelRegister("gPlol", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;

var $3VIOx = parcelRequire("3VIOx");

var $hCMvI = parcelRequire("hCMvI");

var $5BeZS = parcelRequire("5BeZS");

var $2jnSB = parcelRequire("2jnSB");

var $aKDeZ = parcelRequire("aKDeZ");
const META_SCHEMA_ID = "JTD-meta-schema";
class Ajv extends $3VIOx.default {
    constructor(opts = {}){
        super({
            ...opts,
            jtd: true
        });
    }
    _addVocabularies() {
        super._addVocabularies();
        this.addVocabulary($hCMvI.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        this.addMetaSchema($5BeZS.default, META_SCHEMA_ID, false);
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
    compileSerializer(schema) {
        const sch = this._addSchema(schema);
        return sch.serialize || this._compileSerializer(sch);
    }
    compileParser(schema) {
        const sch = this._addSchema(schema);
        return sch.parse || this._compileParser(sch);
    }
    _compileSerializer(sch) {
        $2jnSB.default.call(this, sch, sch.schema.definitions || {});
        /* istanbul ignore if */ if (!sch.serialize) throw new Error("ajv implementation error");
        return sch.serialize;
    }
    _compileParser(sch) {
        $aKDeZ.default.call(this, sch, sch.schema.definitions || {});
        /* istanbul ignore if */ if (!sch.parse) throw new Error("ajv implementation error");
        return sch.parse;
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $1HVa7 = parcelRequire("1HVa7");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $1HVa7.KeywordCxt;
    }
});

var $4pmHt = parcelRequire("4pmHt");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $4pmHt._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $4pmHt.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $4pmHt.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $4pmHt.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $4pmHt.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $4pmHt.CodeGen;
    }
});

var $5lJYv = parcelRequire("5lJYv");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $5lJYv.default;
    }
});

var $1SZ5T = parcelRequire("1SZ5T");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $1SZ5T.default;
    }
});

});
parcelRegister("3VIOx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $1HVa7 = parcelRequire("1HVa7");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $1HVa7.KeywordCxt;
    }
});

var $4pmHt = parcelRequire("4pmHt");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $4pmHt._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $4pmHt.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $4pmHt.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $4pmHt.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $4pmHt.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $4pmHt.CodeGen;
    }
});

var $5lJYv = parcelRequire("5lJYv");

var $1SZ5T = parcelRequire("1SZ5T");

var $74cn9 = parcelRequire("74cn9");

var $3vHot = parcelRequire("3vHot");

var $4pmHt = parcelRequire("4pmHt");

var $7Xb8J = parcelRequire("7Xb8J");

var $dVYlM = parcelRequire("dVYlM");

var $leU6J = parcelRequire("leU6J");

var $8Je1D = parcelRequire("8Je1D");

var $g9nm9 = parcelRequire("g9nm9");
const $2dc97524f5616ee9$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$2dc97524f5616ee9$var$defaultRegExp.code = "new RegExp";
const $2dc97524f5616ee9$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $2dc97524f5616ee9$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $2dc97524f5616ee9$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $2dc97524f5616ee9$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $2dc97524f5616ee9$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $2dc97524f5616ee9$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $2dc97524f5616ee9$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $g9nm9.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $2dc97524f5616ee9$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $2dc97524f5616ee9$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $2dc97524f5616ee9$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$2dc97524f5616ee9$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $4pmHt.ValueScope({
            scope: {},
            prefixes: $2dc97524f5616ee9$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $2dc97524f5616ee9$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $74cn9.getRules)();
        $2dc97524f5616ee9$var$checkOptions.call(this, $2dc97524f5616ee9$var$removedOptions, opts, "NOT SUPPORTED");
        $2dc97524f5616ee9$var$checkOptions.call(this, $2dc97524f5616ee9$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $2dc97524f5616ee9$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $2dc97524f5616ee9$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $2dc97524f5616ee9$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $2dc97524f5616ee9$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $8Je1D;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$8Je1D
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $1SZ5T.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $7Xb8J.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $2dc97524f5616ee9$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $3vHot.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $3vHot.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $2dc97524f5616ee9$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $7Xb8J.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $2dc97524f5616ee9$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $leU6J.eachItem)(keyword, (kwd)=>$2dc97524f5616ee9$var$addRule.call(this, kwd));
            return this;
        }
        $2dc97524f5616ee9$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $dVYlM.getJSONTypes)(def.type),
            schemaType: (0, $dVYlM.getJSONTypes)(def.schemaType)
        };
        (0, $leU6J.eachItem)(keyword, definition.type.length === 0 ? (k)=>$2dc97524f5616ee9$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$2dc97524f5616ee9$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $2dc97524f5616ee9$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $7Xb8J.normalizeId)(id || baseId);
        const localRefs = $7Xb8J.getSchemaRefs.call(this, schema, baseId);
        sch = new $3vHot.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $3vHot.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $3vHot.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
$2dc97524f5616ee9$var$Ajv.ValidationError = $5lJYv.default;
$2dc97524f5616ee9$var$Ajv.MissingRefError = $1SZ5T.default;
module.exports.default = $2dc97524f5616ee9$var$Ajv;
function $2dc97524f5616ee9$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $2dc97524f5616ee9$var$getSchEnv(keyRef) {
    keyRef = (0, $7Xb8J.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $2dc97524f5616ee9$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $2dc97524f5616ee9$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $2dc97524f5616ee9$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $2dc97524f5616ee9$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $2dc97524f5616ee9$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $2dc97524f5616ee9$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $2dc97524f5616ee9$var$getLogger(logger) {
    if (logger === false) return $2dc97524f5616ee9$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $2dc97524f5616ee9$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $2dc97524f5616ee9$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $leU6J.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$2dc97524f5616ee9$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $2dc97524f5616ee9$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $dVYlM.getJSONTypes)(definition.type),
            schemaType: (0, $dVYlM.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $2dc97524f5616ee9$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $2dc97524f5616ee9$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $2dc97524f5616ee9$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $2dc97524f5616ee9$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $2dc97524f5616ee9$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $2dc97524f5616ee9$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $2dc97524f5616ee9$var$$dataRef
        ]
    };
}

});
parcelRegister("1HVa7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $7DPTj = parcelRequire("7DPTj");

var $dVYlM = parcelRequire("dVYlM");

var $eJ1Xi = parcelRequire("eJ1Xi");

var $dVYlM = parcelRequire("dVYlM");

var $dGPBf = parcelRequire("dGPBf");

var $aGaOS = parcelRequire("aGaOS");

var $kLNYw = parcelRequire("kLNYw");

var $4pmHt = parcelRequire("4pmHt");

var $3ZPj5 = parcelRequire("3ZPj5");

var $7Xb8J = parcelRequire("7Xb8J");

var $leU6J = parcelRequire("leU6J");

var $2W7cp = parcelRequire("2W7cp");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $13e625d466fc8bd6$var$validateFunctionCode(it) {
    if ($13e625d466fc8bd6$var$isSchemaObj(it)) {
        $13e625d466fc8bd6$var$checkKeywords(it);
        if ($13e625d466fc8bd6$var$schemaCxtHasRules(it)) {
            $13e625d466fc8bd6$var$topSchemaObjCode(it);
            return;
        }
    }
    $13e625d466fc8bd6$var$validateFunction(it, ()=>(0, $7DPTj.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $13e625d466fc8bd6$var$validateFunctionCode;
function $13e625d466fc8bd6$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $4pmHt._)`${$3ZPj5.default.data}, ${$3ZPj5.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $4pmHt._)`"use strict"; ${$13e625d466fc8bd6$var$funcSourceUrl(schema, opts)}`);
        $13e625d466fc8bd6$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $4pmHt._)`${$3ZPj5.default.data}, ${$13e625d466fc8bd6$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($13e625d466fc8bd6$var$funcSourceUrl(schema, opts)).code(body));
}
function $13e625d466fc8bd6$var$destructureValCxt(opts) {
    return (0, $4pmHt._)`{${$3ZPj5.default.instancePath}="", ${$3ZPj5.default.parentData}, ${$3ZPj5.default.parentDataProperty}, ${$3ZPj5.default.rootData}=${$3ZPj5.default.data}${opts.dynamicRef ? (0, $4pmHt._)`, ${$3ZPj5.default.dynamicAnchors}={}` : $4pmHt.nil}}={}`;
}
function $13e625d466fc8bd6$var$destructureValCxtES5(gen, opts) {
    gen.if($3ZPj5.default.valCxt, ()=>{
        gen.var($3ZPj5.default.instancePath, (0, $4pmHt._)`${$3ZPj5.default.valCxt}.${$3ZPj5.default.instancePath}`);
        gen.var($3ZPj5.default.parentData, (0, $4pmHt._)`${$3ZPj5.default.valCxt}.${$3ZPj5.default.parentData}`);
        gen.var($3ZPj5.default.parentDataProperty, (0, $4pmHt._)`${$3ZPj5.default.valCxt}.${$3ZPj5.default.parentDataProperty}`);
        gen.var($3ZPj5.default.rootData, (0, $4pmHt._)`${$3ZPj5.default.valCxt}.${$3ZPj5.default.rootData}`);
        if (opts.dynamicRef) gen.var($3ZPj5.default.dynamicAnchors, (0, $4pmHt._)`${$3ZPj5.default.valCxt}.${$3ZPj5.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($3ZPj5.default.instancePath, (0, $4pmHt._)`""`);
        gen.var($3ZPj5.default.parentData, (0, $4pmHt._)`undefined`);
        gen.var($3ZPj5.default.parentDataProperty, (0, $4pmHt._)`undefined`);
        gen.var($3ZPj5.default.rootData, $3ZPj5.default.data);
        if (opts.dynamicRef) gen.var($3ZPj5.default.dynamicAnchors, (0, $4pmHt._)`{}`);
    });
}
function $13e625d466fc8bd6$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $13e625d466fc8bd6$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $13e625d466fc8bd6$var$commentKeyword(it);
        $13e625d466fc8bd6$var$checkNoDefault(it);
        gen.let($3ZPj5.default.vErrors, null);
        gen.let($3ZPj5.default.errors, 0);
        if (opts.unevaluated) $13e625d466fc8bd6$var$resetEvaluated(it);
        $13e625d466fc8bd6$var$typeAndKeywords(it);
        $13e625d466fc8bd6$var$returnResults(it);
    });
    return;
}
function $13e625d466fc8bd6$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $4pmHt._)`${validateName}.evaluated`);
    gen.if((0, $4pmHt._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $4pmHt._)`${it.evaluated}.props`, (0, $4pmHt._)`undefined`));
    gen.if((0, $4pmHt._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $4pmHt._)`${it.evaluated}.items`, (0, $4pmHt._)`undefined`));
}
function $13e625d466fc8bd6$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $4pmHt._)`/*# sourceURL=${schId} */` : $4pmHt.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $13e625d466fc8bd6$var$subschemaCode(it, valid) {
    if ($13e625d466fc8bd6$var$isSchemaObj(it)) {
        $13e625d466fc8bd6$var$checkKeywords(it);
        if ($13e625d466fc8bd6$var$schemaCxtHasRules(it)) {
            $13e625d466fc8bd6$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $7DPTj.boolOrEmptySchema)(it, valid);
}
function $13e625d466fc8bd6$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $13e625d466fc8bd6$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $13e625d466fc8bd6$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $13e625d466fc8bd6$var$commentKeyword(it);
    $13e625d466fc8bd6$var$updateContext(it);
    $13e625d466fc8bd6$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $3ZPj5.default.errors);
    $13e625d466fc8bd6$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $4pmHt._)`${errsCount} === ${$3ZPj5.default.errors}`);
}
function $13e625d466fc8bd6$var$checkKeywords(it) {
    (0, $leU6J.checkUnknownRules)(it);
    $13e625d466fc8bd6$var$checkRefsAndKeywords(it);
}
function $13e625d466fc8bd6$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $13e625d466fc8bd6$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $dVYlM.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $dVYlM.coerceAndCheckDataType)(it, types);
    $13e625d466fc8bd6$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $13e625d466fc8bd6$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $leU6J.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $13e625d466fc8bd6$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $leU6J.checkStrictMode)(it, "default is ignored in the schema root");
}
function $13e625d466fc8bd6$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $7Xb8J.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $13e625d466fc8bd6$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $13e625d466fc8bd6$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $4pmHt._)`${$3ZPj5.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $4pmHt.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $4pmHt._)`${$3ZPj5.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $13e625d466fc8bd6$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $4pmHt._)`${$3ZPj5.default.errors} === 0`, ()=>gen.return($3ZPj5.default.data), ()=>gen.throw((0, $4pmHt._)`new ${ValidationError}(${$3ZPj5.default.vErrors})`));
    else {
        gen.assign((0, $4pmHt._)`${validateName}.errors`, $3ZPj5.default.vErrors);
        if (opts.unevaluated) $13e625d466fc8bd6$var$assignEvaluated(it);
        gen.return((0, $4pmHt._)`${$3ZPj5.default.errors} === 0`);
    }
}
function $13e625d466fc8bd6$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $4pmHt.Name) gen.assign((0, $4pmHt._)`${evaluated}.props`, props);
    if (items instanceof $4pmHt.Name) gen.assign((0, $4pmHt._)`${evaluated}.items`, items);
}
function $13e625d466fc8bd6$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $leU6J.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$13e625d466fc8bd6$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $13e625d466fc8bd6$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $eJ1Xi.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $dVYlM.checkDataType)(group.type, data, opts.strictNumbers));
            $13e625d466fc8bd6$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $dVYlM.reportTypeError)(it);
            }
            gen.endIf();
        } else $13e625d466fc8bd6$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $4pmHt._)`${$3ZPj5.default.errors} === ${errsCount || 0}`);
    }
}
function $13e625d466fc8bd6$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $dGPBf.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $eJ1Xi.shouldUseRule)(schema, rule)) $13e625d466fc8bd6$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $13e625d466fc8bd6$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $13e625d466fc8bd6$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $13e625d466fc8bd6$var$checkMultipleTypes(it, types);
    $13e625d466fc8bd6$var$checkKeywordTypes(it, it.dataTypes);
}
function $13e625d466fc8bd6$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$13e625d466fc8bd6$var$includesType(it.dataTypes, t)) $13e625d466fc8bd6$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    $13e625d466fc8bd6$var$narrowSchemaTypes(it, types);
}
function $13e625d466fc8bd6$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $13e625d466fc8bd6$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $13e625d466fc8bd6$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $eJ1Xi.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$13e625d466fc8bd6$var$hasApplicableType(ts, t))) $13e625d466fc8bd6$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $13e625d466fc8bd6$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $13e625d466fc8bd6$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $13e625d466fc8bd6$var$narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if ($13e625d466fc8bd6$var$includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function $13e625d466fc8bd6$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $leU6J.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $13e625d466fc8bd6$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $aGaOS.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $leU6J.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $13e625d466fc8bd6$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $aGaOS.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $3ZPj5.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $4pmHt.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $4pmHt.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $4pmHt._)`${schemaCode} !== undefined && (${(0, $4pmHt.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $2W7cp.reportExtraError : $2W7cp.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $2W7cp.reportError)(this, this.def.$dataError || $2W7cp.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $2W7cp.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $4pmHt.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $4pmHt.nil, $dataValid = $4pmHt.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $4pmHt.or)((0, $4pmHt._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $4pmHt.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $4pmHt.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $4pmHt.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $4pmHt.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $4pmHt._)`${(0, $dVYlM.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $dVYlM.DataType.Wrong)}`;
            }
            return $4pmHt.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $4pmHt._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $4pmHt.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $kLNYw.getSubschema)(this.it, appl);
        (0, $kLNYw.extendSubschemaData)(subschema, this.it, appl);
        (0, $kLNYw.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $13e625d466fc8bd6$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $leU6J.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $leU6J.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $4pmHt.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $13e625d466fc8bd6$var$KeywordCxt;
function $13e625d466fc8bd6$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $13e625d466fc8bd6$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $aGaOS.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $aGaOS.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $aGaOS.funcKeywordCode)(cxt, def);
}
const $13e625d466fc8bd6$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $13e625d466fc8bd6$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $13e625d466fc8bd6$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $3ZPj5.default.rootData;
    if ($data[0] === "/") {
        if (!$13e625d466fc8bd6$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $3ZPj5.default.rootData;
    } else {
        const matches = $13e625d466fc8bd6$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)((0, $leU6J.unescapeJsonPointer)(segment))}`;
        expr = (0, $4pmHt._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $13e625d466fc8bd6$var$getData;

});
parcelRegister("7DPTj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $2W7cp = parcelRequire("2W7cp");

var $4pmHt = parcelRequire("4pmHt");

var $3ZPj5 = parcelRequire("3ZPj5");
const $016f8e26ccbf1821$var$boolError = {
    message: "boolean schema is false"
};
function $016f8e26ccbf1821$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $016f8e26ccbf1821$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($3ZPj5.default.data);
    else {
        gen.assign((0, $4pmHt._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $016f8e26ccbf1821$var$topBoolOrEmptySchema;
function $016f8e26ccbf1821$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $016f8e26ccbf1821$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $016f8e26ccbf1821$var$boolOrEmptySchema;
function $016f8e26ccbf1821$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $2W7cp.reportError)(cxt, $016f8e26ccbf1821$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("2W7cp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $leU6J = parcelRequire("leU6J");

var $3ZPj5 = parcelRequire("3ZPj5");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $4pmHt.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $4pmHt.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $4pmHt.str)`"${keyword}" keyword is invalid ($data)`
};
function $22369525586ccba7$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $22369525586ccba7$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $22369525586ccba7$var$addError(gen, errObj);
    else $22369525586ccba7$var$returnErrors(it, (0, $4pmHt._)`[${errObj}]`);
}
module.exports.reportError = $22369525586ccba7$var$reportError;
function $22369525586ccba7$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $22369525586ccba7$var$errorObjectCode(cxt, error, errorPaths);
    $22369525586ccba7$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $22369525586ccba7$var$returnErrors(it, $3ZPj5.default.vErrors);
}
module.exports.reportExtraError = $22369525586ccba7$var$reportExtraError;
function $22369525586ccba7$var$resetErrorsCount(gen, errsCount) {
    gen.assign($3ZPj5.default.errors, errsCount);
    gen.if((0, $4pmHt._)`${$3ZPj5.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $4pmHt._)`${$3ZPj5.default.vErrors}.length`, errsCount), ()=>gen.assign($3ZPj5.default.vErrors, null)));
}
module.exports.resetErrorsCount = $22369525586ccba7$var$resetErrorsCount;
function $22369525586ccba7$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $3ZPj5.default.errors, (i)=>{
        gen.const(err, (0, $4pmHt._)`${$3ZPj5.default.vErrors}[${i}]`);
        gen.if((0, $4pmHt._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $4pmHt._)`${err}.instancePath`, (0, $4pmHt.strConcat)($3ZPj5.default.instancePath, it.errorPath)));
        gen.assign((0, $4pmHt._)`${err}.schemaPath`, (0, $4pmHt.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $4pmHt._)`${err}.schema`, schemaValue);
            gen.assign((0, $4pmHt._)`${err}.data`, data);
        }
    });
}
module.exports.extendErrors = $22369525586ccba7$var$extendErrors;
function $22369525586ccba7$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $4pmHt._)`${$3ZPj5.default.vErrors} === null`, ()=>gen.assign($3ZPj5.default.vErrors, (0, $4pmHt._)`[${err}]`), (0, $4pmHt._)`${$3ZPj5.default.vErrors}.push(${err})`);
    gen.code((0, $4pmHt._)`${$3ZPj5.default.errors}++`);
}
function $22369525586ccba7$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $4pmHt._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $4pmHt._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $22369525586ccba7$var$E = {
    keyword: new $4pmHt.Name("keyword"),
    schemaPath: new $4pmHt.Name("schemaPath"),
    params: new $4pmHt.Name("params"),
    propertyName: new $4pmHt.Name("propertyName"),
    message: new $4pmHt.Name("message"),
    schema: new $4pmHt.Name("schema"),
    parentSchema: new $4pmHt.Name("parentSchema")
};
function $22369525586ccba7$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $4pmHt._)`{}`;
    return $22369525586ccba7$var$errorObject(cxt, error, errorPaths);
}
function $22369525586ccba7$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $22369525586ccba7$var$errorInstancePath(it, errorPaths),
        $22369525586ccba7$var$errorSchemaPath(cxt, errorPaths)
    ];
    $22369525586ccba7$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $22369525586ccba7$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $4pmHt.str)`${errorPath}${(0, $leU6J.getErrorPath)(instancePath, $leU6J.Type.Str)}` : errorPath;
    return [
        $3ZPj5.default.instancePath,
        (0, $4pmHt.strConcat)($3ZPj5.default.instancePath, instPath)
    ];
}
function $22369525586ccba7$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $4pmHt.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $4pmHt.str)`${schPath}${(0, $leU6J.getErrorPath)(schemaPath, $leU6J.Type.Str)}`;
    return [
        $22369525586ccba7$var$E.schemaPath,
        schPath
    ];
}
function $22369525586ccba7$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $22369525586ccba7$var$E.keyword,
        keyword
    ], [
        $22369525586ccba7$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $4pmHt._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $22369525586ccba7$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $22369525586ccba7$var$E.schema,
        schemaValue
    ], [
        $22369525586ccba7$var$E.parentSchema,
        (0, $4pmHt._)`${topSchemaRef}${schemaPath}`
    ], [
        $3ZPj5.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $22369525586ccba7$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("4pmHt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $dNane = parcelRequire("dNane");

var $kyL5p = parcelRequire("kyL5p");

var $dNane = parcelRequire("dNane");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $dNane._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $dNane.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $dNane.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $dNane.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $dNane.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $dNane.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $dNane.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $dNane.Name;
    }
});

var $kyL5p = parcelRequire("kyL5p");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $kyL5p.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $kyL5p.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $kyL5p.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $kyL5p.varKinds;
    }
});
module.exports.operators = {
    GT: new $dNane._Code(">"),
    GTE: new $dNane._Code(">="),
    LT: new $dNane._Code("<"),
    LTE: new $dNane._Code("<="),
    EQ: new $dNane._Code("==="),
    NEQ: new $dNane._Code("!=="),
    NOT: new $dNane._Code("!"),
    OR: new $dNane._Code("||"),
    AND: new $dNane._Code("&&"),
    ADD: new $dNane._Code("+")
};
class $335b1b01710d189c$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $335b1b01710d189c$var$Def extends $335b1b01710d189c$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $kyL5p.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $335b1b01710d189c$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $dNane._CodeOrName ? this.rhs.names : {};
    }
}
class $335b1b01710d189c$var$Assign extends $335b1b01710d189c$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $dNane.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $335b1b01710d189c$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $dNane.Name ? {} : {
            ...this.lhs.names
        };
        return $335b1b01710d189c$var$addExprNames(names, this.rhs);
    }
}
class $335b1b01710d189c$var$AssignOp extends $335b1b01710d189c$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $335b1b01710d189c$var$Label extends $335b1b01710d189c$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $335b1b01710d189c$var$Break extends $335b1b01710d189c$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $335b1b01710d189c$var$Throw extends $335b1b01710d189c$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $335b1b01710d189c$var$AnyCode extends $335b1b01710d189c$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $335b1b01710d189c$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $dNane._CodeOrName ? this.code.names : {};
    }
}
class $335b1b01710d189c$var$ParentNode extends $335b1b01710d189c$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $335b1b01710d189c$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$335b1b01710d189c$var$addNames(names, n.names), {});
    }
}
class $335b1b01710d189c$var$BlockNode extends $335b1b01710d189c$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $335b1b01710d189c$var$Root extends $335b1b01710d189c$var$ParentNode {
}
class $335b1b01710d189c$var$Else extends $335b1b01710d189c$var$BlockNode {
}
$335b1b01710d189c$var$Else.kind = "else";
class $335b1b01710d189c$var$If extends $335b1b01710d189c$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $335b1b01710d189c$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $335b1b01710d189c$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $335b1b01710d189c$var$If($335b1b01710d189c$var$not(cond), e instanceof $335b1b01710d189c$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $335b1b01710d189c$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $335b1b01710d189c$var$addExprNames(names, this.condition);
        if (this.else) $335b1b01710d189c$var$addNames(names, this.else.names);
        return names;
    }
}
$335b1b01710d189c$var$If.kind = "if";
class $335b1b01710d189c$var$For extends $335b1b01710d189c$var$BlockNode {
}
$335b1b01710d189c$var$For.kind = "for";
class $335b1b01710d189c$var$ForLoop extends $335b1b01710d189c$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $335b1b01710d189c$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $335b1b01710d189c$var$addNames(super.names, this.iteration.names);
    }
}
class $335b1b01710d189c$var$ForRange extends $335b1b01710d189c$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $kyL5p.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $335b1b01710d189c$var$addExprNames(super.names, this.from);
        return $335b1b01710d189c$var$addExprNames(names, this.to);
    }
}
class $335b1b01710d189c$var$ForIter extends $335b1b01710d189c$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $335b1b01710d189c$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $335b1b01710d189c$var$addNames(super.names, this.iterable.names);
    }
}
class $335b1b01710d189c$var$Func extends $335b1b01710d189c$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$335b1b01710d189c$var$Func.kind = "func";
class $335b1b01710d189c$var$Return extends $335b1b01710d189c$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$335b1b01710d189c$var$Return.kind = "return";
class $335b1b01710d189c$var$Try extends $335b1b01710d189c$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $335b1b01710d189c$var$addNames(names, this.catch.names);
        if (this.finally) $335b1b01710d189c$var$addNames(names, this.finally.names);
        return names;
    }
}
class $335b1b01710d189c$var$Catch extends $335b1b01710d189c$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$335b1b01710d189c$var$Catch.kind = "catch";
class $335b1b01710d189c$var$Finally extends $335b1b01710d189c$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$335b1b01710d189c$var$Finally.kind = "finally";
class $335b1b01710d189c$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $kyL5p.Scope({
            parent: extScope
        });
        this._nodes = [
            new $335b1b01710d189c$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $335b1b01710d189c$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($kyL5p.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($kyL5p.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($kyL5p.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $335b1b01710d189c$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $335b1b01710d189c$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $dNane.nil) this._leafNode(new $335b1b01710d189c$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $dNane.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $dNane._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $335b1b01710d189c$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $335b1b01710d189c$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $335b1b01710d189c$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($335b1b01710d189c$var$If, $335b1b01710d189c$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $335b1b01710d189c$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $kyL5p.varKinds.var : $kyL5p.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $335b1b01710d189c$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $kyL5p.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $dNane.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $dNane._)`${arr}.length`, (i)=>{
                this.var(name, (0, $dNane._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $335b1b01710d189c$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $kyL5p.varKinds.var : $kyL5p.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $dNane._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $335b1b01710d189c$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($335b1b01710d189c$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $335b1b01710d189c$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $335b1b01710d189c$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $335b1b01710d189c$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($335b1b01710d189c$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $335b1b01710d189c$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $335b1b01710d189c$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $335b1b01710d189c$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($335b1b01710d189c$var$Catch, $335b1b01710d189c$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $335b1b01710d189c$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $dNane.nil, async, funcBody) {
        this._blockNode(new $335b1b01710d189c$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($335b1b01710d189c$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $335b1b01710d189c$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $335b1b01710d189c$var$CodeGen;
function $335b1b01710d189c$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $335b1b01710d189c$var$addExprNames(names, from) {
    return from instanceof $dNane._CodeOrName ? $335b1b01710d189c$var$addNames(names, from.names) : names;
}
function $335b1b01710d189c$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $dNane.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $dNane._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $dNane.Name) c = replaceName(c);
        if (c instanceof $dNane._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $dNane._Code && e._items.some((c)=>c instanceof $dNane.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $335b1b01710d189c$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $335b1b01710d189c$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $dNane._)`!${$335b1b01710d189c$var$par(x)}`;
}
module.exports.not = $335b1b01710d189c$var$not;
const $335b1b01710d189c$var$andCode = $335b1b01710d189c$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $335b1b01710d189c$var$and(...args) {
    return args.reduce($335b1b01710d189c$var$andCode);
}
module.exports.and = $335b1b01710d189c$var$and;
const $335b1b01710d189c$var$orCode = $335b1b01710d189c$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $335b1b01710d189c$var$or(...args) {
    return args.reduce($335b1b01710d189c$var$orCode);
}
module.exports.or = $335b1b01710d189c$var$or;
function $335b1b01710d189c$var$mappend(op) {
    return (x, y)=>x === $dNane.nil ? y : y === $dNane.nil ? x : (0, $dNane._)`${$335b1b01710d189c$var$par(x)} ${op} ${$335b1b01710d189c$var$par(y)}`;
}
function $335b1b01710d189c$var$par(x) {
    return x instanceof $dNane.Name ? x : (0, $dNane._)`(${x})`;
}

});
parcelRegister("dNane", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class $a0a7e5fd284a5422$var$_CodeOrName {
}
module.exports._CodeOrName = $a0a7e5fd284a5422$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $a0a7e5fd284a5422$var$Name extends $a0a7e5fd284a5422$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $a0a7e5fd284a5422$var$Name;
class $a0a7e5fd284a5422$var$_Code extends $a0a7e5fd284a5422$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $a0a7e5fd284a5422$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $a0a7e5fd284a5422$var$_Code;
module.exports.nil = new $a0a7e5fd284a5422$var$_Code("");
function $a0a7e5fd284a5422$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $a0a7e5fd284a5422$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $a0a7e5fd284a5422$var$_Code(code);
}
module.exports._ = $a0a7e5fd284a5422$var$_;
const $a0a7e5fd284a5422$var$plus = new $a0a7e5fd284a5422$var$_Code("+");
function $a0a7e5fd284a5422$var$str(strs, ...args) {
    const expr = [
        $a0a7e5fd284a5422$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($a0a7e5fd284a5422$var$plus);
        $a0a7e5fd284a5422$var$addCodeArg(expr, args[i]);
        expr.push($a0a7e5fd284a5422$var$plus, $a0a7e5fd284a5422$var$safeStringify(strs[++i]));
    }
    $a0a7e5fd284a5422$var$optimize(expr);
    return new $a0a7e5fd284a5422$var$_Code(expr);
}
module.exports.str = $a0a7e5fd284a5422$var$str;
function $a0a7e5fd284a5422$var$addCodeArg(code, arg) {
    if (arg instanceof $a0a7e5fd284a5422$var$_Code) code.push(...arg._items);
    else if (arg instanceof $a0a7e5fd284a5422$var$Name) code.push(arg);
    else code.push($a0a7e5fd284a5422$var$interpolate(arg));
}
module.exports.addCodeArg = $a0a7e5fd284a5422$var$addCodeArg;
function $a0a7e5fd284a5422$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $a0a7e5fd284a5422$var$plus) {
            const res = $a0a7e5fd284a5422$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $a0a7e5fd284a5422$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $a0a7e5fd284a5422$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $a0a7e5fd284a5422$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $a0a7e5fd284a5422$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $a0a7e5fd284a5422$var$str`${c1}${c2}`;
}
module.exports.strConcat = $a0a7e5fd284a5422$var$strConcat;
// TODO do not allow arrays here
function $a0a7e5fd284a5422$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $a0a7e5fd284a5422$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $a0a7e5fd284a5422$var$stringify(x) {
    return new $a0a7e5fd284a5422$var$_Code($a0a7e5fd284a5422$var$safeStringify(x));
}
module.exports.stringify = $a0a7e5fd284a5422$var$stringify;
function $a0a7e5fd284a5422$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $a0a7e5fd284a5422$var$safeStringify;
function $a0a7e5fd284a5422$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $a0a7e5fd284a5422$var$_Code(`.${key}`) : $a0a7e5fd284a5422$var$_`[${key}]`;
}
module.exports.getProperty = $a0a7e5fd284a5422$var$getProperty;
//Does best effort to format the name properly
function $a0a7e5fd284a5422$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $a0a7e5fd284a5422$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $a0a7e5fd284a5422$var$getEsmExportName;
function $a0a7e5fd284a5422$var$regexpCode(rx) {
    return new $a0a7e5fd284a5422$var$_Code(rx.toString());
}
module.exports.regexpCode = $a0a7e5fd284a5422$var$regexpCode;

});

parcelRegister("kyL5p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $dNane = parcelRequire("dNane");
class $ef7b81faee9ca308$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $ef7b81faee9ca308$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($ef7b81faee9ca308$var$UsedValueState || (module.exports.UsedValueState = $ef7b81faee9ca308$var$UsedValueState = {}));
module.exports.varKinds = {
    const: new $dNane.Name("const"),
    let: new $dNane.Name("let"),
    var: new $dNane.Name("var")
};
class $ef7b81faee9ca308$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $dNane.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $dNane.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $ef7b81faee9ca308$var$Scope;
class $ef7b81faee9ca308$var$ValueScopeName extends $dNane.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $dNane._)`.${new $dNane.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $ef7b81faee9ca308$var$ValueScopeName;
const $ef7b81faee9ca308$var$line = (0, $dNane._)`\n`;
class $ef7b81faee9ca308$var$ValueScope extends $ef7b81faee9ca308$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $ef7b81faee9ca308$var$line : $dNane.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $ef7b81faee9ca308$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $dNane._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $dNane.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $ef7b81faee9ca308$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $dNane._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $dNane._)`${code}${c}${this.opts._n}`;
                else throw new $ef7b81faee9ca308$var$ValueError(name);
                nameSet.set(name, $ef7b81faee9ca308$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $ef7b81faee9ca308$var$ValueScope;

});


parcelRegister("leU6J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $dNane = parcelRequire("dNane");
// TODO refactor to use Set
function $f7666d8e940989d2$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $f7666d8e940989d2$var$toHash;
function $f7666d8e940989d2$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $f7666d8e940989d2$var$checkUnknownRules(it, schema);
    return !$f7666d8e940989d2$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $f7666d8e940989d2$var$alwaysValidSchema;
function $f7666d8e940989d2$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $f7666d8e940989d2$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $f7666d8e940989d2$var$checkUnknownRules;
function $f7666d8e940989d2$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $f7666d8e940989d2$var$schemaHasRules;
function $f7666d8e940989d2$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $f7666d8e940989d2$var$schemaHasRulesButRef;
function $f7666d8e940989d2$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $4pmHt._)`${schema}`;
    }
    return (0, $4pmHt._)`${topSchemaRef}${schemaPath}${(0, $4pmHt.getProperty)(keyword)}`;
}
module.exports.schemaRefOrVal = $f7666d8e940989d2$var$schemaRefOrVal;
function $f7666d8e940989d2$var$unescapeFragment(str) {
    return $f7666d8e940989d2$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $f7666d8e940989d2$var$unescapeFragment;
function $f7666d8e940989d2$var$escapeFragment(str) {
    return encodeURIComponent($f7666d8e940989d2$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $f7666d8e940989d2$var$escapeFragment;
function $f7666d8e940989d2$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $f7666d8e940989d2$var$escapeJsonPointer;
function $f7666d8e940989d2$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $f7666d8e940989d2$var$unescapeJsonPointer;
function $f7666d8e940989d2$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $f7666d8e940989d2$var$eachItem;
function $f7666d8e940989d2$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $4pmHt.Name ? (from instanceof $4pmHt.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $4pmHt.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $4pmHt.Name && !(res instanceof $4pmHt.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $f7666d8e940989d2$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $4pmHt._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $4pmHt._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $4pmHt._)`${to} || {}`).code((0, $4pmHt._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $4pmHt._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $4pmHt._)`${to} || {}`);
                    $f7666d8e940989d2$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $f7666d8e940989d2$var$evaluatedPropsToName
    }),
    items: $f7666d8e940989d2$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $4pmHt._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $4pmHt._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $4pmHt._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $4pmHt._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $f7666d8e940989d2$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $4pmHt._)`{}`);
    if (ps !== undefined) $f7666d8e940989d2$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $f7666d8e940989d2$var$evaluatedPropsToName;
function $f7666d8e940989d2$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $4pmHt._)`${props}${(0, $4pmHt.getProperty)(p)}`, true));
}
module.exports.setEvaluated = $f7666d8e940989d2$var$setEvaluated;
const $f7666d8e940989d2$var$snippets = {};
function $f7666d8e940989d2$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $f7666d8e940989d2$var$snippets[f.code] || ($f7666d8e940989d2$var$snippets[f.code] = new $dNane._Code(f.code))
    });
}
module.exports.useFunc = $f7666d8e940989d2$var$useFunc;
var $f7666d8e940989d2$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($f7666d8e940989d2$var$Type || (module.exports.Type = $f7666d8e940989d2$var$Type = {}));
function $f7666d8e940989d2$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $4pmHt.Name) {
        const isNumber = dataPropType === $f7666d8e940989d2$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $4pmHt._)`"[" + ${dataProp} + "]"` : (0, $4pmHt._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $4pmHt._)`"/" + ${dataProp}` : (0, $4pmHt._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $4pmHt.getProperty)(dataProp).toString() : "/" + $f7666d8e940989d2$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $f7666d8e940989d2$var$getErrorPath;
function $f7666d8e940989d2$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $f7666d8e940989d2$var$checkStrictMode;

});

parcelRegister("3ZPj5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4pmHt = parcelRequire("4pmHt");
const $2e8ede1902fd74ed$var$names = {
    // validation function arguments
    data: new $4pmHt.Name("data"),
    // args passed from referencing schema
    valCxt: new $4pmHt.Name("valCxt"),
    instancePath: new $4pmHt.Name("instancePath"),
    parentData: new $4pmHt.Name("parentData"),
    parentDataProperty: new $4pmHt.Name("parentDataProperty"),
    rootData: new $4pmHt.Name("rootData"),
    dynamicAnchors: new $4pmHt.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $4pmHt.Name("vErrors"),
    errors: new $4pmHt.Name("errors"),
    this: new $4pmHt.Name("this"),
    // "globals"
    self: new $4pmHt.Name("self"),
    scope: new $4pmHt.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $4pmHt.Name("json"),
    jsonPos: new $4pmHt.Name("jsonPos"),
    jsonLen: new $4pmHt.Name("jsonLen"),
    jsonPart: new $4pmHt.Name("jsonPart")
};
module.exports.default = $2e8ede1902fd74ed$var$names;

});



parcelRegister("dVYlM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $74cn9 = parcelRequire("74cn9");

var $eJ1Xi = parcelRequire("eJ1Xi");

var $2W7cp = parcelRequire("2W7cp");

var $4pmHt = parcelRequire("4pmHt");

var $leU6J = parcelRequire("leU6J");
var $a24f698a7fd3c8dc$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($a24f698a7fd3c8dc$var$DataType || (module.exports.DataType = $a24f698a7fd3c8dc$var$DataType = {}));
function $a24f698a7fd3c8dc$var$getSchemaTypes(schema) {
    const types = $a24f698a7fd3c8dc$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $a24f698a7fd3c8dc$var$getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function $a24f698a7fd3c8dc$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($74cn9.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $a24f698a7fd3c8dc$var$getJSONTypes;
function $a24f698a7fd3c8dc$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $a24f698a7fd3c8dc$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $eJ1Xi.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $a24f698a7fd3c8dc$var$checkDataTypes(types, data, opts.strictNumbers, $a24f698a7fd3c8dc$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $a24f698a7fd3c8dc$var$coerceData(it, types, coerceTo);
            else $a24f698a7fd3c8dc$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $a24f698a7fd3c8dc$var$coerceAndCheckDataType;
const $a24f698a7fd3c8dc$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $a24f698a7fd3c8dc$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$a24f698a7fd3c8dc$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $a24f698a7fd3c8dc$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $4pmHt._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $4pmHt._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $4pmHt._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $4pmHt._)`${data}[0]`).assign(dataType, (0, $4pmHt._)`typeof ${data}`).if($a24f698a7fd3c8dc$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $4pmHt._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($a24f698a7fd3c8dc$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $a24f698a7fd3c8dc$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $4pmHt._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $a24f698a7fd3c8dc$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $4pmHt._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $4pmHt._)`"" + ${data}`).elseIf((0, $4pmHt._)`${data} === null`).assign(coerced, (0, $4pmHt._)`""`);
                return;
            case "number":
                gen.elseIf((0, $4pmHt._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $4pmHt._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $4pmHt._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $4pmHt._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $4pmHt._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $4pmHt._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $4pmHt._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $4pmHt._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $4pmHt._)`[${data}]`);
        }
    }
}
function $a24f698a7fd3c8dc$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $4pmHt._)`${parentData} !== undefined`, ()=>gen.assign((0, $4pmHt._)`${parentData}[${parentDataProperty}]`, expr));
}
function $a24f698a7fd3c8dc$var$checkDataType(dataType, data, strictNums, correct = $a24f698a7fd3c8dc$var$DataType.Correct) {
    const EQ = correct === $a24f698a7fd3c8dc$var$DataType.Correct ? $4pmHt.operators.EQ : $4pmHt.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $4pmHt._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $4pmHt._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $4pmHt._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $4pmHt._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $4pmHt._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $a24f698a7fd3c8dc$var$DataType.Correct ? cond : (0, $4pmHt.not)(cond);
    function numCond(_cond = $4pmHt.nil) {
        return (0, $4pmHt.and)((0, $4pmHt._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $4pmHt._)`isFinite(${data})` : $4pmHt.nil);
    }
}
module.exports.checkDataType = $a24f698a7fd3c8dc$var$checkDataType;
function $a24f698a7fd3c8dc$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $a24f698a7fd3c8dc$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $leU6J.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $4pmHt._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $4pmHt._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $4pmHt.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $4pmHt.and)(cond, $a24f698a7fd3c8dc$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $a24f698a7fd3c8dc$var$checkDataTypes;
const $a24f698a7fd3c8dc$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $4pmHt._)`{type: ${schema}}` : (0, $4pmHt._)`{type: ${schemaValue}}`
};
function $a24f698a7fd3c8dc$var$reportTypeError(it) {
    const cxt = $a24f698a7fd3c8dc$var$getTypeErrorContext(it);
    (0, $2W7cp.reportError)(cxt, $a24f698a7fd3c8dc$var$typeError);
}
module.exports.reportTypeError = $a24f698a7fd3c8dc$var$reportTypeError;
function $a24f698a7fd3c8dc$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $leU6J.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("74cn9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $525281068de8e0f1$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $525281068de8e0f1$var$jsonTypes = new Set($525281068de8e0f1$var$_jsonTypes);
function $525281068de8e0f1$var$isJSONType(x) {
    return typeof x == "string" && $525281068de8e0f1$var$jsonTypes.has(x);
}
module.exports.isJSONType = $525281068de8e0f1$var$isJSONType;
function $525281068de8e0f1$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $525281068de8e0f1$var$getRules;

});

parcelRegister("eJ1Xi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $ab86c8f0066a04fe$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $ab86c8f0066a04fe$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $ab86c8f0066a04fe$var$schemaHasRulesForType;
function $ab86c8f0066a04fe$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$ab86c8f0066a04fe$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $ab86c8f0066a04fe$var$shouldUseGroup;
function $ab86c8f0066a04fe$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $ab86c8f0066a04fe$var$shouldUseRule;

});


parcelRegister("dGPBf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $leU6J = parcelRequire("leU6J");
function $9f77393b6183266e$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$9f77393b6183266e$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$9f77393b6183266e$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $9f77393b6183266e$var$assignDefaults;
function $9f77393b6183266e$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $leU6J.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $4pmHt._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $4pmHt._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $4pmHt._)`${childData} = ${(0, $4pmHt.stringify)(defaultValue)}`);
}

});

parcelRegister("aGaOS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $3ZPj5 = parcelRequire("3ZPj5");

var $bLF7l = parcelRequire("bLF7l");

var $2W7cp = parcelRequire("2W7cp");
function $7c6638272e5f72e3$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $7c6638272e5f72e3$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $4pmHt.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $7c6638272e5f72e3$var$macroKeywordCode;
function $7c6638272e5f72e3$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $7c6638272e5f72e3$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $7c6638272e5f72e3$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $7c6638272e5f72e3$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $7c6638272e5f72e3$var$modifyData(cxt);
            reportErrs(()=>$7c6638272e5f72e3$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $4pmHt._)`await `), (e)=>gen.assign(valid, false).if((0, $4pmHt._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $4pmHt._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $4pmHt._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($4pmHt.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $4pmHt._)`await ` : $4pmHt.nil) {
        const passCxt = it.opts.passContext ? $3ZPj5.default.this : $3ZPj5.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $4pmHt._)`${_await}${(0, $bLF7l.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $4pmHt.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $7c6638272e5f72e3$var$funcKeywordCode;
function $7c6638272e5f72e3$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $4pmHt._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $7c6638272e5f72e3$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $4pmHt._)`Array.isArray(${errs})`, ()=>{
        gen.assign($3ZPj5.default.vErrors, (0, $4pmHt._)`${$3ZPj5.default.vErrors} === null ? ${errs} : ${$3ZPj5.default.vErrors}.concat(${errs})`).assign($3ZPj5.default.errors, (0, $4pmHt._)`${$3ZPj5.default.vErrors}.length`);
        (0, $2W7cp.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $7c6638272e5f72e3$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $7c6638272e5f72e3$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $4pmHt.stringify)(result)
    });
}
function $7c6638272e5f72e3$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $7c6638272e5f72e3$var$validSchemaType;
function $7c6638272e5f72e3$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $7c6638272e5f72e3$var$validateKeywordUsage;

});
parcelRegister("bLF7l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $leU6J = parcelRequire("leU6J");

var $3ZPj5 = parcelRequire("3ZPj5");

var $leU6J = parcelRequire("leU6J");
function $8913fa8d7c20910f$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($8913fa8d7c20910f$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $4pmHt._)`${prop}`
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $8913fa8d7c20910f$var$checkReportMissingProp;
function $8913fa8d7c20910f$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $4pmHt.or)(...properties.map((prop)=>(0, $4pmHt.and)($8913fa8d7c20910f$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $4pmHt._)`${missing} = ${prop}`)));
}
module.exports.checkMissingProp = $8913fa8d7c20910f$var$checkMissingProp;
function $8913fa8d7c20910f$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $8913fa8d7c20910f$var$reportMissingProp;
function $8913fa8d7c20910f$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $4pmHt._)`Object.prototype.hasOwnProperty`
    });
}
module.exports.hasPropFunc = $8913fa8d7c20910f$var$hasPropFunc;
function $8913fa8d7c20910f$var$isOwnProperty(gen, data, property) {
    return (0, $4pmHt._)`${$8913fa8d7c20910f$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
module.exports.isOwnProperty = $8913fa8d7c20910f$var$isOwnProperty;
function $8913fa8d7c20910f$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $4pmHt._)`${cond} && ${$8913fa8d7c20910f$var$isOwnProperty(gen, data, property)}` : cond;
}
module.exports.propertyInData = $8913fa8d7c20910f$var$propertyInData;
function $8913fa8d7c20910f$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $4pmHt.or)(cond, (0, $4pmHt.not)($8913fa8d7c20910f$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $8913fa8d7c20910f$var$noPropertyInData;
function $8913fa8d7c20910f$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $8913fa8d7c20910f$var$allSchemaProperties;
function $8913fa8d7c20910f$var$schemaProperties(it, schemaMap) {
    return $8913fa8d7c20910f$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $leU6J.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $8913fa8d7c20910f$var$schemaProperties;
function $8913fa8d7c20910f$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $4pmHt._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $3ZPj5.default.instancePath,
            (0, $4pmHt.strConcat)($3ZPj5.default.instancePath, errorPath)
        ],
        [
            $3ZPj5.default.parentData,
            it.parentData
        ],
        [
            $3ZPj5.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $3ZPj5.default.rootData,
            $3ZPj5.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $3ZPj5.default.dynamicAnchors,
        $3ZPj5.default.dynamicAnchors
    ]);
    const args = (0, $4pmHt._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $4pmHt.nil ? (0, $4pmHt._)`${func}.call(${context}, ${args})` : (0, $4pmHt._)`${func}(${args})`;
}
module.exports.callValidateCode = $8913fa8d7c20910f$var$callValidateCode;
const $8913fa8d7c20910f$var$newRegExp = (0, $4pmHt._)`new RegExp`;
function $8913fa8d7c20910f$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $4pmHt._)`${regExp.code === "new RegExp" ? $8913fa8d7c20910f$var$newRegExp : (0, $leU6J.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
module.exports.usePattern = $8913fa8d7c20910f$var$usePattern;
function $8913fa8d7c20910f$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $4pmHt._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $leU6J.Type.Num
            }, valid);
            gen.if((0, $4pmHt.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $8913fa8d7c20910f$var$validateArray;
function $8913fa8d7c20910f$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $leU6J.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $4pmHt._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $4pmHt.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $8913fa8d7c20910f$var$validateUnion;

});


parcelRegister("kLNYw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $leU6J = parcelRequire("leU6J");
function $f1eef67173a9bd23$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $4pmHt._)`${it.schemaPath}${(0, $4pmHt.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $4pmHt._)`${it.schemaPath}${(0, $4pmHt.getProperty)(keyword)}${(0, $4pmHt.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $leU6J.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $f1eef67173a9bd23$var$getSubschema;
function $f1eef67173a9bd23$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $4pmHt._)`${it.data}${(0, $4pmHt.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $4pmHt.str)`${errorPath}${(0, $leU6J.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $4pmHt._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $4pmHt.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $f1eef67173a9bd23$var$extendSubschemaData;
function $f1eef67173a9bd23$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $f1eef67173a9bd23$var$extendSubschemaMode;

});

parcelRegister("7Xb8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $leU6J = parcelRequire("leU6J");

var $egl9j = parcelRequire("egl9j");

var $7Z2pt = parcelRequire("7Z2pt");
// TODO refactor to use keyword definitions
const $5ca6af3cd04e8eb1$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $5ca6af3cd04e8eb1$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$5ca6af3cd04e8eb1$var$hasRef(schema);
    if (!limit) return false;
    return $5ca6af3cd04e8eb1$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $5ca6af3cd04e8eb1$var$inlineRef;
const $5ca6af3cd04e8eb1$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $5ca6af3cd04e8eb1$var$hasRef(schema) {
    for(const key in schema){
        if ($5ca6af3cd04e8eb1$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($5ca6af3cd04e8eb1$var$hasRef)) return true;
        if (typeof sch == "object" && $5ca6af3cd04e8eb1$var$hasRef(sch)) return true;
    }
    return false;
}
function $5ca6af3cd04e8eb1$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($5ca6af3cd04e8eb1$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $leU6J.eachItem)(schema[key], (sch)=>count += $5ca6af3cd04e8eb1$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $5ca6af3cd04e8eb1$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $5ca6af3cd04e8eb1$var$normalizeId(id);
    const p = resolver.parse(id);
    return $5ca6af3cd04e8eb1$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $5ca6af3cd04e8eb1$var$getFullPath;
function $5ca6af3cd04e8eb1$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $5ca6af3cd04e8eb1$var$_getFullPath;
const $5ca6af3cd04e8eb1$var$TRAILING_SLASH_HASH = /#\/?$/;
function $5ca6af3cd04e8eb1$var$normalizeId(id) {
    return id ? id.replace($5ca6af3cd04e8eb1$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $5ca6af3cd04e8eb1$var$normalizeId;
function $5ca6af3cd04e8eb1$var$resolveUrl(resolver, baseId, id) {
    id = $5ca6af3cd04e8eb1$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $5ca6af3cd04e8eb1$var$resolveUrl;
const $5ca6af3cd04e8eb1$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $5ca6af3cd04e8eb1$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $5ca6af3cd04e8eb1$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $5ca6af3cd04e8eb1$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $7Z2pt(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $5ca6af3cd04e8eb1$var$normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $5ca6af3cd04e8eb1$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$5ca6af3cd04e8eb1$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$egl9j(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $5ca6af3cd04e8eb1$var$getSchemaRefs;

});
parcelRegister("egl9j", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("7Z2pt", function(module, exports) {
"use strict";
var $5d00197a40550bb7$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == "function") {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == "function" ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $5d00197a40550bb7$var$_traverse(opts, pre, post, schema, "", schema);
};
$5d00197a40550bb7$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$5d00197a40550bb7$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$5d00197a40550bb7$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$5d00197a40550bb7$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $5d00197a40550bb7$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == "object" && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $5d00197a40550bb7$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$5d00197a40550bb7$var$_traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $5d00197a40550bb7$var$traverse.propsKeywords) {
                if (sch && typeof sch == "object") for(var prop in sch)$5d00197a40550bb7$var$_traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + $5d00197a40550bb7$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $5d00197a40550bb7$var$traverse.keywords || opts.allKeys && !(key in $5d00197a40550bb7$var$traverse.skipKeywords)) $5d00197a40550bb7$var$_traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $5d00197a40550bb7$var$escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}

});



parcelRegister("5lJYv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $3e5293950aaec907$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $3e5293950aaec907$var$ValidationError;

});

parcelRegister("1SZ5T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7Xb8J = parcelRequire("7Xb8J");
class $15fa399d12b6766d$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $7Xb8J.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $7Xb8J.normalizeId)((0, $7Xb8J.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $15fa399d12b6766d$var$MissingRefError;

});

parcelRegister("3vHot", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $5lJYv = parcelRequire("5lJYv");

var $3ZPj5 = parcelRequire("3ZPj5");

var $7Xb8J = parcelRequire("7Xb8J");

var $leU6J = parcelRequire("leU6J");

var $1HVa7 = parcelRequire("1HVa7");
class $28e5ed72d3d0e5a9$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $7Xb8J.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $28e5ed72d3d0e5a9$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $28e5ed72d3d0e5a9$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $28e5ed72d3d0e5a9$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $7Xb8J.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $4pmHt.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $5lJYv.default,
        code: (0, $4pmHt._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $3ZPj5.default.data,
        parentData: $3ZPj5.default.parentData,
        parentDataProperty: $3ZPj5.default.parentDataProperty,
        dataNames: [
            $3ZPj5.default.data
        ],
        dataPathArr: [
            $4pmHt.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $4pmHt.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $4pmHt.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $4pmHt._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $1HVa7.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($3ZPj5.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$3ZPj5.default.self}`, `${$3ZPj5.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $4pmHt.Name ? undefined : props,
                items: items instanceof $4pmHt.Name ? undefined : items,
                dynamicProps: props instanceof $4pmHt.Name,
                dynamicItems: items instanceof $4pmHt.Name
            };
            if (validate.source) validate.source.evaluated = (0, $4pmHt.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $28e5ed72d3d0e5a9$var$compileSchema;
function $28e5ed72d3d0e5a9$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $7Xb8J.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $28e5ed72d3d0e5a9$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $28e5ed72d3d0e5a9$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $28e5ed72d3d0e5a9$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $28e5ed72d3d0e5a9$var$resolveRef;
function $28e5ed72d3d0e5a9$var$inlineOrCompile(sch) {
    if ((0, $7Xb8J.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $28e5ed72d3d0e5a9$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $28e5ed72d3d0e5a9$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($28e5ed72d3d0e5a9$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $28e5ed72d3d0e5a9$var$getCompilingSchema;
function $28e5ed72d3d0e5a9$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $28e5ed72d3d0e5a9$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $28e5ed72d3d0e5a9$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $28e5ed72d3d0e5a9$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $7Xb8J._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $7Xb8J.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $28e5ed72d3d0e5a9$var$getJsonPointer.call(this, p, root);
    const id = (0, $7Xb8J.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $28e5ed72d3d0e5a9$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $28e5ed72d3d0e5a9$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $28e5ed72d3d0e5a9$var$compileSchema.call(this, schOrRef);
    if (id === (0, $7Xb8J.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $7Xb8J.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $28e5ed72d3d0e5a9$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $28e5ed72d3d0e5a9$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $28e5ed72d3d0e5a9$var$resolveSchema;
const $28e5ed72d3d0e5a9$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $28e5ed72d3d0e5a9$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $leU6J.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$28e5ed72d3d0e5a9$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $7Xb8J.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $leU6J.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $7Xb8J.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $28e5ed72d3d0e5a9$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $28e5ed72d3d0e5a9$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("8Je1D", function(module, exports) {
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

});

parcelRegister("g9nm9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6qeul = parcelRequire("6qeul");
$6qeul.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $6qeul;

});
parcelRegister("6qeul", function(module, exports) {
"use strict";

var $6IkXK = parcelRequire("6IkXK");
var $4ad068e8387cea06$require$normalizeIPv6 = $6IkXK.normalizeIPv6;
var $4ad068e8387cea06$require$normalizeIPv4 = $6IkXK.normalizeIPv4;
var $4ad068e8387cea06$require$removeDotSegments = $6IkXK.removeDotSegments;
var $4ad068e8387cea06$require$recomposeAuthority = $6IkXK.recomposeAuthority;
var $4ad068e8387cea06$require$normalizeComponentEncoding = $6IkXK.normalizeComponentEncoding;

var $lFr1Y = parcelRequire("lFr1Y");
function $4ad068e8387cea06$var$normalize(uri, options) {
    if (typeof uri === "string") uri = $4ad068e8387cea06$var$serialize($4ad068e8387cea06$var$parse(uri, options), options);
    else if (typeof uri === "object") uri = $4ad068e8387cea06$var$parse($4ad068e8387cea06$var$serialize(uri, options), options);
    return uri;
}
function $4ad068e8387cea06$var$resolve(baseURI, relativeURI, options) {
    const schemelessOptions = Object.assign({
        scheme: "null"
    }, options);
    const resolved = $4ad068e8387cea06$var$resolveComponents($4ad068e8387cea06$var$parse(baseURI, schemelessOptions), $4ad068e8387cea06$var$parse(relativeURI, schemelessOptions), schemelessOptions, true);
    return $4ad068e8387cea06$var$serialize(resolved, {
        ...schemelessOptions,
        skipEscape: true
    });
}
function $4ad068e8387cea06$var$resolveComponents(base, relative, options, skipNormalization) {
    const target = {};
    if (!skipNormalization) {
        base = $4ad068e8387cea06$var$parse($4ad068e8387cea06$var$serialize(base, options), options) // normalize base components
        ;
        relative = $4ad068e8387cea06$var$parse($4ad068e8387cea06$var$serialize(relative, options), options) // normalize relative components
        ;
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        // target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = $4ad068e8387cea06$require$removeDotSegments(relative.path || "");
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            // target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = $4ad068e8387cea06$require$removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) target.query = relative.query;
                else target.query = base.query;
            } else {
                if (relative.path.charAt(0) === "/") target.path = $4ad068e8387cea06$require$removeDotSegments(relative.path);
                else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                    else if (!base.path) target.path = relative.path;
                    else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                    target.path = $4ad068e8387cea06$require$removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            // target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}
function $4ad068e8387cea06$var$equal(uriA, uriB, options) {
    if (typeof uriA === "string") {
        uriA = unescape(uriA);
        uriA = $4ad068e8387cea06$var$serialize($4ad068e8387cea06$require$normalizeComponentEncoding($4ad068e8387cea06$var$parse(uriA, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriA === "object") uriA = $4ad068e8387cea06$var$serialize($4ad068e8387cea06$require$normalizeComponentEncoding(uriA, true), {
        ...options,
        skipEscape: true
    });
    if (typeof uriB === "string") {
        uriB = unescape(uriB);
        uriB = $4ad068e8387cea06$var$serialize($4ad068e8387cea06$require$normalizeComponentEncoding($4ad068e8387cea06$var$parse(uriB, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriB === "object") uriB = $4ad068e8387cea06$var$serialize($4ad068e8387cea06$require$normalizeComponentEncoding(uriB, true), {
        ...options,
        skipEscape: true
    });
    return uriA.toLowerCase() === uriB.toLowerCase();
}
function $4ad068e8387cea06$var$serialize(cmpts, opts) {
    const components = {
        host: cmpts.host,
        scheme: cmpts.scheme,
        userinfo: cmpts.userinfo,
        port: cmpts.port,
        path: cmpts.path,
        query: cmpts.query,
        nid: cmpts.nid,
        nss: cmpts.nss,
        uuid: cmpts.uuid,
        fragment: cmpts.fragment,
        reference: cmpts.reference,
        resourceName: cmpts.resourceName,
        secure: cmpts.secure,
        error: ""
    };
    const options = Object.assign({}, opts);
    const uriTokens = [];
    // find scheme handler
    const schemeHandler = $lFr1Y[(options.scheme || components.scheme || "").toLowerCase()];
    // perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
    if (components.path !== undefined) {
        if (!options.skipEscape) {
            components.path = escape(components.path);
            if (components.scheme !== undefined) components.path = components.path.split("%3A").join(":");
        } else components.path = unescape(components.path);
    }
    if (options.reference !== "suffix" && components.scheme) uriTokens.push(components.scheme, ":");
    const authority = $4ad068e8387cea06$require$recomposeAuthority(components, options);
    if (authority !== undefined) {
        if (options.reference !== "suffix") uriTokens.push("//");
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
    }
    if (components.path !== undefined) {
        let s = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = $4ad068e8387cea06$require$removeDotSegments(s);
        if (authority === undefined) s = s.replace(/^\/\//u, "/%2F") // don't allow the path to start with "//"
        ;
        uriTokens.push(s);
    }
    if (components.query !== undefined) uriTokens.push("?", components.query);
    if (components.fragment !== undefined) uriTokens.push("#", components.fragment);
    return uriTokens.join("");
}
const $4ad068e8387cea06$var$hexLookUp = Array.from({
    length: 127
}, (v, k)=>/[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(k)));
function $4ad068e8387cea06$var$nonSimpleDomain(value) {
    let code = 0;
    for(let i = 0, len = value.length; i < len; ++i){
        code = value.charCodeAt(i);
        if (code > 126 || $4ad068e8387cea06$var$hexLookUp[code]) return true;
    }
    return false;
}
const $4ad068e8387cea06$var$URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
function $4ad068e8387cea06$var$parse(uri, opts) {
    const options = Object.assign({}, opts);
    const parsed = {
        scheme: undefined,
        userinfo: undefined,
        host: "",
        port: undefined,
        path: "",
        query: undefined,
        fragment: undefined
    };
    const gotEncoding = uri.indexOf("%") !== -1;
    let isIP = false;
    if (options.reference === "suffix") uri = (options.scheme ? options.scheme + ":" : "") + "//" + uri;
    const matches = uri.match($4ad068e8387cea06$var$URI_PARSE);
    if (matches) {
        // store each component
        parsed.scheme = matches[1];
        parsed.userinfo = matches[3];
        parsed.host = matches[4];
        parsed.port = parseInt(matches[5], 10);
        parsed.path = matches[6] || "";
        parsed.query = matches[7];
        parsed.fragment = matches[8];
        // fix port number
        if (isNaN(parsed.port)) parsed.port = matches[5];
        if (parsed.host) {
            const ipv4result = $4ad068e8387cea06$require$normalizeIPv4(parsed.host);
            if (ipv4result.isIPV4 === false) {
                const ipv6result = $4ad068e8387cea06$require$normalizeIPv6(ipv4result.host, {
                    isIPV4: false
                });
                parsed.host = ipv6result.host.toLowerCase();
                isIP = ipv6result.isIPV6;
            } else {
                parsed.host = ipv4result.host;
                isIP = true;
            }
        }
        if (parsed.scheme === undefined && parsed.userinfo === undefined && parsed.host === undefined && parsed.port === undefined && !parsed.path && parsed.query === undefined) parsed.reference = "same-document";
        else if (parsed.scheme === undefined) parsed.reference = "relative";
        else if (parsed.fragment === undefined) parsed.reference = "absolute";
        else parsed.reference = "uri";
        // check for reference errors
        if (options.reference && options.reference !== "suffix" && options.reference !== parsed.reference) parsed.error = parsed.error || "URI is not a " + options.reference + " reference.";
        // find scheme handler
        const schemeHandler = $lFr1Y[(options.scheme || parsed.scheme || "").toLowerCase()];
        // check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            // if host component is a domain name
            if (parsed.host && (options.domainHost || schemeHandler && schemeHandler.domainHost) && isIP === false && $4ad068e8387cea06$var$nonSimpleDomain(parsed.host)) // convert Unicode IDN -> ASCII IDN
            try {
                parsed.host = URL.domainToASCII(parsed.host.toLowerCase());
            } catch (e) {
                parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e;
            }
        // convert IRI -> URI
        }
        if (!schemeHandler || schemeHandler && !schemeHandler.skipNormalize) {
            if (gotEncoding && parsed.scheme !== undefined) parsed.scheme = unescape(parsed.scheme);
            if (gotEncoding && parsed.host !== undefined) parsed.host = unescape(parsed.host);
            if (parsed.path !== undefined && parsed.path.length) parsed.path = escape(unescape(parsed.path));
            if (parsed.fragment !== undefined && parsed.fragment.length) parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
        }
        // perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) schemeHandler.parse(parsed, options);
    } else parsed.error = parsed.error || "URI can not be parsed.";
    return parsed;
}
const $4ad068e8387cea06$var$fastUri = {
    SCHEMES: $lFr1Y,
    normalize: $4ad068e8387cea06$var$normalize,
    resolve: $4ad068e8387cea06$var$resolve,
    resolveComponents: $4ad068e8387cea06$var$resolveComponents,
    equal: $4ad068e8387cea06$var$equal,
    serialize: $4ad068e8387cea06$var$serialize,
    parse: $4ad068e8387cea06$var$parse
};
module.exports = $4ad068e8387cea06$var$fastUri;
module.exports.default = $4ad068e8387cea06$var$fastUri;
module.exports.fastUri = $4ad068e8387cea06$var$fastUri;

});
parcelRegister("6IkXK", function(module, exports) {
"use strict";

var $3DTWZ = parcelRequire("3DTWZ");
var $4e371ce04e8e5a22$require$HEX = $3DTWZ.HEX;
function $4e371ce04e8e5a22$var$normalizeIPv4(host) {
    if ($4e371ce04e8e5a22$var$findToken(host, ".") < 3) return {
        host: host,
        isIPV4: false
    };
    const matches = host.match(/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/u) || [];
    const [address] = matches;
    if (address) return {
        host: $4e371ce04e8e5a22$var$stripLeadingZeros(address, "."),
        isIPV4: true
    };
    else return {
        host: host,
        isIPV4: false
    };
}
/**
 * @param {string[]} input
 * @param {boolean} [keepZero=false]
 * @returns {string|undefined}
 */ function $4e371ce04e8e5a22$var$stringArrayToHexStripped(input, keepZero = false) {
    let acc = "";
    let strip = true;
    for (const c of input){
        if ($4e371ce04e8e5a22$require$HEX[c] === undefined) return undefined;
        if (c !== "0" && strip === true) strip = false;
        if (!strip) acc += c;
    }
    if (keepZero && acc.length === 0) acc = "0";
    return acc;
}
function $4e371ce04e8e5a22$var$getIPV6(input) {
    let tokenCount = 0;
    const output = {
        error: false,
        address: "",
        zone: ""
    };
    const address = [];
    const buffer = [];
    let isZone = false;
    let endipv6Encountered = false;
    let endIpv6 = false;
    function consume() {
        if (buffer.length) {
            if (isZone === false) {
                const hex = $4e371ce04e8e5a22$var$stringArrayToHexStripped(buffer);
                if (hex !== undefined) address.push(hex);
                else {
                    output.error = true;
                    return false;
                }
            }
            buffer.length = 0;
        }
        return true;
    }
    for(let i = 0; i < input.length; i++){
        const cursor = input[i];
        if (cursor === "[" || cursor === "]") continue;
        if (cursor === ":") {
            if (endipv6Encountered === true) endIpv6 = true;
            if (!consume()) break;
            tokenCount++;
            address.push(":");
            if (tokenCount > 7) {
                // not valid
                output.error = true;
                break;
            }
            if (i - 1 >= 0 && input[i - 1] === ":") endipv6Encountered = true;
            continue;
        } else if (cursor === "%") {
            if (!consume()) break;
            // switch to zone detection
            isZone = true;
        } else {
            buffer.push(cursor);
            continue;
        }
    }
    if (buffer.length) {
        if (isZone) output.zone = buffer.join("");
        else if (endIpv6) address.push(buffer.join(""));
        else address.push($4e371ce04e8e5a22$var$stringArrayToHexStripped(buffer));
    }
    output.address = address.join("");
    return output;
}
function $4e371ce04e8e5a22$var$normalizeIPv6(host, opts = {}) {
    if ($4e371ce04e8e5a22$var$findToken(host, ":") < 2) return {
        host: host,
        isIPV6: false
    };
    const ipv6 = $4e371ce04e8e5a22$var$getIPV6(host);
    if (!ipv6.error) {
        let newHost = ipv6.address;
        let escapedHost = ipv6.address;
        if (ipv6.zone) {
            newHost += "%" + ipv6.zone;
            escapedHost += "%25" + ipv6.zone;
        }
        return {
            host: newHost,
            escapedHost: escapedHost,
            isIPV6: true
        };
    } else return {
        host: host,
        isIPV6: false
    };
}
function $4e371ce04e8e5a22$var$stripLeadingZeros(str, token) {
    let out = "";
    let skip = true;
    const l = str.length;
    for(let i = 0; i < l; i++){
        const c = str[i];
        if (c === "0" && skip) {
            if (i + 1 <= l && str[i + 1] === token || i + 1 === l) {
                out += c;
                skip = false;
            }
        } else {
            if (c === token) skip = true;
            else skip = false;
            out += c;
        }
    }
    return out;
}
function $4e371ce04e8e5a22$var$findToken(str, token) {
    let ind = 0;
    for(let i = 0; i < str.length; i++)if (str[i] === token) ind++;
    return ind;
}
const $4e371ce04e8e5a22$var$RDS1 = /^\.\.?\//u;
const $4e371ce04e8e5a22$var$RDS2 = /^\/\.(?:\/|$)/u;
const $4e371ce04e8e5a22$var$RDS3 = /^\/\.\.(?:\/|$)/u;
const $4e371ce04e8e5a22$var$RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/u;
function $4e371ce04e8e5a22$var$removeDotSegments(input) {
    const output = [];
    while(input.length){
        if (input.match($4e371ce04e8e5a22$var$RDS1)) input = input.replace($4e371ce04e8e5a22$var$RDS1, "");
        else if (input.match($4e371ce04e8e5a22$var$RDS2)) input = input.replace($4e371ce04e8e5a22$var$RDS2, "/");
        else if (input.match($4e371ce04e8e5a22$var$RDS3)) {
            input = input.replace($4e371ce04e8e5a22$var$RDS3, "/");
            output.pop();
        } else if (input === "." || input === "..") input = "";
        else {
            const im = input.match($4e371ce04e8e5a22$var$RDS5);
            if (im) {
                const s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else throw new Error("Unexpected dot segment condition");
        }
    }
    return output.join("");
}
function $4e371ce04e8e5a22$var$normalizeComponentEncoding(components, esc) {
    const func = esc !== true ? escape : unescape;
    if (components.scheme !== undefined) components.scheme = func(components.scheme);
    if (components.userinfo !== undefined) components.userinfo = func(components.userinfo);
    if (components.host !== undefined) components.host = func(components.host);
    if (components.path !== undefined) components.path = func(components.path);
    if (components.query !== undefined) components.query = func(components.query);
    if (components.fragment !== undefined) components.fragment = func(components.fragment);
    return components;
}
function $4e371ce04e8e5a22$var$recomposeAuthority(components, options) {
    const uriTokens = [];
    if (components.userinfo !== undefined) {
        uriTokens.push(components.userinfo);
        uriTokens.push("@");
    }
    if (components.host !== undefined) {
        let host = unescape(components.host);
        const ipV4res = $4e371ce04e8e5a22$var$normalizeIPv4(host);
        if (ipV4res.isIPV4) host = ipV4res.host;
        else {
            const ipV6res = $4e371ce04e8e5a22$var$normalizeIPv6(ipV4res.host, {
                isIPV4: false
            });
            if (ipV6res.isIPV6 === true) host = `[${ipV6res.escapedHost}]`;
            else host = components.host;
        }
        uriTokens.push(host);
    }
    if (typeof components.port === "number" || typeof components.port === "string") {
        uriTokens.push(":");
        uriTokens.push(String(components.port));
    }
    return uriTokens.length ? uriTokens.join("") : undefined;
}
module.exports = {
    recomposeAuthority: $4e371ce04e8e5a22$var$recomposeAuthority,
    normalizeComponentEncoding: $4e371ce04e8e5a22$var$normalizeComponentEncoding,
    removeDotSegments: $4e371ce04e8e5a22$var$removeDotSegments,
    normalizeIPv4: $4e371ce04e8e5a22$var$normalizeIPv4,
    normalizeIPv6: $4e371ce04e8e5a22$var$normalizeIPv6,
    stringArrayToHexStripped: $4e371ce04e8e5a22$var$stringArrayToHexStripped
};

});
parcelRegister("3DTWZ", function(module, exports) {
"use strict";
const $2a706a2f2c97b152$var$HEX = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    a: 10,
    A: 10,
    b: 11,
    B: 11,
    c: 12,
    C: 12,
    d: 13,
    D: 13,
    e: 14,
    E: 14,
    f: 15,
    F: 15
};
module.exports = {
    HEX: $2a706a2f2c97b152$var$HEX
};

});


parcelRegister("lFr1Y", function(module, exports) {
"use strict";
const $fc62650d54f3255b$var$UUID_REG = /^[\da-f]{8}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{12}$/iu;
const $fc62650d54f3255b$var$URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
function $fc62650d54f3255b$var$isSecure(wsComponents) {
    return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
}
function $fc62650d54f3255b$var$httpParse(components) {
    if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
    return components;
}
function $fc62650d54f3255b$var$httpSerialize(components) {
    const secure = String(components.scheme).toLowerCase() === "https";
    // normalize the default port
    if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
    // normalize the empty path
    if (!components.path) components.path = "/";
    // NOTE: We do not parse query strings for HTTP URIs
    // as WWW Form Url Encoded query strings are part of the HTML4+ spec,
    // and not the HTTP spec.
    return components;
}
function $fc62650d54f3255b$var$wsParse(wsComponents) {
    // indicate if the secure flag is set
    wsComponents.secure = $fc62650d54f3255b$var$isSecure(wsComponents);
    // construct resouce name
    wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
    wsComponents.path = undefined;
    wsComponents.query = undefined;
    return wsComponents;
}
function $fc62650d54f3255b$var$wsSerialize(wsComponents) {
    // normalize the default port
    if (wsComponents.port === ($fc62650d54f3255b$var$isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
    // ensure scheme matches secure flag
    if (typeof wsComponents.secure === "boolean") {
        wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
        wsComponents.secure = undefined;
    }
    // reconstruct path from resource name
    if (wsComponents.resourceName) {
        const [path, query] = wsComponents.resourceName.split("?");
        wsComponents.path = path && path !== "/" ? path : undefined;
        wsComponents.query = query;
        wsComponents.resourceName = undefined;
    }
    // forbid fragment component
    wsComponents.fragment = undefined;
    return wsComponents;
}
function $fc62650d54f3255b$var$urnParse(urnComponents, options) {
    if (!urnComponents.path) {
        urnComponents.error = "URN can not be parsed";
        return urnComponents;
    }
    const matches = urnComponents.path.match($fc62650d54f3255b$var$URN_REG);
    if (matches) {
        const scheme = options.scheme || urnComponents.scheme || "urn";
        urnComponents.nid = matches[1].toLowerCase();
        urnComponents.nss = matches[2];
        const urnScheme = `${scheme}:${options.nid || urnComponents.nid}`;
        const schemeHandler = $fc62650d54f3255b$var$SCHEMES[urnScheme];
        urnComponents.path = undefined;
        if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
    } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
    return urnComponents;
}
function $fc62650d54f3255b$var$urnSerialize(urnComponents, options) {
    const scheme = options.scheme || urnComponents.scheme || "urn";
    const nid = urnComponents.nid.toLowerCase();
    const urnScheme = `${scheme}:${options.nid || nid}`;
    const schemeHandler = $fc62650d54f3255b$var$SCHEMES[urnScheme];
    if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
    const uriComponents = urnComponents;
    const nss = urnComponents.nss;
    uriComponents.path = `${nid || options.nid}:${nss}`;
    options.skipEscape = true;
    return uriComponents;
}
function $fc62650d54f3255b$var$urnuuidParse(urnComponents, options) {
    const uuidComponents = urnComponents;
    uuidComponents.uuid = uuidComponents.nss;
    uuidComponents.nss = undefined;
    if (!options.tolerant && (!uuidComponents.uuid || !$fc62650d54f3255b$var$UUID_REG.test(uuidComponents.uuid))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
    return uuidComponents;
}
function $fc62650d54f3255b$var$urnuuidSerialize(uuidComponents) {
    const urnComponents = uuidComponents;
    // normalize UUID
    urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
    return urnComponents;
}
const $fc62650d54f3255b$var$http = {
    scheme: "http",
    domainHost: true,
    parse: $fc62650d54f3255b$var$httpParse,
    serialize: $fc62650d54f3255b$var$httpSerialize
};
const $fc62650d54f3255b$var$https = {
    scheme: "https",
    domainHost: $fc62650d54f3255b$var$http.domainHost,
    parse: $fc62650d54f3255b$var$httpParse,
    serialize: $fc62650d54f3255b$var$httpSerialize
};
const $fc62650d54f3255b$var$ws = {
    scheme: "ws",
    domainHost: true,
    parse: $fc62650d54f3255b$var$wsParse,
    serialize: $fc62650d54f3255b$var$wsSerialize
};
const $fc62650d54f3255b$var$wss = {
    scheme: "wss",
    domainHost: $fc62650d54f3255b$var$ws.domainHost,
    parse: $fc62650d54f3255b$var$ws.parse,
    serialize: $fc62650d54f3255b$var$ws.serialize
};
const $fc62650d54f3255b$var$urn = {
    scheme: "urn",
    parse: $fc62650d54f3255b$var$urnParse,
    serialize: $fc62650d54f3255b$var$urnSerialize,
    skipNormalize: true
};
const $fc62650d54f3255b$var$urnuuid = {
    scheme: "urn:uuid",
    parse: $fc62650d54f3255b$var$urnuuidParse,
    serialize: $fc62650d54f3255b$var$urnuuidSerialize,
    skipNormalize: true
};
const $fc62650d54f3255b$var$SCHEMES = {
    http: $fc62650d54f3255b$var$http,
    https: $fc62650d54f3255b$var$https,
    ws: $fc62650d54f3255b$var$ws,
    wss: $fc62650d54f3255b$var$wss,
    urn: $fc62650d54f3255b$var$urn,
    "urn:uuid": $fc62650d54f3255b$var$urnuuid
};
module.exports = $fc62650d54f3255b$var$SCHEMES;

});




parcelRegister("hCMvI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kRH9m = parcelRequire("kRH9m");

var $jEHUU = parcelRequire("jEHUU");

var $3nioA = parcelRequire("3nioA");

var $eHcq7 = parcelRequire("eHcq7");

var $dYQpp = parcelRequire("dYQpp");

var $b5h6X = parcelRequire("b5h6X");

var $5xyWg = parcelRequire("5xyWg");

var $1tty0 = parcelRequire("1tty0");

var $f7wuJ = parcelRequire("f7wuJ");

var $dVD0e = parcelRequire("dVD0e");
const $cd4b9d76d59bf115$var$jtdVocabulary = [
    "definitions",
    $kRH9m.default,
    $jEHUU.default,
    $3nioA.default,
    $eHcq7.default,
    $dYQpp.default,
    $b5h6X.default,
    $5xyWg.default,
    $1tty0.default,
    $f7wuJ.default,
    $dVD0e.default,
    {
        keyword: "additionalProperties",
        schemaType: "boolean"
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    }
];
module.exports.default = $cd4b9d76d59bf115$var$jtdVocabulary;

});
parcelRegister("kRH9m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasRef = void 0;

var $3vHot = parcelRequire("3vHot");

var $4pmHt = parcelRequire("4pmHt");

var $1SZ5T = parcelRequire("1SZ5T");

var $3ZPj5 = parcelRequire("3ZPj5");

var $7UCBW = parcelRequire("7UCBW");

var $dVD0e = parcelRequire("dVD0e");
const $f30a3a94fd40c0a0$var$def = {
    keyword: "ref",
    schemaType: "string",
    code (cxt) {
        (0, $dVD0e.checkMetadata)(cxt);
        const { gen: gen, data: data, schema: ref, parentSchema: parentSchema, it: it } = cxt;
        const { schemaEnv: { root: root } } = it;
        const valid = gen.name("valid");
        if (parentSchema.nullable) {
            gen.var(valid, (0, $4pmHt._)`${data} === null`);
            gen.if((0, $4pmHt.not)(valid), validateJtdRef);
        } else {
            gen.var(valid, false);
            validateJtdRef();
        }
        cxt.ok(valid);
        function validateJtdRef() {
            var _a;
            const refSchema = (_a = root.schema.definitions) === null || _a === void 0 ? void 0 : _a[ref];
            if (!refSchema) throw new $1SZ5T.default(it.opts.uriResolver, "", ref, `No definition ${ref}`);
            if ($f30a3a94fd40c0a0$var$hasRef(refSchema) || !it.opts.inlineRefs) callValidate(refSchema);
            else inlineRefSchema(refSchema);
        }
        function callValidate(schema) {
            const sch = $3vHot.compileSchema.call(it.self, new $3vHot.SchemaEnv({
                schema: schema,
                root: root,
                schemaPath: `/definitions/${ref}`
            }));
            const v = (0, $7UCBW.getValidate)(cxt, sch);
            const errsCount = gen.const("_errs", $3ZPj5.default.errors);
            (0, $7UCBW.callRef)(cxt, v, sch, sch.$async);
            gen.assign(valid, (0, $4pmHt._)`${errsCount} === ${$3ZPj5.default.errors}`);
        }
        function inlineRefSchema(schema) {
            const schName = gen.scopeValue("schema", it.opts.code.source === true ? {
                ref: schema,
                code: (0, $4pmHt.stringify)(schema)
            } : {
                ref: schema
            });
            cxt.subschema({
                schema: schema,
                dataTypes: [],
                schemaPath: $4pmHt.nil,
                topSchemaRef: schName,
                errSchemaPath: `/definitions/${ref}`
            }, valid);
        }
    }
};
function $f30a3a94fd40c0a0$var$hasRef(schema) {
    for(const key in schema){
        let sch;
        if (key === "ref" || typeof (sch = schema[key]) == "object" && $f30a3a94fd40c0a0$var$hasRef(sch)) return true;
    }
    return false;
}
module.exports.hasRef = $f30a3a94fd40c0a0$var$hasRef;
module.exports.default = $f30a3a94fd40c0a0$var$def;

});
parcelRegister("7UCBW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $1SZ5T = parcelRequire("1SZ5T");

var $bLF7l = parcelRequire("bLF7l");

var $4pmHt = parcelRequire("4pmHt");

var $3ZPj5 = parcelRequire("3ZPj5");

var $3vHot = parcelRequire("3vHot");

var $leU6J = parcelRequire("leU6J");
const $5c2bb6b461103266$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $3vHot.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $1SZ5T.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $3vHot.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $5c2bb6b461103266$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $5c2bb6b461103266$var$callRef(cxt, (0, $4pmHt._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $5c2bb6b461103266$var$getValidate(cxt, sch);
            $5c2bb6b461103266$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $4pmHt.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $4pmHt.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $5c2bb6b461103266$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $4pmHt._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
module.exports.getValidate = $5c2bb6b461103266$var$getValidate;
function $5c2bb6b461103266$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $3ZPj5.default.this : $4pmHt.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $4pmHt._)`await ${(0, $bLF7l.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $4pmHt._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $bLF7l.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $4pmHt._)`${source}.errors`;
        gen.assign($3ZPj5.default.vErrors, (0, $4pmHt._)`${$3ZPj5.default.vErrors} === null ? ${errs} : ${$3ZPj5.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($3ZPj5.default.errors, (0, $4pmHt._)`${$3ZPj5.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $leU6J.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $4pmHt._)`${source}.evaluated.props`);
                it.props = $leU6J.mergeEvaluated.props(gen, props, it.props, $4pmHt.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $leU6J.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $4pmHt._)`${source}.evaluated.items`);
                it.items = $leU6J.mergeEvaluated.items(gen, items, it.items, $4pmHt.Name);
            }
        }
    }
}
module.exports.callRef = $5c2bb6b461103266$var$callRef;
module.exports.default = $5c2bb6b461103266$var$def;

});

parcelRegister("dVD0e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkMetadata = void 0;

var $leU6J = parcelRequire("leU6J");
const $a23eda5e38007bf3$var$def = {
    keyword: "metadata",
    schemaType: "object",
    code (cxt) {
        $a23eda5e38007bf3$var$checkMetadata(cxt);
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $leU6J.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "metadata",
            jtdMetadata: true
        }, valid);
        cxt.ok(valid);
    }
};
function $a23eda5e38007bf3$var$checkMetadata({ it: it, keyword: keyword }, metadata) {
    if (it.jtdMetadata !== metadata) throw new Error(`JTD: "${keyword}" cannot be used in this schema location`);
}
module.exports.checkMetadata = $a23eda5e38007bf3$var$checkMetadata;
module.exports.default = $a23eda5e38007bf3$var$def;

});


parcelRegister("jEHUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.intRange = void 0;

var $4pmHt = parcelRequire("4pmHt");

var $f8zmd = parcelRequire("f8zmd");

var $leU6J = parcelRequire("leU6J");

var $dVD0e = parcelRequire("dVD0e");

var $cADKB = parcelRequire("cADKB");
module.exports.intRange = {
    int8: [
        -128,
        127,
        3
    ],
    uint8: [
        0,
        255,
        3
    ],
    int16: [
        -32768,
        32767,
        5
    ],
    uint16: [
        0,
        65535,
        5
    ],
    int32: [
        -2147483648,
        2147483647,
        10
    ],
    uint32: [
        0,
        4294967295,
        10
    ]
};
const $e4f3d1b762e2a340$var$error = {
    message: (cxt)=>(0, $cADKB.typeErrorMessage)(cxt, cxt.schema),
    params: (cxt)=>(0, $cADKB.typeErrorParams)(cxt, cxt.schema)
};
function $e4f3d1b762e2a340$var$timestampCode(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    const { timestamp: timestamp, allowDate: allowDate } = it.opts;
    if (timestamp === "date") return (0, $4pmHt._)`${data} instanceof Date `;
    const vts = (0, $leU6J.useFunc)(gen, $f8zmd.default);
    const allowDateArg = allowDate ? (0, $4pmHt._)`, true` : $4pmHt.nil;
    const validString = (0, $4pmHt._)`typeof ${data} == "string" && ${vts}(${data}${allowDateArg})`;
    return timestamp === "string" ? validString : (0, $4pmHt.or)((0, $4pmHt._)`${data} instanceof Date`, validString);
}
const $e4f3d1b762e2a340$var$def = {
    keyword: "type",
    schemaType: "string",
    error: $e4f3d1b762e2a340$var$error,
    code (cxt) {
        (0, $dVD0e.checkMetadata)(cxt);
        const { data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        let cond;
        switch(schema){
            case "boolean":
            case "string":
                cond = (0, $4pmHt._)`typeof ${data} == ${schema}`;
                break;
            case "timestamp":
                cond = $e4f3d1b762e2a340$var$timestampCode(cxt);
                break;
            case "float32":
            case "float64":
                cond = (0, $4pmHt._)`typeof ${data} == "number"`;
                break;
            default:
                {
                    const sch = schema;
                    cond = (0, $4pmHt._)`typeof ${data} == "number" && isFinite(${data}) && !(${data} % 1)`;
                    if (!it.opts.int32range && (sch === "int32" || sch === "uint32")) {
                        if (sch === "uint32") cond = (0, $4pmHt._)`${cond} && ${data} >= 0`;
                    } else {
                        const [min, max] = module.exports.intRange[sch];
                        cond = (0, $4pmHt._)`${cond} && ${data} >= ${min} && ${data} <= ${max}`;
                    }
                }
        }
        cxt.pass(parentSchema.nullable ? (0, $4pmHt.or)((0, $4pmHt._)`${data} === null`, cond) : cond);
    }
};
module.exports.default = $e4f3d1b762e2a340$var$def;

});
parcelRegister("f8zmd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $b05307972e830136$var$DT_SEPARATOR = /t|\s/i;
const $b05307972e830136$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const $b05307972e830136$var$TIME = /^(\d\d):(\d\d):(\d\d)(?:\.\d+)?(?:z|([+-]\d\d)(?::?(\d\d))?)$/i;
const $b05307972e830136$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b05307972e830136$var$validTimestamp(str, allowDate) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dt = str.split($b05307972e830136$var$DT_SEPARATOR);
    return dt.length === 2 && $b05307972e830136$var$validDate(dt[0]) && $b05307972e830136$var$validTime(dt[1]) || allowDate && dt.length === 1 && $b05307972e830136$var$validDate(dt[0]);
}
module.exports.default = $b05307972e830136$var$validTimestamp;
function $b05307972e830136$var$validDate(str) {
    const matches = $b05307972e830136$var$DATE.exec(str);
    if (!matches) return false;
    const y = +matches[1];
    const m = +matches[2];
    const d = +matches[3];
    return m >= 1 && m <= 12 && d >= 1 && (d <= $b05307972e830136$var$DAYS[m] || // leap year: https://tools.ietf.org/html/rfc3339#appendix-C
    m === 2 && d === 29 && (y % 100 === 0 ? y % 400 === 0 : y % 4 === 0));
}
function $b05307972e830136$var$validTime(str) {
    const matches = $b05307972e830136$var$TIME.exec(str);
    if (!matches) return false;
    const hr = +matches[1];
    const min = +matches[2];
    const sec = +matches[3];
    const tzH = +(matches[4] || 0);
    const tzM = +(matches[5] || 0);
    return hr <= 23 && min <= 59 && sec <= 59 || // leap second
    hr - tzH === 23 && min - tzM === 59 && sec === 60;
}
$b05307972e830136$var$validTimestamp.code = 'require("ajv/dist/runtime/timestamp").default';

});

parcelRegister("cADKB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typeErrorParams = module.exports.typeErrorMessage = module.exports.typeError = void 0;

var $4pmHt = parcelRequire("4pmHt");
function $92a7ae7e1acafc66$var$typeError(t) {
    return {
        message: (cxt)=>$92a7ae7e1acafc66$var$typeErrorMessage(cxt, t),
        params: (cxt)=>$92a7ae7e1acafc66$var$typeErrorParams(cxt, t)
    };
}
module.exports.typeError = $92a7ae7e1acafc66$var$typeError;
function $92a7ae7e1acafc66$var$typeErrorMessage({ parentSchema: parentSchema }, t) {
    return (parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.nullable) ? `must be ${t} or null` : `must be ${t}`;
}
module.exports.typeErrorMessage = $92a7ae7e1acafc66$var$typeErrorMessage;
function $92a7ae7e1acafc66$var$typeErrorParams({ parentSchema: parentSchema }, t) {
    return (0, $4pmHt._)`{type: ${t}, nullable: ${!!(parentSchema === null || parentSchema === void 0 ? void 0 : parentSchema.nullable)}}`;
}
module.exports.typeErrorParams = $92a7ae7e1acafc66$var$typeErrorParams;

});


parcelRegister("3nioA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4pmHt = parcelRequire("4pmHt");

var $dVD0e = parcelRequire("dVD0e");

var $bncUk = parcelRequire("bncUk");
const $2751ca0e382415c7$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $4pmHt._)`{allowedValues: ${schemaCode}}`
};
const $2751ca0e382415c7$var$def = {
    keyword: "enum",
    schemaType: "array",
    error: $2751ca0e382415c7$var$error,
    code (cxt) {
        (0, $dVD0e.checkMetadata)(cxt);
        const { gen: gen, data: data, schema: schema, schemaValue: schemaValue, parentSchema: parentSchema, it: it } = cxt;
        if (schema.length === 0) throw new Error("enum must have non-empty array");
        if (schema.length !== new Set(schema).size) throw new Error("enum items must be unique");
        let valid;
        const isString = (0, $4pmHt._)`typeof ${data} == "string"`;
        if (schema.length >= it.opts.loopEnum) {
            let cond;
            [valid, cond] = (0, $bncUk.checkNullable)(cxt, isString);
            gen.if(cond, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            valid = (0, $4pmHt.and)(isString, (0, $4pmHt.or)(...schema.map((value)=>(0, $4pmHt._)`${data} === ${value}`)));
            if (parentSchema.nullable) valid = (0, $4pmHt.or)((0, $4pmHt._)`${data} === null`, valid);
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.forOf("v", schemaValue, (v)=>gen.if((0, $4pmHt._)`${valid} = ${data} === ${v}`, ()=>gen.break()));
        }
    }
};
module.exports.default = $2751ca0e382415c7$var$def;

});
parcelRegister("bncUk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkNullableObject = module.exports.checkNullable = void 0;

var $4pmHt = parcelRequire("4pmHt");
function $847bdad962f42c97$var$checkNullable({ gen: gen, data: data, parentSchema: parentSchema }, cond = $4pmHt.nil) {
    const valid = gen.name("valid");
    if (parentSchema.nullable) {
        gen.let(valid, (0, $4pmHt._)`${data} === null`);
        cond = (0, $4pmHt.not)(valid);
    } else gen.let(valid, false);
    return [
        valid,
        cond
    ];
}
module.exports.checkNullable = $847bdad962f42c97$var$checkNullable;
function $847bdad962f42c97$var$checkNullableObject(cxt, cond) {
    const [valid, cond_] = $847bdad962f42c97$var$checkNullable(cxt, cond);
    return [
        valid,
        (0, $4pmHt._)`${cond_} && typeof ${cxt.data} == "object" && !Array.isArray(${cxt.data})`
    ];
}
module.exports.checkNullableObject = $847bdad962f42c97$var$checkNullableObject;

});


parcelRegister("eHcq7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $leU6J = parcelRequire("leU6J");

var $bLF7l = parcelRequire("bLF7l");

var $4pmHt = parcelRequire("4pmHt");

var $dVD0e = parcelRequire("dVD0e");

var $bncUk = parcelRequire("bncUk");

var $cADKB = parcelRequire("cADKB");
const $ab2eb73e8ffcd966$var$def = {
    keyword: "elements",
    schemaType: "object",
    error: (0, $cADKB.typeError)("array"),
    code (cxt) {
        (0, $dVD0e.checkMetadata)(cxt);
        const { gen: gen, data: data, schema: schema, it: it } = cxt;
        if ((0, $leU6J.alwaysValidSchema)(it, schema)) return;
        const [valid] = (0, $bncUk.checkNullable)(cxt);
        gen.if((0, $4pmHt.not)(valid), ()=>gen.if((0, $4pmHt._)`Array.isArray(${data})`, ()=>gen.assign(valid, (0, $bLF7l.validateArray)(cxt)), ()=>cxt.error()));
        cxt.ok(valid);
    }
};
module.exports.default = $ab2eb73e8ffcd966$var$def;

});

parcelRegister("dYQpp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateProperties = module.exports.error = void 0;

var $bLF7l = parcelRequire("bLF7l");

var $leU6J = parcelRequire("leU6J");

var $4pmHt = parcelRequire("4pmHt");

var $dVD0e = parcelRequire("dVD0e");

var $bncUk = parcelRequire("bncUk");

var $cADKB = parcelRequire("cADKB");
var $a2d98843f8bda8c8$var$PropError;
(function(PropError) {
    PropError["Additional"] = "additional";
    PropError["Missing"] = "missing";
})($a2d98843f8bda8c8$var$PropError || ($a2d98843f8bda8c8$var$PropError = {}));
module.exports.error = {
    message: (cxt)=>{
        const { params: params } = cxt;
        return params.propError ? params.propError === $a2d98843f8bda8c8$var$PropError.Additional ? "must NOT have additional properties" : `must have property '${params.missingProperty}'` : (0, $cADKB.typeErrorMessage)(cxt, "object");
    },
    params: (cxt)=>{
        const { params: params } = cxt;
        return params.propError ? params.propError === $a2d98843f8bda8c8$var$PropError.Additional ? (0, $4pmHt._)`{error: ${params.propError}, additionalProperty: ${params.additionalProperty}}` : (0, $4pmHt._)`{error: ${params.propError}, missingProperty: ${params.missingProperty}}` : (0, $cADKB.typeErrorParams)(cxt, "object");
    }
};
const $a2d98843f8bda8c8$var$def = {
    keyword: "properties",
    schemaType: "object",
    error: module.exports.error,
    code: $a2d98843f8bda8c8$var$validateProperties
};
// const error: KeywordErrorDefinition = {
//   message: "should NOT have additional properties",
//   params: ({params}) => _`{additionalProperty: ${params.additionalProperty}}`,
// }
function $a2d98843f8bda8c8$var$validateProperties(cxt) {
    (0, $dVD0e.checkMetadata)(cxt);
    const { gen: gen, data: data, parentSchema: parentSchema, it: it } = cxt;
    const { additionalProperties: additionalProperties, nullable: nullable } = parentSchema;
    if (it.jtdDiscriminator && nullable) throw new Error("JTD: nullable inside discriminator mapping");
    if (commonProperties()) throw new Error("JTD: properties and optionalProperties have common members");
    const [allProps, properties] = schemaProperties("properties");
    const [allOptProps, optProperties] = schemaProperties("optionalProperties");
    if (properties.length === 0 && optProperties.length === 0 && additionalProperties) return;
    const [valid, cond] = it.jtdDiscriminator === undefined ? (0, $bncUk.checkNullableObject)(cxt, data) : [
        gen.let("valid", false),
        true
    ];
    gen.if(cond, ()=>gen.assign(valid, true).block(()=>{
            validateProps(properties, "properties", true);
            validateProps(optProperties, "optionalProperties");
            if (!additionalProperties) validateAdditional();
        }));
    cxt.pass(valid);
    function commonProperties() {
        const props = parentSchema.properties;
        const optProps = parentSchema.optionalProperties;
        if (!(props && optProps)) return false;
        for(const p in props){
            if (Object.prototype.hasOwnProperty.call(optProps, p)) return true;
        }
        return false;
    }
    function schemaProperties(keyword) {
        const schema = parentSchema[keyword];
        const allPs = schema ? (0, $bLF7l.allSchemaProperties)(schema) : [];
        if (it.jtdDiscriminator && allPs.some((p)=>p === it.jtdDiscriminator)) throw new Error(`JTD: discriminator tag used in ${keyword}`);
        const ps = allPs.filter((p)=>!(0, $leU6J.alwaysValidSchema)(it, schema[p]));
        return [
            allPs,
            ps
        ];
    }
    function validateProps(props, keyword, required) {
        const _valid = gen.var("valid");
        for (const prop of props){
            gen.if((0, $bLF7l.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>applyPropertySchema(prop, keyword, _valid), ()=>missingProperty(prop));
            cxt.ok(_valid);
        }
        function missingProperty(prop) {
            if (required) {
                gen.assign(_valid, false);
                cxt.error(false, {
                    propError: $a2d98843f8bda8c8$var$PropError.Missing,
                    missingProperty: prop
                }, {
                    schemaPath: prop
                });
            } else gen.assign(_valid, true);
        }
    }
    function applyPropertySchema(prop, keyword, _valid) {
        cxt.subschema({
            keyword: keyword,
            schemaProp: prop,
            dataProp: prop
        }, _valid);
    }
    function validateAdditional() {
        gen.forIn("key", data, (key)=>{
            const addProp = isAdditional(key, allProps, "properties", it.jtdDiscriminator);
            const addOptProp = isAdditional(key, allOptProps, "optionalProperties");
            const extra = addProp === true ? addOptProp : addOptProp === true ? addProp : (0, $4pmHt.and)(addProp, addOptProp);
            gen.if(extra, ()=>{
                if (it.opts.removeAdditional) gen.code((0, $4pmHt._)`delete ${data}[${key}]`);
                else {
                    cxt.error(false, {
                        propError: $a2d98843f8bda8c8$var$PropError.Additional,
                        additionalProperty: key
                    }, {
                        instancePath: key,
                        parentSchema: true
                    });
                    if (!it.opts.allErrors) gen.break();
                }
            });
        });
    }
    function isAdditional(key, props, keyword, jtdDiscriminator) {
        let additional;
        if (props.length > 8) {
            // TODO maybe an option instead of hard-coded 8?
            const propsSchema = (0, $leU6J.schemaRefOrVal)(it, parentSchema[keyword], keyword);
            additional = (0, $4pmHt.not)((0, $bLF7l.isOwnProperty)(gen, propsSchema, key));
            if (jtdDiscriminator !== undefined) additional = (0, $4pmHt.and)(additional, (0, $4pmHt._)`${key} !== ${jtdDiscriminator}`);
        } else if (props.length || jtdDiscriminator !== undefined) {
            const ps = jtdDiscriminator === undefined ? props : [
                jtdDiscriminator
            ].concat(props);
            additional = (0, $4pmHt.and)(...ps.map((p)=>(0, $4pmHt._)`${key} !== ${p}`));
        } else additional = true;
        return additional;
    }
}
module.exports.validateProperties = $a2d98843f8bda8c8$var$validateProperties;
module.exports.default = $a2d98843f8bda8c8$var$def;

});

parcelRegister("b5h6X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYQpp = parcelRequire("dYQpp");
const $811d6f49e98ddd0f$var$def = {
    keyword: "optionalProperties",
    schemaType: "object",
    error: $dYQpp.error,
    code (cxt) {
        if (cxt.parentSchema.properties) return;
        (0, $dYQpp.validateProperties)(cxt);
    }
};
module.exports.default = $811d6f49e98ddd0f$var$def;

});

parcelRegister("5xyWg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4pmHt = parcelRequire("4pmHt");

var $dVD0e = parcelRequire("dVD0e");

var $bncUk = parcelRequire("bncUk");

var $cADKB = parcelRequire("cADKB");

var $dfn87 = parcelRequire("dfn87");
const $408b22e7d8635fd7$var$error = {
    message: (cxt)=>{
        const { schema: schema, params: params } = cxt;
        return params.discrError ? params.discrError === $dfn87.DiscrError.Tag ? `tag "${schema}" must be string` : `value of tag "${schema}" must be in mapping` : (0, $cADKB.typeErrorMessage)(cxt, "object");
    },
    params: (cxt)=>{
        const { schema: schema, params: params } = cxt;
        return params.discrError ? (0, $4pmHt._)`{error: ${params.discrError}, tag: ${schema}, tagValue: ${params.tag}}` : (0, $cADKB.typeErrorParams)(cxt, "object");
    }
};
const $408b22e7d8635fd7$var$def = {
    keyword: "discriminator",
    schemaType: "string",
    implements: [
        "mapping"
    ],
    error: $408b22e7d8635fd7$var$error,
    code (cxt) {
        (0, $dVD0e.checkMetadata)(cxt);
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema } = cxt;
        const [valid, cond] = (0, $bncUk.checkNullableObject)(cxt, data);
        gen.if(cond);
        validateDiscriminator();
        gen.elseIf((0, $4pmHt.not)(valid));
        cxt.error();
        gen.endIf();
        cxt.ok(valid);
        function validateDiscriminator() {
            const tag = gen.const("tag", (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)(schema)}`);
            gen.if((0, $4pmHt._)`${tag} === undefined`);
            cxt.error(false, {
                discrError: $dfn87.DiscrError.Tag,
                tag: tag
            });
            gen.elseIf((0, $4pmHt._)`typeof ${tag} == "string"`);
            validateMapping(tag);
            gen.else();
            cxt.error(false, {
                discrError: $dfn87.DiscrError.Tag,
                tag: tag
            }, {
                instancePath: schema
            });
            gen.endIf();
        }
        function validateMapping(tag) {
            gen.if(false);
            for(const tagValue in parentSchema.mapping){
                gen.elseIf((0, $4pmHt._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(tagValue));
            }
            gen.else();
            cxt.error(false, {
                discrError: $dfn87.DiscrError.Mapping,
                tag: tag
            }, {
                instancePath: schema,
                schemaPath: "mapping",
                parentSchema: true
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            cxt.subschema({
                keyword: "mapping",
                schemaProp: schemaProp,
                jtdDiscriminator: schema
            }, _valid);
            return _valid;
        }
    }
};
module.exports.default = $408b22e7d8635fd7$var$def;

});
parcelRegister("dfn87", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $9a4e9e32b6705bfd$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($9a4e9e32b6705bfd$var$DiscrError || (module.exports.DiscrError = $9a4e9e32b6705bfd$var$DiscrError = {}));

});


parcelRegister("1tty0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $leU6J = parcelRequire("leU6J");

var $4pmHt = parcelRequire("4pmHt");

var $dVD0e = parcelRequire("dVD0e");

var $bncUk = parcelRequire("bncUk");

var $cADKB = parcelRequire("cADKB");
const $112f6b5e7b5b8aa9$var$def = {
    keyword: "values",
    schemaType: "object",
    error: (0, $cADKB.typeError)("object"),
    code (cxt) {
        (0, $dVD0e.checkMetadata)(cxt);
        const { gen: gen, data: data, schema: schema, it: it } = cxt;
        const [valid, cond] = (0, $bncUk.checkNullableObject)(cxt, data);
        if ((0, $leU6J.alwaysValidSchema)(it, schema)) gen.if((0, $4pmHt.not)((0, $4pmHt.or)(cond, valid)), ()=>cxt.error());
        else {
            gen.if(cond);
            gen.assign(valid, validateMap());
            gen.elseIf((0, $4pmHt.not)(valid));
            cxt.error();
            gen.endIf();
        }
        cxt.ok(valid);
        function validateMap() {
            const _valid = gen.name("valid");
            if (it.allErrors) {
                const validMap = gen.let("valid", true);
                validateValues(()=>gen.assign(validMap, false));
                return validMap;
            }
            gen.var(_valid, true);
            validateValues(()=>gen.break());
            return _valid;
            function validateValues(notValid) {
                gen.forIn("key", data, (key)=>{
                    cxt.subschema({
                        keyword: "values",
                        dataProp: key,
                        dataPropType: $leU6J.Type.Str
                    }, _valid);
                    gen.if((0, $4pmHt.not)(_valid), notValid);
                });
            }
        }
    }
};
module.exports.default = $112f6b5e7b5b8aa9$var$def;

});

parcelRegister("f7wuJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bLF7l = parcelRequire("bLF7l");
const $b020b739a7969c5a$var$def = {
    keyword: "union",
    schemaType: "array",
    trackErrors: true,
    code: $bLF7l.validateUnion,
    error: {
        message: "must match a schema in union"
    }
};
module.exports.default = $b020b739a7969c5a$var$def;

});


parcelRegister("5BeZS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $413c0a88a5e1dd38$var$shared = (root)=>{
    const sch = {
        nullable: {
            type: "boolean"
        },
        metadata: {
            optionalProperties: {
                union: {
                    elements: {
                        ref: "schema"
                    }
                }
            },
            additionalProperties: true
        }
    };
    if (root) sch.definitions = {
        values: {
            ref: "schema"
        }
    };
    return sch;
};
const $413c0a88a5e1dd38$var$emptyForm = (root)=>({
        optionalProperties: $413c0a88a5e1dd38$var$shared(root)
    });
const $413c0a88a5e1dd38$var$refForm = (root)=>({
        properties: {
            ref: {
                type: "string"
            }
        },
        optionalProperties: $413c0a88a5e1dd38$var$shared(root)
    });
const $413c0a88a5e1dd38$var$typeForm = (root)=>({
        properties: {
            type: {
                enum: [
                    "boolean",
                    "timestamp",
                    "string",
                    "float32",
                    "float64",
                    "int8",
                    "uint8",
                    "int16",
                    "uint16",
                    "int32",
                    "uint32"
                ]
            }
        },
        optionalProperties: $413c0a88a5e1dd38$var$shared(root)
    });
const $413c0a88a5e1dd38$var$enumForm = (root)=>({
        properties: {
            enum: {
                elements: {
                    type: "string"
                }
            }
        },
        optionalProperties: $413c0a88a5e1dd38$var$shared(root)
    });
const $413c0a88a5e1dd38$var$elementsForm = (root)=>({
        properties: {
            elements: {
                ref: "schema"
            }
        },
        optionalProperties: $413c0a88a5e1dd38$var$shared(root)
    });
const $413c0a88a5e1dd38$var$propertiesForm = (root)=>({
        properties: {
            properties: {
                values: {
                    ref: "schema"
                }
            }
        },
        optionalProperties: {
            optionalProperties: {
                values: {
                    ref: "schema"
                }
            },
            additionalProperties: {
                type: "boolean"
            },
            ...$413c0a88a5e1dd38$var$shared(root)
        }
    });
const $413c0a88a5e1dd38$var$optionalPropertiesForm = (root)=>({
        properties: {
            optionalProperties: {
                values: {
                    ref: "schema"
                }
            }
        },
        optionalProperties: {
            additionalProperties: {
                type: "boolean"
            },
            ...$413c0a88a5e1dd38$var$shared(root)
        }
    });
const $413c0a88a5e1dd38$var$discriminatorForm = (root)=>({
        properties: {
            discriminator: {
                type: "string"
            },
            mapping: {
                values: {
                    metadata: {
                        union: [
                            $413c0a88a5e1dd38$var$propertiesForm(false),
                            $413c0a88a5e1dd38$var$optionalPropertiesForm(false)
                        ]
                    }
                }
            }
        },
        optionalProperties: $413c0a88a5e1dd38$var$shared(root)
    });
const $413c0a88a5e1dd38$var$valuesForm = (root)=>({
        properties: {
            values: {
                ref: "schema"
            }
        },
        optionalProperties: $413c0a88a5e1dd38$var$shared(root)
    });
const $413c0a88a5e1dd38$var$schema = (root)=>({
        metadata: {
            union: [
                $413c0a88a5e1dd38$var$emptyForm,
                $413c0a88a5e1dd38$var$refForm,
                $413c0a88a5e1dd38$var$typeForm,
                $413c0a88a5e1dd38$var$enumForm,
                $413c0a88a5e1dd38$var$elementsForm,
                $413c0a88a5e1dd38$var$propertiesForm,
                $413c0a88a5e1dd38$var$optionalPropertiesForm,
                $413c0a88a5e1dd38$var$discriminatorForm,
                $413c0a88a5e1dd38$var$valuesForm
            ].map((s)=>s(root))
        }
    });
const $413c0a88a5e1dd38$var$jtdMetaSchema = {
    definitions: {
        schema: $413c0a88a5e1dd38$var$schema(false)
    },
    ...$413c0a88a5e1dd38$var$schema(true)
};
module.exports.default = $413c0a88a5e1dd38$var$jtdMetaSchema;

});

parcelRegister("2jnSB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3QGyQ = parcelRequire("3QGyQ");

var $3vHot = parcelRequire("3vHot");

var $4pmHt = parcelRequire("4pmHt");

var $1SZ5T = parcelRequire("1SZ5T");

var $3ZPj5 = parcelRequire("3ZPj5");

var $bLF7l = parcelRequire("bLF7l");

var $kRH9m = parcelRequire("kRH9m");

var $leU6J = parcelRequire("leU6J");

var $6Hk0T = parcelRequire("6Hk0T");
const $1aefe11dc31ae346$var$genSerialize = {
    elements: $1aefe11dc31ae346$var$serializeElements,
    values: $1aefe11dc31ae346$var$serializeValues,
    discriminator: $1aefe11dc31ae346$var$serializeDiscriminator,
    properties: $1aefe11dc31ae346$var$serializeProperties,
    optionalProperties: $1aefe11dc31ae346$var$serializeProperties,
    enum: $1aefe11dc31ae346$var$serializeString,
    type: $1aefe11dc31ae346$var$serializeType,
    ref: $1aefe11dc31ae346$var$serializeRef
};
function $1aefe11dc31ae346$var$compileSerializer(sch, definitions) {
    const _sch = $3vHot.getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $4pmHt.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    const serializeName = gen.scopeName("serialize");
    const cxt = {
        self: this,
        gen: gen,
        schema: sch.schema,
        schemaEnv: sch,
        definitions: definitions,
        data: $3ZPj5.default.data
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        sch.serializeName = serializeName;
        gen.func(serializeName, $3ZPj5.default.data, false, ()=>{
            gen.let($3ZPj5.default.json, (0, $4pmHt.str)``);
            $1aefe11dc31ae346$var$serializeCode(cxt);
            gen.return($3ZPj5.default.json);
        });
        gen.optimize(this.opts.code.optimize);
        const serializeFuncCode = gen.toString();
        sourceCode = `${gen.scopeRefs($3ZPj5.default.scope)}return ${serializeFuncCode}`;
        const makeSerialize = new Function(`${$3ZPj5.default.scope}`, sourceCode);
        const serialize = makeSerialize(this.scope.get());
        this.scope.value(serializeName, {
            ref: serialize
        });
        sch.serialize = serialize;
    } catch (e) {
        if (sourceCode) this.logger.error("Error compiling serializer, function code:", sourceCode);
        delete sch.serialize;
        delete sch.serializeName;
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
    return sch;
}
module.exports.default = $1aefe11dc31ae346$var$compileSerializer;
function $1aefe11dc31ae346$var$serializeCode(cxt) {
    let form;
    for (const key of $3QGyQ.jtdForms)if (key in cxt.schema) {
        form = key;
        break;
    }
    $1aefe11dc31ae346$var$serializeNullable(cxt, form ? $1aefe11dc31ae346$var$genSerialize[form] : $1aefe11dc31ae346$var$serializeEmpty);
}
function $1aefe11dc31ae346$var$serializeNullable(cxt, serializeForm) {
    const { gen: gen, schema: schema, data: data } = cxt;
    if (!schema.nullable) return serializeForm(cxt);
    gen.if((0, $4pmHt._)`${data} === undefined || ${data} === null`, ()=>gen.add($3ZPj5.default.json, (0, $4pmHt._)`"null"`), ()=>serializeForm(cxt));
}
function $1aefe11dc31ae346$var$serializeElements(cxt) {
    const { gen: gen, schema: schema, data: data } = cxt;
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`[`);
    const first = gen.let("first", true);
    gen.forOf("el", data, (el)=>{
        $1aefe11dc31ae346$var$addComma(cxt, first);
        $1aefe11dc31ae346$var$serializeCode({
            ...cxt,
            schema: schema.elements,
            data: el
        });
    });
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`]`);
}
function $1aefe11dc31ae346$var$serializeValues(cxt) {
    const { gen: gen, schema: schema, data: data } = cxt;
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`{`);
    const first = gen.let("first", true);
    gen.forIn("key", data, (key)=>$1aefe11dc31ae346$var$serializeKeyValue(cxt, key, schema.values, first));
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`}`);
}
function $1aefe11dc31ae346$var$serializeKeyValue(cxt, key, schema, first) {
    const { gen: gen, data: data } = cxt;
    $1aefe11dc31ae346$var$addComma(cxt, first);
    $1aefe11dc31ae346$var$serializeString({
        ...cxt,
        data: key
    });
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`:`);
    const value = gen.const("value", (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)(key)}`);
    $1aefe11dc31ae346$var$serializeCode({
        ...cxt,
        schema: schema,
        data: value
    });
}
function $1aefe11dc31ae346$var$serializeDiscriminator(cxt) {
    const { gen: gen, schema: schema, data: data } = cxt;
    const { discriminator: discriminator } = schema;
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`{${JSON.stringify(discriminator)}:`);
    const tag = gen.const("tag", (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)(discriminator)}`);
    $1aefe11dc31ae346$var$serializeString({
        ...cxt,
        data: tag
    });
    gen.if(false);
    for(const tagValue in schema.mapping){
        gen.elseIf((0, $4pmHt._)`${tag} === ${tagValue}`);
        const sch = schema.mapping[tagValue];
        $1aefe11dc31ae346$var$serializeSchemaProperties({
            ...cxt,
            schema: sch
        }, discriminator);
    }
    gen.endIf();
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`}`);
}
function $1aefe11dc31ae346$var$serializeProperties(cxt) {
    const { gen: gen } = cxt;
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`{`);
    $1aefe11dc31ae346$var$serializeSchemaProperties(cxt);
    gen.add($3ZPj5.default.json, (0, $4pmHt.str)`}`);
}
function $1aefe11dc31ae346$var$serializeSchemaProperties(cxt, discriminator) {
    const { gen: gen, schema: schema, data: data } = cxt;
    const { properties: properties, optionalProperties: optionalProperties } = schema;
    const props = keys(properties);
    const optProps = keys(optionalProperties);
    const allProps = allProperties(props.concat(optProps));
    let first = !discriminator;
    let firstProp;
    for (const key of props){
        if (first) first = false;
        else gen.add($3ZPj5.default.json, (0, $4pmHt.str)`,`);
        serializeProperty(key, properties[key], keyValue(key));
    }
    if (first) firstProp = gen.let("first", true);
    for (const key of optProps){
        const value = keyValue(key);
        gen.if((0, $4pmHt.and)((0, $4pmHt._)`${value} !== undefined`, (0, $bLF7l.isOwnProperty)(gen, data, key)), ()=>{
            $1aefe11dc31ae346$var$addComma(cxt, firstProp);
            serializeProperty(key, optionalProperties[key], value);
        });
    }
    if (schema.additionalProperties) gen.forIn("key", data, (key)=>gen.if(isAdditional(key, allProps), ()=>$1aefe11dc31ae346$var$serializeKeyValue(cxt, key, {}, firstProp)));
    function keys(ps) {
        return ps ? Object.keys(ps) : [];
    }
    function allProperties(ps) {
        if (discriminator) ps.push(discriminator);
        if (new Set(ps).size !== ps.length) throw new Error("JTD: properties/optionalProperties/disciminator overlap");
        return ps;
    }
    function keyValue(key) {
        return gen.const("value", (0, $4pmHt._)`${data}${(0, $4pmHt.getProperty)(key)}`);
    }
    function serializeProperty(key, propSchema, value) {
        gen.add($3ZPj5.default.json, (0, $4pmHt.str)`${JSON.stringify(key)}:`);
        $1aefe11dc31ae346$var$serializeCode({
            ...cxt,
            schema: propSchema,
            data: value
        });
    }
    function isAdditional(key, ps) {
        return ps.length ? (0, $4pmHt.and)(...ps.map((p)=>(0, $4pmHt._)`${key} !== ${p}`)) : true;
    }
}
function $1aefe11dc31ae346$var$serializeType(cxt) {
    const { gen: gen, schema: schema, data: data } = cxt;
    switch(schema.type){
        case "boolean":
            gen.add($3ZPj5.default.json, (0, $4pmHt._)`${data} ? "true" : "false"`);
            break;
        case "string":
            $1aefe11dc31ae346$var$serializeString(cxt);
            break;
        case "timestamp":
            gen.if((0, $4pmHt._)`${data} instanceof Date`, ()=>gen.add($3ZPj5.default.json, (0, $4pmHt._)`'"' + ${data}.toISOString() + '"'`), ()=>$1aefe11dc31ae346$var$serializeString(cxt));
            break;
        default:
            $1aefe11dc31ae346$var$serializeNumber(cxt);
    }
}
function $1aefe11dc31ae346$var$serializeString({ gen: gen, data: data }) {
    gen.add($3ZPj5.default.json, (0, $4pmHt._)`${(0, $leU6J.useFunc)(gen, $6Hk0T.default)}(${data})`);
}
function $1aefe11dc31ae346$var$serializeNumber({ gen: gen, data: data }) {
    gen.add($3ZPj5.default.json, (0, $4pmHt._)`"" + ${data}`);
}
function $1aefe11dc31ae346$var$serializeRef(cxt) {
    const { gen: gen, self: self, data: data, definitions: definitions, schema: schema, schemaEnv: schemaEnv } = cxt;
    const { ref: ref } = schema;
    const refSchema = definitions[ref];
    if (!refSchema) throw new $1SZ5T.default(self.opts.uriResolver, "", ref, `No definition ${ref}`);
    if (!(0, $kRH9m.hasRef)(refSchema)) return $1aefe11dc31ae346$var$serializeCode({
        ...cxt,
        schema: refSchema
    });
    const { root: root } = schemaEnv;
    const sch = $1aefe11dc31ae346$var$compileSerializer.call(self, new $3vHot.SchemaEnv({
        schema: refSchema,
        root: root
    }), definitions);
    gen.add($3ZPj5.default.json, (0, $4pmHt._)`${$1aefe11dc31ae346$var$getSerialize(gen, sch)}(${data})`);
}
function $1aefe11dc31ae346$var$getSerialize(gen, sch) {
    return sch.serialize ? gen.scopeValue("serialize", {
        ref: sch.serialize
    }) : (0, $4pmHt._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.serialize`;
}
function $1aefe11dc31ae346$var$serializeEmpty({ gen: gen, data: data }) {
    gen.add($3ZPj5.default.json, (0, $4pmHt._)`JSON.stringify(${data})`);
}
function $1aefe11dc31ae346$var$addComma({ gen: gen }, first) {
    if (first) gen.if(first, ()=>gen.assign(first, false), ()=>gen.add($3ZPj5.default.json, (0, $4pmHt.str)`,`));
    else gen.add($3ZPj5.default.json, (0, $4pmHt.str)`,`);
}

});
parcelRegister("3QGyQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jtdForms = void 0;
module.exports.jtdForms = [
    "elements",
    "values",
    "discriminator",
    "properties",
    "optionalProperties",
    "enum",
    "type",
    "ref"
];

});

parcelRegister("6Hk0T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $4e064875bb44aa1c$var$rxEscapable = // eslint-disable-next-line no-control-regex, no-misleading-character-class
/[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
const $4e064875bb44aa1c$var$escaped = {
    "\b": "\\b",
    "	": "\\t",
    "\n": "\\n",
    "\f": "\\f",
    "\r": "\\r",
    '"': '\\"',
    "\\": "\\\\"
};
function $4e064875bb44aa1c$var$quote(s) {
    $4e064875bb44aa1c$var$rxEscapable.lastIndex = 0;
    return '"' + ($4e064875bb44aa1c$var$rxEscapable.test(s) ? s.replace($4e064875bb44aa1c$var$rxEscapable, (a)=>{
        const c = $4e064875bb44aa1c$var$escaped[a];
        return typeof c === "string" ? c : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
    }) : s) + '"';
}
module.exports.default = $4e064875bb44aa1c$var$quote;
$4e064875bb44aa1c$var$quote.code = 'require("ajv/dist/runtime/quote").default';

});


parcelRegister("aKDeZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3QGyQ = parcelRequire("3QGyQ");

var $3vHot = parcelRequire("3vHot");

var $4pmHt = parcelRequire("4pmHt");

var $1SZ5T = parcelRequire("1SZ5T");

var $3ZPj5 = parcelRequire("3ZPj5");

var $bLF7l = parcelRequire("bLF7l");

var $kRH9m = parcelRequire("kRH9m");

var $jEHUU = parcelRequire("jEHUU");

var $dglos = parcelRequire("dglos");

var $leU6J = parcelRequire("leU6J");

var $f8zmd = parcelRequire("f8zmd");
const $7d3ca3a58cd2cb76$var$genParse = {
    elements: $7d3ca3a58cd2cb76$var$parseElements,
    values: $7d3ca3a58cd2cb76$var$parseValues,
    discriminator: $7d3ca3a58cd2cb76$var$parseDiscriminator,
    properties: $7d3ca3a58cd2cb76$var$parseProperties,
    optionalProperties: $7d3ca3a58cd2cb76$var$parseProperties,
    enum: $7d3ca3a58cd2cb76$var$parseEnum,
    type: $7d3ca3a58cd2cb76$var$parseType,
    ref: $7d3ca3a58cd2cb76$var$parseRef
};
function $7d3ca3a58cd2cb76$var$compileParser(sch, definitions) {
    const _sch = $3vHot.getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $4pmHt.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    const parseName = gen.scopeName("parse");
    const cxt = {
        self: this,
        gen: gen,
        schema: sch.schema,
        schemaEnv: sch,
        definitions: definitions,
        data: $3ZPj5.default.data,
        parseName: parseName,
        char: gen.name("c")
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        sch.parseName = parseName;
        $7d3ca3a58cd2cb76$var$parserFunction(cxt);
        gen.optimize(this.opts.code.optimize);
        const parseFuncCode = gen.toString();
        sourceCode = `${gen.scopeRefs($3ZPj5.default.scope)}return ${parseFuncCode}`;
        const makeParse = new Function(`${$3ZPj5.default.scope}`, sourceCode);
        const parse = makeParse(this.scope.get());
        this.scope.value(parseName, {
            ref: parse
        });
        sch.parse = parse;
    } catch (e) {
        if (sourceCode) this.logger.error("Error compiling parser, function code:", sourceCode);
        delete sch.parse;
        delete sch.parseName;
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
    return sch;
}
module.exports.default = $7d3ca3a58cd2cb76$var$compileParser;
const $7d3ca3a58cd2cb76$var$undef = (0, $4pmHt._)`undefined`;
function $7d3ca3a58cd2cb76$var$parserFunction(cxt) {
    const { gen: gen, parseName: parseName, char: char } = cxt;
    gen.func(parseName, (0, $4pmHt._)`${$3ZPj5.default.json}, ${$3ZPj5.default.jsonPos}, ${$3ZPj5.default.jsonPart}`, false, ()=>{
        gen.let($3ZPj5.default.data);
        gen.let(char);
        gen.assign((0, $4pmHt._)`${parseName}.message`, $7d3ca3a58cd2cb76$var$undef);
        gen.assign((0, $4pmHt._)`${parseName}.position`, $7d3ca3a58cd2cb76$var$undef);
        gen.assign($3ZPj5.default.jsonPos, (0, $4pmHt._)`${$3ZPj5.default.jsonPos} || 0`);
        gen.const($3ZPj5.default.jsonLen, (0, $4pmHt._)`${$3ZPj5.default.json}.length`);
        $7d3ca3a58cd2cb76$var$parseCode(cxt);
        $7d3ca3a58cd2cb76$var$skipWhitespace(cxt);
        gen.if($3ZPj5.default.jsonPart, ()=>{
            gen.assign((0, $4pmHt._)`${parseName}.position`, $3ZPj5.default.jsonPos);
            gen.return($3ZPj5.default.data);
        });
        gen.if((0, $4pmHt._)`${$3ZPj5.default.jsonPos} === ${$3ZPj5.default.jsonLen}`, ()=>gen.return($3ZPj5.default.data));
        $7d3ca3a58cd2cb76$var$jsonSyntaxError(cxt);
    });
}
function $7d3ca3a58cd2cb76$var$parseCode(cxt) {
    let form;
    for (const key of $3QGyQ.jtdForms)if (key in cxt.schema) {
        form = key;
        break;
    }
    if (form) $7d3ca3a58cd2cb76$var$parseNullable(cxt, $7d3ca3a58cd2cb76$var$genParse[form]);
    else $7d3ca3a58cd2cb76$var$parseEmpty(cxt);
}
const $7d3ca3a58cd2cb76$var$parseBoolean = $7d3ca3a58cd2cb76$var$parseBooleanToken(true, $7d3ca3a58cd2cb76$var$parseBooleanToken(false, $7d3ca3a58cd2cb76$var$jsonSyntaxError));
function $7d3ca3a58cd2cb76$var$parseNullable(cxt, parseForm) {
    const { gen: gen, schema: schema, data: data } = cxt;
    if (!schema.nullable) return parseForm(cxt);
    $7d3ca3a58cd2cb76$var$tryParseToken(cxt, "null", parseForm, ()=>gen.assign(data, null));
}
function $7d3ca3a58cd2cb76$var$parseElements(cxt) {
    const { gen: gen, schema: schema, data: data } = cxt;
    $7d3ca3a58cd2cb76$var$parseToken(cxt, "[");
    const ix = gen.let("i", 0);
    gen.assign(data, (0, $4pmHt._)`[]`);
    $7d3ca3a58cd2cb76$var$parseItems(cxt, "]", ()=>{
        const el = gen.let("el");
        $7d3ca3a58cd2cb76$var$parseCode({
            ...cxt,
            schema: schema.elements,
            data: el
        });
        gen.assign((0, $4pmHt._)`${data}[${ix}++]`, el);
    });
}
function $7d3ca3a58cd2cb76$var$parseValues(cxt) {
    const { gen: gen, schema: schema, data: data } = cxt;
    $7d3ca3a58cd2cb76$var$parseToken(cxt, "{");
    gen.assign(data, (0, $4pmHt._)`{}`);
    $7d3ca3a58cd2cb76$var$parseItems(cxt, "}", ()=>$7d3ca3a58cd2cb76$var$parseKeyValue(cxt, schema.values));
}
function $7d3ca3a58cd2cb76$var$parseItems(cxt, endToken, block) {
    $7d3ca3a58cd2cb76$var$tryParseItems(cxt, endToken, block);
    $7d3ca3a58cd2cb76$var$parseToken(cxt, endToken);
}
function $7d3ca3a58cd2cb76$var$tryParseItems(cxt, endToken, block) {
    const { gen: gen } = cxt;
    gen.for((0, $4pmHt._)`;${$3ZPj5.default.jsonPos}<${$3ZPj5.default.jsonLen} && ${$7d3ca3a58cd2cb76$var$jsonSlice(1)}!==${endToken};`, ()=>{
        block();
        $7d3ca3a58cd2cb76$var$tryParseToken(cxt, ",", ()=>gen.break(), hasItem);
    });
    function hasItem() {
        $7d3ca3a58cd2cb76$var$tryParseToken(cxt, endToken, ()=>{}, $7d3ca3a58cd2cb76$var$jsonSyntaxError);
    }
}
function $7d3ca3a58cd2cb76$var$parseKeyValue(cxt, schema) {
    const { gen: gen } = cxt;
    const key = gen.let("key");
    $7d3ca3a58cd2cb76$var$parseString({
        ...cxt,
        data: key
    });
    $7d3ca3a58cd2cb76$var$parseToken(cxt, ":");
    $7d3ca3a58cd2cb76$var$parsePropertyValue(cxt, key, schema);
}
function $7d3ca3a58cd2cb76$var$parseDiscriminator(cxt) {
    const { gen: gen, data: data, schema: schema } = cxt;
    const { discriminator: discriminator, mapping: mapping } = schema;
    $7d3ca3a58cd2cb76$var$parseToken(cxt, "{");
    gen.assign(data, (0, $4pmHt._)`{}`);
    const startPos = gen.const("pos", $3ZPj5.default.jsonPos);
    const value = gen.let("value");
    const tag = gen.let("tag");
    $7d3ca3a58cd2cb76$var$tryParseItems(cxt, "}", ()=>{
        const key = gen.let("key");
        $7d3ca3a58cd2cb76$var$parseString({
            ...cxt,
            data: key
        });
        $7d3ca3a58cd2cb76$var$parseToken(cxt, ":");
        gen.if((0, $4pmHt._)`${key} === ${discriminator}`, ()=>{
            $7d3ca3a58cd2cb76$var$parseString({
                ...cxt,
                data: tag
            });
            gen.assign((0, $4pmHt._)`${data}[${key}]`, tag);
            gen.break();
        }, ()=>$7d3ca3a58cd2cb76$var$parseEmpty({
                ...cxt,
                data: value
            }) // can be discarded/skipped
        );
    });
    gen.assign($3ZPj5.default.jsonPos, startPos);
    gen.if((0, $4pmHt._)`${tag} === undefined`);
    $7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt.str)`discriminator tag not found`);
    for(const tagValue in mapping){
        gen.elseIf((0, $4pmHt._)`${tag} === ${tagValue}`);
        $7d3ca3a58cd2cb76$var$parseSchemaProperties({
            ...cxt,
            schema: mapping[tagValue]
        }, discriminator);
    }
    gen.else();
    $7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt.str)`discriminator value not in schema`);
    gen.endIf();
}
function $7d3ca3a58cd2cb76$var$parseProperties(cxt) {
    const { gen: gen, data: data } = cxt;
    $7d3ca3a58cd2cb76$var$parseToken(cxt, "{");
    gen.assign(data, (0, $4pmHt._)`{}`);
    $7d3ca3a58cd2cb76$var$parseSchemaProperties(cxt);
}
function $7d3ca3a58cd2cb76$var$parseSchemaProperties(cxt, discriminator) {
    const { gen: gen, schema: schema, data: data } = cxt;
    const { properties: properties, optionalProperties: optionalProperties, additionalProperties: additionalProperties } = schema;
    $7d3ca3a58cd2cb76$var$parseItems(cxt, "}", ()=>{
        const key = gen.let("key");
        $7d3ca3a58cd2cb76$var$parseString({
            ...cxt,
            data: key
        });
        $7d3ca3a58cd2cb76$var$parseToken(cxt, ":");
        gen.if(false);
        $7d3ca3a58cd2cb76$var$parseDefinedProperty(cxt, key, properties);
        $7d3ca3a58cd2cb76$var$parseDefinedProperty(cxt, key, optionalProperties);
        if (discriminator) {
            gen.elseIf((0, $4pmHt._)`${key} === ${discriminator}`);
            const tag = gen.let("tag");
            $7d3ca3a58cd2cb76$var$parseString({
                ...cxt,
                data: tag
            }); // can be discarded, it is already assigned
        }
        gen.else();
        if (additionalProperties) $7d3ca3a58cd2cb76$var$parseEmpty({
            ...cxt,
            data: (0, $4pmHt._)`${data}[${key}]`
        });
        else $7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt.str)`property ${key} not allowed`);
        gen.endIf();
    });
    if (properties) {
        const hasProp = (0, $bLF7l.hasPropFunc)(gen);
        const allProps = (0, $4pmHt.and)(...Object.keys(properties).map((p)=>(0, $4pmHt._)`${hasProp}.call(${data}, ${p})`));
        gen.if((0, $4pmHt.not)(allProps), ()=>$7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt.str)`missing required properties`));
    }
}
function $7d3ca3a58cd2cb76$var$parseDefinedProperty(cxt, key, schemas = {}) {
    const { gen: gen } = cxt;
    for(const prop in schemas){
        gen.elseIf((0, $4pmHt._)`${key} === ${prop}`);
        $7d3ca3a58cd2cb76$var$parsePropertyValue(cxt, key, schemas[prop]);
    }
}
function $7d3ca3a58cd2cb76$var$parsePropertyValue(cxt, key, schema) {
    $7d3ca3a58cd2cb76$var$parseCode({
        ...cxt,
        schema: schema,
        data: (0, $4pmHt._)`${cxt.data}[${key}]`
    });
}
function $7d3ca3a58cd2cb76$var$parseType(cxt) {
    const { gen: gen, schema: schema, data: data, self: self } = cxt;
    switch(schema.type){
        case "boolean":
            $7d3ca3a58cd2cb76$var$parseBoolean(cxt);
            break;
        case "string":
            $7d3ca3a58cd2cb76$var$parseString(cxt);
            break;
        case "timestamp":
            {
                $7d3ca3a58cd2cb76$var$parseString(cxt);
                const vts = (0, $leU6J.useFunc)(gen, $f8zmd.default);
                const { allowDate: allowDate, parseDate: parseDate } = self.opts;
                const notValid = allowDate ? (0, $4pmHt._)`!${vts}(${data}, true)` : (0, $4pmHt._)`!${vts}(${data})`;
                const fail = parseDate ? (0, $4pmHt.or)(notValid, (0, $4pmHt._)`(${data} = new Date(${data}), false)`, (0, $4pmHt._)`isNaN(${data}.valueOf())`) : notValid;
                gen.if(fail, ()=>$7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt.str)`invalid timestamp`));
                break;
            }
        case "float32":
        case "float64":
            $7d3ca3a58cd2cb76$var$parseNumber(cxt);
            break;
        default:
            {
                const t = schema.type;
                if (!self.opts.int32range && (t === "int32" || t === "uint32")) {
                    $7d3ca3a58cd2cb76$var$parseNumber(cxt, 16); // 2 ** 53 - max safe integer
                    if (t === "uint32") gen.if((0, $4pmHt._)`${data} < 0`, ()=>$7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt.str)`integer out of range`));
                } else {
                    const [min, max, maxDigits] = $jEHUU.intRange[t];
                    $7d3ca3a58cd2cb76$var$parseNumber(cxt, maxDigits);
                    gen.if((0, $4pmHt._)`${data} < ${min} || ${data} > ${max}`, ()=>$7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt.str)`integer out of range`));
                }
            }
    }
}
function $7d3ca3a58cd2cb76$var$parseString(cxt) {
    $7d3ca3a58cd2cb76$var$parseToken(cxt, '"');
    $7d3ca3a58cd2cb76$var$parseWith(cxt, $dglos.parseJsonString);
}
function $7d3ca3a58cd2cb76$var$parseEnum(cxt) {
    const { gen: gen, data: data, schema: schema } = cxt;
    const enumSch = schema.enum;
    $7d3ca3a58cd2cb76$var$parseToken(cxt, '"');
    // TODO loopEnum
    gen.if(false);
    for (const value of enumSch){
        const valueStr = JSON.stringify(value).slice(1); // remove starting quote
        gen.elseIf((0, $4pmHt._)`${$7d3ca3a58cd2cb76$var$jsonSlice(valueStr.length)} === ${valueStr}`);
        gen.assign(data, (0, $4pmHt.str)`${value}`);
        gen.add($3ZPj5.default.jsonPos, valueStr.length);
    }
    gen.else();
    $7d3ca3a58cd2cb76$var$jsonSyntaxError(cxt);
    gen.endIf();
}
function $7d3ca3a58cd2cb76$var$parseNumber(cxt, maxDigits) {
    const { gen: gen } = cxt;
    $7d3ca3a58cd2cb76$var$skipWhitespace(cxt);
    gen.if((0, $4pmHt._)`"-0123456789".indexOf(${$7d3ca3a58cd2cb76$var$jsonSlice(1)}) < 0`, ()=>$7d3ca3a58cd2cb76$var$jsonSyntaxError(cxt), ()=>$7d3ca3a58cd2cb76$var$parseWith(cxt, $dglos.parseJsonNumber, maxDigits));
}
function $7d3ca3a58cd2cb76$var$parseBooleanToken(bool, fail) {
    return (cxt)=>{
        const { gen: gen, data: data } = cxt;
        $7d3ca3a58cd2cb76$var$tryParseToken(cxt, `${bool}`, ()=>fail(cxt), ()=>gen.assign(data, bool));
    };
}
function $7d3ca3a58cd2cb76$var$parseRef(cxt) {
    const { gen: gen, self: self, definitions: definitions, schema: schema, schemaEnv: schemaEnv } = cxt;
    const { ref: ref } = schema;
    const refSchema = definitions[ref];
    if (!refSchema) throw new $1SZ5T.default(self.opts.uriResolver, "", ref, `No definition ${ref}`);
    if (!(0, $kRH9m.hasRef)(refSchema)) return $7d3ca3a58cd2cb76$var$parseCode({
        ...cxt,
        schema: refSchema
    });
    const { root: root } = schemaEnv;
    const sch = $7d3ca3a58cd2cb76$var$compileParser.call(self, new $3vHot.SchemaEnv({
        schema: refSchema,
        root: root
    }), definitions);
    $7d3ca3a58cd2cb76$var$partialParse(cxt, $7d3ca3a58cd2cb76$var$getParser(gen, sch), true);
}
function $7d3ca3a58cd2cb76$var$getParser(gen, sch) {
    return sch.parse ? gen.scopeValue("parse", {
        ref: sch.parse
    }) : (0, $4pmHt._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.parse`;
}
function $7d3ca3a58cd2cb76$var$parseEmpty(cxt) {
    $7d3ca3a58cd2cb76$var$parseWith(cxt, $dglos.parseJson);
}
function $7d3ca3a58cd2cb76$var$parseWith(cxt, parseFunc, args) {
    $7d3ca3a58cd2cb76$var$partialParse(cxt, (0, $leU6J.useFunc)(cxt.gen, parseFunc), args);
}
function $7d3ca3a58cd2cb76$var$partialParse(cxt, parseFunc, args) {
    const { gen: gen, data: data } = cxt;
    gen.assign(data, (0, $4pmHt._)`${parseFunc}(${$3ZPj5.default.json}, ${$3ZPj5.default.jsonPos}${args ? (0, $4pmHt._)`, ${args}` : $4pmHt.nil})`);
    gen.assign($3ZPj5.default.jsonPos, (0, $4pmHt._)`${parseFunc}.position`);
    gen.if((0, $4pmHt._)`${data} === undefined`, ()=>$7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt._)`${parseFunc}.message`));
}
function $7d3ca3a58cd2cb76$var$parseToken(cxt, tok) {
    $7d3ca3a58cd2cb76$var$tryParseToken(cxt, tok, $7d3ca3a58cd2cb76$var$jsonSyntaxError);
}
function $7d3ca3a58cd2cb76$var$tryParseToken(cxt, tok, fail, success) {
    const { gen: gen } = cxt;
    const n = tok.length;
    $7d3ca3a58cd2cb76$var$skipWhitespace(cxt);
    gen.if((0, $4pmHt._)`${$7d3ca3a58cd2cb76$var$jsonSlice(n)} === ${tok}`, ()=>{
        gen.add($3ZPj5.default.jsonPos, n);
        success === null || success === void 0 || success(cxt);
    }, ()=>fail(cxt));
}
function $7d3ca3a58cd2cb76$var$skipWhitespace({ gen: gen, char: c }) {
    gen.code((0, $4pmHt._)`while((${c}=${$3ZPj5.default.json}[${$3ZPj5.default.jsonPos}],${c}===" "||${c}==="\\n"||${c}==="\\r"||${c}==="\\t"))${$3ZPj5.default.jsonPos}++;`);
}
function $7d3ca3a58cd2cb76$var$jsonSlice(len) {
    return len === 1 ? (0, $4pmHt._)`${$3ZPj5.default.json}[${$3ZPj5.default.jsonPos}]` : (0, $4pmHt._)`${$3ZPj5.default.json}.slice(${$3ZPj5.default.jsonPos}, ${$3ZPj5.default.jsonPos}+${len})`;
}
function $7d3ca3a58cd2cb76$var$jsonSyntaxError(cxt) {
    $7d3ca3a58cd2cb76$var$parsingError(cxt, (0, $4pmHt._)`"unexpected token " + ${$3ZPj5.default.json}[${$3ZPj5.default.jsonPos}]`);
}
function $7d3ca3a58cd2cb76$var$parsingError({ gen: gen, parseName: parseName }, msg) {
    gen.assign((0, $4pmHt._)`${parseName}.message`, msg);
    gen.assign((0, $4pmHt._)`${parseName}.position`, $3ZPj5.default.jsonPos);
    gen.return($7d3ca3a58cd2cb76$var$undef);
}

});
parcelRegister("dglos", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseJsonString = module.exports.parseJsonNumber = module.exports.parseJson = void 0;
const $9a7d5d4cafaea14a$var$rxParseJson = /position\s(\d+)(?: \(line \d+ column \d+\))?$/;
function $9a7d5d4cafaea14a$var$parseJson(s, pos) {
    let endPos;
    $9a7d5d4cafaea14a$var$parseJson.message = undefined;
    let matches;
    if (pos) s = s.slice(pos);
    try {
        $9a7d5d4cafaea14a$var$parseJson.position = pos + s.length;
        return JSON.parse(s);
    } catch (e) {
        matches = $9a7d5d4cafaea14a$var$rxParseJson.exec(e.message);
        if (!matches) {
            $9a7d5d4cafaea14a$var$parseJson.message = "unexpected end";
            return undefined;
        }
        endPos = +matches[1];
        const c = s[endPos];
        s = s.slice(0, endPos);
        $9a7d5d4cafaea14a$var$parseJson.position = pos + endPos;
        try {
            return JSON.parse(s);
        } catch (e1) {
            $9a7d5d4cafaea14a$var$parseJson.message = `unexpected token ${c}`;
            return undefined;
        }
    }
}
module.exports.parseJson = $9a7d5d4cafaea14a$var$parseJson;
$9a7d5d4cafaea14a$var$parseJson.message = undefined;
$9a7d5d4cafaea14a$var$parseJson.position = 0;
$9a7d5d4cafaea14a$var$parseJson.code = 'require("ajv/dist/runtime/parseJson").parseJson';
function $9a7d5d4cafaea14a$var$parseJsonNumber(s, pos, maxDigits) {
    let numStr = "";
    let c;
    $9a7d5d4cafaea14a$var$parseJsonNumber.message = undefined;
    if (s[pos] === "-") {
        numStr += "-";
        pos++;
    }
    if (s[pos] === "0") {
        numStr += "0";
        pos++;
    } else if (!parseDigits(maxDigits)) {
        errorMessage();
        return undefined;
    }
    if (maxDigits) {
        $9a7d5d4cafaea14a$var$parseJsonNumber.position = pos;
        return +numStr;
    }
    if (s[pos] === ".") {
        numStr += ".";
        pos++;
        if (!parseDigits()) {
            errorMessage();
            return undefined;
        }
    }
    if (c = s[pos], c === "e" || c === "E") {
        numStr += "e";
        pos++;
        if (c = s[pos], c === "+" || c === "-") {
            numStr += c;
            pos++;
        }
        if (!parseDigits()) {
            errorMessage();
            return undefined;
        }
    }
    $9a7d5d4cafaea14a$var$parseJsonNumber.position = pos;
    return +numStr;
    function parseDigits(maxLen) {
        let digit = false;
        while(c = s[pos], c >= "0" && c <= "9" && (maxLen === undefined || maxLen-- > 0)){
            digit = true;
            numStr += c;
            pos++;
        }
        return digit;
    }
    function errorMessage() {
        $9a7d5d4cafaea14a$var$parseJsonNumber.position = pos;
        $9a7d5d4cafaea14a$var$parseJsonNumber.message = pos < s.length ? `unexpected token ${s[pos]}` : "unexpected end";
    }
}
module.exports.parseJsonNumber = $9a7d5d4cafaea14a$var$parseJsonNumber;
$9a7d5d4cafaea14a$var$parseJsonNumber.message = undefined;
$9a7d5d4cafaea14a$var$parseJsonNumber.position = 0;
$9a7d5d4cafaea14a$var$parseJsonNumber.code = 'require("ajv/dist/runtime/parseJson").parseJsonNumber';
const $9a7d5d4cafaea14a$var$escapedChars = {
    b: "\b",
    f: "\f",
    n: "\n",
    r: "\r",
    t: "	",
    '"': '"',
    "/": "/",
    "\\": "\\"
};
const $9a7d5d4cafaea14a$var$CODE_A = "a".charCodeAt(0);
const $9a7d5d4cafaea14a$var$CODE_0 = "0".charCodeAt(0);
function $9a7d5d4cafaea14a$var$parseJsonString(s, pos) {
    let str = "";
    let c;
    $9a7d5d4cafaea14a$var$parseJsonString.message = undefined;
    // eslint-disable-next-line no-constant-condition, @typescript-eslint/no-unnecessary-condition
    while(true){
        c = s[pos++];
        if (c === '"') break;
        if (c === "\\") {
            c = s[pos];
            if (c in $9a7d5d4cafaea14a$var$escapedChars) {
                str += $9a7d5d4cafaea14a$var$escapedChars[c];
                pos++;
            } else if (c === "u") {
                pos++;
                let count = 4;
                let code = 0;
                while(count--){
                    code <<= 4;
                    c = s[pos];
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (c === undefined) {
                        errorMessage("unexpected end");
                        return undefined;
                    }
                    c = c.toLowerCase();
                    if (c >= "a" && c <= "f") code += c.charCodeAt(0) - $9a7d5d4cafaea14a$var$CODE_A + 10;
                    else if (c >= "0" && c <= "9") code += c.charCodeAt(0) - $9a7d5d4cafaea14a$var$CODE_0;
                    else {
                        errorMessage(`unexpected token ${c}`);
                        return undefined;
                    }
                    pos++;
                }
                str += String.fromCharCode(code);
            } else {
                errorMessage(`unexpected token ${c}`);
                return undefined;
            }
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        } else if (c === undefined) {
            errorMessage("unexpected end");
            return undefined;
        } else if (c.charCodeAt(0) >= 0x20) str += c;
        else {
            errorMessage(`unexpected token ${c}`);
            return undefined;
        }
    }
    $9a7d5d4cafaea14a$var$parseJsonString.position = pos;
    return str;
    function errorMessage(msg) {
        $9a7d5d4cafaea14a$var$parseJsonString.position = pos;
        $9a7d5d4cafaea14a$var$parseJsonString.message = msg;
    }
}
module.exports.parseJsonString = $9a7d5d4cafaea14a$var$parseJsonString;
$9a7d5d4cafaea14a$var$parseJsonString.message = undefined;
$9a7d5d4cafaea14a$var$parseJsonString.position = 0;
$9a7d5d4cafaea14a$var$parseJsonString.code = 'require("ajv/dist/runtime/parseJson").parseJsonString';

});




/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ 
var $cw5sC = parcelRequire("cw5sC");

var $cw5sC = parcelRequire("cw5sC");

var $6B4AI = parcelRequire("6B4AI");

var $4aVzI = parcelRequire("4aVzI");
const $cc5d0749d0b75bc5$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $cc5d0749d0b75bc5$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $cc5d0749d0b75bc5$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $cc5d0749d0b75bc5$var$textRange = function(node, from, to) {
    let range = $cc5d0749d0b75bc5$var$reusedRange || ($cc5d0749d0b75bc5$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $cc5d0749d0b75bc5$var$clearReusedRange = function() {
    $cc5d0749d0b75bc5$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $cc5d0749d0b75bc5$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($cc5d0749d0b75bc5$var$scanFor(node, off, targetNode, targetOff, -1) || $cc5d0749d0b75bc5$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $cc5d0749d0b75bc5$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $cc5d0749d0b75bc5$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $cc5d0749d0b75bc5$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $cc5d0749d0b75bc5$var$hasBlockDesc(node) || $cc5d0749d0b75bc5$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $cc5d0749d0b75bc5$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $cc5d0749d0b75bc5$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $cc5d0749d0b75bc5$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $cc5d0749d0b75bc5$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $cc5d0749d0b75bc5$var$nodeSize(node);
        } else if (node.parentNode && !$cc5d0749d0b75bc5$var$hasBlockDesc(node)) {
            offset = $cc5d0749d0b75bc5$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $cc5d0749d0b75bc5$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$cc5d0749d0b75bc5$var$hasBlockDesc(node)) {
            offset = $cc5d0749d0b75bc5$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $cc5d0749d0b75bc5$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $cc5d0749d0b75bc5$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $cc5d0749d0b75bc5$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $cc5d0749d0b75bc5$var$nodeSize(node);
    }
}
function $cc5d0749d0b75bc5$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $cc5d0749d0b75bc5$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $cc5d0749d0b75bc5$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $cc5d0749d0b75bc5$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $cc5d0749d0b75bc5$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $cc5d0749d0b75bc5$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($cc5d0749d0b75bc5$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($cc5d0749d0b75bc5$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $cc5d0749d0b75bc5$var$nav = typeof navigator != "undefined" ? navigator : null;
const $cc5d0749d0b75bc5$var$doc = typeof document != "undefined" ? document : null;
const $cc5d0749d0b75bc5$var$agent = $cc5d0749d0b75bc5$var$nav && $cc5d0749d0b75bc5$var$nav.userAgent || "";
const $cc5d0749d0b75bc5$var$ie_edge = /Edge\/(\d+)/.exec($cc5d0749d0b75bc5$var$agent);
const $cc5d0749d0b75bc5$var$ie_upto10 = /MSIE \d/.exec($cc5d0749d0b75bc5$var$agent);
const $cc5d0749d0b75bc5$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($cc5d0749d0b75bc5$var$agent);
const $cc5d0749d0b75bc5$var$ie = !!($cc5d0749d0b75bc5$var$ie_upto10 || $cc5d0749d0b75bc5$var$ie_11up || $cc5d0749d0b75bc5$var$ie_edge);
const $cc5d0749d0b75bc5$var$ie_version = $cc5d0749d0b75bc5$var$ie_upto10 ? document.documentMode : $cc5d0749d0b75bc5$var$ie_11up ? +$cc5d0749d0b75bc5$var$ie_11up[1] : $cc5d0749d0b75bc5$var$ie_edge ? +$cc5d0749d0b75bc5$var$ie_edge[1] : 0;
const $cc5d0749d0b75bc5$var$gecko = !$cc5d0749d0b75bc5$var$ie && /gecko\/(\d+)/i.test($cc5d0749d0b75bc5$var$agent);
$cc5d0749d0b75bc5$var$gecko && (/Firefox\/(\d+)/.exec($cc5d0749d0b75bc5$var$agent) || [
    0,
    0
])[1];
const $cc5d0749d0b75bc5$var$_chrome = !$cc5d0749d0b75bc5$var$ie && /Chrome\/(\d+)/.exec($cc5d0749d0b75bc5$var$agent);
const $cc5d0749d0b75bc5$var$chrome = !!$cc5d0749d0b75bc5$var$_chrome;
const $cc5d0749d0b75bc5$var$chrome_version = $cc5d0749d0b75bc5$var$_chrome ? +$cc5d0749d0b75bc5$var$_chrome[1] : 0;
const $cc5d0749d0b75bc5$var$safari = !$cc5d0749d0b75bc5$var$ie && !!$cc5d0749d0b75bc5$var$nav && /Apple Computer/.test($cc5d0749d0b75bc5$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $cc5d0749d0b75bc5$var$ios = $cc5d0749d0b75bc5$var$safari && (/Mobile\/\w+/.test($cc5d0749d0b75bc5$var$agent) || !!$cc5d0749d0b75bc5$var$nav && $cc5d0749d0b75bc5$var$nav.maxTouchPoints > 2);
const $cc5d0749d0b75bc5$var$mac = $cc5d0749d0b75bc5$var$ios || ($cc5d0749d0b75bc5$var$nav ? /Mac/.test($cc5d0749d0b75bc5$var$nav.platform) : false);
const $cc5d0749d0b75bc5$var$windows = $cc5d0749d0b75bc5$var$nav ? /Win/.test($cc5d0749d0b75bc5$var$nav.platform) : false;
const $cc5d0749d0b75bc5$var$android = /Android \d/.test($cc5d0749d0b75bc5$var$agent);
const $cc5d0749d0b75bc5$var$webkit = !!$cc5d0749d0b75bc5$var$doc && "webkitFontSmoothing" in $cc5d0749d0b75bc5$var$doc.documentElement.style;
const $cc5d0749d0b75bc5$var$webkit_version = $cc5d0749d0b75bc5$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $cc5d0749d0b75bc5$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $cc5d0749d0b75bc5$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $cc5d0749d0b75bc5$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $cc5d0749d0b75bc5$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $cc5d0749d0b75bc5$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $cc5d0749d0b75bc5$var$windowRect(doc) : $cc5d0749d0b75bc5$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $cc5d0749d0b75bc5$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $cc5d0749d0b75bc5$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $cc5d0749d0b75bc5$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $cc5d0749d0b75bc5$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $cc5d0749d0b75bc5$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $cc5d0749d0b75bc5$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $cc5d0749d0b75bc5$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $cc5d0749d0b75bc5$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $cc5d0749d0b75bc5$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $cc5d0749d0b75bc5$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $cc5d0749d0b75bc5$var$scrollStack(view.dom)
    };
}
function $cc5d0749d0b75bc5$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $cc5d0749d0b75bc5$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $cc5d0749d0b75bc5$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $cc5d0749d0b75bc5$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $cc5d0749d0b75bc5$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $cc5d0749d0b75bc5$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $cc5d0749d0b75bc5$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($cc5d0749d0b75bc5$var$preventScrollSupported) return dom.focus($cc5d0749d0b75bc5$var$preventScrollSupported);
    let stored = $cc5d0749d0b75bc5$var$scrollStack(dom);
    dom.focus($cc5d0749d0b75bc5$var$preventScrollSupported == null ? {
        get preventScroll () {
            $cc5d0749d0b75bc5$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$cc5d0749d0b75bc5$var$preventScrollSupported) {
        $cc5d0749d0b75bc5$var$preventScrollSupported = false;
        $cc5d0749d0b75bc5$var$restoreScrollStack(stored, 0);
    }
}
function $cc5d0749d0b75bc5$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $cc5d0749d0b75bc5$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $cc5d0749d0b75bc5$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $cc5d0749d0b75bc5$var$findOffsetInNode(closest, coordsClosest);
}
function $cc5d0749d0b75bc5$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $cc5d0749d0b75bc5$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($cc5d0749d0b75bc5$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $cc5d0749d0b75bc5$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $cc5d0749d0b75bc5$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $cc5d0749d0b75bc5$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $cc5d0749d0b75bc5$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $cc5d0749d0b75bc5$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true);
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM)) {
            let rect = desc.dom.getBoundingClientRect();
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $cc5d0749d0b75bc5$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($cc5d0749d0b75bc5$var$inRect(coords, rect)) return $cc5d0749d0b75bc5$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $cc5d0749d0b75bc5$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $cc5d0749d0b75bc5$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$cc5d0749d0b75bc5$var$inRect(coords, box)) return null;
        elt = $cc5d0749d0b75bc5$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($cc5d0749d0b75bc5$var$safari) {
        for(let p = elt; node && p; p = $cc5d0749d0b75bc5$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $cc5d0749d0b75bc5$var$targetKludge(elt, coords);
    if (node) {
        if ($cc5d0749d0b75bc5$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($cc5d0749d0b75bc5$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $cc5d0749d0b75bc5$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $cc5d0749d0b75bc5$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $cc5d0749d0b75bc5$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $cc5d0749d0b75bc5$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($cc5d0749d0b75bc5$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $cc5d0749d0b75bc5$var$nonZero) || target.getBoundingClientRect();
}
const $cc5d0749d0b75bc5$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $cc5d0749d0b75bc5$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $cc5d0749d0b75bc5$var$webkit || $cc5d0749d0b75bc5$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($cc5d0749d0b75bc5$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $cc5d0749d0b75bc5$var$singleRect($cc5d0749d0b75bc5$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($cc5d0749d0b75bc5$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $cc5d0749d0b75bc5$var$singleRect($cc5d0749d0b75bc5$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $cc5d0749d0b75bc5$var$singleRect($cc5d0749d0b75bc5$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $cc5d0749d0b75bc5$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $cc5d0749d0b75bc5$var$flattenV($cc5d0749d0b75bc5$var$singleRect($cc5d0749d0b75bc5$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $cc5d0749d0b75bc5$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $cc5d0749d0b75bc5$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $cc5d0749d0b75bc5$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $cc5d0749d0b75bc5$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $cc5d0749d0b75bc5$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $cc5d0749d0b75bc5$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $cc5d0749d0b75bc5$var$textRange(before, $cc5d0749d0b75bc5$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $cc5d0749d0b75bc5$var$flattenV($cc5d0749d0b75bc5$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $cc5d0749d0b75bc5$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $cc5d0749d0b75bc5$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $cc5d0749d0b75bc5$var$flattenV($cc5d0749d0b75bc5$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $cc5d0749d0b75bc5$var$flattenV($cc5d0749d0b75bc5$var$singleRect(node.nodeType == 3 ? $cc5d0749d0b75bc5$var$textRange(node) : node, -side), side >= 0);
}
function $cc5d0749d0b75bc5$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $cc5d0749d0b75bc5$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $cc5d0749d0b75bc5$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $cc5d0749d0b75bc5$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $cc5d0749d0b75bc5$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $cc5d0749d0b75bc5$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $cc5d0749d0b75bc5$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $cc5d0749d0b75bc5$var$maybeRTL = /[\u0590-\u08ac]/;
function $cc5d0749d0b75bc5$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$cc5d0749d0b75bc5$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $cc5d0749d0b75bc5$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $cc5d0749d0b75bc5$var$cachedState = null;
let $cc5d0749d0b75bc5$var$cachedDir = null;
let $cc5d0749d0b75bc5$var$cachedResult = false;
function $cc5d0749d0b75bc5$var$endOfTextblock(view, state, dir) {
    if ($cc5d0749d0b75bc5$var$cachedState == state && $cc5d0749d0b75bc5$var$cachedDir == dir) return $cc5d0749d0b75bc5$var$cachedResult;
    $cc5d0749d0b75bc5$var$cachedState = state;
    $cc5d0749d0b75bc5$var$cachedDir = dir;
    return $cc5d0749d0b75bc5$var$cachedResult = dir == "up" || dir == "down" ? $cc5d0749d0b75bc5$var$endOfTextblockVertical(view, state, dir) : $cc5d0749d0b75bc5$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $cc5d0749d0b75bc5$var$NOT_DIRTY = 0, $cc5d0749d0b75bc5$var$CHILD_DIRTY = 1, $cc5d0749d0b75bc5$var$CONTENT_DIRTY = 2, $cc5d0749d0b75bc5$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $cc5d0749d0b75bc5$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $cc5d0749d0b75bc5$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $cc5d0749d0b75bc5$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $cc5d0749d0b75bc5$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $cc5d0749d0b75bc5$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $cc5d0749d0b75bc5$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $cc5d0749d0b75bc5$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $cc5d0749d0b75bc5$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $cc5d0749d0b75bc5$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, root, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = root.getSelection();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($cc5d0749d0b75bc5$var$gecko || $cc5d0749d0b75bc5$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $cc5d0749d0b75bc5$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($cc5d0749d0b75bc5$var$gecko && domSel.focusNode && domSel.focusNode != headDOM.node && domSel.focusNode.nodeType == 1) {
            let after = domSel.focusNode.childNodes[domSel.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $cc5d0749d0b75bc5$var$safari) && $cc5d0749d0b75bc5$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) && $cc5d0749d0b75bc5$var$isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $cc5d0749d0b75bc5$var$CONTENT_DIRTY : $cc5d0749d0b75bc5$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $cc5d0749d0b75bc5$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $cc5d0749d0b75bc5$var$CONTENT_DIRTY : $cc5d0749d0b75bc5$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $cc5d0749d0b75bc5$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $cc5d0749d0b75bc5$var$CONTENT_DIRTY : $cc5d0749d0b75bc5$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $cc5d0749d0b75bc5$var$WidgetViewDesc extends $cc5d0749d0b75bc5$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $cc5d0749d0b75bc5$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $cc5d0749d0b75bc5$var$CompositionViewDesc extends $cc5d0749d0b75bc5$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === "characterData" && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $cc5d0749d0b75bc5$var$MarkViewDesc extends $cc5d0749d0b75bc5$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $6B4AI.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $cc5d0749d0b75bc5$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom);
    }
    parseRule() {
        if (this.dirty & $cc5d0749d0b75bc5$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $cc5d0749d0b75bc5$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $cc5d0749d0b75bc5$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $cc5d0749d0b75bc5$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $cc5d0749d0b75bc5$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $cc5d0749d0b75bc5$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $cc5d0749d0b75bc5$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $cc5d0749d0b75bc5$var$NodeViewDesc extends $cc5d0749d0b75bc5$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $6B4AI.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $cc5d0749d0b75bc5$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $cc5d0749d0b75bc5$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $cc5d0749d0b75bc5$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $cc5d0749d0b75bc5$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $6B4AI.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $cc5d0749d0b75bc5$var$NOT_DIRTY && node.eq(this.node) && $cc5d0749d0b75bc5$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $cc5d0749d0b75bc5$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $cc5d0749d0b75bc5$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $6B4AI.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $cc5d0749d0b75bc5$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $cc5d0749d0b75bc5$var$renderDescs(this.contentDOM, this.children, view);
            if ($cc5d0749d0b75bc5$var$ios) $cc5d0749d0b75bc5$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $cw5sC.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $cc5d0749d0b75bc5$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $cc5d0749d0b75bc5$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $cc5d0749d0b75bc5$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $cc5d0749d0b75bc5$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $cc5d0749d0b75bc5$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($cc5d0749d0b75bc5$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $cc5d0749d0b75bc5$var$patchOuterDeco(this.dom, this.nodeDOM, $cc5d0749d0b75bc5$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $cc5d0749d0b75bc5$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $cc5d0749d0b75bc5$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $cc5d0749d0b75bc5$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $cc5d0749d0b75bc5$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $cc5d0749d0b75bc5$var$TextViewDesc extends $cc5d0749d0b75bc5$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $cc5d0749d0b75bc5$var$NODE_DIRTY || this.dirty != $cc5d0749d0b75bc5$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $cc5d0749d0b75bc5$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $cc5d0749d0b75bc5$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $cc5d0749d0b75bc5$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $cc5d0749d0b75bc5$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $cc5d0749d0b75bc5$var$TrailingHackViewDesc extends $cc5d0749d0b75bc5$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $cc5d0749d0b75bc5$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $cc5d0749d0b75bc5$var$CustomNodeViewDesc extends $cc5d0749d0b75bc5$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $cc5d0749d0b75bc5$var$NODE_DIRTY) return false;
        if (this.spec.update) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, root, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, root) : super.setSelection(anchor, head, root, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $cc5d0749d0b75bc5$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $cc5d0749d0b75bc5$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $cc5d0749d0b75bc5$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $cc5d0749d0b75bc5$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $cc5d0749d0b75bc5$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $cc5d0749d0b75bc5$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$cc5d0749d0b75bc5$var$OuterDecoLevel.prototype = Object.create(null);
const $cc5d0749d0b75bc5$var$noDeco = [
    new $cc5d0749d0b75bc5$var$OuterDecoLevel
];
function $cc5d0749d0b75bc5$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $cc5d0749d0b75bc5$var$noDeco;
    let top = needsWrap ? $cc5d0749d0b75bc5$var$noDeco[0] : new $cc5d0749d0b75bc5$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $cc5d0749d0b75bc5$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $cc5d0749d0b75bc5$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $cc5d0749d0b75bc5$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $cc5d0749d0b75bc5$var$noDeco && curComputed == $cc5d0749d0b75bc5$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $cc5d0749d0b75bc5$var$noDeco[0];
                curDOM = parent;
            }
        }
        $cc5d0749d0b75bc5$var$patchAttributes(curDOM, prev || $cc5d0749d0b75bc5$var$noDeco[0], deco);
    }
    return curDOM;
}
function $cc5d0749d0b75bc5$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $cc5d0749d0b75bc5$var$applyOuterDeco(dom, deco, node) {
    return $cc5d0749d0b75bc5$var$patchOuterDeco(dom, dom, $cc5d0749d0b75bc5$var$noDeco, $cc5d0749d0b75bc5$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $cc5d0749d0b75bc5$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $cc5d0749d0b75bc5$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $cc5d0749d0b75bc5$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $cc5d0749d0b75bc5$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $cc5d0749d0b75bc5$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $cc5d0749d0b75bc5$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $cc5d0749d0b75bc5$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $cc5d0749d0b75bc5$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $cc5d0749d0b75bc5$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $cc5d0749d0b75bc5$var$NODE_DIRTY && $cc5d0749d0b75bc5$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $cc5d0749d0b75bc5$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $cc5d0749d0b75bc5$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$cc5d0749d0b75bc5$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $cc5d0749d0b75bc5$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $cc5d0749d0b75bc5$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $cc5d0749d0b75bc5$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $cc5d0749d0b75bc5$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $cc5d0749d0b75bc5$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($cc5d0749d0b75bc5$var$safari || $cc5d0749d0b75bc5$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $cc5d0749d0b75bc5$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $cc5d0749d0b75bc5$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $cc5d0749d0b75bc5$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $cc5d0749d0b75bc5$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $cc5d0749d0b75bc5$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($cc5d0749d0b75bc5$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $cc5d0749d0b75bc5$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $cc5d0749d0b75bc5$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $cc5d0749d0b75bc5$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $cc5d0749d0b75bc5$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($cc5d0749d0b75bc5$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $cw5sC.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $cc5d0749d0b75bc5$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $cw5sC.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $cc5d0749d0b75bc5$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $cc5d0749d0b75bc5$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $cc5d0749d0b75bc5$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $cc5d0749d0b75bc5$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $cc5d0749d0b75bc5$var$syncNodeSelection(view, sel);
    if (!$cc5d0749d0b75bc5$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $cc5d0749d0b75bc5$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $cc5d0749d0b75bc5$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $cc5d0749d0b75bc5$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($cc5d0749d0b75bc5$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $cw5sC.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $cc5d0749d0b75bc5$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $cc5d0749d0b75bc5$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view.root, force);
        if ($cc5d0749d0b75bc5$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $cc5d0749d0b75bc5$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $cc5d0749d0b75bc5$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $cc5d0749d0b75bc5$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $cc5d0749d0b75bc5$var$brokenSelectBetweenUneditable = $cc5d0749d0b75bc5$var$safari || $cc5d0749d0b75bc5$var$chrome && $cc5d0749d0b75bc5$var$chrome_version < 63;
function $cc5d0749d0b75bc5$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($cc5d0749d0b75bc5$var$safari && after && after.contentEditable == "false") return $cc5d0749d0b75bc5$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $cc5d0749d0b75bc5$var$setEditable(after);
        else if (before) return $cc5d0749d0b75bc5$var$setEditable(before);
    }
}
function $cc5d0749d0b75bc5$var$setEditable(element) {
    element.contentEditable = "true";
    if ($cc5d0749d0b75bc5$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $cc5d0749d0b75bc5$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $cc5d0749d0b75bc5$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$cc5d0749d0b75bc5$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $cc5d0749d0b75bc5$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $cc5d0749d0b75bc5$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $cc5d0749d0b75bc5$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $cw5sC.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $cc5d0749d0b75bc5$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $cc5d0749d0b75bc5$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $cc5d0749d0b75bc5$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $cc5d0749d0b75bc5$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $cw5sC.TextSelection).between($anchor, $head, bias);
}
function $cc5d0749d0b75bc5$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $cc5d0749d0b75bc5$var$hasSelection(view);
}
function $cc5d0749d0b75bc5$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $cc5d0749d0b75bc5$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $cc5d0749d0b75bc5$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $cc5d0749d0b75bc5$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $cw5sC.Selection).findFrom($start, dir);
}
function $cc5d0749d0b75bc5$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $cc5d0749d0b75bc5$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $cw5sC.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $cc5d0749d0b75bc5$var$apply(view, new (0, $cw5sC.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $cc5d0749d0b75bc5$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $cw5sC.NodeSelection)) return $cc5d0749d0b75bc5$var$apply(view, next);
            return false;
        } else if (!($cc5d0749d0b75bc5$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $cw5sC.NodeSelection).isSelectable(node)) return $cc5d0749d0b75bc5$var$apply(view, new (0, $cw5sC.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($cc5d0749d0b75bc5$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $cc5d0749d0b75bc5$var$apply(view, new (0, $cw5sC.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $cw5sC.NodeSelection) && sel.node.isInline) return $cc5d0749d0b75bc5$var$apply(view, new (0, $cw5sC.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $cc5d0749d0b75bc5$var$moveSelectionBlock(view.state, dir);
        if (next) return $cc5d0749d0b75bc5$var$apply(view, next);
        return false;
    }
}
function $cc5d0749d0b75bc5$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $cc5d0749d0b75bc5$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $cc5d0749d0b75bc5$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $cc5d0749d0b75bc5$var$skipIgnoredNodesBefore(view) : $cc5d0749d0b75bc5$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $cc5d0749d0b75bc5$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($cc5d0749d0b75bc5$var$gecko && node.nodeType == 1 && offset < $cc5d0749d0b75bc5$var$nodeLen(node) && $cc5d0749d0b75bc5$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($cc5d0749d0b75bc5$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($cc5d0749d0b75bc5$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $cc5d0749d0b75bc5$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $cc5d0749d0b75bc5$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $cc5d0749d0b75bc5$var$nodeLen(node);
            }
        }
    }
    if (force) $cc5d0749d0b75bc5$var$setSelFocus(view, node, offset);
    else if (moveNode) $cc5d0749d0b75bc5$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $cc5d0749d0b75bc5$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $cc5d0749d0b75bc5$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($cc5d0749d0b75bc5$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($cc5d0749d0b75bc5$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $cc5d0749d0b75bc5$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $cc5d0749d0b75bc5$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $cc5d0749d0b75bc5$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $cc5d0749d0b75bc5$var$setSelFocus(view, moveNode, moveOffset);
}
function $cc5d0749d0b75bc5$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $cc5d0749d0b75bc5$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$cc5d0749d0b75bc5$var$hasBlockDesc(node)){
        offset = $cc5d0749d0b75bc5$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $cc5d0749d0b75bc5$var$textNodeBefore(node, offset) {
    while(node && !offset && !$cc5d0749d0b75bc5$var$hasBlockDesc(node)){
        offset = $cc5d0749d0b75bc5$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $cc5d0749d0b75bc5$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $cc5d0749d0b75bc5$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $cc5d0749d0b75bc5$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($cc5d0749d0b75bc5$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $cc5d0749d0b75bc5$var$selectionToDOM(view);
    }, 50);
}
function $cc5d0749d0b75bc5$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($cc5d0749d0b75bc5$var$chrome || $cc5d0749d0b75bc5$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $cc5d0749d0b75bc5$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $cw5sC.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($cc5d0749d0b75bc5$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $cc5d0749d0b75bc5$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $cw5sC.NodeSelection)) return $cc5d0749d0b75bc5$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $cw5sC.AllSelection) ? (0, $cw5sC.Selection).near(side, dir) : (0, $cw5sC.Selection).findFrom(side, dir);
        return beyond ? $cc5d0749d0b75bc5$var$apply(view, beyond) : false;
    }
    return false;
}
function $cc5d0749d0b75bc5$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $cw5sC.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $cc5d0749d0b75bc5$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $cc5d0749d0b75bc5$var$safariDownArrowBug(view) {
    if (!$cc5d0749d0b75bc5$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $cc5d0749d0b75bc5$var$switchEditable(view, child, "true");
        setTimeout(()=>$cc5d0749d0b75bc5$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $cc5d0749d0b75bc5$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $cc5d0749d0b75bc5$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $cc5d0749d0b75bc5$var$getMods(event);
    if (code == 8 || $cc5d0749d0b75bc5$var$mac && code == 72 && mods == "c") return $cc5d0749d0b75bc5$var$stopNativeHorizontalDelete(view, -1) || $cc5d0749d0b75bc5$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $cc5d0749d0b75bc5$var$mac && code == 68 && mods == "c") return $cc5d0749d0b75bc5$var$stopNativeHorizontalDelete(view, 1) || $cc5d0749d0b75bc5$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $cc5d0749d0b75bc5$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $cc5d0749d0b75bc5$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $cc5d0749d0b75bc5$var$selectHorizontally(view, dir, mods) || $cc5d0749d0b75bc5$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $cc5d0749d0b75bc5$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $cc5d0749d0b75bc5$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $cc5d0749d0b75bc5$var$selectHorizontally(view, dir, mods) || $cc5d0749d0b75bc5$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $cc5d0749d0b75bc5$var$mac && code == 80 && mods == "c") return $cc5d0749d0b75bc5$var$selectVertically(view, -1, mods) || $cc5d0749d0b75bc5$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $cc5d0749d0b75bc5$var$mac && code == 78 && mods == "c") return $cc5d0749d0b75bc5$var$safariDownArrowBug(view) || $cc5d0749d0b75bc5$var$selectVertically(view, 1, mods) || $cc5d0749d0b75bc5$var$skipIgnoredNodes(view, 1);
    else if (mods == ($cc5d0749d0b75bc5$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $cc5d0749d0b75bc5$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $6B4AI.DOMSerializer).fromSchema(view.state.schema);
    let doc = $cc5d0749d0b75bc5$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $cc5d0749d0b75bc5$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $cc5d0749d0b75bc5$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $6B4AI.Slice)((0, $6B4AI.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $6B4AI.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $6B4AI.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $cc5d0749d0b75bc5$var$readHTML(html);
        if ($cc5d0749d0b75bc5$var$webkit) $cc5d0749d0b75bc5$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $6B4AI.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$cc5d0749d0b75bc5$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $cc5d0749d0b75bc5$var$addContext($cc5d0749d0b75bc5$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $6B4AI.Slice).maxOpen($cc5d0749d0b75bc5$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $cc5d0749d0b75bc5$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $cc5d0749d0b75bc5$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $cc5d0749d0b75bc5$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $cc5d0749d0b75bc5$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $cc5d0749d0b75bc5$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $cc5d0749d0b75bc5$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $6B4AI.Fragment).from(result);
    }
    return fragment;
}
function $cc5d0749d0b75bc5$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $6B4AI.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $cc5d0749d0b75bc5$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $cc5d0749d0b75bc5$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $6B4AI.Fragment).from($cc5d0749d0b75bc5$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $cc5d0749d0b75bc5$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $cc5d0749d0b75bc5$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $6B4AI.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $cc5d0749d0b75bc5$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $cc5d0749d0b75bc5$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $6B4AI.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $cc5d0749d0b75bc5$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $6B4AI.Slice)($cc5d0749d0b75bc5$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $6B4AI.Slice)($cc5d0749d0b75bc5$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $cc5d0749d0b75bc5$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $cc5d0749d0b75bc5$var$_detachedDoc = null;
function $cc5d0749d0b75bc5$var$detachedDoc() {
    return $cc5d0749d0b75bc5$var$_detachedDoc || ($cc5d0749d0b75bc5$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
function $cc5d0749d0b75bc5$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    return trustedTypes.createPolicy("detachedDocument", {
        createHTML: (s)=>s
    }).createHTML(html);
}
function $cc5d0749d0b75bc5$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $cc5d0749d0b75bc5$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $cc5d0749d0b75bc5$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $cc5d0749d0b75bc5$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $cc5d0749d0b75bc5$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($cc5d0749d0b75bc5$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\xa0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $cc5d0749d0b75bc5$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $6B4AI.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $6B4AI.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $cc5d0749d0b75bc5$var$handlers = {};
const $cc5d0749d0b75bc5$var$editHandlers = {};
const $cc5d0749d0b75bc5$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $cc5d0749d0b75bc5$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastAndroidDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $cc5d0749d0b75bc5$var$initInput(view) {
    for(let event in $cc5d0749d0b75bc5$var$handlers){
        let handler = $cc5d0749d0b75bc5$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($cc5d0749d0b75bc5$var$eventBelongsToView(view, event) && !$cc5d0749d0b75bc5$var$runCustomHandler(view, event) && (view.editable || !(event.type in $cc5d0749d0b75bc5$var$editHandlers))) handler(view, event);
        }, $cc5d0749d0b75bc5$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($cc5d0749d0b75bc5$var$safari) view.dom.addEventListener("input", ()=>null);
    $cc5d0749d0b75bc5$var$ensureListeners(view);
}
function $cc5d0749d0b75bc5$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $cc5d0749d0b75bc5$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $cc5d0749d0b75bc5$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$cc5d0749d0b75bc5$var$runCustomHandler(view, event));
    });
}
function $cc5d0749d0b75bc5$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $cc5d0749d0b75bc5$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $cc5d0749d0b75bc5$var$dispatchEvent(view, event) {
    if (!$cc5d0749d0b75bc5$var$runCustomHandler(view, event) && $cc5d0749d0b75bc5$var$handlers[event.type] && (view.editable || !(event.type in $cc5d0749d0b75bc5$var$editHandlers))) $cc5d0749d0b75bc5$var$handlers[event.type](view, event);
}
$cc5d0749d0b75bc5$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($cc5d0749d0b75bc5$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($cc5d0749d0b75bc5$var$android && $cc5d0749d0b75bc5$var$chrome && event.keyCode == 13) return;
    if (view.domObserver.selectionChanged(view.domSelectionRange())) view.domObserver.flush();
    else if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($cc5d0749d0b75bc5$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $cc5d0749d0b75bc5$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $cc5d0749d0b75bc5$var$captureKeyDown(view, event)) event.preventDefault();
    else $cc5d0749d0b75bc5$var$setSelectionOrigin(view, "key");
};
$cc5d0749d0b75bc5$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$cc5d0749d0b75bc5$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($cc5d0749d0b75bc5$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $cc5d0749d0b75bc5$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $cw5sC.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $cc5d0749d0b75bc5$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $cc5d0749d0b75bc5$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $cc5d0749d0b75bc5$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $cc5d0749d0b75bc5$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $cc5d0749d0b75bc5$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $cw5sC.NodeSelection).isSelectable(node)) {
        $cc5d0749d0b75bc5$var$updateSelection(view, new (0, $cw5sC.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $cc5d0749d0b75bc5$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $cw5sC.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $cw5sC.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $cc5d0749d0b75bc5$var$updateSelection(view, (0, $cw5sC.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $cc5d0749d0b75bc5$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $cc5d0749d0b75bc5$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $cc5d0749d0b75bc5$var$selectClickedNode(view, inside) : $cc5d0749d0b75bc5$var$selectClickedLeaf(view, inside));
}
function $cc5d0749d0b75bc5$var$handleDoubleClick(view, pos, inside, event) {
    return $cc5d0749d0b75bc5$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $cc5d0749d0b75bc5$var$handleTripleClick(view, pos, inside, event) {
    return $cc5d0749d0b75bc5$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $cc5d0749d0b75bc5$var$defaultTripleClick(view, inside, event);
}
function $cc5d0749d0b75bc5$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $cc5d0749d0b75bc5$var$updateSelection(view, (0, $cw5sC.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $cc5d0749d0b75bc5$var$updateSelection(view, (0, $cw5sC.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $cw5sC.NodeSelection).isSelectable(node)) $cc5d0749d0b75bc5$var$updateSelection(view, (0, $cw5sC.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $cc5d0749d0b75bc5$var$forceDOMFlush(view) {
    return $cc5d0749d0b75bc5$var$endComposition(view);
}
const $cc5d0749d0b75bc5$var$selectNodeModifier = $cc5d0749d0b75bc5$var$mac ? "metaKey" : "ctrlKey";
$cc5d0749d0b75bc5$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $cc5d0749d0b75bc5$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $cc5d0749d0b75bc5$var$isNear(event, view.input.lastClick) && !event[$cc5d0749d0b75bc5$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($cc5d0749d0b75bc5$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $cc5d0749d0b75bc5$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $cc5d0749d0b75bc5$var$handleDoubleClick : $cc5d0749d0b75bc5$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $cc5d0749d0b75bc5$var$setSelectionOrigin(view, "pointer");
};
class $cc5d0749d0b75bc5$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$cc5d0749d0b75bc5$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $cw5sC.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $cc5d0749d0b75bc5$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $cc5d0749d0b75bc5$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$cc5d0749d0b75bc5$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($cc5d0749d0b75bc5$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $cc5d0749d0b75bc5$var$setSelectionOrigin(this.view, "pointer");
        else if ($cc5d0749d0b75bc5$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $cc5d0749d0b75bc5$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $cc5d0749d0b75bc5$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $cc5d0749d0b75bc5$var$updateSelection(this.view, (0, $cw5sC.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $cc5d0749d0b75bc5$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $cc5d0749d0b75bc5$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$cc5d0749d0b75bc5$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $cc5d0749d0b75bc5$var$forceDOMFlush(view);
    $cc5d0749d0b75bc5$var$setSelectionOrigin(view, "pointer");
};
$cc5d0749d0b75bc5$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $cc5d0749d0b75bc5$var$setSelectionOrigin(view, "pointer");
};
$cc5d0749d0b75bc5$var$handlers.contextmenu = (view)=>$cc5d0749d0b75bc5$var$forceDOMFlush(view);
function $cc5d0749d0b75bc5$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($cc5d0749d0b75bc5$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $cc5d0749d0b75bc5$var$timeoutComposition = $cc5d0749d0b75bc5$var$android ? 5000 : -1;
$cc5d0749d0b75bc5$var$editHandlers.compositionstart = $cc5d0749d0b75bc5$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $cw5sC.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $cc5d0749d0b75bc5$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $cc5d0749d0b75bc5$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($cc5d0749d0b75bc5$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $cc5d0749d0b75bc5$var$scheduleComposeEnd(view, $cc5d0749d0b75bc5$var$timeoutComposition);
};
$cc5d0749d0b75bc5$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $cc5d0749d0b75bc5$var$scheduleComposeEnd(view, 20);
    }
};
function $cc5d0749d0b75bc5$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$cc5d0749d0b75bc5$var$endComposition(view), delay);
}
function $cc5d0749d0b75bc5$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $cc5d0749d0b75bc5$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $cc5d0749d0b75bc5$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $cc5d0749d0b75bc5$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $cc5d0749d0b75bc5$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $cc5d0749d0b75bc5$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $cc5d0749d0b75bc5$var$endComposition(view, restarting = false) {
    if ($cc5d0749d0b75bc5$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $cc5d0749d0b75bc5$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $cc5d0749d0b75bc5$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $cc5d0749d0b75bc5$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $cc5d0749d0b75bc5$var$brokenClipboardAPI = $cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version < 15 || $cc5d0749d0b75bc5$var$ios && $cc5d0749d0b75bc5$var$webkit_version < 604;
$cc5d0749d0b75bc5$var$handlers.copy = $cc5d0749d0b75bc5$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $cc5d0749d0b75bc5$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $cc5d0749d0b75bc5$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $cc5d0749d0b75bc5$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $cc5d0749d0b75bc5$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $cc5d0749d0b75bc5$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $cc5d0749d0b75bc5$var$doPaste(view, target.value, null, plain, event);
        else $cc5d0749d0b75bc5$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $cc5d0749d0b75bc5$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $cc5d0749d0b75bc5$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $6B4AI.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $cc5d0749d0b75bc5$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $cc5d0749d0b75bc5$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$cc5d0749d0b75bc5$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$cc5d0749d0b75bc5$var$android) return;
    let data = $cc5d0749d0b75bc5$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $cc5d0749d0b75bc5$var$doPaste(view, $cc5d0749d0b75bc5$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $cc5d0749d0b75bc5$var$capturePaste(view, event);
};
class $cc5d0749d0b75bc5$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $cc5d0749d0b75bc5$var$dragCopyModifier = $cc5d0749d0b75bc5$var$mac ? "altKey" : "ctrlKey";
$cc5d0749d0b75bc5$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($cc5d0749d0b75bc5$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $cw5sC.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $cw5sC.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $cw5sC.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $cc5d0749d0b75bc5$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$cc5d0749d0b75bc5$var$chrome || $cc5d0749d0b75bc5$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($cc5d0749d0b75bc5$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$cc5d0749d0b75bc5$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $cc5d0749d0b75bc5$var$Dragging(slice, !event[$cc5d0749d0b75bc5$var$dragCopyModifier], node);
};
$cc5d0749d0b75bc5$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$cc5d0749d0b75bc5$var$editHandlers.dragover = $cc5d0749d0b75bc5$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$cc5d0749d0b75bc5$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($cc5d0749d0b75bc5$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $cc5d0749d0b75bc5$var$parseFromClipboard(view, $cc5d0749d0b75bc5$var$getText(event.dataTransfer), $cc5d0749d0b75bc5$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$cc5d0749d0b75bc5$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $6B4AI.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $4aVzI.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $cw5sC.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $cw5sC.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($cc5d0749d0b75bc5$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$cc5d0749d0b75bc5$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $cc5d0749d0b75bc5$var$selectionToDOM(view);
        }, 20);
    }
};
$cc5d0749d0b75bc5$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$cc5d0749d0b75bc5$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($cc5d0749d0b75bc5$var$chrome && $cc5d0749d0b75bc5$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $cc5d0749d0b75bc5$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $cc5d0749d0b75bc5$var$editHandlers)$cc5d0749d0b75bc5$var$handlers[prop] = $cc5d0749d0b75bc5$var$editHandlers[prop];
function $cc5d0749d0b75bc5$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $cc5d0749d0b75bc5$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $cc5d0749d0b75bc5$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $cc5d0749d0b75bc5$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $cc5d0749d0b75bc5$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $cc5d0749d0b75bc5$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $cc5d0749d0b75bc5$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $cc5d0749d0b75bc5$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $cc5d0749d0b75bc5$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $cc5d0749d0b75bc5$var$InlineType && $cc5d0749d0b75bc5$var$compareObjs(this.attrs, other.attrs) && $cc5d0749d0b75bc5$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $cc5d0749d0b75bc5$var$InlineType;
    }
    destroy() {}
}
class $cc5d0749d0b75bc5$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $cc5d0749d0b75bc5$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $cc5d0749d0b75bc5$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $cc5d0749d0b75bc5$var$NodeType && $cc5d0749d0b75bc5$var$compareObjs(this.attrs, other.attrs) && $cc5d0749d0b75bc5$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $cc5d0749d0b75bc5$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $cc5d0749d0b75bc5$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $cc5d0749d0b75bc5$export$10e30b733df217ea(pos, pos, new $cc5d0749d0b75bc5$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $cc5d0749d0b75bc5$export$10e30b733df217ea(from, to, new $cc5d0749d0b75bc5$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $cc5d0749d0b75bc5$export$10e30b733df217ea(from, to, new $cc5d0749d0b75bc5$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $cc5d0749d0b75bc5$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $cc5d0749d0b75bc5$var$WidgetType;
    }
}
const $cc5d0749d0b75bc5$var$none = [], $cc5d0749d0b75bc5$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $cc5d0749d0b75bc5$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $cc5d0749d0b75bc5$var$none;
        this.children = children.length ? children : $cc5d0749d0b75bc5$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $cc5d0749d0b75bc5$var$buildTree(decorations, doc, 0, $cc5d0749d0b75bc5$var$noSpec) : $cc5d0749d0b75bc5$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $cc5d0749d0b75bc5$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $cc5d0749d0b75bc5$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $cc5d0749d0b75bc5$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $cc5d0749d0b75bc5$export$93bf62eb445cec98(newLocal.sort($cc5d0749d0b75bc5$var$byPos), $cc5d0749d0b75bc5$var$none) : $cc5d0749d0b75bc5$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $cc5d0749d0b75bc5$var$empty) return $cc5d0749d0b75bc5$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $cc5d0749d0b75bc5$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $cc5d0749d0b75bc5$var$buildTree(found, childNode, baseOffset + 1, $cc5d0749d0b75bc5$var$noSpec));
            childIndex += 3;
        });
        let local = $cc5d0749d0b75bc5$var$moveSpans(childIndex ? $cc5d0749d0b75bc5$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $cc5d0749d0b75bc5$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($cc5d0749d0b75bc5$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $cc5d0749d0b75bc5$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $cc5d0749d0b75bc5$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $cc5d0749d0b75bc5$export$93bf62eb445cec98(local, children) : $cc5d0749d0b75bc5$var$empty;
    }
    forChild(offset, node) {
        if (this == $cc5d0749d0b75bc5$var$empty) return this;
        if (node.isLeaf) return $cc5d0749d0b75bc5$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $cc5d0749d0b75bc5$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $cc5d0749d0b75bc5$export$93bf62eb445cec98(local.sort($cc5d0749d0b75bc5$var$byPos), $cc5d0749d0b75bc5$var$none);
            return child ? new $cc5d0749d0b75bc5$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $cc5d0749d0b75bc5$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $cc5d0749d0b75bc5$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $cc5d0749d0b75bc5$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $cc5d0749d0b75bc5$var$empty) return $cc5d0749d0b75bc5$var$none;
        if (node.inlineContent || !this.local.some($cc5d0749d0b75bc5$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $cc5d0749d0b75bc5$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $cc5d0749d0b75bc5$export$93bf62eb445cec98.empty = new $cc5d0749d0b75bc5$export$93bf62eb445cec98([], []);
/**
@internal
*/ $cc5d0749d0b75bc5$export$93bf62eb445cec98.removeOverlap = $cc5d0749d0b75bc5$var$removeOverlap;
const $cc5d0749d0b75bc5$var$empty = $cc5d0749d0b75bc5$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $cc5d0749d0b75bc5$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $cc5d0749d0b75bc5$var$noSpec));
        return $cc5d0749d0b75bc5$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $cc5d0749d0b75bc5$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $cc5d0749d0b75bc5$var$empty) continue;
            if (result instanceof $cc5d0749d0b75bc5$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $cc5d0749d0b75bc5$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $cc5d0749d0b75bc5$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $cc5d0749d0b75bc5$var$removeOverlap(sorted ? result : result.sort($cc5d0749d0b75bc5$var$byPos)) : $cc5d0749d0b75bc5$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $cc5d0749d0b75bc5$var$empty;
            case 1:
                return members[0];
            default:
                return new $cc5d0749d0b75bc5$var$DecorationGroup(members.every((m)=>m instanceof $cc5d0749d0b75bc5$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $cc5d0749d0b75bc5$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $cc5d0749d0b75bc5$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $cc5d0749d0b75bc5$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $cc5d0749d0b75bc5$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $cc5d0749d0b75bc5$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $cc5d0749d0b75bc5$export$93bf62eb445cec98(newLocal.sort($cc5d0749d0b75bc5$var$byPos), children);
}
function $cc5d0749d0b75bc5$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $cc5d0749d0b75bc5$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $cc5d0749d0b75bc5$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $cc5d0749d0b75bc5$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $cc5d0749d0b75bc5$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $cc5d0749d0b75bc5$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $cc5d0749d0b75bc5$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $cc5d0749d0b75bc5$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $cc5d0749d0b75bc5$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $cc5d0749d0b75bc5$var$moveSpans(hasNulls ? $cc5d0749d0b75bc5$var$withoutNulls(spans) : spans, -offset).sort($cc5d0749d0b75bc5$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $cc5d0749d0b75bc5$export$93bf62eb445cec98(locals, children) : $cc5d0749d0b75bc5$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $cc5d0749d0b75bc5$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $cc5d0749d0b75bc5$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $cc5d0749d0b75bc5$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $cc5d0749d0b75bc5$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $cc5d0749d0b75bc5$var$insertAhead(array, i, deco) {
    while(i < array.length && $cc5d0749d0b75bc5$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $cc5d0749d0b75bc5$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $cc5d0749d0b75bc5$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($cc5d0749d0b75bc5$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $cc5d0749d0b75bc5$var$DecorationGroup.from(found);
}
const $cc5d0749d0b75bc5$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $cc5d0749d0b75bc5$var$useCharData = $cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version <= 11;
class $cc5d0749d0b75bc5$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $cc5d0749d0b75bc5$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $cc5d0749d0b75bc5$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($cc5d0749d0b75bc5$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $cc5d0749d0b75bc5$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$cc5d0749d0b75bc5$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $cc5d0749d0b75bc5$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $cc5d0749d0b75bc5$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $cc5d0749d0b75bc5$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $cc5d0749d0b75bc5$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    selectionChanged(sel) {
        return !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $cc5d0749d0b75bc5$var$hasFocusAndSelection(this.view) && !this.ignoreSelectionChange(sel);
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange(), newSel = this.selectionChanged(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($cc5d0749d0b75bc5$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $cc5d0749d0b75bc5$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $cc5d0749d0b75bc5$var$selectionCollapsed(sel) && (readSel = $cc5d0749d0b75bc5$var$selectionFromDOM(view)) && readSel.eq((0, $cw5sC.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $cc5d0749d0b75bc5$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $cc5d0749d0b75bc5$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $cc5d0749d0b75bc5$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $cc5d0749d0b75bc5$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $cc5d0749d0b75bc5$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $cc5d0749d0b75bc5$var$cssChecked = new WeakMap();
let $cc5d0749d0b75bc5$var$cssCheckWarned = false;
function $cc5d0749d0b75bc5$var$checkCSS(view) {
    if ($cc5d0749d0b75bc5$var$cssChecked.has(view)) return;
    $cc5d0749d0b75bc5$var$cssChecked.set(view, null);
    if ([
        "normal",
        "nowrap",
        "pre-line"
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $cc5d0749d0b75bc5$var$gecko;
        if ($cc5d0749d0b75bc5$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $cc5d0749d0b75bc5$var$cssCheckWarned = true;
    }
}
function $cc5d0749d0b75bc5$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($cc5d0749d0b75bc5$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $cc5d0749d0b75bc5$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $cc5d0749d0b75bc5$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $cc5d0749d0b75bc5$var$rangeToSelectionRange(view, found) : null;
}
function $cc5d0749d0b75bc5$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $cc5d0749d0b75bc5$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$cc5d0749d0b75bc5$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($cc5d0749d0b75bc5$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $6B4AI.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $cc5d0749d0b75bc5$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $cc5d0749d0b75bc5$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($cc5d0749d0b75bc5$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $cc5d0749d0b75bc5$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $cc5d0749d0b75bc5$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $cc5d0749d0b75bc5$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $cc5d0749d0b75bc5$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($cc5d0749d0b75bc5$var$chrome && $cc5d0749d0b75bc5$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $cc5d0749d0b75bc5$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $cc5d0749d0b75bc5$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $cc5d0749d0b75bc5$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($cc5d0749d0b75bc5$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $cc5d0749d0b75bc5$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$cc5d0749d0b75bc5$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $cc5d0749d0b75bc5$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $cw5sC.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $cc5d0749d0b75bc5$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $cw5sC.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \xa0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($cc5d0749d0b75bc5$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $cw5sC.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $cc5d0749d0b75bc5$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $cc5d0749d0b75bc5$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $cc5d0749d0b75bc5$var$keyEvent(8, "Backspace")))) {
        if ($cc5d0749d0b75bc5$var$android && $cc5d0749d0b75bc5$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome Android will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($cc5d0749d0b75bc5$var$chrome && $cc5d0749d0b75bc5$var$android && change.endB == change.start) view.input.lastAndroidDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($cc5d0749d0b75bc5$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $cc5d0749d0b75bc5$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($cc5d0749d0b75bc5$var$ie && $cc5d0749d0b75bc5$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$cc5d0749d0b75bc5$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $cc5d0749d0b75bc5$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $cc5d0749d0b75bc5$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome Android will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($cc5d0749d0b75bc5$var$chrome && $cc5d0749d0b75bc5$var$android && view.composing && sel.empty && (change.start != change.endB || view.input.lastAndroidDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $cc5d0749d0b75bc5$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $cc5d0749d0b75bc5$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $cc5d0749d0b75bc5$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $cc5d0749d0b75bc5$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $6B4AI.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $cc5d0749d0b75bc5$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $cc5d0749d0b75bc5$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($cc5d0749d0b75bc5$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $cc5d0749d0b75bc5$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $cc5d0749d0b75bc5$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $cc5d0749d0b75bc5$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $cc5d0749d0b75bc5$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $cc5d0749d0b75bc5$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $cc5d0749d0b75bc5$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $cc5d0749d0b75bc5$export$38b79e3fdcfcfd68 = $cc5d0749d0b75bc5$var$serializeForClipboard;
/**
@internal
*/ const $cc5d0749d0b75bc5$export$5d42ca91c11c9e4d = $cc5d0749d0b75bc5$var$parseFromClipboard;
/**
@internal
*/ const $cc5d0749d0b75bc5$export$76b14d3c719c32fc = $cc5d0749d0b75bc5$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $cc5d0749d0b75bc5$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $cc5d0749d0b75bc5$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($cc5d0749d0b75bc5$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $cc5d0749d0b75bc5$var$getEditable(this);
        $cc5d0749d0b75bc5$var$updateCursorWrapper(this);
        this.nodeViews = $cc5d0749d0b75bc5$var$buildNodeViews(this);
        this.docView = $cc5d0749d0b75bc5$var$docViewDesc(this.state.doc, $cc5d0749d0b75bc5$var$computeDocDeco(this), $cc5d0749d0b75bc5$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $cc5d0749d0b75bc5$var$DOMObserver(this, (from, to, typeOver, added)=>$cc5d0749d0b75bc5$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $cc5d0749d0b75bc5$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $cc5d0749d0b75bc5$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($cc5d0749d0b75bc5$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $cc5d0749d0b75bc5$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $cc5d0749d0b75bc5$var$buildNodeViews(this);
            if ($cc5d0749d0b75bc5$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $cc5d0749d0b75bc5$var$ensureListeners(this);
        this.editable = $cc5d0749d0b75bc5$var$getEditable(this);
        $cc5d0749d0b75bc5$var$updateCursorWrapper(this);
        let innerDeco = $cc5d0749d0b75bc5$var$viewDecorations(this), outerDeco = $cc5d0749d0b75bc5$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $cc5d0749d0b75bc5$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($cc5d0749d0b75bc5$var$ie || $cc5d0749d0b75bc5$var$chrome) && !this.composing && $cc5d0749d0b75bc5$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $cc5d0749d0b75bc5$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $cc5d0749d0b75bc5$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $cc5d0749d0b75bc5$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $cc5d0749d0b75bc5$var$anchorInRightPlace(this))) $cc5d0749d0b75bc5$var$selectionToDOM(this, forceSelUpdate);
            else {
                $cc5d0749d0b75bc5$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $cc5d0749d0b75bc5$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $cw5sC.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $cc5d0749d0b75bc5$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $cc5d0749d0b75bc5$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $cc5d0749d0b75bc5$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $cw5sC.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($cc5d0749d0b75bc5$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == "false") return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $cc5d0749d0b75bc5$var$focusPreventScroll(this.dom);
        $cc5d0749d0b75bc5$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $cc5d0749d0b75bc5$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $cc5d0749d0b75bc5$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $cc5d0749d0b75bc5$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $cc5d0749d0b75bc5$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $cc5d0749d0b75bc5$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $cc5d0749d0b75bc5$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $cc5d0749d0b75bc5$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $cc5d0749d0b75bc5$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $cc5d0749d0b75bc5$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $cc5d0749d0b75bc5$var$safari && this.root.nodeType === 11 && $cc5d0749d0b75bc5$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $cc5d0749d0b75bc5$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $cc5d0749d0b75bc5$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $cc5d0749d0b75bc5$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $cc5d0749d0b75bc5$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $cc5d0749d0b75bc5$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $cc5d0749d0b75bc5$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $cc5d0749d0b75bc5$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $cc5d0749d0b75bc5$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $cc5d0749d0b75bc5$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $cc5d0749d0b75bc5$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}



var $6B4AI = parcelRequire("6B4AI");

var $6SXdZ = parcelRequire("6SXdZ");
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $21dae5303f17a106$exports = {};
"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ var $21dae5303f17a106$var$__createBinding = $21dae5303f17a106$exports && $21dae5303f17a106$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21dae5303f17a106$var$__exportStar = $21dae5303f17a106$exports && $21dae5303f17a106$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $21dae5303f17a106$var$__createBinding(exports1, m, p);
};
Object.defineProperty($21dae5303f17a106$exports, "__esModule", {
    value: true
});

$21dae5303f17a106$var$__exportStar((parcelRequire("5h1Kk")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("bryhC")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("3qV5N")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("1t04f")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("15gHg")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("4Q5jk")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("6FTYo")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("is3B8")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("aSs4u")), $21dae5303f17a106$exports);

$21dae5303f17a106$var$__exportStar((parcelRequire("xZx54")), $21dae5303f17a106$exports);



var $iFY8P = parcelRequire("iFY8P");
const $67a74e96f4453962$var$storedFile = localStorage.getItem("file");
let $67a74e96f4453962$var$xml;
// Read XML from the localStorage
// It should be stored there after uploading it via the editor UI,
// handled by demo-plugin.ts
if ($67a74e96f4453962$var$storedFile) $67a74e96f4453962$var$xml = $67a74e96f4453962$var$storedFile;
// Otherwise take this XML example as a start for the demo editor
// It is the content of file petal-introduction.xml
if (!$67a74e96f4453962$var$storedFile) $67a74e96f4453962$var$xml = `<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE topic PUBLIC "-//OASIS//DTD LIGHTWEIGHT DITA Topic//EN" "lw-topic.dtd">
<topic id="petal">
    <title>What is Petal?</title>
    <body>
        <p dir="ltr">Sadly many projects lack proper documentation, but why is that?</p>
        <fig>
            <image href="https://static.evolvedbinary.com/petal/eb-rose-small.png"></image>
        </fig>

        <p dir="ltr">The effort that goes into coding great software is paramount, but often
            pointless if others can't understand and use the software. Most developers have
            witnessed brilliant code with incomplete or entirely missing documentation. Petal lowers
            the barrier to delivering this critical part of any software product.</p>
        <p dir="ltr">Often it is difficult or time-consuming to add documentation to a project.
            Potentially great projects stay in obscurity because users and developers don't have the
            information they need to understand them and use them.</p>
        <p dir="ltr">Our dream is to make adding documentation to a project as easy as typing text
            into a web browser and hitting save. This approach would lead to more usable projects
            through robust and helpful documentation.</p>
        <p dir="ltr">Petal is a first of its kind technical documentation editor that realises this
            dream!</p>
        <p dir="ltr">Petal makes it simple to:</p>
        <ul>
            <li dir="ltr">
                <p dir="ltr">Create new pages of documentation</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Update existing pages of documentation</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Submit your work for review</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Accept documentation contributions from the community</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Integrate with version control repositories such as GitHub</p>
            </li>
        </ul>
        <p dir="ltr">Petal is:</p>
        <ul>
            <li dir="ltr">
                <p dir="ltr">A Visual Technical Documentation Editor</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Accessible through a Web Browser just like a Wiki</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Filling a gap in the market where other offerings are too complex</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Open Source</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Standards compliant</p>
            </li>
            <li dir="ltr">
                <p dir="ltr">Developed with the latest web technologies</p>
            </li>
        </ul>
        <p dir="ltr">Bad documentation keeps good projects from being GREAT.</p>
        <p dir="ltr">Petal helps anyone to contribute documentation to a project with ease. If you know how to type text on a computer, then you already know how to use Petal.</p>
    </body>
</topic>`;
var // transform the xml to Jdita object
// then transform the Jdita object to Prosemirror schema
$67a74e96f4453962$export$2e2bcd8739ae039 = (0, $iFY8P.xditaToJdita)($67a74e96f4453962$var$xml, true).then((json)=>(0, $21dae5303f17a106$exports.document)(json));


/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/ 
var $6jolL = parcelRequire("6jolL");


var $iFY8P = parcelRequire("iFY8P");

var $16ZiD = parcelRequire("16ZiD");

var $gEPNU = parcelRequire("gEPNU");
/**
 * Open file selection dialog and select and file to insert into the local storage.
 *
 * @param localization - localization
 * @param input - The input element
 * @returns The command for opening a file
 */ function $e2e7b6d6591d76d0$var$openFile(localization, input) {
    return (state, dispatch)=>{
        function fileSelected(_event) {
            if (input.el?.files?.length === 1) {
                const file = input.el.files[0];
                const fileName = file.name;
                const reader = new FileReader();
                reader.readAsBinaryString(file);
                reader.onerror = ()=>{
                    (0, $21dae5303f17a106$exports.showToast)(localization.t("error.toastFileUploadInvalid"), "error");
                    console.log("Error reading file");
                };
                reader.onload = ()=>{
                    if (dispatch && typeof reader.result === "string") {
                        localStorage.setItem("file", reader.result);
                        localStorage.setItem("fileName", fileName);
                        dispatch(state.tr);
                        location.reload();
                    }
                };
            } else (0, $21dae5303f17a106$exports.showToast)(localization.t("error.toastFileUpload"), "error");
        }
        try {
            if (!state.selection.empty) return false;
            if (dispatch) {
                if (!input.el) {
                    (0, $21dae5303f17a106$exports.showToast)(localization.t("error.toastFileUploadNoInput"), "error");
                    console.log("no input found");
                    return false;
                }
                input.el.value = "";
                input.on("command", fileSelected);
                return true;
            }
            return true;
        } catch (e) {
            (0, $21dae5303f17a106$exports.showToast)(localization.t("error.toastFileUpload"), "error");
            console.error(e);
            return false;
        }
    };
}
function $e2e7b6d6591d76d0$export$2482d013fd583a86(localization) {
    const input = new (0, $21dae5303f17a106$exports.InputContainer)();
    return new (0, $6jolL.MenuItem)({
        enable: ()=>true,
        render (_editorView) {
            const el = document.createElement("div");
            el.classList.add("ProseMirror-menuitem-file");
            el.classList.add("label");
            input.el = document.createElement("input");
            input.el.type = "file";
            input.el.id = "fileUpload";
            input.el.accept = "application/dita+xml,application/xml,.xml,.dita";
            input.el.title = "Upload an XDITA file";
            const label = document.createElement("label");
            label.setAttribute("for", "fileUpload");
            label.innerText = "Open XDITA file";
            el.appendChild(input.el);
            el.appendChild(label);
            return el;
        },
        class: "ic-open",
        run: $e2e7b6d6591d76d0$var$openFile(localization, input)
    });
}
/**
 * Get stored file name from local storage
 * 
 * @returns a string with the stored file name or the default value 'Petal.xml'
 */ function $e2e7b6d6591d76d0$var$getStoredFileName() {
    return localStorage.getItem("fileName") || "Petal.xml";
}
/**
 * Get the file name from URL parameters or local storage
 * 
 * @param urlParams - URL parameters
 * @returns a string with the file name
 */ function $e2e7b6d6591d76d0$var$getFileName(urlParams) {
    const storedFileName = $e2e7b6d6591d76d0$var$getStoredFileName();
    return urlParams ? urlParams.source.split("/").slice(-1)[0] : storedFileName;
}
function $e2e7b6d6591d76d0$export$a10f575d509ad338(config, localization, urlParams) {
    const fileNameLabel = $e2e7b6d6591d76d0$var$getFileName(urlParams);
    return new (0, $6jolL.MenuItem)({
        enable: ()=>true,
        render (_editorView) {
            const el = document.createElement("div");
            el.classList.add("ProseMirror-menuitem-file", "publish");
            const link = document.createElement("a");
            link.download = fileNameLabel;
            link.textContent = "Publish " + fileNameLabel;
            link.id = "publishFile";
            el.appendChild(link);
            return el;
        },
        class: "ic-github",
        run: $e2e7b6d6591d76d0$var$publishGithubDocument(config, localization, urlParams)
    });
}
/**
 * Creates a command that publishes the current document to GitHub.
 *
 * @param config - configuration
 * @param localization - localization
 *
 * @returns The command to publish a GitHub document
 */ function $e2e7b6d6591d76d0$var$publishGithubDocument(config, localization, urlParams) {
    return (state, dispatch)=>{
        if (dispatch) {
            dispatch(state.tr);
            const documentNode = $e2e7b6d6591d76d0$var$transformToJditaDocumentNode(state);
            // get the base url from the referer & escape it for regex
            const baseUrl = (0, (/*@__PURE__*/$parcel$interopDefault($gEPNU)))(urlParams.referer).origin().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            // should match href="${baseUrl}" and remove it
            const document1 = documentNode.replace(new RegExp(`href="(${baseUrl}[^"]*)"`, "g"), (_match, url)=>{
                return `href="${(0, (/*@__PURE__*/$parcel$interopDefault($gEPNU)))(url).relativeTo(urlParams.referer).href()}"`;
            });
            // show the publishing dialog
            (0, $21dae5303f17a106$exports.renderPrDialog)(config, localization, urlParams.ghrepo, urlParams.source, urlParams.branch, document1);
        } else {
            (0, $21dae5303f17a106$exports.showToast)(localization.t("error.toastGitHubPublishNoEditorState"), "error");
            console.log("Nothing to publish, no EditorState has been dispatched.");
        }
    };
}
function $e2e7b6d6591d76d0$export$3d39a71d79a8dc29(urlParams, localization, _props = {}) {
    const link = new (0, $21dae5303f17a106$exports.InputContainer)();
    const fileName = $e2e7b6d6591d76d0$var$getFileName(urlParams);
    return new (0, $6jolL.MenuItem)({
        enable: ()=>true,
        render (_editorView) {
            const el = document.createElement("div");
            el.classList.add("ProseMirror-menuitem-file");
            const link = document.createElement("a");
            link.download = fileName;
            link.textContent = "Download " + fileName;
            link.id = "saveFile";
            el.appendChild(link);
            return el;
        },
        class: "ic-download",
        run: $e2e7b6d6591d76d0$var$saveFile(localization, link)
    });
}
/**
 * Provide a download facility for the current file in the Prosemirror editor
 * Create a data url for the JDITA object and
 * offer a JSON file download when the element is clicked
 *
 * @param localization - localization
 * @param input - The menu item containing the download link
 * @returns The HTML data url
 */ function $e2e7b6d6591d76d0$var$saveFile(localization, _input) {
    return (state, dispatch)=>{
        if (dispatch) {
            dispatch(state.tr);
            const documentNode = $e2e7b6d6591d76d0$var$transformToJditaDocumentNode(state);
            const data = new Blob([
                documentNode
            ], {
                type: "text/plain"
            });
            const url = window.URL.createObjectURL(data);
            const link = document.getElementById("saveFile");
            if (link) link.setAttribute("href", url);
            else {
                (0, $21dae5303f17a106$exports.showToast)(localization.t("error.toastFileDownload"), "error");
                console.log("The URL could not be assigned to the element, the link is not available.");
            }
        // TODO: Implement a callback function to check if the download has been completed
        // After the load has completed revoke the data URL with `URL.revokeObjectURL(url);`
        // See https://w3c.github.io/FileAPI/#examplesOfCreationRevocation
        } else {
            (0, $21dae5303f17a106$exports.showToast)(localization.t("error.toastFileDownload"), "error");
            console.log("Nothing to download, no EditorState has been dispatched.");
        }
    };
}
/**
 * Parse the current Prosemirror Editor state to a JSON object and
 * transform it to a JDITA object
 *
 * @param state - The current editor state
 * @returns The JDITA document node object
 */ function $e2e7b6d6591d76d0$var$transformToJditaDocumentNode(state) {
    const prosemirrorJson = state.toJSON();
    // Change the type value from 'type: doc' to expected 'type: document' for JDITA processing
    prosemirrorJson.doc.type = "document";
    const documentNode = (0, $21dae5303f17a106$exports.unTravel)(prosemirrorJson.doc);
    const xdita = (0, $iFY8P.jditaToAst)(documentNode);
    const outStream = new (0, $16ZiD.InMemoryTextSimpleOutputStreamCollector)();
    const serializer = new (0, $iFY8P.XditaSerializer)(outStream, true);
    serializer.serialize(xdita);
    return outStream.getText();
}
function $e2e7b6d6591d76d0$export$b97f34331221dcb3(props = {}) {
    return new (0, $6jolL.MenuItem)({
        enable: ()=>true,
        render (_editorView) {
            const el = document.createElement("div");
            el.classList.add("ProseMirror-menuitem-file");
            const icon = document.createElement("span");
            icon.className = "ic-github";
            icon.style.marginInlineEnd = "0.5em";
            const label = document.createElement("span");
            label.innerHTML = props.label || "";
            const link = document.createElement("a");
            link.href = props.url || "#";
            link.style.textDecoration = "none";
            link.style.padding = "0 0.5em";
            link.append(icon);
            link.append(label);
            el.appendChild(link);
            return el;
        },
        label: "See on Github",
        run: ()=>{}
    });
}




var $5zHp0 = parcelRequire("5zHp0");
//load the localization 
const $61c36dc206ab8ac6$var$localization = (0, $5zHp0.createLocalization)();
//load the schema
const $61c36dc206ab8ac6$var$schemaObject = (0, $21dae5303f17a106$exports.schema)();
async function $61c36dc206ab8ac6$var$loadConfig(url) {
    const response = await fetch(url);
    if (!response.ok) {
        const errorMessage = "Unable to download JSON config " + url + ": " + response.statusText;
        console.error(errorMessage);
        throw new Error(errorMessage);
    } else {
        const configJson = await response.text();
        return (0, $21dae5303f17a106$exports.parseConfig)(configJson);
    }
}
// Entry point for the script
async function $61c36dc206ab8ac6$var$entryPoint() {
    // show the welcome note
    if (!(0, $21dae5303f17a106$exports.hasConfirmedNotification)()) (0, $21dae5303f17a106$exports.showWelcomeNote)($61c36dc206ab8ac6$var$localization);
    // load the config file
    const config = await $61c36dc206ab8ac6$var$loadConfig("config.json");
    /**
  * Process the URL parameters
  */ const urlParams = (0, $21dae5303f17a106$exports.processRequest)(config, $61c36dc206ab8ac6$var$localization);
    let loadJsonDoc = (0, $67a74e96f4453962$export$2e2bcd8739ae039);
    // if the URL parameters are present, fetch the document from GitHub
    if (urlParams) loadJsonDoc = (0, $21dae5303f17a106$exports.fetchAndTransform)(config, urlParams.ghrepo, urlParams.source, urlParams.branch, urlParams.referer);
    // render the prosemirror document
    const jsonDoc = await loadJsonDoc;
    $61c36dc206ab8ac6$var$renderProsemirrorDocument(jsonDoc, urlParams, config);
}
function $61c36dc206ab8ac6$var$renderProsemirrorDocument(jsonDoc, urlParams, config) {
    // get the editor element from the DOM
    const domEl = document.querySelector("#editor");
    // clear the element innerHTML
    domEl.innerHTML = "";
    // if the element exists, create a new EditorView
    if (domEl) {
        // take in the schema and the json document
        const doc = (0, $6B4AI.Node).fromJSON($61c36dc206ab8ac6$var$schemaObject, jsonDoc);
        // create a new EditorState with the doc and the plugins
        const state = (0, $cw5sC.EditorState).create({
            doc: doc,
            plugins: [
                // history plugin comes from prosemirror-history
                (0, $6SXdZ.history)(),
                // these were custom plugins check the prosemirror-lwdita/src/plugin.ts file
                (0, $21dae5303f17a106$exports.shortcuts)($61c36dc206ab8ac6$var$localization, $61c36dc206ab8ac6$var$schemaObject),
                (0, $21dae5303f17a106$exports.menu)($61c36dc206ab8ac6$var$localization, $61c36dc206ab8ac6$var$schemaObject, {
                    end: [
                        [
                            (0, $e2e7b6d6591d76d0$export$b97f34331221dcb3)({
                                label: "lwdita",
                                url: "https://github.com/evolvedbinary/lwdita"
                            }),
                            (0, $e2e7b6d6591d76d0$export$b97f34331221dcb3)({
                                label: "prosemirror-lwdita",
                                url: "https://github.com/evolvedbinary/prosemirror-lwdita"
                            })
                        ]
                    ],
                    start: [
                        [
                            urlParams ? (0, $e2e7b6d6591d76d0$export$a10f575d509ad338)(config, $61c36dc206ab8ac6$var$localization, urlParams) : (0, $e2e7b6d6591d76d0$export$2482d013fd583a86)($61c36dc206ab8ac6$var$localization),
                            (0, $e2e7b6d6591d76d0$export$3d39a71d79a8dc29)(urlParams, $61c36dc206ab8ac6$var$localization)
                        ]
                    ]
                }),
                (0, $21dae5303f17a106$exports.doubleClickImagePlugin)($61c36dc206ab8ac6$var$localization)
            ]
        });
        // create a new EditorView with the dom element and the state
        new (0, $cc5d0749d0b75bc5$export$eece2fccabbb77c5)(domEl, {
            state: state
        });
    }
// TODO handled the case where we can not render the editor
}
// call the entryPoint function
$61c36dc206ab8ac6$var$entryPoint().then(()=>{
    console.log("Editor loaded");
}).catch((error)=>{
    console.error("Error loading editor", error);
});


//# sourceMappingURL=index.1843f428.js.map
